/* eslint-disable */
import React, { useState, useEffect, useCallback, useRef } from 'react';
import './responsive.css';
import { db, auth, googleProvider, storage } from './firebase';
import { ref, uploadBytes, getDownloadURL } from 'firebase/storage';

// Push Notifications — solo en app nativa
let PushNotifications = null;
try {
  const cap = require('@capacitor/push-notifications');
  PushNotifications = cap.PushNotifications;
} catch (e) { /* no disponible en web */ }


// ── Sagas y autores curados ───────────────────────────────────────────────────
export const SAGAS_CONOCIDAS = [
  { terminos: ['señor de los anillos', 'senor de los anillos', 'lord of the rings', 'tolkien'], libros: [{ titulo: 'El Señor de los Anillos. La Comunidad del Anillo', autor: 'J.R.R. Tolkien' }, { titulo: 'El Señor de los Anillos. Las Dos Torres', autor: 'J.R.R. Tolkien' }, { titulo: 'El Señor de los Anillos. El Retorno del Rey', autor: 'J.R.R. Tolkien' }, { titulo: 'El Hobbit', autor: 'J.R.R. Tolkien' }, { titulo: 'El Silmarillion', autor: 'J.R.R. Tolkien' }] },
  { terminos: ['harry potter', 'rowling'], libros: [{ titulo: 'Harry Potter y la piedra filosofal', autor: 'J.K. Rowling' }, { titulo: 'Harry Potter y la cámara secreta', autor: 'J.K. Rowling' }, { titulo: 'Harry Potter y el prisionero de Azkaban', autor: 'J.K. Rowling' }, { titulo: 'Harry Potter y el cáliz de fuego', autor: 'J.K. Rowling' }, { titulo: 'Harry Potter y la Orden del Fénix', autor: 'J.K. Rowling' }, { titulo: 'Harry Potter y el misterio del príncipe', autor: 'J.K. Rowling' }, { titulo: 'Harry Potter y las Reliquias de la Muerte', autor: 'J.K. Rowling' }] },
  { terminos: ['juego de tronos', 'cancion de hielo y fuego', 'george martin', 'george r.r. martin'], libros: [{ titulo: 'Juego de tronos', autor: 'George R.R. Martin' }, { titulo: 'Choque de reyes', autor: 'George R.R. Martin' }, { titulo: 'Tormenta de espadas', autor: 'George R.R. Martin' }, { titulo: 'Festín de cuervos', autor: 'George R.R. Martin' }, { titulo: 'Danza de dragones', autor: 'George R.R. Martin' }] },
  { terminos: ['dune', 'frank herbert'], libros: [{ titulo: 'Dune', autor: 'Frank Herbert' }, { titulo: 'El Mesías de Dune', autor: 'Frank Herbert' }, { titulo: 'Hijos de Dune', autor: 'Frank Herbert' }, { titulo: 'Dios Emperador de Dune', autor: 'Frank Herbert' }, { titulo: 'Cazadores de Dune', autor: 'Brian Herbert y Kevin J. Anderson' }, { titulo: 'Gusanos de Dune', autor: 'Brian Herbert y Kevin J. Anderson' }] },
  { terminos: ['reina roja', 'juan gomez jurado', 'gomez-jurado'], libros: [{ titulo: 'Reina Roja', autor: 'Juan Gómez-Jurado' }, { titulo: 'Loba Negra', autor: 'Juan Gómez-Jurado' }, { titulo: 'Rey Blanco', autor: 'Juan Gómez-Jurado' }, { titulo: 'Todo arde', autor: 'Juan Gómez-Jurado' }] },
  { terminos: ['sombra del viento', 'carlos ruiz zafon', 'zafon'], libros: [{ titulo: 'La sombra del viento', autor: 'Carlos Ruiz Zafón' }, { titulo: 'El juego del ángel', autor: 'Carlos Ruiz Zafón' }, { titulo: 'El prisionero del cielo', autor: 'Carlos Ruiz Zafón' }, { titulo: 'El laberinto de los espíritus', autor: 'Carlos Ruiz Zafón' }] },
  { terminos: ['habitos atomicos', 'hábitos atómicos', 'james clear'], libros: [{ titulo: 'Hábitos atómicos', autor: 'James Clear' }] },
  { terminos: ['sapiens', 'yuval harari', 'yuval noah harari', 'harari', 'homo deus', '21 lecciones'], libros: [{ titulo: 'Sapiens', autor: 'Yuval Noah Harari' }, { titulo: 'Homo Deus', autor: 'Yuval Noah Harari' }, { titulo: '21 lecciones para el siglo XXI', autor: 'Yuval Noah Harari' }] },
  { terminos: ['alas de sangre', 'cuarta ala', 'rebecca yarros'], libros: [{ titulo: 'Alas de sangre', autor: 'Rebecca Yarros' }, { titulo: 'Trono de hierro y ceniza', autor: 'Rebecca Yarros' }] },
  { terminos: ['name of the wind', 'nombre del viento', 'patrick rothfuss'], libros: [{ titulo: 'El nombre del viento', autor: 'Patrick Rothfuss' }, { titulo: 'El temor de un hombre sabio', autor: 'Patrick Rothfuss' }] },
  { terminos: ['pillars of the earth', 'pilares de la tierra', 'ken follett'], libros: [{ titulo: 'Los pilares de la Tierra', autor: 'Ken Follett' }, { titulo: 'Un mundo sin fin', autor: 'Ken Follett' }, { titulo: 'Una columna de fuego', autor: 'Ken Follett' }] },
  { terminos: ['codigo da vinci', 'código da vinci', 'dan brown'], libros: [{ titulo: 'El código Da Vinci', autor: 'Dan Brown' }, { titulo: 'Ángeles y demonios', autor: 'Dan Brown' }, { titulo: 'Inferno', autor: 'Dan Brown' }, { titulo: 'Origen', autor: 'Dan Brown' }] },
  { terminos: ['it', 'resplandor', 'stephen king', 'misery', 'cementerio de animales', 'king'], libros: [
    { titulo: 'It', autor: 'Stephen King' },
    { titulo: 'El resplandor', autor: 'Stephen King' },
    { titulo: 'Misery', autor: 'Stephen King' },
    { titulo: 'Cementerio de animales', autor: 'Stephen King' },
    { titulo: 'La Torre Oscura', autor: 'Stephen King' },
    { titulo: 'El juego de Gerald', autor: 'Stephen King' },
    { titulo: 'Apocalipsis', autor: 'Stephen King' },
    { titulo: 'Carrie', autor: 'Stephen King' },
    { titulo: 'El misterio de Salem\'s Lot', autor: 'Stephen King' },
    { titulo: 'Cujo', autor: 'Stephen King' },
    { titulo: 'Christine', autor: 'Stephen King' },
    { titulo: 'La cúpula', autor: 'Stephen King' },
  ] },
  { terminos: ['el principito', 'principito', 'petit prince', 'little prince', 'saint exupery', 'saint-exupery', 'exupery'], libros: [
    { titulo: 'El Principito', autor: 'Antoine de Saint-Exupéry' },
  ] },
  { terminos: ['orgullo y prejuicio', 'jane austen'], libros: [{ titulo: 'Orgullo y Prejuicio', autor: 'Jane Austen' }, { titulo: 'Sentido y sensibilidad', autor: 'Jane Austen' }, { titulo: 'Persuasión', autor: 'Jane Austen' }, { titulo: 'Emma', autor: 'Jane Austen' }] },
  { terminos: ['cien años de soledad', 'garcia marquez', 'gabriel garcia marquez'], libros: [{ titulo: 'Cien años de soledad', autor: 'Gabriel García Márquez' }, { titulo: 'El amor en los tiempos del cólera', autor: 'Gabriel García Márquez' }, { titulo: 'Crónica de una muerte anunciada', autor: 'Gabriel García Márquez' }] },
  { terminos: ['1984', 'rebelion en la granja', 'george orwell'], libros: [{ titulo: '1984', autor: 'George Orwell' }, { titulo: 'Rebelión en la granja', autor: 'George Orwell' }] },
  { terminos: ['mistborn', 'brandon sanderson', 'stormlight', 'way of kings'], libros: [{ titulo: 'El Imperio Final', autor: 'Brandon Sanderson' }, { titulo: 'El Pozo de la Ascensión', autor: 'Brandon Sanderson' }, { titulo: 'El Héroe de las Eras', autor: 'Brandon Sanderson' }, { titulo: 'El Camino de los Reyes', autor: 'Brandon Sanderson' }] },
  { terminos: ['juegos del hambre', 'hunger games', 'suzanne collins'], libros: [{ titulo: 'Los Juegos del Hambre', autor: 'Suzanne Collins' }, { titulo: 'En llamas', autor: 'Suzanne Collins' }, { titulo: 'Sinsajo', autor: 'Suzanne Collins' }, { titulo: 'Balada de pájaros cantores y serpientes', autor: 'Suzanne Collins' }] },
  { terminos: ['divergente', 'veronica roth'], libros: [{ titulo: 'Divergente', autor: 'Veronica Roth' }, { titulo: 'Insurgente', autor: 'Veronica Roth' }, { titulo: 'Leal', autor: 'Veronica Roth' }] },
  { terminos: ['twilight', 'crepusculo', 'crepúsculo', 'stephenie meyer'], libros: [{ titulo: 'Crepúsculo', autor: 'Stephenie Meyer' }, { titulo: 'Luna nueva', autor: 'Stephenie Meyer' }, { titulo: 'Eclipse', autor: 'Stephenie Meyer' }, { titulo: 'Amanecer', autor: 'Stephenie Meyer' }] },
  { terminos: ['percy jackson', 'rick riordan'], libros: [{ titulo: 'El ladrón del rayo', autor: 'Rick Riordan' }, { titulo: 'El mar de los monstruos', autor: 'Rick Riordan' }, { titulo: 'La maldición del Titán', autor: 'Rick Riordan' }, { titulo: 'La batalla del laberinto', autor: 'Rick Riordan' }, { titulo: 'El último héroe del Olimpo', autor: 'Rick Riordan' }] },
  { terminos: ['agatha christie', 'poirot', 'miss marple'], libros: [{ titulo: 'Asesinato en el Orient Express', autor: 'Agatha Christie' }, { titulo: 'Muerte en el Nilo', autor: 'Agatha Christie' }, { titulo: 'Diez negritos', autor: 'Agatha Christie' }, { titulo: 'El asesinato de Roger Ackroyd', autor: 'Agatha Christie' }] },
  { terminos: ['padre rico padre pobre', 'rich dad poor dad', 'robert kiyosaki', 'kiyosaki'], libros: [{ titulo: 'Padre Rico, Padre Pobre', autor: 'Robert T. Kiyosaki' }, { titulo: 'El cuadrante del flujo de dinero', autor: 'Robert T. Kiyosaki' }] },
  { terminos: ['el monje que vendio su ferrari', 'monje ferrari', 'robin sharma', 'sharma'], libros: [{ titulo: 'El monje que vendió su Ferrari', autor: 'Robin Sharma' }, { titulo: 'El líder que no tenía cargo', autor: 'Robin Sharma' }, { titulo: 'Las 5 de la mañana', autor: 'Robin Sharma' }] },
  { terminos: ['el alquimista', 'paulo coelho', 'coelho'], libros: [{ titulo: 'El Alquimista', autor: 'Paulo Coelho' }, { titulo: 'Once Minutos', autor: 'Paulo Coelho' }, { titulo: 'El Zahir', autor: 'Paulo Coelho' }] },
  { terminos: ['don quijote', 'quijote', 'cervantes'], libros: [{ titulo: 'Don Quijote de la Mancha', autor: 'Miguel de Cervantes' }] },
  { terminos: ['los cuatro acuerdos', 'miguel ruiz', 'don miguel ruiz'], libros: [{ titulo: 'Los cuatro acuerdos', autor: 'Miguel Ruiz' }] },
  { terminos: ['ikigai', 'hector garcia', 'francesc miralles'], libros: [{ titulo: 'Ikigai', autor: 'Héctor García' }] },
  { terminos: ['colleen hoover', 'hoover', 'it ends with us'], libros: [{ titulo: 'It Ends with Us', autor: 'Colleen Hoover' }, { titulo: 'It Starts with Us', autor: 'Colleen Hoover' }, { titulo: 'Ugly Love', autor: 'Colleen Hoover' }, { titulo: 'Verity', autor: 'Colleen Hoover' }] },
  { terminos: ['los siete maridos de evelyn hugo', 'taylor jenkins reid', 'taylor reid'], libros: [{ titulo: 'Los siete maridos de Evelyn Hugo', autor: 'Taylor Jenkins Reid' }, { titulo: 'Daisy Jones and The Six', autor: 'Taylor Jenkins Reid' }, { titulo: 'Malibu Rising', autor: 'Taylor Jenkins Reid' }] },
  { terminos: ['el tiempo entre costuras', 'maria dueñas', 'dueñas'], libros: [{ titulo: 'El tiempo entre costuras', autor: 'María Dueñas' }, { titulo: 'Misión Olvido', autor: 'María Dueñas' }, { titulo: 'La Templanza', autor: 'María Dueñas' }] },
  { terminos: ['haruki murakami', 'murakami', 'tokio blues', 'kafka en la orilla'], libros: [{ titulo: 'Tokio Blues', autor: 'Haruki Murakami' }, { titulo: 'Kafka en la orilla', autor: 'Haruki Murakami' }, { titulo: '1Q84', autor: 'Haruki Murakami' }] },
  { terminos: ['stieg larsson', 'larsson', 'millennium', 'lisbeth salander'], libros: [{ titulo: 'Los hombres que no amaban a las mujeres', autor: 'Stieg Larsson' }, { titulo: 'La chica que soñaba con una cerilla y un bidón de gasolina', autor: 'Stieg Larsson' }, { titulo: 'La reina en el palacio de las corrientes de aire', autor: 'Stieg Larsson' }] },
  { terminos: ['el cuento de la criada', 'margaret atwood', 'atwood', 'handmaid tale'], libros: [{ titulo: 'El cuento de la criada', autor: 'Margaret Atwood' }, { titulo: 'Los testamentos', autor: 'Margaret Atwood' }] },
  { terminos: ['la paciente silenciosa', 'paciente silenciosa', 'alex michaelides'], libros: [{ titulo: 'La paciente silenciosa', autor: 'Alex Michaelides' }, { titulo: 'Las Furias', autor: 'Alex Michaelides' }] },
  { terminos: ['chica del tren', 'paula hawkins'], libros: [{ titulo: 'La chica del tren', autor: 'Paula Hawkins' }, { titulo: 'En el agua', autor: 'Paula Hawkins' }] },
  { terminos: ['ladrona de libros', 'markus zusak', 'zusak', 'book thief'], libros: [{ titulo: 'La ladrona de libros', autor: 'Markus Zusak' }] },
  { terminos: ['cometas en el cielo', 'khaled hosseini', 'hosseini', 'mil soles esplendidos'], libros: [{ titulo: 'Cometas en el cielo', autor: 'Khaled Hosseini' }, { titulo: 'Mil soles espléndidos', autor: 'Khaled Hosseini' }] },
  { terminos: ['el hombre en busca de sentido', 'viktor frankl', 'frankl'], libros: [{ titulo: 'El hombre en busca de sentido', autor: 'Viktor Frankl' }] },
  { terminos: ['pensar rapido pensar despacio', 'daniel kahneman', 'kahneman'], libros: [{ titulo: 'Pensar rápido, pensar despacio', autor: 'Daniel Kahneman' }] },
  { terminos: ['el sutil arte', 'mark manson', 'manson'], libros: [{ titulo: 'El sutil arte de que todo le importe una mierda', autor: 'Mark Manson' }, { titulo: 'Todo está jodido', autor: 'Mark Manson' }] },
  { terminos: ['irene vallejo', 'vallejo', 'el infinito en un junco'], libros: [{ titulo: 'El infinito en un junco', autor: 'Irene Vallejo' }, { titulo: 'Manifiesto por la lectura', autor: 'Irene Vallejo' }] },
  { terminos: ['matt haig', 'haig', 'biblioteca de medianoche', 'midnight library'], libros: [{ titulo: 'La biblioteca de medianoche', autor: 'Matt Haig' }, { titulo: 'Razones para seguir viviendo', autor: 'Matt Haig' }] },

  // ── Autoayuda / No ficción ────────────────────────────────────────────────
  { terminos: ['48 leyes del poder', 'las 48 leyes', 'robert greene', 'greene'], libros: [{ titulo: 'Las 48 leyes del poder', autor: 'Robert Greene' }, { titulo: 'El arte de la seducción', autor: 'Robert Greene' }, { titulo: 'Las 33 estrategias de la guerra', autor: 'Robert Greene' }, { titulo: 'Las leyes de la naturaleza humana', autor: 'Robert Greene' }] },
  { terminos: ['atomic habits', 'habitos atomicos', 'james clear', 'clear'], libros: [{ titulo: 'Hábitos atómicos', autor: 'James Clear' }] },
  { terminos: ['el poder del ahora', 'eckhart tolle', 'tolle'], libros: [{ titulo: 'El poder del ahora', autor: 'Eckhart Tolle' }, { titulo: 'Un nuevo mundo ahora', autor: 'Eckhart Tolle' }] },
  { terminos: ['talking to strangers', 'outliers', 'tipping point', 'malcolm gladwell', 'gladwell'], libros: [{ titulo: 'Fuera de serie', autor: 'Malcolm Gladwell' }, { titulo: 'El punto clave', autor: 'Malcolm Gladwell' }, { titulo: 'Inteligencia intuitiva', autor: 'Malcolm Gladwell' }] },
  { terminos: ['the power of habit', 'el poder de los habitos', 'charles duhigg', 'duhigg'], libros: [{ titulo: 'El poder de los hábitos', autor: 'Charles Duhigg' }] },
  { terminos: ['estoicismo', 'meditaciones', 'marco aurelio', 'seneca', 'epicteto'], libros: [{ titulo: 'Meditaciones', autor: 'Marco Aurelio' }, { titulo: 'Cartas a Lucilio', autor: 'Séneca' }, { titulo: 'Sobre la brevedad de la vida', autor: 'Séneca' }, { titulo: 'Enchiridion', autor: 'Epicteto' }] },
  { terminos: ['deep work', 'cal newport', 'newport', 'trabajo profundo'], libros: [{ titulo: 'Trabajo profundo', autor: 'Cal Newport' }, { titulo: 'Digital Minimalism', autor: 'Cal Newport' }] },
  { terminos: ['show your work', 'steal like an artist', 'austin kleon', 'kleon'], libros: [{ titulo: 'Roba como un artista', autor: 'Austin Kleon' }, { titulo: 'Comparte tu trabajo', autor: 'Austin Kleon' }] },
  { terminos: ['simon sinek', 'sinek', 'start with why', 'empieza con el por que'], libros: [{ titulo: 'Empieza con el porqué', autor: 'Simon Sinek' }, { titulo: 'Los líderes comen al final', autor: 'Simon Sinek' }] },
  { terminos: ['brene brown', 'brown', 'el poder de ser vulnerable', 'daring greatly'], libros: [{ titulo: 'El poder de ser vulnerable', autor: 'Brené Brown' }, { titulo: 'Los dones de la imperfección', autor: 'Brené Brown' }] },

  // ── Novela española ────────────────────────────────────────────────────────
  { terminos: ['almudena grandes', 'grandes', 'los besos en el pan', 'episodios de una guerra'], libros: [{ titulo: 'Los besos en el pan', autor: 'Almudena Grandes' }, { titulo: 'Las edades de Lulú', autor: 'Almudena Grandes' }] },
  { terminos: ['arturo perez reverte', 'perez reverte', 'el capitan alatriste', 'alatriste'], libros: [{ titulo: 'El capitán Alatriste', autor: 'Arturo Pérez-Reverte' }, { titulo: 'La tabla de Flandes', autor: 'Arturo Pérez-Reverte' }, { titulo: 'El club Dumas', autor: 'Arturo Pérez-Reverte' }, { titulo: 'La reina del sur', autor: 'Arturo Pérez-Reverte' }] },
  { terminos: ['javier marias', 'marias', 'tu rostro manana', 'corazon tan blanco'], libros: [{ titulo: 'Corazón tan blanco', autor: 'Javier Marías' }, { titulo: 'Tu rostro mañana', autor: 'Javier Marías' }] },
  { terminos: ['Eduardo mendoza', 'mendoza', 'la verdad sobre el caso savolta', 'sin noticias de gurb'], libros: [{ titulo: 'Sin noticias de Gurb', autor: 'Eduardo Mendoza' }, { titulo: 'La ciudad de los prodigios', autor: 'Eduardo Mendoza' }] },
  { terminos: ['dolores redondo', 'redondo', 'el guardian invisible', 'trilogia del baztan'], libros: [{ titulo: 'El guardián invisible', autor: 'Dolores Redondo' }, { titulo: 'Legado en los huesos', autor: 'Dolores Redondo' }, { titulo: 'Ofrenda a la tormenta', autor: 'Dolores Redondo' }] },

  // ── Novela internacional ───────────────────────────────────────────────────
  { terminos: ['dostoievski', 'crimen y castigo', 'el idiota', 'los hermanos karamazov'], libros: [{ titulo: 'Crimen y castigo', autor: 'Fiódor Dostoievski' }, { titulo: 'El idiota', autor: 'Fiódor Dostoievski' }, { titulo: 'Los hermanos Karamázov', autor: 'Fiódor Dostoievski' }] },
  { terminos: ['tolstoi', 'guerra y paz', 'anna karenina'], libros: [{ titulo: 'Guerra y paz', autor: 'León Tolstói' }, { titulo: 'Anna Karénina', autor: 'León Tolstói' }] },
  { terminos: ['victor hugo', 'hugo', 'los miserables', 'el jorobado de notre dame'], libros: [{ titulo: 'Los Miserables', autor: 'Victor Hugo' }, { titulo: 'Nuestra Señora de París', autor: 'Victor Hugo' }] },
  { terminos: ['charles dickens', 'dickens', 'oliver twist', 'grandes esperanzas', 'cuento de navidad'], libros: [{ titulo: 'Oliver Twist', autor: 'Charles Dickens' }, { titulo: 'Grandes esperanzas', autor: 'Charles Dickens' }, { titulo: 'Historia de dos ciudades', autor: 'Charles Dickens' }] },
  { terminos: ['gabriel garcia marquez', 'marquez', 'realismo magico', 'macondo'], libros: [{ titulo: 'Cien años de soledad', autor: 'Gabriel García Márquez' }, { titulo: 'El amor en los tiempos del cólera', autor: 'Gabriel García Márquez' }, { titulo: 'Crónica de una muerte anunciada', autor: 'Gabriel García Márquez' }] },
  { terminos: ['isabel allende', 'allende', 'la casa de los espiritus'], libros: [{ titulo: 'La casa de los espíritus', autor: 'Isabel Allende' }, { titulo: 'Eva Luna', autor: 'Isabel Allende' }, { titulo: 'La ciudad de las bestias', autor: 'Isabel Allende' }] },
  { terminos: ['milan kundera', 'kundera', 'la insoportable levedad del ser'], libros: [{ titulo: 'La insoportable levedad del ser', autor: 'Milan Kundera' }, { titulo: 'La broma', autor: 'Milan Kundera' }, { titulo: 'La inmortalidad', autor: 'Milan Kundera' }] },
  { terminos: ['franz kafka', 'kafka', 'la metamorfosis', 'el proceso', 'el castillo'], libros: [{ titulo: 'La metamorfosis', autor: 'Franz Kafka' }, { titulo: 'El proceso', autor: 'Franz Kafka' }, { titulo: 'El castillo', autor: 'Franz Kafka' }] },
  { terminos: ['albert camus', 'camus', 'el extranjero', 'la peste', 'el mito de sisifo'], libros: [{ titulo: 'El extranjero', autor: 'Albert Camus' }, { titulo: 'La peste', autor: 'Albert Camus' }, { titulo: 'El mito de Sísifo', autor: 'Albert Camus' }] },
  { terminos: ['john steinbeck', 'steinbeck', 'las uvas de la ira', 'de ratones y hombres'], libros: [{ titulo: 'Las uvas de la ira', autor: 'John Steinbeck' }, { titulo: 'De ratones y hombres', autor: 'John Steinbeck' }, { titulo: 'Al este del Edén', autor: 'John Steinbeck' }] },
  { terminos: ['ernest hemingway', 'hemingway', 'el viejo y el mar', 'por quien doblan las campanas'], libros: [{ titulo: 'El viejo y el mar', autor: 'Ernest Hemingway' }, { titulo: 'Por quién doblan las campanas', autor: 'Ernest Hemingway' }, { titulo: 'Fiesta', autor: 'Ernest Hemingway' }] },
  { terminos: ['f. scott fitzgerald', 'fitzgerald', 'el gran gatsby'], libros: [{ titulo: 'El gran Gatsby', autor: 'F. Scott Fitzgerald' }] },
  { terminos: ['oscar wilde', 'wilde', 'el retrato de dorian gray', 'la importancia de llamarse ernesto'], libros: [{ titulo: 'El retrato de Dorian Gray', autor: 'Oscar Wilde' }, { titulo: 'De profundis', autor: 'Oscar Wilde' }] },
  { terminos: ['gabriel fonseca', 'toni morrison', 'morrison', 'beloved', 'la cancion de salomon'], libros: [{ titulo: 'Beloved', autor: 'Toni Morrison' }, { titulo: 'La canción de Salomón', autor: 'Toni Morrison' }] },
  { terminos: ['chimamanda ngozi adichie', 'adichie', 'americanah', 'medio sol amarillo'], libros: [{ titulo: 'Americanah', autor: 'Chimamanda Ngozi Adichie' }, { titulo: 'Medio sol amarillo', autor: 'Chimamanda Ngozi Adichie' }, { titulo: 'El peligro de la historia única', autor: 'Chimamanda Ngozi Adichie' }] },
  { terminos: ['john grisham', 'grisham', 'la firma', 'el informe pelicano'], libros: [{ titulo: 'La firma', autor: 'John Grisham' }, { titulo: 'El informe pelícano', autor: 'John Grisham' }, { titulo: 'El cliente', autor: 'John Grisham' }] },
  { terminos: ['ken follett', 'follett', 'los pilares de la tierra', 'un mundo sin fin'], libros: [{ titulo: 'Los pilares de la Tierra', autor: 'Ken Follett' }, { titulo: 'Un mundo sin fin', autor: 'Ken Follett' }, { titulo: 'Una columna de fuego', autor: 'Ken Follett' }] },
  { terminos: ['wilbur smith', 'smith', 'cuando los leones rugen', 'la fuerza del aguila'], libros: [{ titulo: 'Cuando los leones rugieron', autor: 'Wilbur Smith' }, { titulo: 'La fuerza del águila', autor: 'Wilbur Smith' }] },
  { terminos: ['nicholas sparks', 'sparks', 'el diario de noa', 'un lugar donde refugiarse'], libros: [{ titulo: 'El diario de Noa', autor: 'Nicholas Sparks' }, { titulo: 'Un lugar donde refugiarse', autor: 'Nicholas Sparks' }, { titulo: 'Querido John', autor: 'Nicholas Sparks' }] },

  // ── Fantasía / Ciencia ficción ─────────────────────────────────────────────
  { terminos: ['game of thrones', 'cancion de hielo y fuego', 'george r r martin', 'martin'], libros: [{ titulo: 'Juego de tronos', autor: 'George R.R. Martin' }, { titulo: 'Choque de reyes', autor: 'George R.R. Martin' }, { titulo: 'Tormenta de espadas', autor: 'George R.R. Martin' }] },
  { terminos: ['wheel of time', 'rueda del tiempo', 'robert jordan', 'jordan'], libros: [{ titulo: 'El ojo del mundo', autor: 'Robert Jordan' }, { titulo: 'La gran cacería', autor: 'Robert Jordan' }] },
  { terminos: ['sandman', 'neil gaiman', 'gaiman', 'buenos presagios', 'american gods'], libros: [{ titulo: 'American Gods', autor: 'Neil Gaiman' }, { titulo: 'Buenos presagios', autor: 'Terry Pratchett y Neil Gaiman' }, { titulo: 'Coraline', autor: 'Neil Gaiman' }] },
  { terminos: ['terry pratchett', 'pratchett', 'mundodisco', 'discworld'], libros: [{ titulo: 'El color de la magia', autor: 'Terry Pratchett' }, { titulo: 'Guardias guardias', autor: 'Terry Pratchett' }] },
  { terminos: ['isaac asimov', 'asimov', 'fundacion', 'yo robot', 'foundation'], libros: [{ titulo: 'Fundación', autor: 'Isaac Asimov' }, { titulo: 'Yo, Robot', autor: 'Isaac Asimov' }, { titulo: 'El fin de la eternidad', autor: 'Isaac Asimov' }] },
  { terminos: ['philip k dick', 'dick', 'ubik', 'andromeda nebula', 'blade runner', 'do androids dream'], libros: [{ titulo: '¿Sueñan los androides con ovejas eléctricas?', autor: 'Philip K. Dick' }, { titulo: 'Ubik', autor: 'Philip K. Dick' }, { titulo: 'El hombre en el castillo', autor: 'Philip K. Dick' }] },
  { terminos: ['william gibson', 'gibson', 'neuromancer', 'neuromante'], libros: [{ titulo: 'Neuromante', autor: 'William Gibson' }] },
  { terminos: ['andy weir', 'weir', 'the martian', 'el marciano', 'project hail mary'], libros: [{ titulo: 'El marciano', autor: 'Andy Weir' }, { titulo: 'Proyecto Artemisa', autor: 'Andy Weir' }] },
  // ════════════════════════════════════════════════════════════════════════
  // NUEVAS ENTRADAS — Lotes 1 y 2 (Dune y ASOIAF ya completados arriba)
  // ════════════════════════════════════════════════════════════════════════

  // ── Romantasy / BookTok ─────────────────────────────────────────────────
  { terminos: ['sarah j maas', 'sarah maas', 'maas', 'corte de rosas y espinas', 'acotar', 'trono de cristal', 'ciudad medialuna', 'crescent city'], libros: [
    { titulo: 'Una corte de rosas y espinas', autor: 'Sarah J. Maas' },
    { titulo: 'Una corte de niebla y furia', autor: 'Sarah J. Maas' },
    { titulo: 'Una corte de alas y ruina', autor: 'Sarah J. Maas' },
    { titulo: 'Una corte de hielo y estrellas', autor: 'Sarah J. Maas' },
    { titulo: 'Una corte de plata y llamas', autor: 'Sarah J. Maas' },
    { titulo: 'Trono de cristal', autor: 'Sarah J. Maas' },
    { titulo: 'Corona de medianoche', autor: 'Sarah J. Maas' },
    { titulo: 'Heredera de fuego', autor: 'Sarah J. Maas' },
    { titulo: 'Ciudad Medialuna', autor: 'Sarah J. Maas' },
    { titulo: 'Casa de tierra y sangre', autor: 'Sarah J. Maas' },
  ] },
  { terminos: ['ana huang', 'huang', 'twisted love', 'twisted games', 'twisted hate', 'twisted lies', 'serie twisted'], libros: [
    { titulo: 'Twisted Love', autor: 'Ana Huang' },
    { titulo: 'Twisted Games', autor: 'Ana Huang' },
    { titulo: 'Twisted Hate', autor: 'Ana Huang' },
    { titulo: 'Twisted Lies', autor: 'Ana Huang' },
    { titulo: 'King of Wrath', autor: 'Ana Huang' },
    { titulo: 'King of Pride', autor: 'Ana Huang' },
  ] },
  { terminos: ['penelope douglas', 'douglas', 'punk 57', 'birthday girl', 'serie devils night'], libros: [
    { titulo: 'Punk 57', autor: 'Penelope Douglas' },
    { titulo: 'Birthday Girl', autor: 'Penelope Douglas' },
    { titulo: 'Credence', autor: 'Penelope Douglas' },
    { titulo: 'Misconduct', autor: 'Penelope Douglas' },
  ] },
  { terminos: ['chloe walsh', 'walsh', 'los chicos de tommen', 'binding 13', 'boys of tommen'], libros: [
    { titulo: 'Binding 13', autor: 'Chloe Walsh' },
    { titulo: 'Tearing 25', autor: 'Chloe Walsh' },
    { titulo: 'Loving 15', autor: 'Chloe Walsh' },
  ] },
  { terminos: ['jennifer l armentrout', 'armentrout', 'sangre y cenizas', 'from blood and ash', 'vampire royals'], libros: [
    { titulo: 'Sangre y cenizas', autor: 'Jennifer L. Armentrout' },
    { titulo: 'Un reino de carne y fuego', autor: 'Jennifer L. Armentrout' },
    { titulo: 'La corona de huesos gilded', autor: 'Jennifer L. Armentrout' },
  ] },
  { terminos: ['hd carlton', 'h.d. carlton', 'haunting adeline', 'cat and mouse'], libros: [
    { titulo: 'Haunting Adeline', autor: 'H.D. Carlton' },
    { titulo: 'Hunting Adeline', autor: 'H.D. Carlton' },
  ] },
  { terminos: ['ali hazelwood', 'hazelwood', 'the love hypothesis', 'la hipotesis del amor'], libros: [
    { titulo: 'La hipótesis del amor', autor: 'Ali Hazelwood' },
    { titulo: 'Amor en los laboratorios', autor: 'Ali Hazelwood' },
  ] },
  { terminos: ['cassandra clare', 'clare', 'cazadores de sombras', 'shadowhunters', 'ciudad de hueso'], libros: [
    { titulo: 'Ciudad de hueso', autor: 'Cassandra Clare' },
    { titulo: 'Ciudad de ceniza', autor: 'Cassandra Clare' },
    { titulo: 'Ciudad de cristal', autor: 'Cassandra Clare' },
  ] },

  // ── Bestsellers thriller / suspense actuales ──────────────────────────
  { terminos: ['freida mcfadden', 'mcfadden', 'la asistenta', 'the housemaid'], libros: [
    { titulo: 'La asistenta', autor: 'Freida McFadden' },
    { titulo: 'El secreto de la asistenta', autor: 'Freida McFadden' },
    { titulo: 'La asistenta es la nueva esposa', autor: 'Freida McFadden' },
    { titulo: 'La enfermera', autor: 'Freida McFadden' },
    { titulo: 'La vecina perfecta', autor: 'Freida McFadden' },
  ] },
  { terminos: ['jd barker', 'j.d. barker', 'barker', '4 mk'], libros: [
    { titulo: '4MK', autor: 'J.D. Barker' },
    { titulo: 'Dracul', autor: 'J.D. Barker' },
  ] },
  { terminos: ['javier castillo', 'castillo', 'la chica de nieve', 'el dia que se perdio la cordura'], libros: [
    { titulo: 'La chica de nieve', autor: 'Javier Castillo' },
    { titulo: 'El día que se perdió la cordura', autor: 'Javier Castillo' },
    { titulo: 'El juego del alma', autor: 'Javier Castillo' },
    { titulo: 'El bosque de los cuatro vientos', autor: 'Javier Castillo' },
  ] },
  { terminos: ['arantza portabales', 'portabales', 'asesinato en el molino'], libros: [
    { titulo: 'Asesinato en el Molino del Cura', autor: 'Arantza Portabales' },
    { titulo: 'Asesinato en el Club de Golf', autor: 'Arantza Portabales' },
  ] },
  { terminos: ['juan gomez jurado', 'gomez jurado', 'todo arde', 'todo muere'], libros: [
    { titulo: 'Reina roja', autor: 'Juan Gómez-Jurado' },
    { titulo: 'Loba negra', autor: 'Juan Gómez-Jurado' },
    { titulo: 'Rey blanco', autor: 'Juan Gómez-Jurado' },
    { titulo: 'Todo arde', autor: 'Juan Gómez-Jurado' },
    { titulo: 'Todo muere', autor: 'Juan Gómez-Jurado' },
  ] },

  // ── Novela española contemporánea más vendida ────────────────────────
  { terminos: ['sonsoles onega', 'onega', 'las hijas de la criada', 'la guerra de las nubes'], libros: [
    { titulo: 'Las hijas de la criada', autor: 'Sonsoles Ónega' },
    { titulo: 'Las pequeñas mentiras', autor: 'Sonsoles Ónega' },
  ] },
  { terminos: ['juan del val', 'del val', 'vera una historia de amor'], libros: [
    { titulo: 'Vera, una historia de amor', autor: 'Juan del Val' },
    { titulo: 'Candela', autor: 'Juan del Val' },
  ] },
  { terminos: ['lucia solla', 'solla', 'comeras flores'], libros: [
    { titulo: 'Comerás flores', autor: 'Lucía Solla' },
  ] },
  { terminos: ['elisabet benavent', 'benavent', 'valeria', 'saga valeria'], libros: [
    { titulo: 'Valeria en el espejo', autor: 'Elísabet Benavent' },
    { titulo: 'Valeria al desnudo', autor: 'Elísabet Benavent' },
    { titulo: 'En los zapatos de Valeria', autor: 'Elísabet Benavent' },
    { titulo: 'Toda la verdad de mis mentiras', autor: 'Elísabet Benavent' },
    { titulo: 'Una niña buena', autor: 'Elísabet Benavent' },
  ] },

  // ── Juvenil / infantil más leído ──────────────────────────────────────
  { terminos: ['myriam m lejardi', 'lejardi', 'anna kadabra'], libros: [
    { titulo: 'Anna Kadabra y el Club de la Luna Llena', autor: 'Myriam M. Lejardi' },
    { titulo: 'Anna Kadabra y el ladrón de varitas', autor: 'Myriam M. Lejardi' },
  ] },
  { terminos: ['geronimo stilton', 'stilton'], libros: [
    { titulo: 'Geronimo Stilton y el misterio del tesoro desaparecido', autor: 'Geronimo Stilton' },
    { titulo: 'Mi nombre es Stilton, Geronimo Stilton', autor: 'Geronimo Stilton' },
  ] },
  { terminos: ['blue jeans', 'francisco de paula fernandez', 'canciones para paula'], libros: [
    { titulo: 'Canciones para Paula', autor: 'Blue Jeans' },
    { titulo: 'Conexión Saturno', autor: 'Blue Jeans' },
  ] },

  // ── Clásicos hispanoamericanos pendientes ─────────────────────────────
  { terminos: ['jorge luis borges', 'borges', 'ficciones', 'el aleph'], libros: [
    { titulo: 'Ficciones', autor: 'Jorge Luis Borges' },
    { titulo: 'El Aleph', autor: 'Jorge Luis Borges' },
  ] },
  { terminos: ['julio cortazar', 'cortazar', 'rayuela'], libros: [
    { titulo: 'Rayuela', autor: 'Julio Cortázar' },
    { titulo: 'Bestiario', autor: 'Julio Cortázar' },
  ] },
  { terminos: ['mario vargas llosa', 'vargas llosa', 'la ciudad y los perros'], libros: [
    { titulo: 'La ciudad y los perros', autor: 'Mario Vargas Llosa' },
    { titulo: 'La fiesta del Chivo', autor: 'Mario Vargas Llosa' },
  ] },
  { terminos: ['virginia woolf', 'woolf', 'la senora dalloway', 'una habitacion propia'], libros: [
    { titulo: 'Una habitación propia', autor: 'Virginia Woolf' },
    { titulo: 'La señora Dalloway', autor: 'Virginia Woolf' },
    { titulo: 'Orlando', autor: 'Virginia Woolf' },
  ] },
  // ════════════════════════════════════════════════════════════════════
  // LOTE 2 — Terror, novela negra europea, manga, sci-fi clásica, autoayuda/finanzas
  // ════════════════════════════════════════════════════════════════════

  // ── Terror ──────────────────────────────────────────────────────────
  { terminos: ['hp lovecraft', 'h.p. lovecraft', 'lovecraft', 'cthulhu', 'en las montañas de la locura'], libros: [
    { titulo: 'En las montañas de la locura', autor: 'H.P. Lovecraft' },
    { titulo: 'El horror de Dunwich', autor: 'H.P. Lovecraft' },
    { titulo: 'El caso de Charles Dexter Ward', autor: 'H.P. Lovecraft' },
  ] },
  { terminos: ['bram stoker', 'stoker', 'dracula'], libros: [
    { titulo: 'Drácula', autor: 'Bram Stoker' },
  ] },
  { terminos: ['mary shelley', 'shelley', 'frankenstein'], libros: [
    { titulo: 'Frankenstein', autor: 'Mary Shelley' },
  ] },
  { terminos: ['silvia moreno garcia', 'moreno-garcia', 'mexico gotico'], libros: [
    { titulo: 'México gótico', autor: 'Silvia Moreno-Garcia' },
    { titulo: 'El baile de máscaras', autor: 'Silvia Moreno-Garcia' },
  ] },
  { terminos: ['shirley jackson', 'jackson', 'la maldicion de hill house', 'la casa encantada'], libros: [
    { titulo: 'La maldición de Hill House', autor: 'Shirley Jackson' },
    { titulo: 'Siempre hemos vivido en el castillo', autor: 'Shirley Jackson' },
  ] },
  { terminos: ['thomas harris', 'harris', 'el silencio de los corderos', 'hannibal lecter'], libros: [
    { titulo: 'El silencio de los corderos', autor: 'Thomas Harris' },
    { titulo: 'El dragón rojo', autor: 'Thomas Harris' },
    { titulo: 'Hannibal', autor: 'Thomas Harris' },
  ] },
  { terminos: ['william peter blatty', 'blatty', 'el exorcista'], libros: [
    { titulo: 'El exorcista', autor: 'William Peter Blatty' },
  ] },
  { terminos: ['joe hill', 'hill', 'nosferatu', 'cuernos'], libros: [
    { titulo: 'NOS4A2', autor: 'Joe Hill' },
    { titulo: 'Cuernos', autor: 'Joe Hill' },
  ] },

  // ── Novela negra europea ────────────────────────────────────────────
  { terminos: ['jo nesbo', 'nesbo', 'harry hole', 'el muñeco de nieve'], libros: [
    { titulo: 'El muñeco de nieve', autor: 'Jo Nesbø' },
    { titulo: 'El leopardo', autor: 'Jo Nesbø' },
    { titulo: 'Petirrojo', autor: 'Jo Nesbø' },
    { titulo: 'La sed', autor: 'Jo Nesbø' },
  ] },
  { terminos: ['camilla lackberg', 'läckberg', 'la princesa de hielo'], libros: [
    { titulo: 'La princesa de hielo', autor: 'Camilla Läckberg' },
    { titulo: 'Los gritos del pasado', autor: 'Camilla Läckberg' },
  ] },
  { terminos: ['henning mankell', 'mankell', 'wallander', 'asesinos sin rostro'], libros: [
    { titulo: 'Asesinos sin rostro', autor: 'Henning Mankell' },
    { titulo: 'Los perros de Riga', autor: 'Henning Mankell' },
  ] },
  { terminos: ['donato carrisi', 'carrisi', 'el coleccionista de huesos blancos', 'la chica en la niebla'], libros: [
    { titulo: 'La chica en la niebla', autor: 'Donato Carrisi' },
    { titulo: 'El susurrador', autor: 'Donato Carrisi' },
  ] },
  { terminos: ['pierre lemaitre', 'lemaitre', 'irene', 'camille verhoeven'], libros: [
    { titulo: 'Irène', autor: 'Pierre Lemaitre' },
    { titulo: 'Alex', autor: 'Pierre Lemaitre' },
  ] },
  { terminos: ['fred vargas', 'vargas', 'comisario adamsberg'], libros: [
    { titulo: 'Cuando sale la reclusa', autor: 'Fred Vargas' },
    { titulo: 'Un lugar incierto', autor: 'Fred Vargas' },
  ] },
  { terminos: ['dolores redondo', 'redondo', 'el guardian invisible', 'baztan'], libros: [
    { titulo: 'El guardián invisible', autor: 'Dolores Redondo' },
    { titulo: 'Legado en los huesos', autor: 'Dolores Redondo' },
    { titulo: 'Ofrenda a la tormenta', autor: 'Dolores Redondo' },
    { titulo: 'La cara norte del corazón', autor: 'Dolores Redondo' },
  ] },
  { terminos: ['carmen mola', 'mola', 'la novia gitana', 'inspectora elena blanco'], libros: [
    { titulo: 'La novia gitana', autor: 'Carmen Mola' },
    { titulo: 'La red púrpura', autor: 'Carmen Mola' },
    { titulo: 'La nena', autor: 'Carmen Mola' },
  ] },

  // ── Manga / cómic ────────────────────────────────────────────────────
  { terminos: ['naruto', 'masashi kishimoto', 'kishimoto'], libros: [
    { titulo: 'Naruto 1', autor: 'Masashi Kishimoto' },
    { titulo: 'Naruto 2', autor: 'Masashi Kishimoto' },
  ] },
  { terminos: ['one piece', 'eiichiro oda', 'oda'], libros: [
    { titulo: 'One Piece 1', autor: 'Eiichiro Oda' },
    { titulo: 'One Piece 2', autor: 'Eiichiro Oda' },
  ] },
  { terminos: ['attack on titan', 'ataque a los titanes', 'hajime isayama', 'isayama'], libros: [
    { titulo: 'Ataque a los Titanes 1', autor: 'Hajime Isayama' },
    { titulo: 'Ataque a los Titanes 2', autor: 'Hajime Isayama' },
  ] },
  { terminos: ['death note', 'tsugumi ohba', 'ohba'], libros: [
    { titulo: 'Death Note 1', autor: 'Tsugumi Ohba' },
    { titulo: 'Death Note 2', autor: 'Tsugumi Ohba' },
  ] },
  { terminos: ['demon slayer', 'kimetsu no yaiba', 'koyoharu gotouge', 'gotouge'], libros: [
    { titulo: 'Kimetsu no Yaiba 1', autor: 'Koyoharu Gotouge' },
    { titulo: 'Kimetsu no Yaiba 2', autor: 'Koyoharu Gotouge' },
  ] },
  { terminos: ['jujutsu kaisen', 'gege akutami', 'akutami'], libros: [
    { titulo: 'Jujutsu Kaisen 1', autor: 'Gege Akutami' },
    { titulo: 'Jujutsu Kaisen 2', autor: 'Gege Akutami' },
  ] },
  { terminos: ['alice in borderland', 'haro aso', 'aso'], libros: [
    { titulo: 'Alice in Borderland 1', autor: 'Haro Aso' },
  ] },
  { terminos: ['watchmen', 'alan moore', 'moore', 'v de vendetta'], libros: [
    { titulo: 'Watchmen', autor: 'Alan Moore' },
    { titulo: 'V de Vendetta', autor: 'Alan Moore' },
    { titulo: 'La broma asesina', autor: 'Alan Moore' },
  ] },
  { terminos: ['maus', 'art spiegelman', 'spiegelman'], libros: [
    { titulo: 'Maus', autor: 'Art Spiegelman' },
  ] },
  { terminos: ['persepolis', 'marjane satrapi', 'satrapi'], libros: [
    { titulo: 'Persépolis', autor: 'Marjane Satrapi' },
  ] },

  // ── Ciencia ficción clásica ──────────────────────────────────────────
  { terminos: ['ray bradbury', 'bradbury', 'fahrenheit 451', 'cronicas marcianas'], libros: [
    { titulo: 'Fahrenheit 451', autor: 'Ray Bradbury' },
    { titulo: 'Crónicas marcianas', autor: 'Ray Bradbury' },
    { titulo: 'El hombre ilustrado', autor: 'Ray Bradbury' },
  ] },
  { terminos: ['arthur c clarke', 'clarke', '2001 odisea del espacio', 'cita con rama'], libros: [
    { titulo: '2001: Una odisea espacial', autor: 'Arthur C. Clarke' },
    { titulo: 'Cita con Rama', autor: 'Arthur C. Clarke' },
    { titulo: 'El fin de la infancia', autor: 'Arthur C. Clarke' },
  ] },
  { terminos: ['orson scott card', 'card', 'el juego de ender', 'ender'], libros: [
    { titulo: 'El juego de Ender', autor: 'Orson Scott Card' },
    { titulo: 'La voz de los muertos', autor: 'Orson Scott Card' },
    { titulo: 'La sombra de Ender', autor: 'Orson Scott Card' },
  ] },
  { terminos: ['dan simmons', 'simmons', 'hyperion'], libros: [
    { titulo: 'Hyperion', autor: 'Dan Simmons' },
    { titulo: 'La caída de Hyperion', autor: 'Dan Simmons' },
  ] },
  { terminos: ['liu cixin', 'cixin', 'el problema de los tres cuerpos', 'tres cuerpos'], libros: [
    { titulo: 'El problema de los tres cuerpos', autor: 'Liu Cixin' },
    { titulo: 'El bosque oscuro', autor: 'Liu Cixin' },
    { titulo: 'El fin de la muerte', autor: 'Liu Cixin' },
  ] },
  { terminos: ['robert heinlein', 'heinlein', 'tropas del espacio', 'forastero en tierra extraña'], libros: [
    { titulo: 'Tropas del espacio', autor: 'Robert A. Heinlein' },
    { titulo: 'Forastero en tierra extraña', autor: 'Robert A. Heinlein' },
  ] },
  { terminos: ['ursula k le guin', 'le guin', 'terramar', 'los desposeidos'], libros: [
    { titulo: 'Un mago de Terramar', autor: 'Ursula K. Le Guin' },
    { titulo: 'Los desposeídos', autor: 'Ursula K. Le Guin' },
    { titulo: 'La mano izquierda de la oscuridad', autor: 'Ursula K. Le Guin' },
  ] },

  // ── Autoayuda / finanzas / negocios ──────────────────────────────────
  { terminos: ['morgan housel', 'housel', 'la psicologia del dinero'], libros: [
    { titulo: 'La psicología del dinero', autor: 'Morgan Housel' },
  ] },
  { terminos: ['napoleon hill', 'hill', 'piense y hagase rico'], libros: [
    { titulo: 'Piense y hágase rico', autor: 'Napoleon Hill' },
  ] },
  { terminos: ['dale carnegie', 'carnegie', 'como ganar amigos'], libros: [
    { titulo: 'Cómo ganar amigos e influir sobre las personas', autor: 'Dale Carnegie' },
    { titulo: 'Cómo suprimir las preocupaciones y disfrutar de la vida', autor: 'Dale Carnegie' },
  ] },
  { terminos: ['stephen covey', 'covey', '7 habitos de la gente altamente efectiva'], libros: [
    { titulo: 'Los 7 hábitos de la gente altamente efectiva', autor: 'Stephen R. Covey' },
  ] },
  { terminos: ['carol dweck', 'dweck', 'mindset', 'la actitud del exito'], libros: [
    { titulo: 'Mindset: La actitud del éxito', autor: 'Carol S. Dweck' },
  ] },
  { terminos: ['adam grant', 'grant', 'piensa de nuevo', 'originales'], libros: [
    { titulo: 'Piensa de nuevo', autor: 'Adam Grant' },
    { titulo: 'Originales', autor: 'Adam Grant' },
  ] },
  { terminos: ['yuval noah harari', 'harari', 'nexus'], libros: [
    { titulo: 'Nexus', autor: 'Yuval Noah Harari' },
  ] },

  // ── Novela histórica adicional ──────────────────────────────────────
  { terminos: ['santiago posteguillo', 'posteguillo', 'africanus', 'yo julia'], libros: [
    { titulo: 'Africanus, el hijo del cónsul', autor: 'Santiago Posteguillo' },
    { titulo: 'Las legiones malditas', autor: 'Santiago Posteguillo' },
    { titulo: 'Yo, Julia', autor: 'Santiago Posteguillo' },
  ] },
  { terminos: ['matilde asensi', 'asensi', 'el ultimo caton'], libros: [
    { titulo: 'El último Catón', autor: 'Matilde Asensi' },
    { titulo: 'Iacobus', autor: 'Matilde Asensi' },
  ] },
  { terminos: ['ildefonso falcones', 'falcones', 'la catedral del mar'], libros: [
    { titulo: 'La catedral del mar', autor: 'Ildefonso Falcones' },
    { titulo: 'La mano de Fátima', autor: 'Ildefonso Falcones' },
    { titulo: 'La reina descalza', autor: 'Ildefonso Falcones' },
  ] },
  { terminos: ['ken follett kingsbridge', 'el umbral de la eternidad', 'trilogia del siglo'], libros: [
    { titulo: 'La caída de los gigantes', autor: 'Ken Follett' },
    { titulo: 'El invierno del mundo', autor: 'Ken Follett' },
    { titulo: 'El umbral de la eternidad', autor: 'Ken Follett' },
  ] },
  // ════════════════════════════════════════════════════════════════════
  // LOTE 3 — Basado en Top 100 más vendidos (TodosTusLibros, jun 2026)
  // ════════════════════════════════════════════════════════════════════

  // ── Más vendidos actuales en España ───────────────────────────────────
  { terminos: ['mentira', 'gomez jurado mentira'], libros: [
    { titulo: 'Mentira', autor: 'Juan Gómez-Jurado' },
  ] },
  { terminos: ['megan maxwell', 'maxwell', 'riete de las bodas', 'pideme lo que quieras'], libros: [
    { titulo: 'Ríete de las bodas', autor: 'Megan Maxwell' },
    { titulo: 'Pídeme lo que quieras', autor: 'Megan Maxwell' },
    { titulo: 'Vuelvo a buscarte', autor: 'Megan Maxwell' },
  ] },
  { terminos: ['mercedes ron', 'culpables', 'culpa mia', 'culpa tuya', 'culpa nuestra', 'culpa vuestra'], libros: [
    { titulo: 'Culpa mía', autor: 'Mercedes Ron' },
    { titulo: 'Culpa tuya', autor: 'Mercedes Ron' },
    { titulo: 'Culpa nuestra', autor: 'Mercedes Ron' },
    { titulo: 'Culpa vuestra', autor: 'Mercedes Ron' },
  ] },
  { terminos: ['st abby', 's.t. abby', 'mindfuck', 'mindf*ck', 'verdades', 'mentiras serie mindfuck'], libros: [
    { titulo: 'Verdades', autor: 'S.T. Abby' },
    { titulo: 'Secretos', autor: 'S.T. Abby' },
    { titulo: 'Promesas', autor: 'S.T. Abby' },
    { titulo: 'Mentiras', autor: 'S.T. Abby' },
  ] },
  { terminos: ['maria oruña', 'oruña', 'la camara de las maravillas', 'puerto escondido'], libros: [
    { titulo: 'La cámara de las maravillas', autor: 'María Oruña' },
    { titulo: 'Puerto escondido', autor: 'María Oruña' },
    { titulo: 'El bosque de los cuatro vientos', autor: 'María Oruña' },
  ] },
  { terminos: ['john connolly', 'connolly', 'charlie parker', 'hijos de eva'], libros: [
    { titulo: 'Hijos de Eva', autor: 'John Connolly' },
    { titulo: 'Todo lo que muere', autor: 'John Connolly' },
    { titulo: 'El amante', autor: 'John Connolly' },
  ] },
  { terminos: ['david ucles', 'ucles', 'la peninsula de las casas vacias', 'la ciudad de las luces muertas'], libros: [
    { titulo: 'La península de las casas vacías', autor: 'David Uclés' },
    { titulo: 'La ciudad de las luces muertas', autor: 'David Uclés' },
  ] },
  { terminos: ['manel loureiro', 'loureiro', 'antes de que todo cambie', 'apocalipsis z'], libros: [
    { titulo: 'Antes de que todo cambie', autor: 'Manel Loureiro' },
    { titulo: 'Apocalipsis Z', autor: 'Manel Loureiro' },
  ] },
  { terminos: ['pol guasch', 'guasch', 'reliquia', 'napalm en el corazon'], libros: [
    { titulo: 'Reliquia', autor: 'Pol Guasch' },
    { titulo: 'Napalm en el corazón', autor: 'Pol Guasch' },
  ] },
  { terminos: ['eduardo mendoza intriga', 'el detective sin nombre', 'la intriga del funeral'], libros: [
    { titulo: 'La intriga del funeral inconveniente', autor: 'Eduardo Mendoza' },
    { titulo: 'El rey recibe', autor: 'Eduardo Mendoza' },
  ] },
  { terminos: ['manuel jabois', 'jabois', 'mirafiori', 'la vispera'], libros: [
    { titulo: 'La víspera', autor: 'Manuel Jabois' },
    { titulo: 'Mirafiori', autor: 'Manuel Jabois' },
  ] },
  { terminos: ['fernando aramburu', 'aramburu', 'patria', 'maite'], libros: [
    { titulo: 'Patria', autor: 'Fernando Aramburu' },
    { titulo: 'Maite', autor: 'Fernando Aramburu' },
    { titulo: 'Los vencejos', autor: 'Fernando Aramburu' },
  ] },
  { terminos: ['delphine de vigan', 'vigan', 'las gratitudes', 'no y yo'], libros: [
    { titulo: 'Las gratitudes', autor: 'Delphine de Vigan' },
    { titulo: 'No y yo', autor: 'Delphine de Vigan' },
    { titulo: 'Nada se opone a la noche', autor: 'Delphine de Vigan' },
  ] },
  { terminos: ['paco roca', 'roca', 'arrugas', 'el viaje paco roca'], libros: [
    { titulo: 'Arrugas', autor: 'Paco Roca' },
    { titulo: 'El invierno del dibujante', autor: 'Paco Roca' },
    { titulo: 'El viaje', autor: 'Paco Roca' },
  ] },
  { terminos: ['emmanuel carrere', 'carrere', 'koljos', 'el reino', 'yoga carrere'], libros: [
    { titulo: 'El Reino', autor: 'Emmanuel Carrère' },
    { titulo: 'Yoga', autor: 'Emmanuel Carrère' },
    { titulo: 'Koljós', autor: 'Emmanuel Carrère' },
  ] },
  { terminos: ['milena busquets', 'busquets', 'mujeres elegantes', 'tambien esto pasara'], libros: [
    { titulo: 'Mujeres elegantes', autor: 'Milena Busquets' },
    { titulo: 'También esto pasará', autor: 'Milena Busquets' },
  ] },
  { terminos: ['sara barquinero', 'barquinero', 'los escorpiones', 'la chica mas lista que conozco'], libros: [
    { titulo: 'Los Escorpiones', autor: 'Sara Barquinero' },
    { titulo: 'La chica más lista que conozco', autor: 'Sara Barquinero' },
  ] },
  { terminos: ['kathryn stockett', 'stockett', 'criadas y señoras', 'el club de las indomables'], libros: [
    { titulo: 'Criadas y señoras', autor: 'Kathryn Stockett' },
    { titulo: 'El club de las indomables', autor: 'Kathryn Stockett' },
  ] },
  { terminos: ['siri hustvedt', 'hustvedt', 'historias de fantasmas', 'el mundo deslumbrante'], libros: [
    { titulo: 'Historias de fantasmas', autor: 'Siri Hustvedt' },
    { titulo: 'El mundo deslumbrante', autor: 'Siri Hustvedt' },
  ] },
  { terminos: ['valeria luiselli', 'luiselli', 'principio medio fin', 'los ingravidos'], libros: [
    { titulo: 'Principio, medio, fin', autor: 'Valeria Luiselli' },
    { titulo: 'Los ingrávidos', autor: 'Valeria Luiselli' },
  ] },
  { terminos: ['juan luis arsuaga', 'arsuaga', 'la respuesta', 'el primer viaje de nuestra vida'], libros: [
    { titulo: 'La respuesta', autor: 'Juan Luis Arsuaga' },
    { titulo: 'El primer viaje de nuestra vida', autor: 'Juan Luis Arsuaga' },
  ] },
  { terminos: ['byung chul han', 'byung-chul han', 'han', 'la sociedad del cansancio', 'la sociedad de la transparencia'], libros: [
    { titulo: 'La sociedad del cansancio', autor: 'Byung-Chul Han' },
    { titulo: 'La sociedad de la transparencia', autor: 'Byung-Chul Han' },
    { titulo: 'No-cosas', autor: 'Byung-Chul Han' },
  ] },
  { terminos: ['jesus carrasco', 'carrasco', 'intemperie', 'el detalle'], libros: [
    { titulo: 'Intemperie', autor: 'Jesús Carrasco' },
    { titulo: 'El detalle', autor: 'Jesús Carrasco' },
  ] },
  { terminos: ['boticaria garcia', 'mujeres de hierro', 'menopausia boticaria'], libros: [
    { titulo: 'Mujeres de hierro', autor: 'Boticaria García' },
  ] },
  { terminos: ['arturo perez reverte enviado especial', 'enviado especial reverte'], libros: [
    { titulo: 'Enviado especial', autor: 'Arturo Pérez-Reverte' },
  ] },
  { terminos: ['santiago posteguillo nexus', 'posteguillo nexus'], libros: [
    { titulo: 'Nexus', autor: 'Santiago Posteguillo' },
  ] },

  // ── Completar Elísabet Benavent ───────────────────────────────────────
  // (añadir a la entrada existente de Benavent)
  // { titulo: 'Una niña buena', autor: 'Elísabet Benavent' },

  // ── Saga Mindf*ck completa (junto con S.T. Abby añadido arriba) ────────
  // Verdades(1), Secretos(2), Promesas(3), Mentiras(4)

  // ── Otros bestsellers internacionales recientes ───────────────────────
  { terminos: ['fredrik backman', 'backman', 'un hombre llamado ove', 'ansiosos por el dinero'], libros: [
    { titulo: 'Un hombre llamado Ove', autor: 'Fredrik Backman' },
    { titulo: 'Ansiosos por el dinero', autor: 'Fredrik Backman' },
    { titulo: 'Britt-Marie estuvo aquí', autor: 'Fredrik Backman' },
  ] },
  { terminos: ['kristin hannah', 'hannah', 'el ruisenor', 'las cuatro estaciones'], libros: [
    { titulo: 'El ruiseñor', autor: 'Kristin Hannah' },
    { titulo: 'Las cuatro estaciones', autor: 'Kristin Hannah' },
  ] },
  { terminos: ['delia owens', 'owens', 'donde cantan los cangrejos'], libros: [
    { titulo: 'Donde cantan los cangrejos', autor: 'Delia Owens' },
  ] },
  { terminos: ['rebecca yarros alas de hierro', 'alas de hierro', 'onyx storm'], libros: [
    { titulo: 'Alas de hierro', autor: 'Rebecca Yarros' },
    { titulo: 'Alas de plata', autor: 'Rebecca Yarros' },
  ] },
  { terminos: ['donna tartt', 'tartt', 'el secreto', 'el jilguero'], libros: [
    { titulo: 'El secreto', autor: 'Donna Tartt' },
    { titulo: 'El jilguero', autor: 'Donna Tartt' },
  ] },
  { terminos: ['anthony doerr', 'doerr', 'la luz que no puedes ver'], libros: [
    { titulo: 'La luz que no puedes ver', autor: 'Anthony Doerr' },
    { titulo: 'Nube de cuco', autor: 'Anthony Doerr' },
  ] },
  // ════════════════════════════════════════════════════════════════════
  // LOTE 4 — Basado en Top vendidos Casa del Libro (jun 2026)
  // ════════════════════════════════════════════════════════════════════

  { terminos: ['elle kennedy', 'kennedy', 'off campus', 'prohibido enamorarse', 'kiss me'], libros: [
    { titulo: 'Prohibido enamorarse', autor: 'Elle Kennedy' },
    { titulo: 'The Mistake', autor: 'Elle Kennedy' },
    { titulo: 'The Score', autor: 'Elle Kennedy' },
    { titulo: 'The Goal', autor: 'Elle Kennedy' },
  ] },
  { terminos: ['sarah a parker', 'sarah parker', 'la caida lunar', 'la balada de los dragones'], libros: [
    { titulo: 'La caída lunar', autor: 'Sarah A. Parker' },
    { titulo: 'La balada de los dragones', autor: 'Sarah A. Parker' },
  ] },
  { terminos: ['rachel reid', 'reid', 'game changers', 'el precio a pagar'], libros: [
    { titulo: 'El precio a pagar', autor: 'Rachel Reid' },
    { titulo: 'Heated Rivalry', autor: 'Rachel Reid' },
  ] },
  { terminos: ['la vecina rubia', 'el hombre ideal'], libros: [
    { titulo: 'El hombre ideal', autor: 'La Vecina Rubia' },
  ] },
  { terminos: ['jasmine mas', 'villanos', 'los lazos de hercules'], libros: [
    { titulo: 'Villanos. Flor de sangre', autor: 'Jasmine Mas' },
    { titulo: 'Villanos 2. Los lazos de Hércules', autor: 'Jasmine Mas' },
  ] },
  { terminos: ['victoria martin', 'martin influencer', 'se tiene que morir mucha gente'], libros: [
    { titulo: 'Se tiene que morir mucha gente', autor: 'Victoria Martín' },
  ] },
  { terminos: ['hermann hesse', 'hesse', 'siddhartha', 'el lobo estepario', 'demian'], libros: [
    { titulo: 'Siddhartha', autor: 'Hermann Hesse' },
    { titulo: 'El lobo estepario', autor: 'Hermann Hesse' },
    { titulo: 'Demian', autor: 'Hermann Hesse' },
  ] },
  { terminos: ['arturo del burgo', 'del burgo', 'no mientas'], libros: [
    { titulo: 'No mientas', autor: 'Arturo del Burgo' },
  ] },
  { terminos: ['michael jackson', 'moonwalk'], libros: [
    { titulo: 'Moonwalk', autor: 'Michael Jackson' },
  ] },
  { terminos: ['kentaro miura', 'miura', 'berserk'], libros: [
    { titulo: 'Berserk 1', autor: 'Kentaro Miura' },
    { titulo: 'Berserk Master Edition 1', autor: 'Kentaro Miura' },
    { titulo: 'El arte de Berserk', autor: 'Kentaro Miura' },
  ] },
  { terminos: ['haikyu', 'haruichi furudate', 'furudate'], libros: [
    { titulo: 'Haikyû!! 1', autor: 'Haruichi Furudate' },
    { titulo: 'Haikyû!! 2', autor: 'Haruichi Furudate' },
  ] },
  { terminos: ['meguru hinohara', 'hinohara', 'therapy game'], libros: [
    { titulo: 'Therapy Game 1', autor: 'Meguru Hinohara' },
    { titulo: 'Therapy Game Restart 1', autor: 'Meguru Hinohara' },
  ] },
  { terminos: ['ketty garat', 'garat', 'todos los hombres de sanchez'], libros: [
    { titulo: 'Todos los hombres de Sánchez', autor: 'Ketty Garat' },
  ] },
  { terminos: ['juan miguel zunzunegui', 'zunzunegui', 'hernan cortes'], libros: [
    { titulo: 'Hernán Cortés. Encuentro y conquista', autor: 'Juan Miguel Zunzunegui' },
    { titulo: 'Al día siguiente de la conquista', autor: 'Juan Miguel Zunzunegui' },
  ] },
  { terminos: ['manuel garand', 'garand', 'murdoku'], libros: [
    { titulo: 'Murdoku: 80 acertijos de lógica y asesinatos', autor: 'Manuel Garand' },
  ] },
  // ════════════════════════════════════════════════════════════════════
  // LOTE 5 — Bestsellers de la última década (2015-2025) e infantil/juvenil viral
  // ════════════════════════════════════════════════════════════════════

  { terminos: ['delia owens chica salvaje', 'la chica salvaje', 'where the crawdads sing'], libros: [
    { titulo: 'La chica salvaje', autor: 'Delia Owens' },
  ] },
  { terminos: ['tara westover', 'westover', 'educated', 'una educacion'], libros: [
    { titulo: 'Una educación', autor: 'Tara Westover' },
  ] },
  { terminos: ['john green', 'green', 'bajo la misma estrella', 'the fault in our stars'], libros: [
    { titulo: 'Bajo la misma estrella', autor: 'John Green' },
    { titulo: 'Buscando a Alaska', autor: 'John Green' },
  ] },
  { terminos: ['sally rooney', 'rooney', 'gente normal', 'normal people'], libros: [
    { titulo: 'Conversaciones entre amigos', autor: 'Sally Rooney' },
    { titulo: 'Gente normal Random House', autor: 'Sally Rooney' },
    { titulo: 'Dónde estás, mundo bello', autor: 'Sally Rooney' },
    { titulo: 'Intermezzo', autor: 'Sally Rooney' },
  ] },
  { terminos: ['ocean vuong', 'vuong', 'en la tierra somos fugazmente grandiosos'], libros: [
    { titulo: 'En la tierra somos fugazmente grandiosos', autor: 'Ocean Vuong' },
  ] },
  { terminos: ['isabel allende mi nombre es emilia', 'emilia del valle'], libros: [
    { titulo: 'Mi nombre es Emilia del Valle', autor: 'Isabel Allende' },
    { titulo: 'Violeta', autor: 'Isabel Allende' },
  ] },
  { terminos: ['javier cercas', 'cercas', 'el loco de dios', 'soldados de salamina'], libros: [
    { titulo: 'El loco de Dios en el fin del mundo', autor: 'Javier Cercas' },
    { titulo: 'Soldados de Salamina', autor: 'Javier Cercas' },
  ] },
  { terminos: ['rf kuang', 'r.f. kuang', 'kuang', 'babel', 'yellowface'], libros: [
    { titulo: 'Babel', autor: 'R.F. Kuang' },
    { titulo: 'Yellowface', autor: 'R.F. Kuang' },
  ] },
  { terminos: ['nazareth castellanos', 'castellanos', 'el puente donde habitan las mariposas'], libros: [
    { titulo: 'El puente donde habitan las mariposas', autor: 'Nazareth Castellanos' },
    { titulo: 'El cerebro de la gente con suerte', autor: 'Nazareth Castellanos' },
  ] },
  { terminos: ['godeik', 'godeik y la gema maldita'], libros: [
    { titulo: 'GoDeiK 1. GoDeiK y la gema maldita', autor: 'GoDeiK' },
  ] },
  { terminos: ['el ruso', 'alesgf', 'el ruso y el poder del davai'], libros: [
    { titulo: 'El Ruso 1. El Ruso y el poder del ¡Davai!', autor: 'AlesGF' },
    { titulo: 'El Ruso 3. Viaje al centro del Cuchillas', autor: 'AlesGF' },
  ] },
  { terminos: ['gt karber', 'g.t. karber', 'karber', 'asesinato para principiantes', 'club de detectives murdle'], libros: [
    { titulo: 'Asesinato para principiantes', autor: 'G.T. Karber' },
  ] },
  { terminos: ['jennifer armentrout brimstone', 'alquimia y fae', 'quicksilver'], libros: [
    { titulo: 'Quicksilver', autor: 'Jennifer L. Armentrout' },
    { titulo: 'Brimstone', autor: 'Jennifer L. Armentrout' },
  ] },
  { terminos: ['rebecca yarros alas de llamas', 'una corte de llamas plateadas'], libros: [
    { titulo: 'Alas de llamas', autor: 'Rebecca Yarros' },
  ] },
  { terminos: ['el rulas', 'rulas', 'el gran concurso de youtubers'], libros: [
    { titulo: 'El Rulas 5. El Rulas y el Gran Concurso de Youtubers', autor: 'El Rulas' },
  ] },
  { terminos: ['fabian c barrio', 'verity bolsillo', 'colleen hoover verity'], libros: [
    { titulo: 'Verity', autor: 'Colleen Hoover' },
  ] },
  { terminos: ['nuestro largo adios', 'el puente donde habitan las mariposas nazareth', 'mas vendidos 2025 españa'], libros: [
    { titulo: 'Nuestro largo adiós', autor: 'Reyes Monforte' },
  ] },
  { terminos: ['nash la chica del tren mas vendidos', 'las que no duermen'], libros: [
    { titulo: 'Las que no duermen', autor: 'Nash' },
  ] },
  { terminos: ['victoria de juan martinez', 'victoria novela 2025'], libros: [
    { titulo: 'Victoria', autor: 'Almudena Grandes' },
  ] },
  { terminos: ['la vegetariana', 'han kang', 'kang'], libros: [
    { titulo: 'La vegetariana', autor: 'Han Kang' },
    { titulo: 'Actos humanos', autor: 'Han Kang' },
  ] },
  { terminos: ['daniel keyes', 'flores para algernon'], libros: [
    { titulo: 'Flores para Algernon', autor: 'Daniel Keyes' },
  ] },
  { terminos: ['mitch albom', 'albom', 'las cinco personas que encuentras en el cielo', 'martes con mi viejo profesor'], libros: [
    { titulo: 'Las cinco personas que encuentras en el cielo', autor: 'Mitch Albom' },
    { titulo: 'Martes con mi viejo profesor', autor: 'Mitch Albom' },
  ] },
  { terminos: ['paula hawkins en el agua', 'una venganza perfecta hawkins'], libros: [
    { titulo: 'Una venganza perfecta', autor: 'Paula Hawkins' },
  ] },
  { terminos: ['celeste ng', 'ng', 'pequeños fuegos por todas partes', 'little fires everywhere'], libros: [
    { titulo: 'Pequeños fuegos por todas partes', autor: 'Celeste Ng' },
    { titulo: 'Todo lo que no te dije', autor: 'Celeste Ng' },
  ] },
  { terminos: ['gillian flynn', 'flynn', 'perdida', 'gone girl'], libros: [
    { titulo: 'Perdida', autor: 'Gillian Flynn' },
    { titulo: 'Heridas abiertas', autor: 'Gillian Flynn' },
  ] },
  // ════════════════════════════════════════════════════════════════════
  // LOTE 6 — Novela negra española actual y más Amazon bestsellers
  // ════════════════════════════════════════════════════════════════════

  { terminos: ['santiago diaz', 'diaz jotade', 'ivan moreno', 'el inocente'], libros: [
    { titulo: 'El inocente', autor: 'Santiago Díaz' },
    { titulo: 'El cómplice', autor: 'Santiago Díaz' },
    { titulo: 'El testigo', autor: 'Santiago Díaz' },
  ] },
  { terminos: ['eloy moreno', 'moreno', 'el boligrafo de gel verde', 'invisible'], libros: [
    { titulo: 'El bolígrafo de gel verde', autor: 'Eloy Moreno' },
    { titulo: 'Invisible', autor: 'Eloy Moreno' },
    { titulo: 'Las cosas que no te dije', autor: 'Eloy Moreno' },
  ] },
  { terminos: ['nerea llanes', 'llanes', 'ya no tengo miedo'], libros: [
    { titulo: 'Ya no tengo miedo', autor: 'Nerea Llanes' },
  ] },
  { terminos: ['hannah nicole maehrer', 'maehrer', 'crepusculo y acero', 'dia y noche'], libros: [
    { titulo: 'Crepúsculo y acero', autor: 'Hannah Nicole Maehrer' },
  ] },
  { terminos: ['alice oseman', 'oseman', 'heartstopper', 'corazon de tiza'], libros: [
    { titulo: 'Heartstopper 1. Dos chicos juntos', autor: 'Alice Oseman' },
    { titulo: 'Solitario', autor: 'Alice Oseman' },
  ] },
  { terminos: ['ali hazelwood mate', 'mate hazelwood'], libros: [
    { titulo: 'Mate', autor: 'Ali Hazelwood' },
  ] },
  { terminos: ['cuaderno blackie books', 'blackie books cuaderno actividades'], libros: [
    { titulo: 'Cuaderno Blackie Books. Vol. 15', autor: 'Cristobal Fortunez' },
  ] },
  { terminos: ['eric carle', 'carle', 'la oruga glotona', 'la pequeña oruga'], libros: [
    { titulo: 'La pequeña oruga glotona', autor: 'Eric Carle' },
  ] },
  { terminos: ['el monstruo de colores', 'ana llenas', 'llenas'], libros: [
    { titulo: 'El monstruo de colores', autor: 'Anna Llenas' },
    { titulo: 'El monstruo de colores va al cole', autor: 'Anna Llenas' },
  ] },
  { terminos: ['destroza este diario', 'keri smith', 'smith destroza'], libros: [
    { titulo: 'Destroza este diario', autor: 'Keri Smith' },
    { titulo: 'Destroza este diario. Ahora a todo color', autor: 'Keri Smith' },
  ] },
  { terminos: ['carlos garcia miranda', 'el principe de la niebla zafon'], libros: [
    { titulo: 'El príncipe de la niebla', autor: 'Carlos Ruiz Zafón' },
    { titulo: 'El palacio de la medianoche', autor: 'Carlos Ruiz Zafón' },
    { titulo: 'Marina', autor: 'Carlos Ruiz Zafón' },
  ] },
  { terminos: ['anxo lorenzo', 'lorenzo poesia', 'rupi kaur'], libros: [
    { titulo: 'El sol y sus flores', autor: 'Rupi Kaur' },
    { titulo: 'Otras formas de usar la boca', autor: 'Rupi Kaur' },
  ] },
  { terminos: ['raquel diaz reguera', 'reguera', 'eres una caca de unicornio'], libros: [
    { titulo: 'Eres una caca de unicornio', autor: 'Raquel Díaz Reguera' },
  ] },
  { terminos: ['david walliams', 'walliams', 'el mundo del reves', 'mi abuela es un zombi'], libros: [
    { titulo: 'El mundo al revés', autor: 'David Walliams' },
    { titulo: 'Mi abuela es un zombi', autor: 'David Walliams' },
  ] },
  { terminos: ['liane moriarty', 'moriarty', 'big little lies', 'pequeñas mentiras'], libros: [
    { titulo: 'Pequeñas mentiras', autor: 'Liane Moriarty' },
    { titulo: 'Nueve perfectos extraños', autor: 'Liane Moriarty' },
  ] },
  { terminos: ['jodi picoult', 'picoult', 'diecinueve minutos', 'la decision mas dificil'], libros: [
    { titulo: 'Diecinueve minutos', autor: 'Jodi Picoult' },
    { titulo: 'La decisión más difícil', autor: 'Jodi Picoult' },
  ] },
  { terminos: ['holly black', 'black', 'el principe cruel', 'the cruel prince'], libros: [
    { titulo: 'El príncipe cruel', autor: 'Holly Black' },
    { titulo: 'El rey malvado', autor: 'Holly Black' },
  ] },
  { terminos: ['leigh bardugo', 'bardugo', 'sombra y hueso', 'seis de cuervos'], libros: [
    { titulo: 'Sombra y hueso', autor: 'Leigh Bardugo' },
    { titulo: 'Seis de cuervos', autor: 'Leigh Bardugo' },
  ] },

  // ── Lote 7 — Cozy romance, BookTok España 2024-2026, sagas tienda/pueblo ────
  { terminos: ['laurie gilmore', 'dream harbor', 'cafe aroma calabaza', 'cafe con aroma'], libros: [
    { titulo: 'Café con aroma a calabaza', autor: 'Laurie Gilmore' },
    { titulo: 'La asombrosa tienda de la señora Yeom', autor: 'Laurie Gilmore' },
    { titulo: 'La Casa de las Tortitas de Fresa', autor: 'Laurie Gilmore' },
    { titulo: 'La Casa del Pan de Jengibre', autor: 'Laurie Gilmore' },
    { titulo: 'La granja de árboles de Navidad', autor: 'Laurie Gilmore' },
    { titulo: 'Las maravillas de la tienda de Cheongpa-dong', autor: 'Laurie Gilmore' },
    { titulo: 'La Floristería de la Guirnalda de Margaritas', autor: 'Laurie Gilmore' },
  ] },
  { terminos: ['kim ho yeon', 'tienda yeom', 'pasteleria cinnamon', 'cinnamon bun', 'dolci misteri', 'lidia yuknavitch'], libros: [
    { titulo: 'Dolci misteri alla libreria Cinnamon Bun', autor: 'Kim Ho-yeon' },
    { titulo: 'Bienvenidos a la librería Hyunam-Dong', autor: 'Hwang Bo-Reum' },
  ] },
  { terminos: ['beth o leary', 'o leary', 'piso para dos', 'the flatshare'], libros: [
    { titulo: 'Piso para dos', autor: 'Beth O\'Leary' },
    { titulo: 'El turno de noche', autor: 'Beth O\'Leary' },
    { titulo: 'La boda de Isla', autor: 'Beth O\'Leary' },
    { titulo: 'El viaje', autor: 'Beth O\'Leary' },
  ] },
  { terminos: ['emily henry', 'henry', 'beach read', 'people we meet', 'verano en la playa', 'gente que conocemos'], libros: [
    { titulo: 'Verano en la playa', autor: 'Emily Henry' },
    { titulo: 'Gente que conocemos en las vacaciones', autor: 'Emily Henry' },
    { titulo: 'Book Lovers', autor: 'Emily Henry' },
    { titulo: 'Happy Place', autor: 'Emily Henry' },
    { titulo: 'Great Big Beautiful Life', autor: 'Emily Henry' },
  ] },
  { terminos: ['elena armas', 'armas', 'amor en juego', 'dilema de la novia', 'siempre seras mia'], libros: [
    { titulo: 'Farsa de amor a la española', autor: 'Elena Armas' },
    { titulo: 'Experimento de amor en Nueva York', autor: 'Elena Armas' },
    { titulo: 'Amor en juego', autor: 'Elena Armas' },
    { titulo: 'El dilema de la novia', autor: 'Elena Armas' },
    { titulo: 'Siempre serás mía', autor: 'Elena Armas' },
  ] },
  { terminos: ['rina kent', 'legacy of gods', 'royal elite', 'deviant king', 'captive prince rina'], libros: [
    { titulo: 'Deviant King', autor: 'Rina Kent' },
    { titulo: 'Steel Princess', autor: 'Rina Kent' },
    { titulo: 'Cruel King', autor: 'Rina Kent' },
    { titulo: 'God of Malice', autor: 'Rina Kent' },
    { titulo: 'God of Ruin', autor: 'Rina Kent' },
  ] },
  { terminos: ['hannah nicole maehrer', 'maehrer', 'assistants and assassins', 'accomplice villain', 'crepusculo acero'], libros: [
    { titulo: 'Crepúsculo y acero', autor: 'Hannah Nicole Maehrer' },
    { titulo: 'Accomplice to the Villain', autor: 'Hannah Nicole Maehrer' },
  ] },
  { terminos: ['nerea llanes', 'llanes', 'ya no tengo miedo', 'nerea'], libros: [
    { titulo: 'Ya no tengo miedo', autor: 'Nerea Llanes' },
    { titulo: 'Sola en el mundo', autor: 'Nerea Llanes' },
    { titulo: 'Lo que nadie sabe de mí', autor: 'Nerea Llanes' },
  ] },
  { terminos: ['julie soto', 'rose in chains', 'evermore', 'trilogia evermore'], libros: [
    { titulo: 'Rose in chains', autor: 'Julie Soto' },
  ] },
  { terminos: ['blackwater', 'mcammon', 'robert mccammon', 'la riada', 'el dique blackwater'], libros: [
    { titulo: 'Blackwater I. La riada', autor: 'Robert McCammon' },
    { titulo: 'Blackwater II. El dique', autor: 'Blackwater' },
    { titulo: 'Blackwater III. La casa', autor: 'Blackwater' },
    { titulo: 'Blackwater IV. La guerra', autor: 'Blackwater' },
    { titulo: 'Blackwater V. El azar', autor: 'Blackwater' },
    { titulo: 'Blackwater VI. El asentamiento', autor: 'Blackwater' },
  ] },
  { terminos: ['powerless brynne', 'sara stewart', 'fearless powerless', 'lauren roberts powerless'], libros: [
    { titulo: 'Powerless', autor: 'Lauren Roberts' },
    { titulo: 'Reckless', autor: 'Lauren Roberts' },
    { titulo: 'Fearless', autor: 'Lauren Roberts' },
  ] },
  { terminos: ['la academia aurora', 'ocaso academia', 'academia aurora nerea'], libros: [
    { titulo: 'La Academia 1. Ocaso', autor: 'La Academia' },
    { titulo: 'La Academia 2. Aurora', autor: 'La Academia' },
  ] },
  { terminos: ['acelerando en rojo', 'iryna zubkova', 'ir_zu', 'f1 romance', 'sports romance f1'], libros: [
    { titulo: 'Acelerando en rojo', autor: 'Iryna Zubkova' },
  ] },
  { terminos: ['alquimia y fae', 'jennifer armentrout', 'quicksilver armentrout', 'from blood and ash'], libros: [
    { titulo: 'Quicksilver', autor: 'Jennifer L. Armentrout' },
    { titulo: 'A Shadow in the Ember', autor: 'Jennifer L. Armentrout' },
    { titulo: 'From Blood and Ash', autor: 'Jennifer L. Armentrout' },
    { titulo: 'A Kingdom of Flesh and Fire', autor: 'Jennifer L. Armentrout' },
  ] },
  { terminos: ['alas de onix', 'alas onix', 'empireo', 'rebecca yarros empireo'], libros: [
    { titulo: 'Alas de ónix', autor: 'Rebecca Yarros' },
    { titulo: 'Alas de sangre', autor: 'Rebecca Yarros' },
    { titulo: 'Alas de hierro', autor: 'Rebecca Yarros' },
    { titulo: 'Trono de hierro y ceniza', autor: 'Rebecca Yarros' },
    { titulo: 'Alas de llamas', autor: 'Rebecca Yarros' },
  ] },
  { terminos: ['katee robert', 'dioses ardientes', 'dioses indomables', 'dark olympus', 'neon gods'], libros: [
    { titulo: 'Dioses ardientes', autor: 'Katee Robert' },
    { titulo: 'Dioses indomables', autor: 'Katee Robert' },
    { titulo: 'Dioses eléctricos', autor: 'Katee Robert' },
    { titulo: 'Dioses oscuros', autor: 'Katee Robert' },
    { titulo: 'Neon Gods', autor: 'Katee Robert' },
    { titulo: 'Electric Idol', autor: 'Katee Robert' },
  ] },
  { terminos: ['tracy wolff', 'crave', 'crush wolff', 'covet wolff', 'dulce pesadilla', 'calder academy'], libros: [
    { titulo: 'Dulce pesadilla', autor: 'Tracy Wolff' },
    { titulo: 'Crave', autor: 'Tracy Wolff' },
    { titulo: 'Crush', autor: 'Tracy Wolff' },
    { titulo: 'Covet', autor: 'Tracy Wolff' },
    { titulo: 'Court', autor: 'Tracy Wolff' },
  ] },
  { terminos: ['charlie donlea', 'donlea', 'el adn te condena', 'adn condena'], libros: [
    { titulo: 'El ADN te condena', autor: 'Charlie Donlea' },
    { titulo: 'Verano de 1982', autor: 'Charlie Donlea' },
    { titulo: 'La chica que desapareció en verano', autor: 'Charlie Donlea' },
  ] },
  { terminos: ['holly jackson', 'desaparicion expertos', 'un asesinato para principiantes', 'good girl bad blood'], libros: [
    { titulo: 'Un asesinato para principiantes', autor: 'Holly Jackson' },
    { titulo: 'Buena chica, sangre mala', autor: 'Holly Jackson' },
    { titulo: 'Como si los muertos no existieran', autor: 'Holly Jackson' },
    { titulo: 'Desaparición Para Expertos', autor: 'Holly Jackson' },
    { titulo: 'Five Survive', autor: 'Holly Jackson' },
  ] },
  { terminos: ['mikel santiago', 'el mentiroso', 'archivos illumbe', 'ultimo verano'], libros: [
    { titulo: 'El mentiroso (Trilogía El Archivo de las Illumbe 1)', autor: 'Mikel Santiago' },
    { titulo: 'El último verano', autor: 'Mikel Santiago' },
    { titulo: 'El vigilante del fiordo', autor: 'Mikel Santiago' },
  ] },
  { terminos: ['r.l. stine', 'rl stine', 'escalofrios', 'goosebumps monstruos'], libros: [
    { titulo: 'Escalofríos: Los Monstruos Oviparos', autor: 'R.L. Stine' },
    { titulo: 'Goosebumps', autor: 'R.L. Stine' },
  ] },
  { terminos: ['r.m. gray', 'rm gray', 'starchaser', 'sarah j gray'], libros: [
    { titulo: 'Starchaser', autor: 'R.M. Gray' },
  ] },
  { terminos: ['brandon sanderson', 'sanderson', 'ritmo guerra', 'el ritmo de la guerra', 'el camino de los reyes', 'nacidos de la bruma', 'mistborn', 'cosmere', 'archivo tormentas', 'viento y verdad', 'elantris', 'warbreaker', 'escuadron', 'skyward', 'reckoners'], libros: [
    // ── El Archivo de las Tormentas (Stormlight Archive) ──
    { titulo: 'El camino de los reyes', autor: 'Brandon Sanderson' },
    { titulo: 'Palabras radiantes', autor: 'Brandon Sanderson' },
    { titulo: 'Juramentada', autor: 'Brandon Sanderson' },
    { titulo: 'El ritmo de la guerra', autor: 'Brandon Sanderson' },
    { titulo: 'Viento y Verdad', autor: 'Brandon Sanderson' },
    // ── Nacidos de la Bruma / Mistborn ──
    { titulo: 'El Imperio Final', autor: 'Brandon Sanderson' },
    { titulo: 'El Pozo de la Ascensión', autor: 'Brandon Sanderson' },
    { titulo: 'El Héroe de las Eras', autor: 'Brandon Sanderson' },
    { titulo: 'El Aliento del Ausente', autor: 'Brandon Sanderson' },
    { titulo: 'Sombras de identidad', autor: 'Brandon Sanderson' },
    { titulo: 'Brazales del Duelo', autor: 'Brandon Sanderson' },
    { titulo: 'El metal perdido', autor: 'Brandon Sanderson' },
    // ── Cosmere autoconclusivas ──
    { titulo: 'Elantris', autor: 'Brandon Sanderson' },
    { titulo: 'El aliento de los dioses', autor: 'Brandon Sanderson' },
    { titulo: 'Arcanum Ilimitado', autor: 'Brandon Sanderson' },
    // ── Novelas Secretas (Proyectos Kickstarter) ──
    { titulo: 'Trenza del mar Esmeralda', autor: 'Brandon Sanderson' },
    { titulo: 'La guía del mago frugal para sobrevivir en la Inglaterra del Medievo', autor: 'Brandon Sanderson' },
    { titulo: 'Yumi y el pintor de pesadillas', autor: 'Brandon Sanderson' },
    { titulo: 'El hombre iluminado', autor: 'Brandon Sanderson' },
    { titulo: 'Islas de la Ascuaoscura', autor: 'Brandon Sanderson' },
    // ── Escuadrón / Skyward ──
    { titulo: 'Escuadrón', autor: 'Brandon Sanderson' },
    { titulo: 'Estelar', autor: 'Brandon Sanderson' },
    { titulo: 'Cítara', autor: 'Brandon Sanderson' },
    { titulo: 'Infinito', autor: 'Brandon Sanderson' },
    // ── The Reckoners ──
    { titulo: 'Steelheart', autor: 'Brandon Sanderson' },
    { titulo: 'Firefight', autor: 'Brandon Sanderson' },
    { titulo: 'Calamidad', autor: 'Brandon Sanderson' },
    // ── Alcatraz ──
    { titulo: 'Alcatraz contra los Bibliotecarios Malvados', autor: 'Brandon Sanderson' },
    { titulo: 'Los huesos del escribano', autor: 'Brandon Sanderson' },
    { titulo: 'El caballero de cristal', autor: 'Brandon Sanderson' },
    { titulo: 'La oscuridad de la lente', autor: 'Brandon Sanderson' },
    // ── La Rueda del Tiempo (obras de Sanderson) ──
    { titulo: 'La Memoria de la Luz', autor: 'Robert Jordan / Brandon Sanderson' },
    { titulo: 'Torres de Medianoche', autor: 'Robert Jordan / Brandon Sanderson' },
    { titulo: 'Llamas de la Eternidad', autor: 'Robert Jordan / Brandon Sanderson' },
    // ── Otras obras ──
    { titulo: 'El alma del Emperador', autor: 'Brandon Sanderson' },
  ] },
  { terminos: ['vera premio planeta', 'vera amor planeta 2025', 'jose antonio leon vera'], libros: [
    { titulo: 'Vera, una historia de amor', autor: 'Premio Planeta 2025' },
  ] },
];

// ── Filtros globales de búsqueda de libros ────────────────────────────────────
const EXCLUIR_TITULO_GLOBAL = [
  /tarot/i, /\bjuego\b/i, /\balbum\b/i, /tv\s*tie.?in/i, /tie.?in/i,
  /\bpack\b/i, /\bestuche\b/i, /\bboxed\s+set\b/i, /\btetralog[ií]a\b/i,
  /cuaderno\s+de\s+bocetos/i, /\bcoloring\b/i, /libro\s+de\s+colorear\b/i, /\bpuzzle\b/i,
  /edici[oó]n\s+(revisada|ilustrada|especial|coleccionista|lujo|limitada)/i,
  /\bgu[ií]a\s+de\s+(lectura|estudio)\b/i, /\bresum[ea]n\b/i,
  /\bclaves\s+de\b/i, /\bsummary\b/i, /\banalisis\b/i, /\ban[aá]lisis\b/i,
  /resumenexpress/i, /\btrilogi[aá]\b.*\bcompleta\b/i,
  /una\s+inspiraci[oó]n\s+para/i, /lecciones\s+sobre\s+la\s+vida/i,
  /curso\s+completo\s+de\s+maestr[ií]a/i, /las\s+\d+\s+claves\s+del/i,
  /sabidur[ií]a\s+cotidiana/i, /cartas\s+secretas/i,
  /descubre\s+tu\s+destino/i, /metacurso/i,
  /\d+\s+claves\s+(del|de\s+la)/i, /las\s+cartas\s+secretas/i,
  /\(.*tie.?in.*\)/i, /guia\s+(de\s+)?fotos/i,
  // Añadidos: cromos, revistas, apuntes, periódicos, académico
  /\bcromos?\b/i, /\brevista\b/i, /\bperiodico\b/i, /\bperiódico\b/i,
  /\bapuntes\b/i, /\btesis\b/i, /\bwork.?book\b/i, /\blibro\s+de\s+texto\b/i,
  /\bvolumen\s+\d+/i, /\bnumero\s+\d+/i, /\btomo\s+[ivxlcdm]+\b/i,
  /\bseguridad\s+vial\b/i, /\boposicion(es)?\b/i, /\bexamen(es)?\b/i,
];
const EXCLUIR_AUTOR_GLOBAL = /^(an[oó]nimo|varios|vv\.?aa\.?|anonymous|desconocido|unknown|resumenexpress|metacurso|autor\s+desconocido|sin\s+autor)$/i;
const esLibroValido = (titulo, autor) =>
  !EXCLUIR_TITULO_GLOBAL.some(p => p.test(titulo)) &&
  !EXCLUIR_AUTOR_GLOBAL.test((titulo + ' ' + autor).toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').trim().split(' ').slice(-2).join(' ')) &&
  !EXCLUIR_AUTOR_GLOBAL.test((autor || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').trim());

// Hook global para detección de móvil reactiva

// ── localStorage seguro — evita crashes en Safari privado y almacenamiento lleno
const lsGet = (key) => { try { return localStorage.getItem(key); } catch { return null; } };
const lsSet = (key, val) => { try { localStorage.setItem(key, val); } catch { } };
const lsRemove = (key) => { try { localStorage.removeItem(key); } catch { } };


function useIsMobile() {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  useEffect(() => {
    const handler = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener('resize', handler);
    return () => window.removeEventListener('resize', handler);
  }, []);
  return isMobile;
}
import { signInWithPopup, signInWithRedirect, getRedirectResult, signInWithCredential, GoogleAuthProvider, onAuthStateChanged, signOut, createUserWithEmailAndPassword, signInWithEmailAndPassword, updateProfile } from "firebase/auth";
import { collection, addDoc, query, onSnapshot, orderBy, serverTimestamp, where, updateDoc, doc, setDoc, getDoc, limit, getDocs, deleteDoc, increment, arrayUnion, arrayRemove } from "firebase/firestore";

import { Icon, Avatar, SpoilerBlur, GLOBAL_STYLES } from './ui';
import { SeccionInsignias, useStats, INSIGNIAS_DEF, calcularNivel, NIVELES } from './Insignias';
import { EstadisticasAvanzadas } from './Estadisticas';
import { RetoLector } from './RetoLector';
import { ImportarGoodreads } from './ImportarGoodreads';
import { TimerLectura } from './TimerLectura';
import { CitasLibro } from './CitasLibro';
import { MoodTags } from './MoodTags';
import { BuddyReads } from './BuddyReads';
import { CalendarioLectura } from './CalendarioLectura';
import { SeccionClubs } from './Clubs';
import { SeccionFeed } from './Feed';
import { Onboarding } from './Onboarding';
import { animarSalasInactivas } from './ClubBot';
import {
  ADMIN_UID, LISTAS_LIBROS, CATEGORIAS_VISUALES, GENEROS_LIBROS, MESES_ES,
  ESTADOS_LECTURA, MAX_ACTIVIDAD, generarIdLibro, normalizarTexto,
  mantenerSalas, registrarActividad
} from './constants';

// RevenueCat — solo en app nativa
const REVENUECAT_API_KEY = 'goog_uQFnTwAGPSMVBZqDiIAWwDEWOKF';
const GOOGLE_BOOKS_API_KEY = 'AIzaSyDmTfy3ePtPB-LUZjMkaXQdOU2CmSGT5cU';
const CF_TENDENCIAS = 'https://gettendencias-kulpd7v54q-uc.a.run.app';
const CF_PARA_TI = 'https://getparati-kulpd7v54q-uc.a.run.app';
const CF_BUSCAR_PORTADA = 'https://buscarportada-kulpd7v54q-uc.a.run.app';
const ENTITLEMENT_PREMIUM = 'Leemos Pro';

let Purchases = null;
let purchasesPromise = null;
if (typeof window !== 'undefined' && window.Capacitor?.isNativePlatform?.()) {
  purchasesPromise = import('@revenuecat/purchases-capacitor').then(mod => {
    Purchases = mod.Purchases;
    Purchases.configure({ apiKey: REVENUECAT_API_KEY });
    return mod.Purchases;
  }).catch(e => { console.error('RevenueCat error:', e); return null; });
}

async function comprarPremiumMensual() {
  const rc = Purchases || (purchasesPromise ? await purchasesPromise : null);
  if (!rc) return { exito: false, error: 'Purchases no disponible' };
  try {
    const offerings = await rc.getOfferings();
    const oferta = offerings.current;
    if (!oferta) return { exito: false, error: 'Sin ofertas. Verifica RevenueCat dashboard.' };
    const paquete = oferta.monthly || oferta.availablePackages?.[0];
    if (!paquete) return { exito: false, error: 'Paquete mensual no encontrado' };
    const { customerInfo } = await rc.purchasePackage({ aPackage: paquete });
    const esPremium = customerInfo.entitlements.active[ENTITLEMENT_PREMIUM] !== undefined;
    return { exito: esPremium, customerInfo };
  } catch (e) {
    if (e.code === 'PURCHASE_CANCELLED') return { exito: false, cancelado: true };
    return { exito: false, error: e.message };
  }
}

async function comprarPremiumAnual() {
  const rc = Purchases || (purchasesPromise ? await purchasesPromise : null);
  if (!rc) return { exito: false, error: 'Purchases no disponible' };
  try {
    const offerings = await rc.getOfferings();
    const oferta = offerings.current;
    if (!oferta) return { exito: false, error: 'Sin ofertas. Verifica RevenueCat dashboard.' };
    const paquete = oferta.annual || oferta.availablePackages?.find(p => p.identifier.includes('annual') || p.identifier.includes('yearly'));
    if (!paquete) return { exito: false, error: 'Paquete anual no encontrado' };
    const { customerInfo } = await rc.purchasePackage({ aPackage: paquete });
    const esPremium = customerInfo.entitlements.active[ENTITLEMENT_PREMIUM] !== undefined;
    return { exito: esPremium, customerInfo };
  } catch (e) {
    if (e.code === 'PURCHASE_CANCELLED') return { exito: false, cancelado: true };
    return { exito: false, error: e.message };
  }
}

async function restaurarCompras() {
  const rc = Purchases || (purchasesPromise ? await purchasesPromise : null);
  if (!rc) return false;
  try {
    const { customerInfo } = await rc.restorePurchases();
    return customerInfo.entitlements.active[ENTITLEMENT_PREMIUM] !== undefined;
  } catch (e) { return false; }
}

async function cancelarSuscripcion() {
  // RevenueCat no cancela directamente — redirige a Google Play
  if (typeof window !== 'undefined') {
    window.open('https://play.google.com/store/account/subscriptions', '_blank');
  }
}

async function comprobarPremiumRevenueCat(userId) {
  const rc = Purchases || (purchasesPromise ? await purchasesPromise : null);
  if (!rc) return false;
  try {
    await rc.logIn({ appUserID: userId });
    const { customerInfo } = await rc.getCustomerInfo();
    return customerInfo.entitlements.active[ENTITLEMENT_PREMIUM] !== undefined;
  } catch (e) { return false; }
}

// ── Estilos input auth ────────────────────────────────────────────────────────
const estiloInputAuth = { width: '100%', background: 'transparent', border: '1px solid #333', borderRadius: '12px', padding: '14px 16px 14px 45px', color: 'white', fontSize: '14px', outline: 'none', boxSizing: 'border-box' };
const estiloSelectAuth = { flex: 1, background: '#111', border: '1px solid #333', borderRadius: '12px', padding: '12px', color: 'white', outline: 'none', appearance: 'none', cursor: 'pointer', fontSize: '14px' };

// ── ValoracionEstrellas ───────────────────────────────────────────────────────
function ValoracionEstrellas({ libroId, userId, libro, onActividad }) {
  const [miVoto, setMiVoto] = useState(0);
  const [hover, setHover] = useState(0);
  const [totalVotos, setTotalVotos] = useState(0);
  const [mediaGlobal, setMediaGlobal] = useState(null);
  const [guardando, setGuardando] = useState(false);
  const [miReseña, setMiReseña] = useState('');
  const [reseñas, setReseñas] = useState([]);
  const [mostrarReseña, setMostrarReseña] = useState(false);
  const [textoReseña, setTextoReseña] = useState('');
  const [mostrarTodasReseñas, setMostrarTodasReseñas] = useState(false);

  useEffect(() => {
    if (!libroId || !userId) return;
    const cargar = async () => {
      try {
        const [miVotoSnap, votosSnap] = await Promise.all([
          getDoc(doc(db, "valoraciones", `${libroId}_${userId}`)),
          getDocs(query(collection(db, "valoraciones"), where("libroId", "==", libroId), limit(100))),
        ]);
        if (miVotoSnap.exists()) {
          setMiVoto(miVotoSnap.data().estrellas);
          setMiReseña(miVotoSnap.data().reseña || '');
          setTextoReseña(miVotoSnap.data().reseña || '');
        }
        const docs = votosSnap.docs.map(d => d.data());
        const votos = docs.map(d => d.estrellas);
        setTotalVotos(votos.length);
        setMediaGlobal(votos.length > 0 ? Math.round(votos.reduce((a, b) => a + b, 0) / votos.length * 10) / 10 : null);
        setReseñas(docs.filter(d => d.reseña && d.reseña.trim() && d.userId !== userId).slice(0, 5));
      } catch (e) {}
    };
    cargar();
  }, [libroId, userId]);

  const votar = async (n) => {
    if (guardando) return; setGuardando(true);
    try {
      const nuevo = miVoto === n ? 0 : n;
      if (nuevo === 0) {
        await deleteDoc(doc(db, "valoraciones", `${libroId}_${userId}`));
        const nuevosVotos = totalVotos - 1;
        setTotalVotos(nuevosVotos);
        setMediaGlobal(nuevosVotos > 0 ? Math.round(((mediaGlobal * totalVotos) - miVoto) / nuevosVotos * 10) / 10 : null);
        setMiReseña(''); setTextoReseña(''); setMostrarReseña(false);
      } else {
        await setDoc(doc(db, "valoraciones", `${libroId}_${userId}`), {
          libroId, userId, estrellas: nuevo,
          reseña: miReseña || '',
          libro: libro ? { titulo: libro.titulo, autor: libro.autor, portada: libro.portada } : null,
          fecha: serverTimestamp()
        });
        if (onActividad) onActividad();
        const suma = (mediaGlobal || 0) * totalVotos - (miVoto || 0) + nuevo;
        const nuevosVotos = miVoto ? totalVotos : totalVotos + 1;
        setTotalVotos(nuevosVotos);
        setMediaGlobal(Math.round(suma / nuevosVotos * 10) / 10);
        setMostrarReseña(true);
      }
      setMiVoto(nuevo);
    } catch (e) {}
    setGuardando(false);
  };

  const guardarReseña = async () => {
    if (!textoReseña.trim() || !miVoto) return;
    try {
      await setDoc(doc(db, "valoraciones", `${libroId}_${userId}`), {
        libroId, userId, estrellas: miVoto,
        reseña: textoReseña.trim(),
        libro: libro ? { titulo: libro.titulo, autor: libro.autor, portada: libro.portada } : null,
        fecha: serverTimestamp()
      }, { merge: true });
      setMiReseña(textoReseña.trim());
      setMostrarReseña(false);
      // Registrar en actividad_reciente para el feed
      if (libro) {
        await setDoc(doc(db, "actividad_reciente", `${userId}_resena_${libroId}`), {
          userId, libroId,
          tipo: 'resena',
          estrellas: miVoto,
          reseña: textoReseña.trim(),
          titulo: libro.titulo,
          autor: libro.autor,
          portada: libro.portada || '',
          fecha: serverTimestamp(),
        });
      }
      if (onActividad) onActividad();
    } catch (e) {}
  };

  return (
    <div style={{ margin: '15px 0' }}>
      <p style={{ fontSize: '11px', color: '#555', marginBottom: '6px', textTransform: 'uppercase', letterSpacing: '1px' }}>Tu valoración</p>
      <div style={{ display: 'flex', gap: '4px', marginBottom: '8px' }}>
        {[1,2,3,4,5].map(n => (
          <span key={n} onMouseEnter={() => setHover(n)} onMouseLeave={() => setHover(0)} onClick={() => votar(n)}
            style={{ fontSize: '24px', cursor: 'pointer', color: n <= (hover || miVoto) ? '#FFD700' : '#2a2a2a', transition: '0.15s', display: 'inline-block', transform: n <= (hover || miVoto) ? 'scale(1.15)' : 'scale(1)' }}>★</span>
        ))}
      </div>

      {/* Invitación a escribir reseña */}
      {mostrarReseña && (
        <div style={{ background: '#111', border: '1px solid #1e1e1e', borderRadius: '12px', padding: '14px', marginBottom: '12px' }}>
          <p style={{ margin: '0 0 10px', fontSize: '13px', color: 'white', fontWeight: 'bold' }}>¿Qué te ha parecido?</p>
          <textarea value={textoReseña} onChange={e => setTextoReseña(e.target.value.slice(0, 500))}
            placeholder="Comparte tu opinión con otros lectores..."
            style={{ width: '100%', background: '#0a0a0a', border: '1px solid #2a2a2a', borderRadius: '8px', padding: '10px', color: 'white', fontSize: '13px', resize: 'none', height: '90px', outline: 'none', boxSizing: 'border-box' }} />
          <div style={{ display: 'flex', gap: '8px', marginTop: '8px' }}>
            <button onClick={guardarReseña} disabled={!textoReseña.trim()}
              style={{ flex: 1, background: textoReseña.trim() ? '#1DB954' : '#1a1a1a', color: textoReseña.trim() ? 'black' : '#333', border: 'none', borderRadius: '20px', padding: '8px', cursor: textoReseña.trim() ? 'pointer' : 'default', fontWeight: 'bold', fontSize: '13px', transition: '0.2s' }}>
              Publicar
            </button>
            <button onClick={() => setMostrarReseña(false)}
              style={{ background: 'none', border: '1px solid #1e1e1e', color: '#444', borderRadius: '20px', padding: '8px 16px', cursor: 'pointer', fontSize: '13px' }}>
              Ahora no
            </button>
          </div>
        </div>
      )}

      {/* Mi reseña publicada */}
      {miReseña && !mostrarReseña && (
        <div style={{ background: '#111', border: '1px solid #1e1e1e', borderRadius: '10px', padding: '10px 14px', marginBottom: '10px', position: 'relative' }}>
          <p style={{ margin: 0, fontSize: '13px', color: '#aaa', lineHeight: '1.5', fontStyle: 'italic' }}>"{miReseña}"</p>
          <button onClick={() => setMostrarReseña(true)}
            style={{ position: 'absolute', top: '8px', right: '10px', background: 'none', border: 'none', color: '#333', cursor: 'pointer', fontSize: '11px' }}>
            Editar
          </button>
        </div>
      )}

      {/* Sin reseña — invitar sutilmente */}
      {miVoto > 0 && !miReseña && !mostrarReseña && (
        <button onClick={() => setMostrarReseña(true)}
          style={{ background: 'none', border: 'none', color: '#333', cursor: 'pointer', fontSize: '12px', padding: '0 0 8px', textDecoration: 'underline' }}>
          Añadir reseña
        </button>
      )}

      {/* Media global */}
      {mediaGlobal !== null
        ? <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
            <span style={{ color: '#FFD700', fontSize: '13px' }}>★</span>
            <span style={{ fontWeight: 'bold', fontSize: '13px' }}>{mediaGlobal}</span>
            <span style={{ color: '#444', fontSize: '12px' }}>({totalVotos})</span>
          </div>
        : <p style={{ fontSize: '12px', color: '#333', margin: 0 }}>Sin valoraciones aún</p>}

      {/* Reseñas de otros */}
      {reseñas.length > 0 && (
        <div style={{ marginTop: '16px' }}>
          <p style={{ fontSize: '11px', color: '#444', textTransform: 'uppercase', letterSpacing: '1px', margin: '0 0 10px' }}>Lo que opinan los lectores</p>
          {(mostrarTodasReseñas ? reseñas : reseñas.slice(0, 2)).map((r, i) => (
            <div key={i} style={{ borderTop: '1px solid #1a1a1a', paddingTop: '10px', marginTop: '10px' }}>
              <div style={{ display: 'flex', gap: '3px', marginBottom: '4px' }}>
                {[1,2,3,4,5].map(n => (
                  <span key={n} style={{ fontSize: '11px', color: n <= r.estrellas ? '#FFD700' : '#2a2a2a' }}>★</span>
                ))}
              </div>
              <p style={{ margin: 0, fontSize: '13px', color: '#666', lineHeight: '1.5', fontStyle: 'italic' }}>"{r.reseña}"</p>
            </div>
          ))}
          {reseñas.length > 2 && (
            <button onClick={() => setMostrarTodasReseñas(!mostrarTodasReseñas)}
              style={{ background: 'none', border: 'none', color: '#444', cursor: 'pointer', fontSize: '12px', marginTop: '8px', textDecoration: 'underline' }}>
              {mostrarTodasReseñas ? 'Ver menos' : `Ver ${reseñas.length - 2} más`}
            </button>
          )}
        </div>
      )}
    </div>
  );
}


// ── ProgresoLectura — actualiza página actual y genera actividad en feed ──────
function ProgresoLectura({ libroId, userId, libro }) {
  const [paginaActual, setPaginaActual] = useState('');
  const [totalPaginas, setTotalPaginas] = useState(null);
  const [guardando, setGuardando] = useState(false);
  const [guardado, setGuardado] = useState(false);
  const [estadoActual, setEstadoActual] = useState(null);

  useEffect(() => {
    if (!libroId || !userId) return;
    const cargar = async () => {
      try {
        const snap = await getDoc(doc(db, 'estados_lectura', `${libroId}_${userId}`));
        if (snap.exists()) {
          const d = snap.data();
          setEstadoActual(d.estado);
          if (d.paginaActual) setPaginaActual(String(d.paginaActual));
          if (d.totalPaginas) setTotalPaginas(d.totalPaginas);
        }
      } catch {}
    };
    cargar();
  }, [libroId, userId]);

  if (estadoActual !== 'leyendo') return null;

  const guardar = async () => {
    const pagina = parseInt(paginaActual);
    if (!pagina || pagina < 1) return;
    setGuardando(true);
    try {
      await setDoc(doc(db, 'estados_lectura', `${libroId}_${userId}`), {
        paginaActual: pagina,
        fechaProgreso: serverTimestamp(),
      }, { merge: true });
      await setDoc(doc(db, 'actividad_reciente', `${userId}_${libroId}_progreso`), {
        userId,
        libroId,
        titulo: libro?.titulo || '',
        autor: libro?.autor || '',
        portada: libro?.portada || '',
        tipo: 'progreso',
        paginaActual: pagina,
        totalPaginas: totalPaginas || null,
        fecha: serverTimestamp(),
      }, { merge: true });
      setGuardado(true);
      setTimeout(() => setGuardado(false), 2000);
    } catch (e) { console.error(e); }
    setGuardando(false);
  };

  const pct = totalPaginas && parseInt(paginaActual) ? Math.min(Math.round((parseInt(paginaActual) / totalPaginas) * 100), 100) : null;

  return (
    <div style={{ margin: '12px 0', background: '#111', borderRadius: '12px', padding: '12px 14px', border: '1px solid #1e1e1e' }}>
      <p style={{ fontSize: '11px', color: '#555', margin: '0 0 10px', textTransform: 'uppercase', letterSpacing: '1px' }}>¿Por qué página vas?</p>
      <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
        <input
          type="number" min="1" max={totalPaginas || 9999}
          value={paginaActual}
          onChange={e => setPaginaActual(e.target.value)}
          placeholder={totalPaginas ? `de ${totalPaginas}` : 'página...'}
          style={{ flex: 1, background: '#1a1a1a', border: '1px solid #2a2a2a', borderRadius: '8px', padding: '8px 12px', color: 'white', fontSize: '14px', outline: 'none' }}
        />
        <button onClick={guardar} disabled={guardando || !paginaActual}
          style={{ background: guardado ? '#15803d' : '#1DB954', color: 'black', border: 'none', borderRadius: '8px', padding: '8px 14px', fontWeight: 'bold', cursor: 'pointer', fontSize: '13px', transition: '0.2s', whiteSpace: 'nowrap' }}>
          {guardado ? '✓ Guardado' : guardando ? '...' : 'Actualizar'}
        </button>
      </div>
      {pct !== null && (
        <div style={{ marginTop: '10px' }}>
          <div style={{ height: '4px', background: '#1a1a1a', borderRadius: '4px', overflow: 'hidden' }}>
            <div style={{ height: '100%', width: `${pct}%`, background: '#1DB954', borderRadius: '4px', transition: '0.4s ease' }} />
          </div>
          <p style={{ margin: '4px 0 0', fontSize: '11px', color: '#1DB954', fontWeight: 'bold' }}>{pct}% completado</p>
        </div>
      )}
    </div>
  );
}


// ── EstadoLectura ─────────────────────────────────────────────────────────────
function EstadoLectura({ libroId, userId, libro, onActividad }) {
  const [estadoActual, setEstadoActual] = useState(null);
  const [guardando, setGuardando] = useState(false);
  const [animando, setAnimando] = useState(false);

  useEffect(() => {
    if (!libroId || !userId) return;
    setEstadoActual(null); // resetear mientras carga
    const cargar = async () => { try { const snap = await getDoc(doc(db, "estados_lectura", `${libroId}_${userId}`)); if (snap.exists()) setEstadoActual(snap.data().estado); } catch (e) {} };
    cargar();
  }, [libroId, userId]);

  const cambiar = async (v) => {
    if (guardando) return;
    const final = estadoActual === v ? null : v;
    setGuardando(true);
    try {
      if (final === null) {
        await deleteDoc(doc(db, "estados_lectura", `${libroId}_${userId}`));
      } else {
        // Si marca como "leyendo", intentar obtener pageCount de Google Books
        let totalPaginas = null;
        if (final === 'leyendo' && libro?.titulo) {
          try {
            const resp = await fetch(
              `https://www.googleapis.com/books/v1/volumes?q=intitle:${encodeURIComponent(libro.titulo)}&maxResults=3&key=AIzaSyDmTfy3ePtPB-LUZjMkaXQdOU2CmSGT5cU`
            );
            const data = await resp.json();
            const item = (data.items || []).find(i => i.volumeInfo?.pageCount > 10);
            if (item) totalPaginas = item.volumeInfo.pageCount;
          } catch { /* silencioso */ }
        }
        // Recuperar la sesión de lectura previa (fechaInicioLectura/fechaFinLectura) para no
        // perderla — setDoc sin merge sustituye el documento entero — y así poder pintar el
        // calendario de lectura con el rango real de cada libro.
        let prevData = null;
        try {
          const prevSnap = await getDoc(doc(db, "estados_lectura", `${libroId}_${userId}`));
          if (prevSnap.exists()) prevData = prevSnap.data();
        } catch { /* silencioso */ }

        const docData = { libroId, userId, estado: final, libro, fecha: serverTimestamp() };
        if (totalPaginas) docData.totalPaginas = totalPaginas;

        if (final === 'leyendo') {
          // Empieza una nueva sesión de lectura
          docData.fechaInicioLectura = serverTimestamp();
        } else {
          if (prevData?.fechaInicioLectura) docData.fechaInicioLectura = prevData.fechaInicioLectura;
          if (estadoActual === 'leyendo') {
            // Cierra la sesión de lectura que estaba activa
            docData.fechaFinLectura = serverTimestamp();
          } else if (prevData?.fechaFinLectura) {
            docData.fechaFinLectura = prevData.fechaFinLectura;
          }
        }

        await setDoc(doc(db, "estados_lectura", `${libroId}_${userId}`), docData);
        if (onActividad) onActividad();
        // Pedir valoración en Play Store cuando marca un libro como leído
        // Solo en nativa, solo si lleva al menos 3 libros leídos, solo una vez cada 30 días
        if (final === 'leido' && detectarNativa() && window.__InAppReview) {
          try {
            const ultimaVezKey = 'leemos_review_solicitada';
            const ultimaVez = parseInt(localStorage.getItem(ultimaVezKey) || '0');
            const hace30dias = Date.now() - 30 * 24 * 3600 * 1000;
            if (ultimaVez < hace30dias) {
              // Contar libros leídos
              const leidosSnap = await getDocs(query(collection(db, 'estados_lectura'), where('userId', '==', userId), where('estado', '==', 'leido')));
              if (leidosSnap.size >= 3) {
                setTimeout(async () => {
                  try {
                    await window.__InAppReview.requestReview();
                    localStorage.setItem(ultimaVezKey, Date.now().toString());
                  } catch {}
                }, 1500);
              }
            }
          } catch {}
        }
      }
      setEstadoActual(final);
      if (final === 'leido') {
        setAnimando(true);
        setTimeout(() => setAnimando(false), 700);
      }
    } catch (e) {}
    setGuardando(false);
  };

  // SVG icons por estado — mismo estilo que ui.jsx
  const ESTADO_ICONS = {
    quiero_leer: (color) => (
      <svg width="13" height="13" viewBox="0 0 24 24" fill={color}>
        <path d="M17 3H7c-1.1 0-1.99.9-1.99 2L5 21l7-3 7 3V5c0-1.1-.9-2-2-2zm0 15l-5-2.18L7 18V5h10v13z"/>
      </svg>
    ),
    leyendo: (color) => (
      <svg width="13" height="13" viewBox="0 0 24 24" fill={color}>
        <path d="M21 5c-1.11-.35-2.33-.5-3.5-.5-1.95 0-4.05.4-5.5 1.5-1.45-1.1-3.55-1.5-5.5-1.5S2.45 4.9 1 6v14.65c0 .25.25.5.5.5.1 0 .15-.05.25-.05C3.1 20.45 5.05 20 6.5 20c1.95 0 4.05.4 5.5 1.5 1.35-.85 3.8-1.5 5.5-1.5 1.65 0 3.35.3 4.75 1.05.1.05.15.05.25.05.25 0 .5-.25.5-.5V6c-.6-.45-1.25-.75-2-1zm0 13.5c-1.1-.35-2.3-.5-3.5-.5-1.7 0-4.15.65-5.5 1.5V8c1.35-.85 3.8-1.5 5.5-1.5 1.2 0 2.4.15 3.5.5v11.5z"/>
      </svg>
    ),
    leido: (color) => (
      <svg width="13" height="13" viewBox="0 0 24 24" fill={color}>
        <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/>
      </svg>
    ),
    dnf: (color) => (
      <svg width="13" height="13" viewBox="0 0 24 24" fill={color}>
        <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/>
      </svg>
    ),
  };

  return (
    <div style={{ margin: '15px 0' }}>
      <p style={{ fontSize: '11px', color: '#555', marginBottom: '8px', textTransform: 'uppercase', letterSpacing: '1px' }}>Estado de lectura</p>
      <div style={{ display: 'flex', gap: '6px', flexWrap: 'wrap' }}>
        {ESTADOS_LECTURA.map(e => {
          const activo = estadoActual === e.valor;
          const iconColor = activo ? 'black' : '#555';
          const celebrar = animando && e.valor === 'leido' && activo;
          return (
            <button key={e.valor} onClick={() => cambiar(e.valor)} disabled={guardando}
              style={{
                position: 'relative',
                background: activo ? e.color : 'transparent',
                color: activo ? 'black' : '#555',
                border: `1px solid ${activo ? e.color : '#2a2a2a'}`,
                borderRadius: '20px',
                padding: '6px 13px',
                fontSize: '12px',
                fontWeight: activo ? 'bold' : 'normal',
                cursor: 'pointer',
                transition: 'all 0.2s ease',
                display: 'flex', alignItems: 'center', gap: '6px',
                boxShadow: activo ? `0 0 10px ${e.color}44` : 'none',
                transform: celebrar ? 'scale(1.15)' : activo ? 'scale(1.02)' : 'scale(1)',
              }}>
              {ESTADO_ICONS[e.valor]?.(iconColor)}
              <span>{e.etiqueta}</span>
              {celebrar && [...Array(6)].map((_, i) => (
                <span key={i} style={{
                  position: 'absolute', left: '50%', top: '50%', width: '5px', height: '5px',
                  borderRadius: '50%', background: ['#FFD700','#1DB954','#fff','#FFA500','#4ade80','#FFD700'][i],
                  animation: `confeti${i} 0.6s ease-out forwards`,
                  pointerEvents: 'none',
                }} />
              ))}
            </button>
          );
        })}
      </div>
      {animando && (
        <style>{`
          @keyframes confeti0 { to { transform: translate(-22px, -18px); opacity: 0; } }
          @keyframes confeti1 { to { transform: translate(20px, -20px); opacity: 0; } }
          @keyframes confeti2 { to { transform: translate(-28px, 6px); opacity: 0; } }
          @keyframes confeti3 { to { transform: translate(26px, 8px); opacity: 0; } }
          @keyframes confeti4 { to { transform: translate(-10px, -28px); opacity: 0; } }
          @keyframes confeti5 { to { transform: translate(12px, -26px); opacity: 0; } }
        `}</style>
      )}
    </div>
  );
}

// ── BusquedaUsuarios ──────────────────────────────────────────────────────────
function BusquedaUsuarios({ userId, siguiendoA, onToggleSeguir, onVerPerfil, onCerrar }) {
  const isMobile = useIsMobile();
  const [texto, setTexto] = useState('');
  const [resultados, setResultados] = useState([]);
  const [buscando, setBuscando] = useState(false);
  const [buscado, setBuscado] = useState(false);
  const inputRef = useRef(null);
  useEffect(() => { if (inputRef.current) inputRef.current.focus(); }, []);

  const buscar = async () => {
    const t = normalizarTexto(texto);
    if (!t || t.length < 2 || buscando) return;
    setBuscando(true); setBuscado(false);
    try {
      const snap = await getDocs(query(collection(db, "users"), where("nombreNormalizado", ">=", t), where("nombreNormalizado", "<=", t + '\uf8ff'), limit(20)));
      setResultados(snap.docs.map(d => ({ id: d.id, ...d.data() })).filter(u => u.id !== userId));
    } catch (e) { setResultados([]); }
    setBuscando(false); setBuscado(true);
  };

  return (
    <div style={{ padding: isMobile ? '0 16px' : '0 32px' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '16px', margin: '40px 0 28px' }}>
        <h1 style={{ fontSize: '36px', margin: 0, flex: 1, fontWeight: 900 }}>Buscar personas</h1>
        <button onClick={onCerrar} style={{ background: 'none', border: 'none', color: '#555', fontSize: '22px', cursor: 'pointer' }}>✕</button>
      </div>
      <div style={{ display: 'flex', gap: '10px', marginBottom: '30px' }}>
        <div style={{ flex: 1, position: 'relative' }}>
          <div style={{ position: 'absolute', left: '14px', top: '50%', transform: 'translateY(-50%)', color: '#555' }}><Icon.Search /></div>
          <input ref={inputRef} placeholder="Busca por nombre..." value={texto} onChange={e => setTexto(e.target.value.slice(0, 40))} onKeyDown={e => e.key === 'Enter' && buscar()}
            style={{ width: '100%', background: '#1a1a1a', border: '1px solid #2a2a2a', borderRadius: '25px', padding: '12px 20px 12px 44px', color: 'white', outline: 'none', fontSize: '14px', boxSizing: 'border-box' }} />
        </div>
        <button onClick={buscar} disabled={buscando || texto.trim().length < 2}
          style={{ background: texto.trim().length >= 2 ? '#1DB954' : '#1a1a1a', color: texto.trim().length >= 2 ? 'black' : '#444', border: 'none', borderRadius: '25px', padding: '12px 24px', fontWeight: 'bold', cursor: texto.trim().length >= 2 ? 'pointer' : 'default', fontSize: '14px', transition: '0.2s' }}>
          {buscando ? '...' : 'Buscar'}
        </button>
      </div>
      {!buscado && <p style={{ color: '#333', fontSize: '13px', textAlign: 'center', marginTop: '80px' }}>Escribe al menos 2 caracteres</p>}
      {buscado && resultados.length === 0 && <p style={{ color: '#333', textAlign: 'center', marginTop: '80px' }}>Sin resultados</p>}
      <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
        {resultados.map(u => {
          const yaSigo = siguiendoA.includes(u.id);
          return (
            <div key={u.id} style={{ background: '#141414', borderRadius: '10px', padding: '14px 18px', display: 'flex', alignItems: 'center', gap: '14px', border: '1px solid #1e1e1e' }}>
              <Avatar src={u.foto} nombre={u.nombre} size={44} onClick={() => onVerPerfil(u)} />
              <div style={{ flex: 1, cursor: 'pointer', minWidth: 0 }} onClick={() => onVerPerfil(u)}>
                <p style={{ margin: 0, fontWeight: 'bold', fontSize: '15px' }}>{u.nombre}</p>
                <p style={{ margin: '3px 0 0', fontSize: '12px', color: '#555' }}>{u.seguidores || 0} seguidores</p>
              </div>
              <button onClick={() => onToggleSeguir(u)}
                style={{ background: yaSigo ? 'transparent' : '#1DB954', color: yaSigo ? '#888' : 'black', border: yaSigo ? '1px solid #333' : 'none', borderRadius: '20px', padding: '8px 18px', fontWeight: 'bold', cursor: 'pointer', fontSize: '13px', transition: '0.2s', flexShrink: 0 }}>
                {yaSigo ? 'Siguiendo' : 'Seguir'}
              </button>
            </div>
          );
        })}
      </div>
    </div>
  );
}

// ── PaginaLegal ───────────────────────────────────────────────────────────────
function PaginaLegal({ seccionInicial = 'terminos', onCerrar }) {
  const isMobile = useIsMobile();
  const [tab, setTab] = useState(seccionInicial);
  const S = ({ titulo, children }) => (
    <div style={{ marginBottom: '32px' }}>
      <h2 style={{ fontSize: '17px', color: '#1DB954', marginBottom: '10px', fontWeight: 'bold' }}>{titulo}</h2>
      <div style={{ color: '#888', lineHeight: '1.8', fontSize: '14px' }}>{children}</div>
    </div>
  );
  return (
    <div style={{ padding: isMobile ? '0 16px 40px' : '0 32px 60px' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '16px', margin: '40px 0 30px' }}>
        <h1 style={{ fontSize: '36px', margin: 0, flex: 1, fontWeight: 900 }}>Aviso Legal</h1>
        {onCerrar && <button onClick={onCerrar} style={{ background: '#1a1a1a', border: '1px solid #2a2a2a', color: 'white', borderRadius: '20px', padding: '8px 20px', cursor: 'pointer', fontSize: '14px' }}>Cerrar</button>}
      </div>
      <div style={{ display: 'flex', gap: '4px', marginBottom: '36px', background: '#141414', padding: '4px', borderRadius: '12px', width: 'fit-content', border: '1px solid #1e1e1e' }}>
        {['terminos', 'privacidad'].map(t => (
          <button key={t} onClick={() => setTab(t)}
            style={{ background: tab === t ? '#1DB954' : 'transparent', color: tab === t ? 'black' : '#555', border: 'none', borderRadius: '8px', padding: '10px 22px', cursor: 'pointer', fontWeight: tab === t ? 'bold' : 'normal', fontSize: '14px', transition: '0.2s' }}>
            {t === 'terminos' ? 'Términos de Uso' : 'Política de Privacidad'}
          </button>
        ))}
      </div>
      {tab === 'terminos' && (
        <div>
          <p style={{ color: '#333', fontSize: '13px', marginBottom: '32px' }}>Última actualización: mayo de 2026</p>
          <S titulo="1. Aceptación">Al registrarte y usar el Leemos, aceptas estos Términos en su totalidad.</S>
          <S titulo="2. Descripción del servicio">Leemos es una plataforma social para descubrir libros, participar en debates en tiempo real, compartir valoraciones y conectar con otros lectores. Gratuita con funciones premium opcionales.</S>
          <S titulo="3. Registro y cuenta">Debes tener al menos 14 años y proporcionar información veraz. Eres responsable de la confidencialidad de tu contraseña.</S>
          <S titulo="4. Normas de conducta"><ul style={{ paddingLeft: '20px', margin: '8px 0' }}><li style={{ marginBottom: '6px' }}>No publicar contenido ofensivo, discriminatorio o ilegal.</li><li style={{ marginBottom: '6px' }}>No hacer spam ni publicidad no solicitada.</li><li style={{ marginBottom: '6px' }}>No suplantar la identidad de otras personas.</li><li>Usar la función de spoiler cuando corresponda.</li></ul></S>
          <S titulo="5. Contenido del usuario">Los mensajes y valoraciones que publiques son de tu responsabilidad. Podemos eliminar contenido inapropiado y suspender cuentas que incumplan estas normas.</S>
          <S titulo="6. Salas y eventos">Las salas sin actividad durante más de 7 días se desactivarán automáticamente. Tras 30 días, se eliminarán permanentemente. Los eventos finalizan automáticamente tras 24h de inactividad.</S>
          <S titulo="7. Funciones premium">Algunas funciones avanzadas pueden requerir suscripción de pago. Los precios y condiciones se informarán en el momento de la contratación.</S>
          <S titulo="8. Limitación de responsabilidad">El Leemos no se hace responsable del contenido publicado por usuarios ni de daños derivados del uso del servicio.</S>
          <S titulo="9. Ley aplicable">Estos términos se rigen por la legislación española.</S>
        </div>
      )}
      {tab === 'privacidad' && (
        <div>
          <p style={{ color: '#333', fontSize: '13px', marginBottom: '32px' }}>Última actualización: mayo de 2026</p>
          <S titulo="1. Responsable">El Leemos, conforme al RGPD (UE) 2016/679 y la LOPDGDD 3/2018.</S>
          <S titulo="2. Datos que recopilamos"><ul style={{ paddingLeft: '20px', margin: '8px 0' }}><li style={{ marginBottom: '6px' }}><b style={{ color: '#ccc' }}>Registro:</b> nombre, correo, fecha de nacimiento, foto.</li><li style={{ marginBottom: '6px' }}><b style={{ color: '#ccc' }}>Actividad:</b> libros, valoraciones, salas, eventos.</li><li><b style={{ color: '#ccc' }}>Social:</b> relaciones de seguimiento.</li></ul></S>
          <S titulo="3. Finalidad">Gestionar tu cuenta, personalizar la experiencia y mantener la seguridad de la plataforma.</S>
          <S titulo="4. Compartición">No vendemos tus datos. Se almacenan en Google Firebase. Los mensajes públicos son visibles para todos los usuarios registrados.</S>
          <S titulo="5. Tus derechos">Acceso, rectificación, supresión, oposición y portabilidad. Reclamaciones ante la AEPD en www.aepd.es.</S>
          <S titulo="6. Seguridad">Autenticación segura, reglas de acceso en base de datos y TLS.</S>
          <S titulo="7. Menores">No dirigido a menores de 14 años.</S>
        </div>
      )}
    </div>
  );
}

// ── PanelAdmin ────────────────────────────────────────────────────────────────
function PanelAdmin({ onCerrar, userId, onVerPerfil }) {
  // Doble verificación — aunque App.js ya lo comprueba
  if (userId !== ADMIN_UID) return null;
  const [stats, setStats] = useState({ usuarios: 0, salasActivas: 0, salasTotal: 0, valoraciones: 0, estados: 0, alertas: 0, eventos: 0 });
  const [usuarios, setUsuarios] = useState([]);
  const [salas, setSalas] = useState([]);
  const [tabAdmin, setTabAdmin] = useState('stats');
  const [cargando, setCargando] = useState(true);
  const [confirmando, setConfirmando] = useState(null);
  const [togglingPremium, setTogglingPremium] = useState(null);
  const [accionUsuario, setAccionUsuario] = useState(null); // { tipo: 'bloquear'|'borrar', usuario }
  const [filtroActividad, setFiltroActividad] = useState(null);
  const [actividadUsuarios, setActividadUsuarios] = useState({}); // { userId: lastDate }
  const [valoracionesLista, setValoracionesLista] = useState([]);
  const [filtroValoraciones, setFiltroValoraciones] = useState('todas'); // 'todas' | 'con_resena'
  const [salaMensajesAbierta, setSalaMensajesAbierta] = useState(null); // id de la sala cuyos mensajes se muestran
  const [mensajesSala, setMensajesSala] = useState([]);
  const [cargandoMensajes, setCargandoMensajes] = useState(false);
  const [borrandoMensajeId, setBorrandoMensajeId] = useState(null);
  const [clubsLista, setClubsLista] = useState([]);
  const [cargandoClubs, setCargandoClubs] = useState(false);
  const [clubMensajesAbierto, setClubMensajesAbierto] = useState(null);
  const [mensajesClub, setMensajesClub] = useState([]);
  const [cargandoMensajesClub, setCargandoMensajesClub] = useState(false);
  const [borrandoMensajeClubId, setBorrandoMensajeClubId] = useState(null);
  const [confirmandoClub, setConfirmandoClub] = useState(null);
  const [confirmandoMiembro, setConfirmandoMiembro] = useState(null);
  const [librosAutor, setLibrosAutor] = useState([]);
  const [formLibroAutor, setFormLibroAutor] = useState({ id: null, titulo: '', autor: '', portada: '', enlaceCompra: '', autorUid: '', descripcion: '' });
  const [guardandoLibroAutor, setGuardandoLibroAutor] = useState(false);
  const [solicitudesLibro, setSolicitudesLibro] = useState([]);
  const [cargandoSolicitudesLibro, setCargandoSolicitudesLibro] = useState(false);
  const [alertasAdmin, setAlertasAdmin] = useState([]);
  const [cargandoAlertasAdmin, setCargandoAlertasAdmin] = useState(false);

  const togglePremium = async (u) => {
    setTogglingPremium(u.id);
    try {
      const nuevoPremium = !u.premium;
      await updateDoc(doc(db, 'users', u.id), { premium: nuevoPremium });
      setUsuarios(prev => prev.map(usr => usr.id === u.id ? { ...usr, premium: nuevoPremium } : usr));
    } catch (e) { console.error(e); }
    setTogglingPremium(null);
  };

  const setVerificado = async (u, tipo) => {
    // tipo: null | 'autor' | 'editorial'
    try {
      const nuevoTipo = u.verificado === tipo ? null : tipo;
      await updateDoc(doc(db, 'users', u.id), { verificado: nuevoTipo });
      setUsuarios(prev => prev.map(usr => usr.id === u.id ? { ...usr, verificado: nuevoTipo } : usr));
    } catch (e) { console.error(e); }
  };

  const bloquearUsuario = async (u) => {
    try {
      const bloqueado = !u.bloqueado;
      await updateDoc(doc(db, 'users', u.id), { bloqueado });
      setUsuarios(prev => prev.map(usr => usr.id === u.id ? { ...usr, bloqueado } : usr));
    } catch (e) { console.error(e); }
    setAccionUsuario(null);
  };

  const borrarUsuario = async (u) => {
    try {
      // Colecciones con campo userId
      const colsUserId = [
        'estados_lectura', 'valoraciones', 'actividad_reciente',
        'retos', 'sesiones_lectura', 'citas'
      ];
      for (const col of colsUserId) {
        try {
          const snap = await getDocs(query(collection(db, col), where('userId', '==', u.id)));
          for (const d of snap.docs) await deleteDoc(d.ref).catch(() => {});
        } catch { }
      }

      // Relaciones (seguidor/seguido)
      const segSnap = await getDocs(query(collection(db, 'relaciones'), where('seguidorId', '==', u.id))).catch(() => ({ docs: [] }));
      for (const d of segSnap.docs) await deleteDoc(d.ref).catch(() => {});
      const segdoSnap = await getDocs(query(collection(db, 'relaciones'), where('seguidoId', '==', u.id))).catch(() => ({ docs: [] }));
      for (const d of segdoSnap.docs) await deleteDoc(d.ref).catch(() => {});

      // Alertas (destinatario/emisor)
      const alertasSnap = await getDocs(query(collection(db, 'alertas'), where('destinatarioId', '==', u.id))).catch(() => ({ docs: [] }));
      for (const d of alertasSnap.docs) await deleteDoc(d.ref).catch(() => {});
      const alertasEnvSnap = await getDocs(query(collection(db, 'alertas'), where('emisorId', '==', u.id))).catch(() => ({ docs: [] }));
      for (const d of alertasEnvSnap.docs) await deleteDoc(d.ref).catch(() => {});

      // Buddy reads (usuarioA o usuarioB)
      try {
        const buddyASnap = await getDocs(query(collection(db, 'buddy_reads'), where('usuarioA.id', '==', u.id)));
        for (const d of buddyASnap.docs) await deleteDoc(d.ref).catch(() => {});
        const buddyBSnap = await getDocs(query(collection(db, 'buddy_reads'), where('usuarioB.id', '==', u.id)));
        for (const d of buddyBSnap.docs) await deleteDoc(d.ref).catch(() => {});
      } catch { }

      // Documentos únicos por userId
      const docsUnicos = [
        doc(db, 'user_stats', u.id),
        doc(db, 'stats_timer', u.id),
        doc(db, 'tbr_plan', u.id),
        doc(db, 'fcm_tokens', u.id),
      ];
      for (const ref of docsUnicos) await deleteDoc(ref).catch(() => {});

      // stats_timer_libro — doc ID: {userId}_{libroId}
      try {
        const timerLibroSnap = await getDocs(query(collection(db, 'stats_timer_libro'), where('userId', '==', u.id)));
        for (const d of timerLibroSnap.docs) await deleteDoc(d.ref).catch(() => {});
      } catch { }

      // Subcolecciones miembros de salas
      try {
        const salasSnap = await getDocs(query(collection(db, 'salas_info')));
        for (const salaDoc of salasSnap.docs) {
          await deleteDoc(doc(db, 'salas', salaDoc.id, 'miembros', u.id)).catch(() => {});
        }
      } catch { }

      // Documento principal del usuario — siempre al final
      await deleteDoc(doc(db, 'users', u.id));
      setUsuarios(prev => prev.filter(usr => usr.id !== u.id));
    } catch (e) {
      console.error('Error borrando usuario:', e);
      alert('Error al borrar el usuario: ' + e.message);
    }
    setAccionUsuario(null);
  };

  useEffect(() => {
    const cargar = async () => {
      setCargando(true);
      try {
        const { getCountFromServer } = await import('firebase/firestore');
        // Cargar usuarios y salas primero — crítico para el panel
        const [usersSnap, salasSnap, salasActivasSnap] = await Promise.all([
          getDocs(query(collection(db, "users"), limit(200))),
          getDocs(query(collection(db, "salas_info"), limit(100))),
          getDocs(query(collection(db, "salas_info"), where("activa", "==", true))),
        ]);
        const usersData = usersSnap.docs.map(d => ({ id: d.id, ...d.data() }));
        setUsuarios(usersData);

        // Cargar última actividad de cada usuario
        const actividadMap = {};
        try {
          const actSnap = await getDocs(query(collection(db, 'actividad_reciente'), limit(500)));
          actSnap.docs.forEach(d => {
            const data = d.data();
            if (!data.userId) return;
            const fecha = data.fecha?.toDate?.();
            if (!fecha) return;
            if (!actividadMap[data.userId] || fecha > actividadMap[data.userId]) {
              actividadMap[data.userId] = fecha;
            }
          });
        } catch {}
        setActividadUsuarios(actividadMap);
        setSalas(salasSnap.docs.map(d => ({ id: d.id, ...d.data() })).sort((a, b) => (b.ultimaActividad?.toDate?.() || 0) - (a.ultimaActividad?.toDate?.() || 0)));

        // Cargar valoraciones completas (con reseña si la tienen), más recientes primero
        try {
          const valSnap = await getDocs(query(collection(db, 'valoraciones'), orderBy('fecha', 'desc'), limit(300)));
          setValoracionesLista(valSnap.docs.map(d => ({ id: d.id, ...d.data() })));
        } catch (e) { console.error('Error cargando valoraciones:', e); }

        // Cargar libros de autores indie (portadas custom gestionadas a mano)
        // Nota: se guardan dentro de portadas_cache con el campo esIndie:true,
        // en vez de en una colección propia "libros_autor" — Firestore devolvía
        // permission-denied de forma persistente en cualquier colección nueva
        // creada en este proyecto (confirmado con soporte de Firebase), así que
        // reutilizamos una colección existente que sí funciona correctamente.
        try {
          const libAutorSnap = await getDocs(query(collection(db, 'portadas_cache'), where('esIndie', '==', true)));
          setLibrosAutor(libAutorSnap.docs.map(d => ({ id: d.id, ...d.data() })));
        } catch (e) { console.error('Error cargando libros de autor:', e); }

        // Cargar conteos — no crítico, puede fallar individualmente
        const [valCount, estadosCount, alertasCount, eventosCount] = await Promise.all([
          getCountFromServer(collection(db, "valoraciones")).catch(() => ({ data: () => ({ count: '?' }) })),
          getCountFromServer(collection(db, "estados_lectura")).catch(() => ({ data: () => ({ count: '?' }) })),
          getCountFromServer(query(collection(db, "alertas"), where("leida", "==", false))).catch(() => ({ data: () => ({ count: '?' }) })),
          getCountFromServer(query(collection(db, "eventos"), where("activo", "==", true))).catch(() => ({ data: () => ({ count: '?' }) })),
        ]);
        setStats({ usuarios: usersSnap.size, salasActivas: salasActivasSnap.size, salasTotal: salasSnap.size, valoraciones: valCount.data().count, estados: estadosCount.data().count, alertas: alertasCount.data().count, eventos: eventosCount.data().count });
      } catch (e) { console.error(e); }
      setCargando(false);
    };
    cargar();
  }, []);

  const borrarSala = async (id) => {
    try {
      // Borrar mensajes
      const msgs = await getDocs(collection(db, "salas", id, "mensajes"));
      for (const m of msgs.docs) await deleteDoc(m.ref);
      // Borrar miembros
      const miembros = await getDocs(collection(db, "salas", id, "miembros"));
      for (const m of miembros.docs) await deleteDoc(m.ref);
      // Borrar sala
      await deleteDoc(doc(db, "salas_info", id));
      setSalas(prev => prev.filter(s => s.id !== id));
    } catch (e) {
      console.error("Error borrando sala:", e);
      alert("Error al borrar la sala. Inténtalo de nuevo.");
    }
    setConfirmando(null);
  };
  const desactivarSala = async (id) => {
    try { await updateDoc(doc(db, "salas_info", id), { activa: false }); setSalas(prev => prev.map(s => s.id === id ? { ...s, activa: false } : s)); } catch (e) { console.error(e); }
  };

  // Ver mensajes de una sala — para poder borrar uno concreto sin borrar la sala entera
  const verMensajesSala = async (salaId) => {
    if (salaMensajesAbierta === salaId) { setSalaMensajesAbierta(null); setMensajesSala([]); return; }
    setSalaMensajesAbierta(salaId);
    setCargandoMensajes(true);
    try {
      const snap = await getDocs(query(collection(db, 'salas', salaId, 'mensajes'), orderBy('fecha', 'desc'), limit(200)));
      setMensajesSala(snap.docs.map(d => ({ id: d.id, ...d.data() })));
    } catch (e) {
      console.error('Error cargando mensajes:', e);
      setMensajesSala([]);
    }
    setCargandoMensajes(false);
  };

  // Borrar un único mensaje — para casos de insultos/spam sin tener que borrar toda la sala
  const borrarMensajeIndividual = async (salaId, mensajeId) => {
    setBorrandoMensajeId(mensajeId);
    try {
      await deleteDoc(doc(db, 'salas', salaId, 'mensajes', mensajeId));
      setMensajesSala(prev => prev.filter(m => m.id !== mensajeId));
    } catch (e) {
      console.error('Error borrando mensaje:', e);
      alert('Error al borrar el mensaje. Inténtalo de nuevo.');
    }
    setBorrandoMensajeId(null);
  };

  // Cargar todos los clubs — solo al entrar en la pestaña, no en la carga inicial del panel
  const cargarClubsAdmin = async () => {
    setCargandoClubs(true);
    try {
      const snap = await getDocs(query(collection(db, 'clubs'), limit(200)));
      setClubsLista(snap.docs.map(d => ({ id: d.id, ...d.data() })));
    } catch (e) { console.error('Error cargando clubs:', e); }
    setCargandoClubs(false);
  };

  const verMensajesClub = async (clubId) => {
    if (clubMensajesAbierto === clubId) { setClubMensajesAbierto(null); setMensajesClub([]); return; }
    setClubMensajesAbierto(clubId);
    setCargandoMensajesClub(true);
    try {
      const snap = await getDocs(query(collection(db, 'clubs', clubId, 'mensajes'), orderBy('fecha', 'desc'), limit(200)));
      setMensajesClub(snap.docs.map(d => ({ id: d.id, ...d.data() })));
    } catch (e) {
      console.error('Error cargando mensajes del club:', e);
      setMensajesClub([]);
    }
    setCargandoMensajesClub(false);
  };

  const borrarMensajeClub = async (clubId, mensajeId) => {
    setBorrandoMensajeClubId(mensajeId);
    try {
      await deleteDoc(doc(db, 'clubs', clubId, 'mensajes', mensajeId));
      setMensajesClub(prev => prev.filter(m => m.id !== mensajeId));
    } catch (e) {
      console.error('Error borrando mensaje del club:', e);
      alert('Error al borrar el mensaje. Inténtalo de nuevo.');
    }
    setBorrandoMensajeClubId(null);
  };

  const borrarClubAdmin = async (clubId) => {
    try {
      const mensajesSnap = await getDocs(collection(db, 'clubs', clubId, 'mensajes'));
      for (const m of mensajesSnap.docs) await deleteDoc(m.ref);
      const votacionesSnap = await getDocs(collection(db, 'clubs', clubId, 'votaciones'));
      for (const v of votacionesSnap.docs) await deleteDoc(v.ref);
      await deleteDoc(doc(db, 'clubs', clubId));
      await deleteDoc(doc(db, 'clubs_publicos', clubId)).catch(() => {});
      setClubsLista(prev => prev.filter(c => c.id !== clubId));
    } catch (e) {
      console.error('Error borrando club:', e);
      alert('Error al borrar el club. Inténtalo de nuevo.');
    }
    setConfirmandoClub(null);
  };

  const expulsarMiembroClub = async (club, miembroId) => {
    try {
      const miembroInfo = (club.miembrosInfo || []).find(m => m.id === miembroId);
      await updateDoc(doc(db, 'clubs', club.id), {
        miembros: arrayRemove(miembroId),
        ...(miembroInfo ? { miembrosInfo: arrayRemove(miembroInfo) } : {}),
      });
      setClubsLista(prev => prev.map(c => c.id === club.id
        ? { ...c, miembros: (c.miembros || []).filter(id => id !== miembroId), miembrosInfo: (c.miembrosInfo || []).filter(m => m.id !== miembroId) }
        : c));
    } catch (e) {
      console.error('Error expulsando miembro:', e);
      alert('Error al expulsar al miembro. Inténtalo de nuevo.');
    }
    setConfirmandoMiembro(null);
  };

  // Guardar (crear o editar) un libro de autor indie con portada custom
  const guardarLibroAutor = async () => {
    if (!formLibroAutor.titulo.trim() || !formLibroAutor.autor.trim() || !formLibroAutor.portada.trim()) {
      alert('Título, autor y portada son obligatorios.');
      return;
    }
    setGuardandoLibroAutor(true);
    try {
      const libroId = formLibroAutor.id || generarIdLibro(formLibroAutor.titulo, formLibroAutor.autor);
      const data = {
        titulo: formLibroAutor.titulo.trim(),
        autor: formLibroAutor.autor.trim(),
        portada: formLibroAutor.portada.trim(),
        enlaceCompra: formLibroAutor.enlaceCompra.trim() || null,
        autorUid: formLibroAutor.autorUid.trim() || null,
        descripcion: formLibroAutor.descripcion.trim() || '',
        esIndie: true,
        actualizadoEn: serverTimestamp(),
      };
      await setDoc(doc(db, 'portadas_cache', libroId), data, { merge: true });
      setLibrosAutor(prev => {
        const existe = prev.find(l => l.id === libroId);
        if (existe) return prev.map(l => l.id === libroId ? { id: libroId, ...data } : l);
        return [...prev, { id: libroId, ...data }];
      });
      setFormLibroAutor({ id: null, titulo: '', autor: '', portada: '', enlaceCompra: '', autorUid: '', descripcion: '' });
    } catch (e) {
      console.error('Error guardando libro de autor:', e);
      alert('Error al guardar. Inténtalo de nuevo.');
    }
    setGuardandoLibroAutor(false);
  };

  const borrarLibroAutor = async (libroId) => {
    try {
      await deleteDoc(doc(db, 'portadas_cache', libroId));
      setLibrosAutor(prev => prev.filter(l => l.id !== libroId));
    } catch (e) { console.error('Error borrando libro de autor:', e); }
  };

  // Cargar solicitudes de publicación de libro pendientes
  const cargarAlertasAdmin = async () => {
    setCargandoAlertasAdmin(true);
    try {
      const snap = await getDocs(query(collection(db, 'alertas'), orderBy('fecha', 'desc'), limit(100)));
      setAlertasAdmin(snap.docs.map(d => ({ id: d.id, ...d.data() })));
    } catch (e) { console.error(e); }
    setCargandoAlertasAdmin(false);
  };

  const cargarSolicitudesLibro = async () => {
    setCargandoSolicitudesLibro(true);
    try {
      const snap = await getDocs(query(collection(db, 'solicitudes_libro'), orderBy('fechaSolicitud', 'desc'), limit(100)));
      setSolicitudesLibro(snap.docs.map(d => ({ id: d.id, ...d.data() })));
    } catch (e) { console.error('Error cargando solicitudes de libro:', e); }
    setCargandoSolicitudesLibro(false);
  };

  const aprobarSolicitudLibro = async (solicitud) => {
    try {
      const libroId = generarIdLibro(solicitud.titulo, solicitud.nombreAutor);
      await setDoc(doc(db, 'portadas_cache', libroId), {
        titulo: solicitud.titulo, autor: solicitud.nombreAutor,
        portada: solicitud.portada, enlaceCompra: solicitud.enlaceCompra || null,
        autorUid: solicitud.autorUid, descripcion: solicitud.descripcion || '',
        esIndie: true, actualizadoEn: serverTimestamp(),
      }, { merge: true });
      await updateDoc(doc(db, 'solicitudes_libro', solicitud.id), { estado: 'aprobado', revisadoEn: serverTimestamp() });
      // Notificar al autor
      await addDoc(collection(db, 'alertas'), {
        tipo: 'libro_aprobado', emisorId: ADMIN_UID, emisorNombre: 'Leemos',
        destinatarioId: solicitud.autorUid, libro: solicitud.titulo,
        fecha: serverTimestamp(), leida: false,
      });
      setSolicitudesLibro(prev => prev.map(s => s.id === solicitud.id ? { ...s, estado: 'aprobado' } : s));
      setLibrosAutor(prev => [...prev, { id: libroId, titulo: solicitud.titulo, autor: solicitud.nombreAutor, portada: solicitud.portada }]);
      showToast(`"${solicitud.titulo}" aprobado y publicado`, 'ok');
    } catch (e) { console.error('Error aprobando libro:', e); alert('Error al aprobar. Inténtalo de nuevo.'); }
  };

  const rechazarSolicitudLibro = async (solicitud, motivo = '') => {
    try {
      await updateDoc(doc(db, 'solicitudes_libro', solicitud.id), { estado: 'rechazado', motivo, revisadoEn: serverTimestamp() });
      await addDoc(collection(db, 'alertas'), {
        tipo: 'libro_rechazado', emisorId: ADMIN_UID, emisorNombre: 'Leemos',
        destinatarioId: solicitud.autorUid, libro: solicitud.titulo, motivo,
        fecha: serverTimestamp(), leida: false,
      });
      setSolicitudesLibro(prev => prev.map(s => s.id === solicitud.id ? { ...s, estado: 'rechazado' } : s));
      showToast(`Solicitud de "${solicitud.titulo}" rechazada`, 'ok');
    } catch (e) { console.error('Error rechazando libro:', e); }
  };

  // Filtrar usuarios por actividad
  const ahora = Date.now();
  const usuariosFiltrados = usuarios.filter(u => {
    if (filtroActividad === null) return true;
    if (filtroActividad === -2) return !u.onboardingCompletado; // sin onboarding
    const ultima = actividadUsuarios[u.id];
    if (filtroActividad === -1) return !ultima || (ahora - ultima.getTime()) > 30 * 24 * 3600 * 1000; // +30 días sin actividad
    if (!ultima) return false;
    return (ahora - ultima.getTime()) <= filtroActividad;
  }).sort((a, b) => {
    const fa = actividadUsuarios[a.id]?.getTime() || 0;
    const fb = actividadUsuarios[b.id]?.getTime() || 0;
    return fb - fa; // más recientes primero
  });

  const formatearUltimaActividad = (userId) => {
    const fecha = actividadUsuarios[userId];
    if (!fecha) return 'Sin actividad registrada';
    const diff = ahora - fecha.getTime();
    const seg = Math.floor(diff / 1000);
    const min = Math.floor(seg / 60);
    const h = Math.floor(min / 60);
    const dias = Math.floor(h / 24);
    const semanas = Math.floor(dias / 7);
    const meses = Math.floor(dias / 30);
    if (seg < 60) return 'Hace unos segundos';
    if (min < 60) return `Hace ${min} min`;
    if (h < 24) return `Hace ${h}h`;
    if (dias < 7) return `Hace ${dias} día${dias > 1 ? 's' : ''}`;
    if (semanas < 4) return `Hace ${semanas} semana${semanas > 1 ? 's' : ''}`;
    return `Hace ${meses} mes${meses > 1 ? 'es' : ''}`;
  };

  const StatCard = ({ emoji, valor, label, color }) => (
    <div style={{ background: '#141414', borderRadius: '12px', padding: '20px 24px', border: '1px solid #1e1e1e' }}>
      <div style={{ fontSize: '26px', marginBottom: '6px' }}>{emoji}</div>
      <div style={{ fontSize: '30px', fontWeight: 900, color }}>{valor}</div>
      <div style={{ fontSize: '12px', color: '#444', marginTop: '4px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>{label}</div>
    </div>
  );

  return (
    <div style={{ padding: '0 32px' }}>
      {/* Modal confirmación bloqueo/borrado */}
      {accionUsuario && (
        <div className="modal-overlay" onClick={() => setAccionUsuario(null)}>
          <div className="modal-content" onClick={e => e.stopPropagation()}>
            <h3 style={{ margin: '0 0 12px', fontSize: '20px', fontWeight: 900, color: accionUsuario.tipo === 'borrar' ? '#f44336' : '#ff9800' }}>
              {accionUsuario.tipo === 'borrar' ? 'Borrar usuario' : accionUsuario.usuario.bloqueado ? 'Desbloquear usuario' : 'Bloquear usuario'}
            </h3>
            <p style={{ color: '#888', fontSize: '14px', margin: '0 0 8px' }}>
              <b style={{ color: 'white' }}>{accionUsuario.usuario.nombre}</b>
            </p>
            <p style={{ color: '#555', fontSize: '13px', margin: '0 0 24px', lineHeight: '1.6' }}>
              {accionUsuario.tipo === 'borrar'
                ? 'Esta acción borrará permanentemente al usuario y todos sus datos: valoraciones, estados de lectura, relaciones y actividad. No se puede deshacer.'
                : accionUsuario.usuario.bloqueado
                  ? 'El usuario podrá volver a iniciar sesión.'
                  : 'El usuario verá un mensaje de cuenta bloqueada al intentar entrar.'}
            </p>
            <div style={{ display: 'flex', gap: '10px' }}>
              <button onClick={() => accionUsuario.tipo === 'borrar' ? borrarUsuario(accionUsuario.usuario) : bloquearUsuario(accionUsuario.usuario)}
                style={{ flex: 1, background: accionUsuario.tipo === 'borrar' ? '#f44336' : '#ff9800', color: 'white', border: 'none', borderRadius: '10px', padding: '12px', fontWeight: 'bold', cursor: 'pointer', fontSize: '14px' }}>
                {accionUsuario.tipo === 'borrar' ? 'Borrar definitivamente' : accionUsuario.usuario.bloqueado ? 'Desbloquear' : 'Bloquear'}
              </button>
              <button onClick={() => setAccionUsuario(null)}
                style={{ flex: 1, background: 'transparent', color: '#555', border: '1px solid #2a2a2a', borderRadius: '10px', padding: '12px', cursor: 'pointer', fontSize: '14px' }}>
                Cancelar
              </button>
            </div>
          </div>
        </div>
      )}

      <div style={{ display: 'flex', alignItems: 'center', gap: '16px', margin: '40px 0 30px' }}>
        <div><h1 style={{ fontSize: '36px', margin: 0, fontWeight: 900 }}>Panel Admin</h1><p style={{ color: '#333', margin: '4px 0 0', fontSize: '13px' }}>Acceso restringido</p></div>
        <button onClick={onCerrar} style={{ marginLeft: 'auto', background: '#1a1a1a', border: '1px solid #2a2a2a', color: 'white', borderRadius: '20px', padding: '8px 20px', cursor: 'pointer', fontSize: '14px' }}>Cerrar</button>
      </div>
      <div style={{ display: 'flex', gap: '4px', marginBottom: '30px', background: '#141414', padding: '4px', borderRadius: '12px', width: 'fit-content', border: '1px solid #1e1e1e' }}>
        {[{ id: 'stats', label: 'Estadísticas' }, { id: 'usuarios', label: 'Usuarios' }, { id: 'salas', label: 'Salas' }, { id: 'clubsadmin', label: 'Clubs' }, { id: 'solicitudes', label: 'Solicitudes' }, { id: 'valoraciones', label: 'Valoraciones' }, { id: 'autores', label: 'Autores' }, { id: 'invitaciones', label: 'Invitaciones' }, { id: 'alertasadmin', label: '🔔 Alertas' }].map(t => (
          <button key={t.id} onClick={() => setTabAdmin(t.id)}
            style={{ background: tabAdmin === t.id ? '#1DB954' : 'transparent', color: tabAdmin === t.id ? 'black' : '#555', border: 'none', borderRadius: '8px', padding: '8px 18px', cursor: 'pointer', fontWeight: tabAdmin === t.id ? 'bold' : 'normal', fontSize: '13px', transition: '0.2s' }}>
            {t.label}
          </button>
        ))}
      </div>
      {cargando ? <p style={{ color: '#333', textAlign: 'center', marginTop: '60px' }}>Cargando...</p> : (
        <>
          {tabAdmin === 'stats' && (
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(155px, 1fr))', gap: '12px' }}>
              <StatCard emoji="👤" valor={stats.usuarios} label="Usuarios" color="#1DB954" />
              <StatCard emoji="💬" valor={stats.salasActivas} label="Salas activas" color="#1DB954" />
              <StatCard emoji="📅" valor={stats.eventos} label="Eventos activos" color="#1DB954" />
              <StatCard emoji="🗂️" valor={stats.salasTotal} label="Salas totales" color="#888" />
              <StatCard emoji="⭐" valor={stats.valoraciones} label="Valoraciones" color="#FFD700" />
              <StatCard emoji="📚" valor={stats.estados} label="Estados" color="#2196F3" />
              <StatCard emoji="🔔" valor={stats.alertas} label="Alertas" color="#f44336" />
            </div>
          )}
          {tabAdmin === 'usuarios' && (
            <div>
              {/* Filtros de actividad */}
              <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap', marginBottom: '16px', alignItems: 'center' }}>
                <p style={{ color: '#444', fontSize: '12px', margin: 0 }}>
                  {usuarios.filter(u => u.premium).length} premium · {usuarios.length} total
                </p>
                <div style={{ marginLeft: 'auto', display: 'flex', gap: '6px', flexWrap: 'wrap' }}>
                  {[
                    { label: 'Todos', valor: null },
                    { label: 'Hoy', valor: 60 * 60 * 24 * 1000 },
                    { label: 'Esta semana', valor: 60 * 60 * 24 * 7 * 1000 },
                    { label: 'Este mes', valor: 60 * 60 * 24 * 30 * 1000 },
                    { label: '+30 días sin actividad', valor: -1 },
                    { label: 'Sin onboarding', valor: -2 },
                  ].map(f => (
                    <button key={f.label}
                      onClick={() => setFiltroActividad(f.valor)}
                      style={{
                        background: filtroActividad === f.valor ? '#1DB954' : 'transparent',
                        color: filtroActividad === f.valor ? 'black' : '#555',
                        border: filtroActividad === f.valor ? 'none' : '1px solid #2a2a2a',
                        borderRadius: '20px', padding: '4px 12px', cursor: 'pointer',
                        fontSize: '11px', fontWeight: filtroActividad === f.valor ? 'bold' : 'normal',
                        transition: '0.15s',
                      }}>
                      {f.label}
                    </button>
                  ))}
                </div>
              </div>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                {usuariosFiltrados.map(u => (
                  <div key={u.id} style={{ background: '#141414', borderRadius: '10px', padding: '12px 16px', display: 'flex', alignItems: 'center', gap: '12px', border: u.premium ? '1px solid #a78bfa44' : u.id === ADMIN_UID ? '1px solid #1DB95444' : '1px solid #1e1e1e' }}>
                    <div
                      onClick={() => onVerPerfil && onVerPerfil(u)}
                      style={{ display: 'flex', alignItems: 'center', gap: '12px', flex: 1, minWidth: 0, cursor: onVerPerfil ? 'pointer' : 'default' }}
                      title="Ver perfil"
                    >
                      <Avatar src={u.foto} nombre={u.nombre} size={38} />
                      <div style={{ flex: 1, minWidth: 0 }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '6px', flexWrap: 'wrap' }}>
                          <b style={{ fontSize: '14px' }}>{u.nombre}</b>
                          {u.id === ADMIN_UID && <span style={{ background: '#1DB954', color: 'black', fontSize: '10px', padding: '1px 6px', borderRadius: '8px', fontWeight: 'bold' }}>ADMIN</span>}
                          {u.premium && <span style={{ background: 'linear-gradient(135deg, #6a3fa0, #a78bfa)', color: 'white', fontSize: '10px', padding: '1px 6px', borderRadius: '8px', fontWeight: 'bold' }}>PREMIUM</span>}
                          {u.verificado === 'autor' && <span style={{ background: '#0ea5e922', color: '#0ea5e9', fontSize: '10px', padding: '1px 6px', borderRadius: '8px', fontWeight: 'bold', border: '1px solid #0ea5e944' }}>✓ Autor</span>}
                          {u.verificado === 'editorial' && <span style={{ background: '#f59e0b22', color: '#f59e0b', fontSize: '10px', padding: '1px 6px', borderRadius: '8px', fontWeight: 'bold', border: '1px solid #f59e0b44' }}>✓ Editorial</span>}
                        </div>
                        <p style={{ margin: '2px 0 0', fontSize: '11px', color: '#333', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{u.id}</p>
                        <p style={{ margin: '2px 0 0', fontSize: '11px', color: '#444' }}>{u.seguidores || 0} seguidores · {u.siguiendo || 0} siguiendo</p>
                        <p style={{ margin: '2px 0 0', fontSize: '11px', color: actividadUsuarios[u.id] ? '#1DB95488' : '#f4433688', display: 'flex', alignItems: 'center', gap: '4px' }}>
                          <svg width="9" height="9" viewBox="0 0 24 24" fill="currentColor"><path d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm.5-13H11v6l5.25 3.15.75-1.23-4.5-2.67V7z"/></svg>
                          {formatearUltimaActividad(u.id)}
                          {!u.onboardingCompletado && <span style={{ background: '#ff980022', color: '#ff9800', fontSize: '9px', padding: '1px 5px', borderRadius: '6px', fontWeight: 'bold', border: '1px solid #ff980033' }}>Sin onboarding</span>}
                        </p>
                      </div>
                    </div>
                    {(
                      <div style={{ display: 'flex', gap: '6px', flexShrink: 0, flexDirection: 'column', alignItems: 'flex-end' }}>
                        <button onClick={() => togglePremium(u)} disabled={togglingPremium === u.id}
                          style={{ background: u.premium ? 'linear-gradient(135deg, #6a3fa0, #a78bfa)' : 'transparent', color: u.premium ? 'white' : '#555', border: u.premium ? 'none' : '1px solid #2a2a2a', borderRadius: '20px', padding: '5px 12px', cursor: 'pointer', fontSize: '11px', fontWeight: 'bold', transition: '0.2s', opacity: togglingPremium === u.id ? 0.5 : 1, whiteSpace: 'nowrap' }}>
                          {togglingPremium === u.id ? '...' : u.premium ? '✦ Premium' : 'Activar Premium'}
                        </button>
                        <div style={{ display: 'flex', gap: '4px' }}>
                          <button onClick={() => setVerificado(u, 'autor')}
                            style={{ background: u.verificado === 'autor' ? '#0ea5e922' : 'transparent', color: u.verificado === 'autor' ? '#0ea5e9' : '#555', border: `1px solid ${u.verificado === 'autor' ? '#0ea5e944' : '#2a2a2a'}`, borderRadius: '12px', padding: '4px 10px', cursor: 'pointer', fontSize: '11px', whiteSpace: 'nowrap' }}>
                            ✓ Autor
                          </button>
                          <button onClick={() => setVerificado(u, 'editorial')}
                            style={{ background: u.verificado === 'editorial' ? '#f59e0b22' : 'transparent', color: u.verificado === 'editorial' ? '#f59e0b' : '#555', border: `1px solid ${u.verificado === 'editorial' ? '#f59e0b44' : '#2a2a2a'}`, borderRadius: '12px', padding: '4px 10px', cursor: 'pointer', fontSize: '11px', whiteSpace: 'nowrap' }}>
                            ✓ Editorial
                          </button>
                        </div>
                        <div style={{ display: 'flex', gap: '4px' }}>
                          <button onClick={() => setAccionUsuario({ tipo: 'bloquear', usuario: u })}
                            style={{ background: u.bloqueado ? '#ff980022' : 'transparent', color: u.bloqueado ? '#ff9800' : '#555', border: `1px solid ${u.bloqueado ? '#ff980044' : '#2a2a2a'}`, borderRadius: '12px', padding: '4px 10px', cursor: 'pointer', fontSize: '11px', whiteSpace: 'nowrap' }}>
                            {u.bloqueado ? 'Bloqueado' : 'Bloquear'}
                          </button>
                          <button onClick={() => setAccionUsuario({ tipo: 'borrar', usuario: u })}
                            style={{ background: 'transparent', color: '#f44336', border: '1px solid #f4433633', borderRadius: '12px', padding: '4px 10px', cursor: 'pointer', fontSize: '11px' }}>
                            Borrar
                          </button>
                        </div>
                      </div>
                    )}
                  </div>
                ))}
              </div>
            </div>
          )}
          {tabAdmin === 'salas' && (
            <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
              {salas.map(s => {
                const fecha = s.ultimaActividad?.toDate?.();
                const mensajesAbiertos = salaMensajesAbierta === s.id;
                return (
                  <div key={s.id} style={{ background: '#141414', borderRadius: '10px', padding: '12px 16px', border: '1px solid #1e1e1e' }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '6px' }}>
                      <span style={{ background: s.activa ? '#1DB95422' : '#2a2a2a', color: s.activa ? '#1DB954' : '#555', fontSize: '10px', padding: '2px 8px', borderRadius: '8px', fontWeight: 'bold' }}>{s.activa ? 'ACTIVA' : 'INACTIVA'}</span>
                      <span style={{ fontSize: '12px', color: '#444', flex: 1, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{s.id}</span>
                    </div>
                    {fecha && <p style={{ margin: '0 0 8px', fontSize: '11px', color: '#333' }}>{fecha.toLocaleDateString('es-ES', { day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' })}</p>}
                    <div style={{ display: 'flex', gap: '6px' }}>
                      <button onClick={() => verMensajesSala(s.id)}
                        style={{ background: mensajesAbiertos ? '#1DB95422' : 'transparent', color: mensajesAbiertos ? '#1DB954' : '#555', border: `1px solid ${mensajesAbiertos ? '#1DB95444' : '#2a2a2a'}`, borderRadius: '8px', padding: '4px 10px', cursor: 'pointer', fontSize: '12px' }}>
                        {mensajesAbiertos ? 'Ocultar mensajes' : 'Ver mensajes'}
                      </button>
                      {s.activa && <button onClick={() => desactivarSala(s.id)} style={{ background: 'transparent', color: '#ff9800', border: '1px solid #ff980033', borderRadius: '8px', padding: '4px 10px', cursor: 'pointer', fontSize: '12px' }}>Desactivar</button>}
                      {confirmando === s.id
                        ? <><span style={{ fontSize: '12px', color: '#f44336', display: 'flex', alignItems: 'center', gap: '6px' }}>¿Borrar?
                            <button onClick={() => borrarSala(s.id)} style={{ background: '#f44336', color: 'white', border: 'none', borderRadius: '8px', padding: '4px 10px', cursor: 'pointer', fontSize: '12px', fontWeight: 'bold' }}>Sí</button>
                            <button onClick={() => setConfirmando(null)} style={{ background: 'transparent', color: '#555', border: 'none', cursor: 'pointer', fontSize: '12px' }}>No</button>
                          </span></>
                        : <button onClick={() => setConfirmando(s.id)} style={{ background: 'transparent', color: '#f44336', border: '1px solid #f4433633', borderRadius: '8px', padding: '4px 10px', cursor: 'pointer', fontSize: '12px' }}>Borrar</button>}
                    </div>

                    {/* Lista de mensajes individuales — para borrar un mensaje concreto sin borrar la sala */}
                    {mensajesAbiertos && (
                      <div style={{ marginTop: '12px', paddingTop: '12px', borderTop: '1px solid #1e1e1e', display: 'flex', flexDirection: 'column', gap: '6px', maxHeight: '320px', overflowY: 'auto' }}>
                        {cargandoMensajes && <p style={{ color: '#333', fontSize: '12px', textAlign: 'center', margin: '8px 0' }}>Cargando mensajes...</p>}
                        {!cargandoMensajes && mensajesSala.length === 0 && (
                          <p style={{ color: '#333', fontSize: '12px', textAlign: 'center', margin: '8px 0' }}>Esta sala no tiene mensajes.</p>
                        )}
                        {!cargandoMensajes && mensajesSala.map(m => {
                          const fechaMsg = m.fecha?.toDate?.();
                          return (
                            <div key={m.id} style={{ background: '#0a0a0a', borderRadius: '8px', padding: '8px 10px', display: 'flex', alignItems: 'flex-start', gap: '8px' }}>
                              <div style={{ flex: 1, minWidth: 0 }}>
                                <p style={{ margin: 0, fontSize: '11px', color: '#555', fontWeight: 'bold' }}>
                                  {m.sender?.nombre || 'Usuario'}
                                  {fechaMsg && <span style={{ color: '#333', fontWeight: 'normal', marginLeft: '6px' }}>{fechaMsg.toLocaleString('es-ES', { day: '2-digit', month: 'short', hour: '2-digit', minute: '2-digit' })}</span>}
                                </p>
                                <p style={{ margin: '2px 0 0', fontSize: '13px', color: '#ccc', wordBreak: 'break-word' }}>{m.texto || '(sin texto)'}</p>
                              </div>
                              <button onClick={() => borrarMensajeIndividual(s.id, m.id)} disabled={borrandoMensajeId === m.id}
                                style={{ background: 'transparent', color: '#f44336', border: '1px solid #f4433633', borderRadius: '8px', padding: '4px 8px', cursor: 'pointer', fontSize: '11px', flexShrink: 0, opacity: borrandoMensajeId === m.id ? 0.5 : 1 }}>
                                {borrandoMensajeId === m.id ? '...' : 'Borrar'}
                              </button>
                            </div>
                          );
                        })}
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          )}

          {tabAdmin === 'clubsadmin' && (
            <div>
              {clubsLista.length === 0 && !cargandoClubs && (
                <div style={{ textAlign: 'center', padding: '30px 0' }}>
                  <button onClick={cargarClubsAdmin} className="btn-verde" style={{ width: 'auto', margin: 0, padding: '10px 24px' }}>
                    Cargar clubs
                  </button>
                </div>
              )}
              {cargandoClubs && <p style={{ color: '#333', textAlign: 'center', padding: '30px 0', fontSize: '13px' }}>Cargando clubs...</p>}
              {clubsLista.length > 0 && (
                <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                  {clubsLista.map(club => {
                    const mensajesAbiertos = clubMensajesAbierto === club.id;
                    return (
                      <div key={club.id} style={{ background: '#141414', borderRadius: '10px', padding: '12px 16px', border: club.verificado ? '1px solid #0ea5e944' : '1px solid #1e1e1e' }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '8px' }}>
                          <div style={{ flex: 1, minWidth: 0 }}>
                            <p style={{ margin: 0, fontSize: '14px', fontWeight: 'bold', display: 'flex', alignItems: 'center', gap: '6px' }}>
                              {club.nombre}
                              {club.verificado && <span style={{ background: '#0ea5e922', color: '#0ea5e9', fontSize: '9px', padding: '1px 6px', borderRadius: '6px', fontWeight: 'bold' }}>✦ {club.verificado === 'autor' ? 'AUTOR' : 'EDITORIAL'}</span>}
                            </p>
                            <p style={{ margin: '2px 0 0', fontSize: '11px', color: '#555' }}>
                              {club.miembros?.length || 0} miembros · Creado por {club.creadorNombre || club.creadorId}
                            </p>
                          </div>
                        </div>

                        {/* Miembros con opción de expulsar */}
                        {club.miembrosInfo?.length > 0 && (
                          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '6px', marginBottom: '10px' }}>
                            {club.miembrosInfo.map(m => (
                              <div key={m.id} style={{ display: 'flex', alignItems: 'center', gap: '6px', background: '#0a0a0a', borderRadius: '14px', padding: '4px 6px 4px 10px', fontSize: '11px' }}>
                                <span style={{ color: m.id === club.creadorId ? '#0ea5e9' : '#aaa' }}>{m.nombre}{m.id === club.creadorId ? ' (admin)' : ''}</span>
                                {m.id !== club.creadorId && (
                                  confirmandoMiembro === `${club.id}_${m.id}` ? (
                                    <span style={{ display: 'flex', gap: '4px' }}>
                                      <button onClick={() => expulsarMiembroClub(club, m.id)} style={{ background: '#f44336', color: 'white', border: 'none', borderRadius: '10px', padding: '2px 8px', cursor: 'pointer', fontSize: '10px', fontWeight: 'bold' }}>Sí</button>
                                      <button onClick={() => setConfirmandoMiembro(null)} style={{ background: 'none', border: 'none', color: '#555', cursor: 'pointer', fontSize: '10px' }}>No</button>
                                    </span>
                                  ) : (
                                    <button onClick={() => setConfirmandoMiembro(`${club.id}_${m.id}`)} style={{ background: 'none', border: 'none', color: '#f44336', cursor: 'pointer', fontSize: '13px', padding: 0, lineHeight: 1 }} title="Expulsar">✕</button>
                                  )
                                )}
                              </div>
                            ))}
                          </div>
                        )}

                        <div style={{ display: 'flex', gap: '6px' }}>
                          <button onClick={() => verMensajesClub(club.id)}
                            style={{ background: mensajesAbiertos ? '#1DB95422' : 'transparent', color: mensajesAbiertos ? '#1DB954' : '#555', border: `1px solid ${mensajesAbiertos ? '#1DB95444' : '#2a2a2a'}`, borderRadius: '8px', padding: '4px 10px', cursor: 'pointer', fontSize: '12px' }}>
                            {mensajesAbiertos ? 'Ocultar mensajes' : 'Ver mensajes'}
                          </button>
                          {confirmandoClub === club.id ? (
                            <span style={{ fontSize: '12px', color: '#f44336', display: 'flex', alignItems: 'center', gap: '6px' }}>¿Borrar club?
                              <button onClick={() => borrarClubAdmin(club.id)} style={{ background: '#f44336', color: 'white', border: 'none', borderRadius: '8px', padding: '4px 10px', cursor: 'pointer', fontSize: '12px', fontWeight: 'bold' }}>Sí</button>
                              <button onClick={() => setConfirmandoClub(null)} style={{ background: 'none', color: '#555', border: 'none', cursor: 'pointer', fontSize: '12px' }}>No</button>
                            </span>
                          ) : (
                            <button onClick={() => setConfirmandoClub(club.id)} style={{ background: 'transparent', color: '#f44336', border: '1px solid #f4433633', borderRadius: '8px', padding: '4px 10px', cursor: 'pointer', fontSize: '12px' }}>Borrar club</button>
                          )}
                        </div>

                        {mensajesAbiertos && (
                          <div style={{ marginTop: '12px', paddingTop: '12px', borderTop: '1px solid #1e1e1e', display: 'flex', flexDirection: 'column', gap: '6px', maxHeight: '320px', overflowY: 'auto' }}>
                            {cargandoMensajesClub && <p style={{ color: '#333', fontSize: '12px', textAlign: 'center', margin: '8px 0' }}>Cargando mensajes...</p>}
                            {!cargandoMensajesClub && mensajesClub.length === 0 && (
                              <p style={{ color: '#333', fontSize: '12px', textAlign: 'center', margin: '8px 0' }}>Este club no tiene mensajes.</p>
                            )}
                            {!cargandoMensajesClub && mensajesClub.map(m => {
                              const fechaMsg = m.fecha?.toDate?.();
                              return (
                                <div key={m.id} style={{ background: '#0a0a0a', borderRadius: '8px', padding: '8px 10px', display: 'flex', alignItems: 'flex-start', gap: '8px' }}>
                                  <div style={{ flex: 1, minWidth: 0 }}>
                                    <p style={{ margin: 0, fontSize: '11px', color: '#555', fontWeight: 'bold' }}>
                                      {m.sender?.nombre || 'Usuario'}
                                      {fechaMsg && <span style={{ color: '#333', fontWeight: 'normal', marginLeft: '6px' }}>{fechaMsg.toLocaleString('es-ES', { day: '2-digit', month: 'short', hour: '2-digit', minute: '2-digit' })}</span>}
                                    </p>
                                    <p style={{ margin: '2px 0 0', fontSize: '13px', color: '#ccc', wordBreak: 'break-word' }}>{m.texto || '(sin texto)'}</p>
                                  </div>
                                  <button onClick={() => borrarMensajeClub(club.id, m.id)} disabled={borrandoMensajeClubId === m.id}
                                    style={{ background: 'transparent', color: '#f44336', border: '1px solid #f4433633', borderRadius: '8px', padding: '4px 8px', cursor: 'pointer', fontSize: '11px', flexShrink: 0, opacity: borrandoMensajeClubId === m.id ? 0.5 : 1 }}>
                                    {borrandoMensajeClubId === m.id ? '...' : 'Borrar'}
                                  </button>
                                </div>
                              );
                            })}
                          </div>
                        )}
                      </div>
                    );
                  })}
                </div>
              )}
            </div>
          )}

          {tabAdmin === 'solicitudes' && (
            <div>
              {solicitudesLibro.length === 0 && !cargandoSolicitudesLibro && (
                <div style={{ textAlign: 'center', padding: '30px 0' }}>
                  <button onClick={cargarSolicitudesLibro} className="btn-verde" style={{ width: 'auto', margin: 0, padding: '10px 24px' }}>
                    Cargar solicitudes
                  </button>
                </div>
              )}
              {cargandoSolicitudesLibro && <p style={{ color: '#333', textAlign: 'center', padding: '30px 0', fontSize: '13px' }}>Cargando solicitudes...</p>}
              {solicitudesLibro.length > 0 && (
                <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                  {/* Pendientes primero */}
                  {['pendiente', 'aprobado', 'rechazado'].map(estado => {
                    const grupo = solicitudesLibro.filter(s => s.estado === estado);
                    if (grupo.length === 0) return null;
                    return (
                      <div key={estado}>
                        <p style={{ fontSize: '11px', color: estado === 'pendiente' ? '#f59e0b' : estado === 'aprobado' ? '#1DB954' : '#f44336', textTransform: 'uppercase', letterSpacing: '1px', margin: '0 0 8px', fontWeight: 'bold' }}>
                          {estado === 'pendiente' ? `⏳ Pendientes (${grupo.length})` : estado === 'aprobado' ? `✅ Aprobados (${grupo.length})` : `❌ Rechazados (${grupo.length})`}
                        </p>
                        {grupo.map(s => (
                          <div key={s.id} style={{ background: '#141414', borderRadius: '12px', padding: '14px 16px', border: `1px solid ${estado === 'pendiente' ? '#f59e0b33' : estado === 'aprobado' ? '#1DB95433' : '#f4433633'}`, marginBottom: '8px' }}>
                            <div style={{ display: 'flex', gap: '12px', alignItems: 'flex-start' }}>
                              {s.portada && (
                                <img src={s.portada} alt="" style={{ width: '48px', height: '68px', objectFit: 'cover', borderRadius: '4px', flexShrink: 0 }} onError={e => e.currentTarget.style.display = 'none'} />
                              )}
                              <div style={{ flex: 1, minWidth: 0 }}>
                                <p style={{ margin: '0 0 2px', fontSize: '14px', fontWeight: 'bold', color: 'white' }}>{s.titulo}</p>
                                <p style={{ margin: '0 0 2px', fontSize: '12px', color: '#555' }}>por {s.nombreAutor}</p>
                                <p style={{ margin: '0 0 4px', fontSize: '11px', color: '#444' }}>Solicitado por: {s.autorNombre} · {s.fechaSolicitud?.toDate?.()?.toLocaleDateString('es-ES') || '—'}</p>
                                {s.descripcion && <p style={{ margin: '0 0 4px', fontSize: '12px', color: '#666', lineHeight: '1.5' }}>{s.descripcion}</p>}
                                {s.enlaceCompra && <a href={s.enlaceCompra} target="_blank" rel="noopener noreferrer" style={{ fontSize: '11px', color: '#0ea5e9' }}>🔗 Ver enlace de compra</a>}
                                {s.portada && (
                                  <div style={{ marginTop: '4px' }}>
                                    <a href={s.portada} target="_blank" rel="noopener noreferrer" style={{ fontSize: '11px', color: '#555' }}>🖼 Ver portada completa</a>
                                  </div>
                                )}
                              </div>
                            </div>
                            {estado === 'pendiente' && (
                              <div style={{ display: 'flex', gap: '8px', marginTop: '12px' }}>
                                <button onClick={() => aprobarSolicitudLibro(s)}
                                  className="btn-verde" style={{ width: 'auto', margin: 0, padding: '7px 18px', fontSize: '13px' }}>
                                  ✅ Aprobar y publicar
                                </button>
                                <button onClick={() => {
                                  const motivo = window.prompt(`Motivo del rechazo para "${s.titulo}" (opcional):`);
                                  if (motivo !== null) rechazarSolicitudLibro(s, motivo);
                                }}
                                  style={{ background: 'transparent', color: '#f44336', border: '1px solid #f4433633', borderRadius: '20px', padding: '7px 18px', cursor: 'pointer', fontSize: '13px', fontWeight: 'bold' }}>
                                  ❌ Rechazar
                                </button>
                              </div>
                            )}
                            {estado === 'rechazado' && s.motivo && (
                              <p style={{ margin: '8px 0 0', fontSize: '11px', color: '#f44336' }}>Motivo: {s.motivo}</p>
                            )}
                          </div>
                        ))}
                      </div>
                    );
                  })}
                </div>
              )}
            </div>
          )}

          {tabAdmin === 'valoraciones' && (
            <div>
              <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap', marginBottom: '16px', alignItems: 'center' }}>
                <p style={{ color: '#444', fontSize: '12px', margin: 0 }}>
                  {valoracionesLista.filter(v => v.reseña && v.reseña.trim()).length} con reseña · {valoracionesLista.length} total
                </p>
                <div style={{ marginLeft: 'auto', display: 'flex', gap: '6px' }}>
                  {[{ label: 'Todas', valor: 'todas' }, { label: 'Solo con reseña', valor: 'con_resena' }].map(f => (
                    <button key={f.valor} onClick={() => setFiltroValoraciones(f.valor)}
                      style={{
                        background: filtroValoraciones === f.valor ? '#1DB954' : 'transparent',
                        color: filtroValoraciones === f.valor ? 'black' : '#555',
                        border: filtroValoraciones === f.valor ? 'none' : '1px solid #2a2a2a',
                        borderRadius: '20px', padding: '4px 12px', cursor: 'pointer',
                        fontSize: '11px', fontWeight: filtroValoraciones === f.valor ? 'bold' : 'normal',
                      }}>
                      {f.label}
                    </button>
                  ))}
                </div>
              </div>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                {valoracionesLista
                  .filter(v => filtroValoraciones === 'todas' || (v.reseña && v.reseña.trim()))
                  .map(v => {
                    const autorValoracion = usuarios.find(u => u.id === v.userId);
                    const fecha = v.fecha?.toDate?.();
                    return (
                      <div key={v.id} style={{ background: '#141414', borderRadius: '10px', padding: '12px 16px', border: '1px solid #1e1e1e' }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: v.reseña ? '8px' : 0 }}>
                          {v.libro?.portada && <img src={v.libro.portada} alt="" style={{ width: '28px', height: '40px', objectFit: 'cover', borderRadius: '4px', flexShrink: 0 }} />}
                          <div style={{ flex: 1, minWidth: 0 }}>
                            <p style={{ margin: 0, fontSize: '13px', fontWeight: 'bold', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{v.libro?.titulo || 'Libro desconocido'}</p>
                            <p style={{ margin: '2px 0 0', fontSize: '11px', color: '#555' }}>
                              {'★'.repeat(v.estrellas || 0)}{'☆'.repeat(5 - (v.estrellas || 0))}
                              <span style={{ marginLeft: '8px' }}>
                                {onVerPerfil
                                  ? <span onClick={() => onVerPerfil(autorValoracion || { id: v.userId })} style={{ color: '#1DB954', cursor: 'pointer' }}>{autorValoracion?.nombre || v.userId}</span>
                                  : (autorValoracion?.nombre || v.userId)}
                              </span>
                              {fecha && <span style={{ marginLeft: '8px', color: '#333' }}>{fecha.toLocaleDateString('es-ES', { day: '2-digit', month: 'short', year: 'numeric' })}</span>}
                            </p>
                          </div>
                        </div>
                        {v.reseña && v.reseña.trim() && (
                          <p style={{ margin: 0, fontSize: '13px', color: '#aaa', lineHeight: '1.5', background: '#0a0a0a', borderRadius: '8px', padding: '10px 12px' }}>{v.reseña}</p>
                        )}
                      </div>
                    );
                  })}
                {valoracionesLista.filter(v => filtroValoraciones === 'todas' || (v.reseña && v.reseña.trim())).length === 0 && (
                  <p style={{ color: '#333', textAlign: 'center', padding: '30px 0', fontSize: '13px' }}>No hay valoraciones que mostrar.</p>
                )}
              </div>
            </div>
          )}

          {tabAdmin === 'autores' && (
            <div>
              {/* Solicitudes de publicación pendientes */}
              <div style={{ background: '#0a1620', border: '1px solid #0ea5e933', borderRadius: '12px', padding: '16px', marginBottom: '20px' }}>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '12px' }}>
                  <p style={{ margin: 0, fontSize: '13px', fontWeight: 900, color: '#0ea5e9' }}>
                    📚 Solicitudes de publicación
                    {solicitudesLibro.filter(s => s.estado === 'pendiente').length > 0 && (
                      <span style={{ background: '#0ea5e9', color: 'white', fontSize: '10px', borderRadius: '10px', padding: '1px 8px', marginLeft: '8px', fontWeight: 'bold' }}>
                        {solicitudesLibro.filter(s => s.estado === 'pendiente').length} pendientes
                      </span>
                    )}
                  </p>
                  <button onClick={cargarSolicitudesLibro} disabled={cargandoSolicitudesLibro}
                    style={{ background: 'transparent', border: '1px solid #0ea5e944', color: '#0ea5e9', borderRadius: '8px', padding: '4px 12px', cursor: 'pointer', fontSize: '12px' }}>
                    {cargandoSolicitudesLibro ? 'Cargando...' : solicitudesLibro.length === 0 ? 'Cargar' : 'Actualizar'}
                  </button>
                </div>

                {solicitudesLibro.length === 0 && !cargandoSolicitudesLibro && (
                  <p style={{ color: '#333', fontSize: '12px', margin: 0, textAlign: 'center', padding: '8px 0' }}>Pulsa "Cargar" para ver las solicitudes pendientes</p>
                )}

                {solicitudesLibro.length > 0 && (
                  <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                    {solicitudesLibro.map(sol => (
                      <div key={sol.id} style={{ background: '#0d1a24', borderRadius: '10px', padding: '12px', border: `1px solid ${sol.estado === 'pendiente' ? '#0ea5e933' : sol.estado === 'aprobado' ? '#1DB95433' : '#f4433633'}` }}>
                        <div style={{ display: 'flex', gap: '12px', alignItems: 'flex-start' }}>
                          {sol.portada && (
                            <img src={sol.portada} alt="" style={{ width: '48px', height: '68px', objectFit: 'cover', borderRadius: '4px', flexShrink: 0 }}
                              onError={e => e.currentTarget.style.display = 'none'} />
                          )}
                          <div style={{ flex: 1, minWidth: 0 }}>
                            <p style={{ margin: '0 0 2px', fontSize: '14px', fontWeight: 'bold', color: 'white' }}>{sol.titulo}</p>
                            <p style={{ margin: '0 0 2px', fontSize: '12px', color: '#555' }}>por {sol.nombreAutor}</p>
                            <p style={{ margin: '0 0 6px', fontSize: '11px', color: '#444' }}>
                              Solicitado por: {sol.autorNombreApp} · {sol.fechaSolicitud?.toDate?.()?.toLocaleDateString('es-ES') || '—'}
                            </p>
                            {sol.descripcion && <p style={{ margin: '0 0 6px', fontSize: '12px', color: '#666', lineHeight: 1.5 }}>{sol.descripcion}</p>}
                            {sol.enlaceCompra && (
                              <a href={sol.enlaceCompra} target="_blank" rel="noopener noreferrer"
                                style={{ fontSize: '11px', color: '#0ea5e9', textDecoration: 'none' }}>🔗 {sol.enlaceCompra.slice(0, 40)}...</a>
                            )}
                            <div style={{ marginTop: '8px', display: 'flex', gap: '6px', alignItems: 'center', flexWrap: 'wrap' }}>
                              {sol.estado === 'pendiente' ? (<>
                                <button onClick={() => aprobarSolicitudLibro(sol)}
                                  className="btn-verde" style={{ width: 'auto', margin: 0, padding: '6px 14px', fontSize: '12px' }}>
                                  ✓ Aprobar y publicar
                                </button>
                                <button onClick={() => {
                                  const motivo = prompt('Motivo del rechazo (opcional):') ?? '';
                                  rechazarSolicitudLibro(sol, motivo);
                                }}
                                  style={{ background: 'transparent', color: '#f44336', border: '1px solid #f4433644', borderRadius: '8px', padding: '6px 14px', cursor: 'pointer', fontSize: '12px' }}>
                                  ✕ Rechazar
                                </button>
                              </>) : (
                                <span style={{ fontSize: '11px', fontWeight: 'bold', color: sol.estado === 'aprobado' ? '#1DB954' : '#f44336' }}>
                                  {sol.estado === 'aprobado' ? '✓ Aprobado' : '✕ Rechazado'}
                                </span>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </div>

              <p style={{ color: '#444', fontSize: '12px', margin: '0 0 16px', lineHeight: '1.6' }}>
                Añade aquí libros de autores verificados que no aparecen en Google Books. La portada se sube como URL de imagen (puedes subir la imagen a Firebase Storage o usar cualquier enlace directo a imagen). Estos libros aparecerán en el buscador de la app con su portada real.
              </p>

              {/* Formulario crear/editar */}
              <div style={{ background: '#141414', borderRadius: '12px', padding: '18px', border: '1px solid #1e1e1e', marginBottom: '20px' }}>
                <p style={{ margin: '0 0 14px', fontSize: '13px', fontWeight: 'bold', color: 'white' }}>
                  {formLibroAutor.id ? 'Editando libro' : 'Añadir nuevo libro'}
                </p>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px', marginBottom: '10px' }}>
                  <input className="input-modal" placeholder="Título del libro" style={{ marginTop: 0 }}
                    value={formLibroAutor.titulo} onChange={e => setFormLibroAutor(p => ({ ...p, titulo: e.target.value }))} />
                  <input className="input-modal" placeholder="Nombre del autor" style={{ marginTop: 0 }}
                    value={formLibroAutor.autor} onChange={e => setFormLibroAutor(p => ({ ...p, autor: e.target.value }))} />
                </div>
                <input className="input-modal" placeholder="URL de la portada (imagen)" style={{ marginTop: 0, marginBottom: '10px' }}
                  value={formLibroAutor.portada} onChange={e => setFormLibroAutor(p => ({ ...p, portada: e.target.value }))} />
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px', marginBottom: '10px' }}>
                  <input className="input-modal" placeholder="Enlace de compra (opcional)" style={{ marginTop: 0 }}
                    value={formLibroAutor.enlaceCompra} onChange={e => setFormLibroAutor(p => ({ ...p, enlaceCompra: e.target.value }))} />
                  <input className="input-modal" placeholder="UID del autor en Leemos (opcional)" style={{ marginTop: 0 }}
                    value={formLibroAutor.autorUid} onChange={e => setFormLibroAutor(p => ({ ...p, autorUid: e.target.value }))} />
                </div>
                <textarea className="input-modal" placeholder="Sinopsis breve (opcional)" style={{ marginTop: 0, height: '60px', resize: 'none' }}
                  value={formLibroAutor.descripcion} onChange={e => setFormLibroAutor(p => ({ ...p, descripcion: e.target.value }))} />
                <div style={{ display: 'flex', gap: '8px', marginTop: '12px' }}>
                  <button onClick={guardarLibroAutor} disabled={guardandoLibroAutor} className="btn-verde" style={{ width: 'auto', margin: 0, padding: '10px 20px' }}>
                    {guardandoLibroAutor ? 'Guardando...' : formLibroAutor.id ? 'Guardar cambios' : 'Añadir libro'}
                  </button>
                  {formLibroAutor.id && (
                    <button onClick={() => setFormLibroAutor({ id: null, titulo: '', autor: '', portada: '', enlaceCompra: '', autorUid: '', descripcion: '' })}
                      className="btn-outline" style={{ width: 'auto', marginTop: 0, padding: '10px 20px' }}>
                      Cancelar
                    </button>
                  )}
                </div>
              </div>

              {/* Lista de libros ya añadidos */}
              <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                {librosAutor.map(libro => (
                  <div key={libro.id} style={{ background: '#141414', borderRadius: '10px', padding: '12px 16px', border: '1px solid #1e1e1e', display: 'flex', alignItems: 'center', gap: '12px' }}>
                    {libro.portada && <img src={libro.portada} alt="" style={{ width: '36px', height: '52px', objectFit: 'cover', borderRadius: '4px', flexShrink: 0 }} />}
                    <div style={{ flex: 1, minWidth: 0 }}>
                      <p style={{ margin: 0, fontSize: '13px', fontWeight: 'bold', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{libro.titulo}</p>
                      <p style={{ margin: '2px 0 0', fontSize: '12px', color: '#555' }}>{libro.autor}</p>
                    </div>
                    <button onClick={() => setFormLibroAutor({ id: libro.id, titulo: libro.titulo, autor: libro.autor, portada: libro.portada, enlaceCompra: libro.enlaceCompra || '', autorUid: libro.autorUid || '', descripcion: libro.descripcion || '' })}
                      style={{ background: 'transparent', color: '#0ea5e9', border: '1px solid #0ea5e944', borderRadius: '8px', padding: '5px 12px', cursor: 'pointer', fontSize: '12px' }}>
                      Editar
                    </button>
                    <button onClick={() => borrarLibroAutor(libro.id)}
                      style={{ background: 'transparent', color: '#f44336', border: '1px solid #f4433633', borderRadius: '8px', padding: '5px 12px', cursor: 'pointer', fontSize: '12px' }}>
                      Borrar
                    </button>
                  </div>
                ))}
                {librosAutor.length === 0 && (
                  <p style={{ color: '#333', textAlign: 'center', padding: '30px 0', fontSize: '13px' }}>Aún no has añadido ningún libro de autor.</p>
                )}
              </div>
            </div>
          )}

          {tabAdmin === 'alertasadmin' && (
          <div>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '16px' }}>
              <p style={{ fontWeight: 900, fontSize: '16px', margin: 0, color: 'white' }}>Alertas del sistema</p>
              <button onClick={cargarAlertasAdmin} disabled={cargandoAlertasAdmin}
                style={{ background: '#1DB954', color: 'black', border: 'none', borderRadius: '8px', padding: '8px 16px', cursor: 'pointer', fontWeight: 'bold', fontSize: '12px' }}>
                {cargandoAlertasAdmin ? 'Cargando...' : alertasAdmin.length === 0 ? 'Cargar alertas' : 'Actualizar'}
              </button>
            </div>
            {alertasAdmin.length === 0 && !cargandoAlertasAdmin && (
              <div style={{ textAlign: 'center', padding: '40px 0' }}>
                <p style={{ color: '#333', fontSize: '13px' }}>Pulsa "Cargar alertas" para ver las alertas</p>
              </div>
            )}
            {cargandoAlertasAdmin && <p style={{ color: '#333', textAlign: 'center', padding: '30px 0', fontSize: '13px' }}>Cargando alertas...</p>}
            {alertasAdmin.length > 0 && (
              <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                {alertasAdmin.map(a => {
                  const tipoColor = {
                    solicitud_club: '#a78bfa',
                    respuesta_solicitud_club: '#38bdf8',
                    solicitud_libro: '#f59e0b',
                    libro_aprobado: '#1DB954',
                    libro_rechazado: '#f44336',
                    nuevo_seguidor: '#fb7185',
                    invitacion_sala: '#38bdf8',
                  }[a.tipo] || '#555';
                  const fecha = a.fecha?.toDate ? a.fecha.toDate().toLocaleString('es-ES', { day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit' }) : '—';
                  return (
                    <div key={a.id} style={{ background: '#111', borderRadius: '10px', padding: '12px 14px', border: `1px solid ${tipoColor}33`, display: 'flex', gap: '12px', alignItems: 'flex-start' }}>
                      <span style={{ background: `${tipoColor}20`, color: tipoColor, borderRadius: '6px', padding: '3px 8px', fontSize: '10px', fontWeight: 'bold', flexShrink: 0, marginTop: '2px' }}>
                        {a.tipo || 'desconocido'}
                      </span>
                      <div style={{ flex: 1, minWidth: 0 }}>
                        <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap', marginBottom: '4px' }}>
                          {a.emisorNombre && <span style={{ fontSize: '12px', color: '#aaa' }}>De: <b style={{ color: 'white' }}>{a.emisorNombre}</b></span>}
                          {a.destinatarioId && <span style={{ fontSize: '12px', color: '#555' }}>→ {a.destinatarioId.slice(0, 8)}...</span>}
                        </div>
                        {a.libro && <p style={{ margin: '0 0 2px', fontSize: '12px', color: '#888' }}>📚 {a.libro}</p>}
                        {a.club && <p style={{ margin: '0 0 2px', fontSize: '12px', color: '#888' }}>👥 {a.club}</p>}
                        {a.motivo && <p style={{ margin: '0 0 2px', fontSize: '11px', color: '#f44336' }}>{a.motivo}</p>}
                      </div>
                      <span style={{ fontSize: '11px', color: '#333', flexShrink: 0 }}>{fecha}</span>
                    </div>
                  );
                })}
              </div>
            )}
          </div>
        )}

        {tabAdmin === 'invitaciones' && (
            <TabInvitaciones />
          )}

        </>
      )}
    </div>
  );
}

// ── TabInvitaciones — panel admin ─────────────────────────────────────────────
function TabInvitaciones() {
  const [invitaciones, setInvitaciones] = React.useState([]);
  const [cargando, setCargando] = React.useState(true);

  React.useEffect(() => {
    getDocs(query(collection(db, 'invitaciones'), orderBy('fecha', 'desc'), limit(100)))
      .then(snap => {
        setInvitaciones(snap.docs.map(d => ({ id: d.id, ...d.data() })));
        setCargando(false);
      }).catch(() => setCargando(false));
  }, []);

  const marcarPremiado = async (id) => {
    await updateDoc(doc(db, 'invitaciones', id), { premiado: true }).catch(() => {});
    setInvitaciones(prev => prev.map(i => i.id === id ? { ...i, premiado: true } : i));
  };

  if (cargando) return <p style={{ color: '#555' }}>Cargando...</p>;
  if (!invitaciones.length) return <p style={{ color: '#555' }}>No hay invitaciones registradas aún.</p>;

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
      <p style={{ color: '#555', fontSize: '13px', margin: '0 0 16px' }}>{invitaciones.length} invitación{invitaciones.length !== 1 ? 'es' : ''} registrada{invitaciones.length !== 1 ? 's' : ''}</p>
      {invitaciones.map(inv => (
        <div key={inv.id} style={{ background: '#141414', borderRadius: '10px', padding: '12px 16px', border: `1px solid ${inv.premiado ? '#1DB95433' : '#1e1e1e'}`, display: 'flex', alignItems: 'center', gap: '12px' }}>
          <div style={{ flex: 1 }}>
            <p style={{ margin: '0 0 2px', fontSize: '13px', color: 'white', fontWeight: 'bold' }}>
              {inv.invitadorNombre} <span style={{ color: '#555', fontWeight: 'normal' }}>invitó a</span> {inv.invitadoNombre}
            </p>
            <p style={{ margin: 0, fontSize: '11px', color: '#333' }}>
              {inv.fecha?.toDate?.().toLocaleDateString('es-ES', { day: '2-digit', month: 'short', year: 'numeric' }) || ''}
            </p>
          </div>
          {inv.premiado
            ? <span style={{ background: '#1DB95422', color: '#1DB954', fontSize: '11px', padding: '3px 10px', borderRadius: '8px', fontWeight: 'bold', flexShrink: 0 }}>Premiado ✓</span>
            : inv.activado
              ? <button onClick={() => marcarPremiado(inv.id)}
                  style={{ background: 'transparent', color: '#1DB954', border: '1px solid #1DB95433', borderRadius: '8px', padding: '5px 12px', cursor: 'pointer', fontSize: '12px', flexShrink: 0 }}>
                  Premiar
                </button>
              : <span style={{ background: '#f59e0b22', color: '#f59e0b', fontSize: '11px', padding: '3px 10px', borderRadius: '8px', fontWeight: 'bold', flexShrink: 0 }}>
                  {inv.diasActivo || 0}/3 días
                </span>
          }
        </div>
      ))}
    </div>
  );
}

// ── PantallaAuth ──────────────────────────────────────────────────────────────
// Descarga foto de Google y la sube a Firebase Storage (URL permanente)
const urlToStorageUrl = async (url, uid) => {
  try {
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 8000);
    const resp = await fetch(url, { signal: controller.signal });
    clearTimeout(timeout);
    const blob = await resp.blob();
    return await new Promise((res, rej) => {
      const img = new window.Image();
      const objectUrl = URL.createObjectURL(blob);
      img.onload = () => {
        const canvas = document.createElement('canvas');
        const MAX = 400;
        const ratio = Math.min(MAX / img.width, MAX / img.height, 1);
        canvas.width = img.width * ratio;
        canvas.height = img.height * ratio;
        canvas.getContext('2d').drawImage(img, 0, 0, canvas.width, canvas.height);
        URL.revokeObjectURL(objectUrl);
        canvas.toBlob(async (b) => {
          try {
            const storageRef = ref(storage, `avatars/${uid}/perfil.jpg`);
            await uploadBytes(storageRef, b, { contentType: 'image/jpeg' });
            const downloadURL = await getDownloadURL(storageRef);
            res(downloadURL);
          } catch { rej(); }
        }, 'image/jpeg', 0.82);
      };
      img.onerror = () => { URL.revokeObjectURL(objectUrl); rej(); };
      img.src = objectUrl;
    });
  } catch { return null; }
};
// Alias para compatibilidad con código existente
const urlToBase64 = async (url, uid) => {
  // Devolver la URL directamente — evita el error 403 de Storage
  // Las URLs de Google Photos son permanentes y no requieren Storage
  if (!url) return null;
  return url;
};

function PantallaAuth({ onVerLegal }) {
  const isMobile = useIsMobile();
  const [tab, setTab] = useState('registro');
  const [nombre, setNombre] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmarPassword, setConfirmarPassword] = useState('');
  const [error, setError] = useState('');
  const [cargando, setCargando] = useState(false);
  const [diaNac, setDiaNac] = useState('');
  const [mesNac, setMesNac] = useState('');
  const [anioNac, setAnioNac] = useState('');
  const [aceptaTerminos, setAceptaTerminos] = useState(false);
  const [mostrarPassword, setMostrarPassword] = useState(false);

  const dias = Array.from({ length: 31 }, (_, i) => i + 1);
  const anioActual = new Date().getFullYear();
  const anios = Array.from({ length: anioActual - 1920 + 1 }, (_, i) => anioActual - i);

  const handleEmail = async () => {
    setError('');
    if (tab === 'registro') {
      if (!nombre.trim()) { setError('Pon un nombre de usuario.'); return; }
      if (nombre.trim().length < 2) { setError('El nombre debe tener al menos 2 caracteres.'); return; }
      if (nombre.trim().length > 40) { setError('El nombre no puede superar 40 caracteres.'); return; }
      if (password.length < 6) { setError('La contraseña debe tener al menos 6 caracteres.'); return; }
      if (password !== confirmarPassword) { setError('Las contraseñas no coinciden.'); return; }
      if (!diaNac || !mesNac || !anioNac) { setError('Indica tu fecha de nacimiento completa.'); return; }
      // Verificar edad mínima de 14 años (LOPDGDD)
      const hoy = new Date();
      const nacimiento = new Date(anioNac, mesNac - 1, diaNac);
      const edad = hoy.getFullYear() - nacimiento.getFullYear() - (hoy < new Date(hoy.getFullYear(), nacimiento.getMonth(), nacimiento.getDate()) ? 1 : 0);
      if (edad < 14) { setError('Debes tener al menos 14 años para registrarte.'); return; }
      if (!aceptaTerminos) { setError('Debes aceptar los Términos de uso y la Política de privacidad.'); return; }
    }
    setCargando(true);
    try {
      if (tab === 'registro') {
        lsSet('leemos_reg_nombre', nombre.trim());
        lsSet('leemos_fecha_nac', `${diaNac}/${mesNac}/${anioNac}`);
        const cred = await createUserWithEmailAndPassword(auth, email, password);
        try { await updateProfile(cred.user, { displayName: nombre.trim() }); } catch {}
        // Crear el perfil directamente aquí — tenemos el objeto user con token válido
        const totalSnap = await getDocs(query(collection(db, "users"), limit(101)));
        const esPionero = totalSnap.size < 100;
        const np = {
          id: cred.user.uid, nombre: nombre.trim(), nombreNormalizado: normalizarTexto(nombre.trim()),
          foto: null,
          fecha: `Miembro desde ${new Date().toLocaleDateString('es-ES', { month: 'long', year: 'numeric' })}`,
          sobreMi: "Cuéntanos algo sobre ti...", seguidores: 0, siguiendo: 0, generos: [],
          fechaNacimiento: `${diaNac}/${mesNac}/${anioNac}`,
          es_pionero: esPionero ? 1 : 0,
          codigoInvitacion: cred.user.uid.slice(0, 6).toUpperCase(),
          onboardingCompletado: false,
        };
        await setDoc(doc(db, "users", cred.user.uid), np);
        lsRemove('leemos_reg_nombre');
        lsRemove('leemos_fecha_nac');
      } else {
        await signInWithEmailAndPassword(auth, email, password);
      }
    } catch (e) {
      const errorMsg = {
        'auth/email-already-in-use': 'Este email ya está en uso.',
        'auth/invalid-email': 'El email no es válido.',
        'auth/user-not-found': 'No existe cuenta con este email.',
        'auth/wrong-password': 'Contraseña incorrecta.',
        'auth/invalid-credential': 'Email o contraseña incorrectos.',
        'auth/too-many-requests': 'Demasiados intentos. Espera unos minutos.',
        'auth/network-request-failed': 'Error de conexión. Comprueba tu internet.',
        'auth/weak-password': 'La contraseña es demasiado débil.',
        'auth/user-disabled': 'Esta cuenta ha sido desactivada.',
      };
      // Solo mostrar error si es un código conocido de auth
      // Si no hay código es un error de Firestore posterior — el usuario ya está creado
      if (e.code && errorMsg[e.code]) {
        setError(errorMsg[e.code]);
        // Limpiar localStorage si el registro falló
        lsRemove('leemos_reg_nombre');
        lsRemove('leemos_fecha_nac');
      }
    }
    setCargando(false);
  };

  const handleGoogle = async () => {
    setError(''); setCargando(true);
    try {
      let firebaseUser = null;

      const googleAuthModule = detectarNativa() ? (GoogleAuth || (googleAuthPromise ? await googleAuthPromise : null)) : null;
      if (detectarNativa() && googleAuthModule) {
        // Android nativo: usar CapacitorGoogleAuth para evitar pantalla blanca
        const googleUser = await googleAuthModule.signIn();
        const idToken = googleUser.authentication?.idToken;
        if (!idToken) throw new Error('No se obtuvo el token de Google.');
        const credential = GoogleAuthProvider.credential(idToken);
        const cred = await signInWithCredential(auth, credential);
        firebaseUser = cred.user;
      } else {
        // Web: signInWithPopup
        const cred = await signInWithPopup(auth, googleProvider);
        firebaseUser = cred.user;
      }

      const userDoc = await getDoc(doc(db, "users", firebaseUser.uid));
      // Verificar bloqueo
      if (userDoc.exists() && userDoc.data().bloqueado === true) {
        await signOut(auth);
        setError('Tu cuenta ha sido suspendida.');
        setCargando(false);
        return;
      }
      if (!userDoc.exists()) {
        const n = firebaseUser.displayName || "Usuario";
        // Esperar más tiempo por el COOP del popup
        await new Promise(r => setTimeout(r, 1000));
        await firebaseUser.getIdToken(true);
        const fotoB64 = firebaseUser.photoURL || null;
        const totalSnap = await getDocs(query(collection(db, "users"), limit(101)));
        const esPionero = totalSnap.size < 100;
        const np = {
          id: firebaseUser.uid, nombre: n, nombreNormalizado: normalizarTexto(n),
          foto: fotoB64,
          fecha: `Miembro desde ${new Date().toLocaleDateString('es-ES', { month: 'long', year: 'numeric' })}`,
          sobreMi: "Cuéntanos algo sobre ti...", seguidores: 0, siguiendo: 0, generos: [],
          fechaNacimiento: null, es_pionero: esPionero ? 1 : 0,
          codigoInvitacion: firebaseUser.uid.slice(0, 6).toUpperCase(),
          onboardingCompletado: false,
        };
        // Reintentos por si el token aún no está propagado
        for (let i = 0; i < 4; i++) {
          try {
            await setDoc(doc(db, "users", firebaseUser.uid), np);
            break;
          } catch (err) {
            if (i < 3) {
              await firebaseUser.getIdToken(true);
              await new Promise(r => setTimeout(r, 800));
            }
          }
        }
      } else {
        const data = userDoc.data();
        const updates = {};
        if (firebaseUser.displayName && firebaseUser.displayName !== data.nombre) { updates.nombre = firebaseUser.displayName; updates.nombreNormalizado = normalizarTexto(firebaseUser.displayName); }
        if (!data.foto && firebaseUser.photoURL) {
          const b64 = await urlToBase64(firebaseUser.photoURL, firebaseUser.uid);
          updates.foto = b64 || firebaseUser.photoURL;
        }
        if (Object.keys(updates).length > 0) await updateDoc(doc(db, "users", firebaseUser.uid), updates);
      }
    } catch (e) {
      console.error('Google sign in error completo:', e.code, e.message, e);
      if (e.code === 'auth/popup-closed-by-user' || e.code === 'auth/cancelled-popup-request') {
        // Usuario cerró el popup — no mostrar error
      } else if (e.code === 'auth/network-request-failed') {
        setError('Error de conexión. Comprueba tu internet.');
      } else if (e.code === 'auth/popup-blocked') {
        setError('El navegador bloqueó el popup. Permite ventanas emergentes para este sitio.');
      } else if (e.message?.includes('Cross-Origin') || e.message?.includes('COOP')) {
        // Error CORS/COOP — intentar de nuevo con redirect
        setError('Error de configuración. Prueba a recargar la página.');
      } else {
        setError(`Error: ${e.code || e.message || 'desconocido'}`);
        console.error('Google sign in error:', e);
      }
    }
    setCargando(false);
  };

  const deshabilitado = cargando || (tab === 'registro' && !aceptaTerminos);

  return (
    <div style={{ height: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: '#000', color: 'white', fontFamily: 'sans-serif' }}>
      <div style={{ display: 'flex', width: isMobile ? '100%' : '900px', height: isMobile ? '100vh' : '750px', backgroundColor: '#0a0a0a', borderRadius: isMobile ? '0' : '24px', overflow: 'hidden', border: '1px solid #1a1a1a', boxShadow: '0 20px 60px rgba(0,0,0,0.7)', flexDirection: isMobile ? 'column' : 'row' }}>
        <div style={{ flex: 1, padding: '60px', display: isMobile ? 'none' : 'flex', flexDirection: 'column', justifyContent: 'space-between', background: 'linear-gradient(135deg, #0d1a0d 0%, #050505 100%)' }}>
          <div>
            <div style={{ width: '50px', height: '50px', borderRadius: '50%', border: '2px solid #4caf50', display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '20px' }}>
              <span style={{ fontSize: '24px' }}>📖</span>
            </div>
            <h1 style={{ fontSize: '32px', margin: '0 0 10px 0', fontWeight: 900 }}>Únete al <br /><span style={{ color: '#4caf50' }}>Leemos.</span></h1>
            <p style={{ color: '#555', lineHeight: '1.6' }}>Lee. Debate.<br />Conecta.</p>
          </div>
          <img src="https://images.unsplash.com/photo-1589998059171-988d887df646?q=80&w=400&auto=format&fit=crop" alt="Libros" style={{ width: '200px', borderRadius: '12px', transform: 'rotate(-5deg)', boxShadow: '0 10px 40px rgba(0,0,0,0.8)' }} />
        </div>
        <div style={{ flex: 1.2, padding: isMobile ? '40px 24px' : '50px 60px', overflowY: 'auto', backgroundColor: '#0d0d0d' }}>
          <h2 style={{ fontSize: '28px', marginBottom: '6px', fontWeight: 900 }}>{tab === 'registro' ? 'Crear cuenta' : 'Iniciar sesión'}</h2>
          <p style={{ color: '#555', marginBottom: '28px', fontSize: '14px' }}>Empieza tu viaje literario.</p>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '14px' }}>
            {tab === 'registro' && (
              <div style={{ position: 'relative' }}>
                <span style={{ position: 'absolute', left: '16px', top: '14px', color: '#444' }}><Icon.Person /></span>
                <input placeholder="Nombre completo" value={nombre} onChange={e => setNombre(e.target.value)} style={estiloInputAuth} />
              </div>
            )}
            <div style={{ position: 'relative' }}>
              <span style={{ position: 'absolute', left: '16px', top: '14px', color: '#444', fontSize: '16px' }}>@</span>
              <input placeholder="Correo electrónico" type="email" value={email} onChange={e => setEmail(e.target.value.toLowerCase().trim())} style={estiloInputAuth} />
            </div>
            <div style={{ position: 'relative' }}>
              <span style={{ position: 'absolute', left: '16px', top: '14px', color: '#444' }}><Icon.Lock /></span>
              <input placeholder="Contraseña" type={mostrarPassword ? 'text' : 'password'} value={password} onChange={e => setPassword(e.target.value)} style={{ ...estiloInputAuth, paddingLeft: '42px', paddingRight: '42px' }} />
              <button type="button" onClick={() => setMostrarPassword(p => !p)}
                style={{ position: 'absolute', right: '14px', top: '12px', background: 'none', border: 'none', color: '#555', cursor: 'pointer', padding: '2px', lineHeight: 1 }}>
                {mostrarPassword
                  ? <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor"><path d="M17.94 17.94A10.07 10.07 0 0112 20c-7 0-11-8-11-8a18.45 18.45 0 015.06-5.94M9.9 4.24A9.12 9.12 0 0112 4c7 0 11 8 11 8a18.5 18.5 0 01-2.16 3.19m-6.72-1.07a3 3 0 11-4.24-4.24M1 1l22 22" stroke="currentColor" strokeWidth="2" strokeLinecap="round" fill="none"/></svg>
                  : <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3" fill="#1a1a1a"/></svg>
                }
              </button>
            </div>
            {tab === 'registro' && (
              <>
                <div style={{ position: 'relative' }}>
                  <span style={{ position: 'absolute', left: '16px', top: '14px', color: '#444' }}><Icon.Lock /></span>
                  <input placeholder="Confirmar contraseña" type={mostrarPassword ? 'text' : 'password'} value={confirmarPassword} onChange={e => setConfirmarPassword(e.target.value)} style={{ ...estiloInputAuth, paddingLeft: '42px', paddingRight: '42px' }} />
                  <button type="button" onClick={() => setMostrarPassword(p => !p)}
                    style={{ position: 'absolute', right: '14px', top: '12px', background: 'none', border: 'none', color: '#555', cursor: 'pointer', padding: '2px', lineHeight: 1 }}>
                    {mostrarPassword
                      ? <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor"><path d="M17.94 17.94A10.07 10.07 0 0112 20c-7 0-11-8-11-8a18.45 18.45 0 015.06-5.94M9.9 4.24A9.12 9.12 0 0112 4c7 0 11 8 11 8a18.5 18.5 0 01-2.16 3.19m-6.72-1.07a3 3 0 11-4.24-4.24M1 1l22 22" stroke="currentColor" strokeWidth="2" strokeLinecap="round" fill="none"/></svg>
                      : <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3" fill="#1a1a1a"/></svg>
                    }
                  </button>
                </div>
                <p style={{ fontSize: '12px', color: '#555', marginBottom: '-6px' }}>Fecha de nacimiento</p>
                <div style={{ display: 'flex', gap: '8px' }}>
                  {[{ val: diaNac, set: setDiaNac, opts: dias, label: 'Día' }, { val: mesNac, set: setMesNac, opts: MESES_ES.map((m, i) => ({ v: i + 1, l: m })), label: 'Mes' }, { val: anioNac, set: setAnioNac, opts: anios, label: 'Año' }].map((sel, idx) => (
                    <select key={idx} style={estiloSelectAuth} value={sel.val} onChange={e => sel.set(e.target.value)}>
                      <option value="" style={{ background: '#111' }}>{sel.label}</option>
                      {sel.opts.map((o, i) => typeof o === 'object'
                        ? <option key={i} value={o.v} style={{ background: '#111' }}>{o.l}</option>
                        : <option key={i} value={o} style={{ background: '#111' }}>{o}</option>)}
                    </select>
                  ))}
                </div>
                <div style={{ display: 'flex', alignItems: 'flex-start', gap: '10px' }}>
                  <input type="checkbox" id="chk" checked={aceptaTerminos} onChange={e => setAceptaTerminos(e.target.checked)} style={{ accentColor: '#4caf50', marginTop: '2px', cursor: 'pointer', width: '15px', height: '15px', flexShrink: 0 }} />
                  <label htmlFor="chk" style={{ fontSize: '12px', color: '#555', cursor: 'pointer', lineHeight: '1.5' }}>
                    Acepto los <span onClick={e => { e.preventDefault(); onVerLegal('terminos'); }} style={{ color: '#4caf50', cursor: 'pointer' }}>Términos de uso</span> y la <span onClick={e => { e.preventDefault(); onVerLegal('privacidad'); }} style={{ color: '#4caf50', cursor: 'pointer' }}>Política de privacidad</span>.
                  </label>
                </div>
              </>
            )}
            {error && <p style={{ color: '#f44336', fontSize: '13px', textAlign: 'center', margin: 0 }}>{error}</p>}
            <button onClick={handleEmail} disabled={deshabilitado}
              style={{ background: deshabilitado ? '#1a1a1a' : '#4caf50', color: deshabilitado ? '#333' : 'black', border: 'none', padding: '14px', borderRadius: '30px', fontWeight: 'bold', fontSize: '15px', cursor: deshabilitado ? 'not-allowed' : 'pointer', transition: '0.2s', marginTop: '4px' }}>
              {cargando ? 'Cargando...' : tab === 'registro' ? 'Crear cuenta' : 'Entrar'}
            </button>
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
              <div style={{ flex: 1, height: '1px', background: '#1a1a1a' }}></div>
              <span style={{ color: '#333', fontSize: '12px' }}>o</span>
              <div style={{ flex: 1, height: '1px', background: '#1a1a1a' }}></div>
            </div>
            <button onClick={handleGoogle} style={{ background: 'transparent', color: 'white', border: '1px solid #1e1e1e', padding: '12px', borderRadius: '30px', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '10px', fontSize: '14px' }}>
              <svg width="18" height="18" viewBox="0 0 48 48"><path fill="#FFC107" d="M43.6 20.5H42V20H24v8h11.3C33.7 32.5 29.3 35 24 35c-6.1 0-11-4.9-11-11s4.9-11 11-11c2.8 0 5.3 1 7.2 2.7l5.7-5.7C33.5 7.1 29 5 24 5 12.9 5 4 13.9 4 25s8.9 20 20 20 20-8.9 20-20c0-1.5-.2-3-.4-4.5z"/><path fill="#FF3D00" d="M6.3 14.7l6.6 4.8C14.6 16 19 13 24 13c2.8 0 5.3 1 7.2 2.7l5.7-5.7C33.5 7.1 29 5 24 5 16.3 5 9.7 9 6.3 14.7z"/><path fill="#4CAF50" d="M24 45c5.2 0 9.9-2 13.4-5.2l-6.2-5.2C29.4 36.4 26.8 37 24 37c-5.2 0-9.7-3.4-11.3-8.1l-6.6 5.1C9.5 41 16.2 45 24 45z"/><path fill="#1976D2" d="M43.6 20.5H42V20H24v8h11.3c-.8 2.3-2.3 4.3-4.3 5.6l6.2 5.2C42 35.2 44 30.4 44 25c0-1.5-.2-3-.4-4.5z"/></svg>
              Continuar con Google
            </button>
            <p style={{ textAlign: 'center', fontSize: '13px', color: '#444' }}>
              {tab === 'registro' ? '¿Ya tienes cuenta?' : '¿No tienes cuenta?'}{' '}
              <span onClick={() => { setTab(tab === 'registro' ? 'login' : 'registro'); setError(''); setPassword(''); setConfirmarPassword(''); setAceptaTerminos(false); setDiaNac(''); setMesNac(''); setAnioNac(''); }} style={{ color: '#4caf50', cursor: 'pointer', fontWeight: 'bold' }}>
                {tab === 'registro' ? 'Inicia sesión' : 'Regístrate'}
              </span>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

// ── BibliotecaPersonal ────────────────────────────────────────────────────────
// Insignias pequeñas para perfil ajeno
function InsigniasPerfil({ userId }) {
  const { stats } = useStats(userId);
  if (!stats) return null;
  return (
    <div style={{ marginTop: '20px' }}>
      <p style={{ fontSize: '12px', color: '#555', textTransform: 'uppercase', letterSpacing: '1px', marginBottom: '12px' }}>Insignias</p>
      <SeccionInsignias userId={userId} stats={stats} pequeña />
    </div>
  );
}

// ── Tarjeta de portada reutilizable ──────────────────────────────────────────
function PortadaLibro({ libro, size = 120 }) {
  const [imgError, setImgError] = React.useState(false);
  const tienePortada = libro?.portada?.startsWith('https://') && !imgError;
  return (
    <div style={{ width: size, minWidth: size, height: size * 1.5, borderRadius: '10px', overflow: 'hidden', background: 'linear-gradient(135deg, #1e1e2e, #141420)', boxShadow: '0 8px 24px rgba(0,0,0,0.6)', display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column', gap: '6px', flexShrink: 0 }}>
      {tienePortada
        ? <img src={libro.portada} alt="" onError={() => setImgError(true)} style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }} />
        : <>
            <span style={{ fontSize: size * 0.22 }}>📖</span>
            <span style={{ fontSize: '9px', color: '#555', textAlign: 'center', padding: '0 6px', lineHeight: 1.3 }}>{libro?.titulo}</span>
          </>
      }
    </div>
  );
}

// ── Bloque de sección (Quiero leer / Leyendo / Leídos) ───────────────────────
function EstanteriaLibros({ libros, gradientColor, onVerLibro, renderOverlay }) {
  return (
    <div style={{ position: 'relative', overflowX: 'auto', overflowY: 'hidden', paddingBottom: '14px', scrollbarWidth: 'thin' }}>
      <div style={{ display: 'flex', alignItems: 'flex-end', gap: '2px', minHeight: '190px', padding: '10px 8px 0' }}>
        {libros.map((entrada, i) => {
          const alturas = [165, 178, 158, 172, 185, 162];
          const h = alturas[i % alturas.length];
          const inclinacion = (i % 3 === 0) ? -2 : (i % 3 === 1) ? 1.5 : 0;
          return (
            <div key={entrada.libroId || entrada.libro?.id}
              onClick={() => onVerLibro(entrada)}
              style={{
                flexShrink: 0, width: '46px', height: `${h}px`, cursor: 'pointer',
                transform: `rotate(${inclinacion}deg)`, transformOrigin: 'bottom center',
                transition: 'transform 0.2s, margin-bottom 0.2s', position: 'relative',
                boxShadow: '2px 0 6px rgba(0,0,0,0.4)', borderRadius: '2px 4px 4px 2px',
                overflow: 'hidden', marginBottom: 0,
              }}
              onMouseEnter={e => { e.currentTarget.style.transform = `rotate(0deg) translateY(-10px)`; e.currentTarget.style.zIndex = '5'; }}
              onMouseLeave={e => { e.currentTarget.style.transform = `rotate(${inclinacion}deg) translateY(0)`; e.currentTarget.style.zIndex = '1'; }}>
              {entrada.libro?.portada?.startsWith('https://')
                ? <img src={entrada.libro.portada} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }} onError={e => e.currentTarget.style.display = 'none'} />
                : <div style={{ width: '100%', height: '100%', background: `${gradientColor}22`, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '9px', color: gradientColor, textAlign: 'center', padding: '4px', writingMode: 'vertical-rl' }}>{entrada.libro?.titulo?.slice(0, 20)}</div>
              }
            </div>
          );
        })}
      </div>
      {/* Madera de la estantería */}
      <div style={{ height: '14px', background: 'linear-gradient(180deg, #2a1d10, #1a1209)', borderRadius: '0 0 4px 4px', boxShadow: 'inset 0 2px 4px rgba(0,0,0,0.4), 0 4px 10px rgba(0,0,0,0.3)', marginTop: '-1px' }} />
    </div>
  );
}

function BloqueSeccion({ titulo, subtitulo, color, gradientColor, svgIcon, libros, cargando, onVerLibro, renderOverlay, onAnadir, onVerTodos, modoGrid = false }) {
  const [vistaEstanteria, setVistaEstanteria] = useState(false);

  if (cargando) return (
    <div style={{ background: `linear-gradient(135deg, ${gradientColor}10 0%, #111 60%)`, borderRadius: '16px', border: `1px solid ${gradientColor}33`, padding: '24px 28px 28px', marginBottom: '20px' }}>
      <div style={{ height: '22px', width: '160px', background: '#1e1e1e', borderRadius: '6px', marginBottom: '24px', animation: 'pulse 1.5s infinite' }} />
      <div style={{ display: 'flex', gap: '14px' }}>
        {[...Array(4)].map((_, i) => <div key={i} style={{ width: 130, height: 195, borderRadius: '10px', background: '#1e1e1e', flexShrink: 0, animation: 'pulse 1.5s infinite' }} />)}
      </div>
    </div>
  );

  // En modoGrid mostramos todos; en carrusel solo los primeros 5
  const librosVisibles = modoGrid ? libros : libros.slice(0, 5);

  return (
    <div style={{ background: `linear-gradient(135deg, ${gradientColor}10 0%, #111 60%)`, borderRadius: '16px', border: `1px solid ${gradientColor}33`, padding: '24px 28px 28px', marginBottom: '20px' }}>
      {/* Cabecera */}
      <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', marginBottom: '4px', gap: '10px' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px', minWidth: 0 }}>
          <svg width="22" height="22" viewBox="0 0 24 24" fill={gradientColor} style={{ flexShrink: 0 }}>{svgIcon}</svg>
          <div style={{ minWidth: 0 }}>
            <div style={{ display: 'flex', alignItems: 'baseline', gap: '8px' }}>
              <span style={{ fontWeight: 900, fontSize: '20px', color: 'white' }}>{titulo}</span>
              <span style={{ fontWeight: 700, fontSize: '20px', color: gradientColor }}>{libros.length}</span>
            </div>
            <p style={{ margin: 0, fontSize: '12px', color: '#555', marginTop: '1px' }}>{subtitulo}</p>
          </div>
        </div>
        {modoGrid && libros.length > 0 && (
          <button onClick={() => setVistaEstanteria(v => !v)} style={{ flexShrink: 0, background: vistaEstanteria ? gradientColor : 'transparent', border: `1px solid ${gradientColor}`, color: vistaEstanteria ? 'black' : gradientColor, borderRadius: '20px', padding: '7px 14px', fontSize: '11px', fontWeight: 900, cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '6px', transition: '0.2s' }}>
            <svg width="13" height="13" viewBox="0 0 24 24" fill="currentColor">{vistaEstanteria ? <path d="M4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6zm16-4H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2z"/> : <path d="M3 3h18v2H3zm2 4h2v14H5zm4 0h2v14H9zm4 0h2v14h-2zm4 0h2v14h-2z"/>}</svg>
            {vistaEstanteria ? 'Vista grid' : 'Estantería'}
          </button>
        )}
      </div>

      {/* Botón Ver todos — solo en carrusel */}
      {!modoGrid && libros.length > 0 && (
        <button onClick={onVerTodos}
          style={{ background: 'transparent', border: `1px solid ${gradientColor}55`, color: gradientColor, borderRadius: '20px', padding: '6px 16px', fontSize: '12px', fontWeight: 'bold', cursor: 'pointer', margin: '14px 0 20px', display: 'inline-flex', alignItems: 'center', gap: '5px', transition: '0.2s' }}
          onMouseEnter={e => e.currentTarget.style.background = `${gradientColor}18`}
          onMouseLeave={e => e.currentTarget.style.background = 'transparent'}>
          Ver todos →
        </button>
      )}
      <div style={{ height: (!modoGrid && libros.length > 0) ? 0 : '18px' }} />

      {libros.length === 0 ? (
        <div style={{ height: '80px', display: 'flex', alignItems: 'center', justifyContent: 'center', border: `1px dashed ${gradientColor}22`, borderRadius: '10px' }}>
          <p style={{ color: '#333', fontSize: '13px', margin: 0 }}>Aún no hay libros aquí</p>
        </div>
      ) : modoGrid && vistaEstanteria ? (
        <EstanteriaLibros libros={libros} gradientColor={gradientColor} onVerLibro={onVerLibro} renderOverlay={renderOverlay} />
      ) : modoGrid ? (
        /* Grid completo para vista categoría */
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(130px, 1fr))', gap: '16px' }}>
          {libros.map((entrada) => (
            <div key={entrada.libroId || entrada.libro?.id}
              onClick={() => onVerLibro(entrada)}
              style={{ cursor: 'pointer', transition: 'transform 0.2s' }}
              onMouseEnter={e => e.currentTarget.style.transform = 'translateY(-5px)'}
              onMouseLeave={e => e.currentTarget.style.transform = 'translateY(0)'}>
              <div style={{ position: 'relative' }}>
                <PortadaLibro libro={entrada.libro} size={130} />
                {renderOverlay && renderOverlay(entrada)}
              </div>
              <p style={{ margin: '10px 0 2px', fontWeight: 'bold', fontSize: '12px', color: 'white', lineHeight: '1.3', display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical', overflow: 'hidden' }}>{entrada.libro?.titulo}</p>
              <p style={{ fontSize: '11px', color: '#555', margin: 0, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{entrada.libro?.autor}</p>
              {entrada.estado === 'leyendo' && entrada.paginaActual > 0 && entrada.totalPaginas > 0 && (() => {
                const pct = Math.min(Math.round((entrada.paginaActual / entrada.totalPaginas) * 100), 100);
                return (<div style={{ marginTop: '6px' }}><div style={{ height: '3px', background: '#1a1a1a', borderRadius: '3px', overflow: 'hidden' }}><div style={{ height: '100%', width: `${pct}%`, background: `linear-gradient(90deg, ${gradientColor}, ${gradientColor}99)`, borderRadius: '3px' }} /></div><p style={{ margin: '3px 0 0', fontSize: '10px', color: gradientColor, fontWeight: 'bold' }}>{pct}%</p></div>);
              })()}
            </div>
          ))}
          <div onClick={onAnadir}
            style={{ height: 195, borderRadius: '10px', border: `1.5px dashed #2a2a2a`, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: '10px', cursor: 'pointer', transition: '0.2s', color: '#333' }}
            onMouseEnter={e => { e.currentTarget.style.borderColor = gradientColor; e.currentTarget.style.color = gradientColor; e.currentTarget.style.background = `${gradientColor}08`; }}
            onMouseLeave={e => { e.currentTarget.style.borderColor = '#2a2a2a'; e.currentTarget.style.color = '#333'; e.currentTarget.style.background = 'transparent'; }}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor"><path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"/></svg>
            <span style={{ fontSize: '11px', fontWeight: 'bold', textAlign: 'center' }}>Añadir libro</span>
          </div>
        </div>
      ) : (
        /* Carrusel — primeros 5 + botón añadir */
        <div style={{ display: 'flex', gap: '16px', overflowX: 'auto', paddingBottom: '8px', scrollbarWidth: 'none', msOverflowStyle: 'none' }}>
          {librosVisibles.map((entrada) => (
            <div key={entrada.libroId || entrada.libro?.id}
              onClick={() => onVerLibro(entrada)}
              style={{ flexShrink: 0, cursor: 'pointer', transition: 'transform 0.2s' }}
              onMouseEnter={e => e.currentTarget.style.transform = 'translateY(-5px)'}
              onMouseLeave={e => e.currentTarget.style.transform = 'translateY(0)'}>
              <div style={{ position: 'relative' }}>
                <PortadaLibro libro={entrada.libro} size={130} />
                {renderOverlay && renderOverlay(entrada)}
              </div>
              <p style={{ margin: '10px 0 2px', fontWeight: 'bold', fontSize: '12px', color: 'white', width: '130px', lineHeight: '1.3', display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical', overflow: 'hidden' }}>{entrada.libro?.titulo}</p>
              <p style={{ fontSize: '11px', color: '#555', margin: 0, width: '130px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{entrada.libro?.autor}</p>
              {entrada.estado === 'leyendo' && entrada.paginaActual > 0 && entrada.totalPaginas > 0 && (() => {
                const pct = Math.min(Math.round((entrada.paginaActual / entrada.totalPaginas) * 100), 100);
                return (<div style={{ marginTop: '6px', width: '130px' }}><div style={{ height: '3px', background: '#1a1a1a', borderRadius: '3px', overflow: 'hidden' }}><div style={{ height: '100%', width: `${pct}%`, background: `linear-gradient(90deg, ${gradientColor}, ${gradientColor}99)`, borderRadius: '3px' }} /></div><p style={{ margin: '3px 0 0', fontSize: '10px', color: gradientColor, fontWeight: 'bold' }}>{pct}%</p></div>);
              })()}
            </div>
          ))}
          <div onClick={onAnadir}
            style={{ flexShrink: 0, width: 130, height: 195, borderRadius: '10px', border: `1.5px dashed #2a2a2a`, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: '10px', cursor: 'pointer', transition: '0.2s', color: '#333' }}
            onMouseEnter={e => { e.currentTarget.style.borderColor = gradientColor; e.currentTarget.style.color = gradientColor; e.currentTarget.style.background = `${gradientColor}08`; }}
            onMouseLeave={e => { e.currentTarget.style.borderColor = '#2a2a2a'; e.currentTarget.style.color = '#333'; e.currentTarget.style.background = 'transparent'; }}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor"><path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"/></svg>
            <span style={{ fontSize: '11px', fontWeight: 'bold', textAlign: 'center' }}>Añadir libro</span>
          </div>
        </div>
      )}
    </div>
  );
}

function PanelProgresoLector({ userId, entradas, compact = false }) {
  const [statsTimer, setStatsTimer] = React.useState(null);
  const [racha, setRacha] = React.useState(0);
  const [mediaVotos, setMediaVotos] = React.useState(null);
  const anio = new Date().getFullYear();

  React.useEffect(() => {
    if (!userId) return;
    getDoc(doc(db, 'stats_timer', userId)).then(snap => {
      if (snap.exists()) setStatsTimer(snap.data());
    }).catch(() => {});
    getDocs(query(collection(db, 'actividad_reciente'), where('userId', '==', userId), orderBy('fecha', 'desc'), limit(365))).then(snap => {
      const actividad = snap.docs.map(d => d.data());
      if (!actividad.length) return;
      const diasUnicos = [...new Set(actividad.map(a => {
        const d = a.fecha?.toDate?.() || new Date(0);
        const dia = new Date(d); dia.setHours(0,0,0,0); return dia.getTime();
      }))].sort((a,b) => b - a);
      const hoy = new Date(); hoy.setHours(0,0,0,0);
      const hoyMs = hoy.getTime(), ayerMs = hoyMs - 86400000;
      if (diasUnicos[0] !== hoyMs && diasUnicos[0] !== ayerMs) { setRacha(0); return; }
      let r = 1;
      for (let i = 1; i < diasUnicos.length; i++) {
        if (diasUnicos[i-1] - diasUnicos[i] === 86400000) r++; else break;
      }
      setRacha(r);
    }).catch(() => {});
    getDocs(query(collection(db, 'valoraciones'), where('userId', '==', userId))).then(snap => {
      if (snap.empty) return;
      const vals = snap.docs.map(d => d.data().estrellas || 0);
      setMediaVotos(Math.round(vals.reduce((a,b) => a+b, 0) / vals.length * 10) / 10);
    }).catch(() => {});
  }, [userId]);

  const leidosEsteAnio = entradas.filter(e => {
    if (e.estado !== 'leido') return false;
    const f = e.fecha?.toDate?.();
    return f && f.getFullYear() === anio;
  }).length;

  const horasLectura = statsTimer?.totalSegundos ? Math.round(statsTimer.totalSegundos / 3600) : 0;

  // Géneros reales únicamente
  const GENEROS_REALES = ['Ficción','Misterio','Ciencia ficción','Fantasía','Romance','No ficción','Terror','Histórica','Ensayo','Drama'];

  const inferirGenero = (titulo, autor) => {
    if (!titulo) return null;
    const norm = s => (s||'').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').trim();
    const t = norm(titulo);
    const a = norm(autor);
    for (const genero of GENEROS_REALES) {
      const libros = LISTAS_LIBROS[genero] || [];
      if (libros.some(l => norm(l.titulo) === t || (norm(l.titulo).length > 8 && t.startsWith(norm(l.titulo).slice(0,10))) || (norm(l.autor) === a && norm(l.titulo).slice(0,8) === t.slice(0,8)))) {
        return genero;
      }
    }
    return null;
  };

  const generosCount = {};
  entradas.filter(e => e.estado === 'leido').forEach(e => {
    const g = e.libro?.genero || inferirGenero(e.libro?.titulo, e.libro?.autor);
    if (g && GENEROS_REALES.includes(g)) generosCount[g] = (generosCount[g] || 0) + 1;
  });
  const generosTop = Object.entries(generosCount).sort((a,b) => b[1]-a[1]).slice(0, 5);
  const totalGeneros = generosTop.reduce((s,[,n]) => s+n, 0);
  const COLORES_GENERO = ['#1DB954', '#a78bfa', '#38bdf8', '#f59e0b', '#f472b6'];

  const CITAS = [
    { texto: 'Un libro es un sueño que tienes en tus manos.', autor: 'Neil Gaiman' },
    { texto: 'No hay amigo tan leal como un libro.', autor: 'Ernest Hemingway' },
    { texto: 'Leer es soñar con los ojos abiertos.', autor: 'Voltaire' },
    { texto: 'Los libros son espejos: solo ves en ellos lo que ya llevas dentro.', autor: 'Carlos Ruiz Zafón' },
    { texto: 'Una habitación sin libros es como un cuerpo sin alma.', autor: 'Marco Tulio Cicerón' },
  ];
  const cita = React.useMemo(() => CITAS[Math.floor(Math.random() * CITAS.length)], []);

  // SVG iconos planos para stats
  const STAT_ICONS = {
    libros: <path d="M4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6zm16-4H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-1 9H9V9h10v2zm-4 4H9v-2h6v2zm4-8H9V5h10v2z"/>,
    horas:  <path d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm.5-13H11v6l5.25 3.15.75-1.23-4.5-2.67V7z"/>,
    racha:  <path d="M13.5.67s.74 2.65.74 4.8c0 2.06-1.35 3.73-3.41 3.73-2.07 0-3.63-1.67-3.63-3.73l.03-.36C5.21 7.51 4 10.62 4 14c0 4.42 3.58 8 8 8s8-3.58 8-8C20 8.61 17.41 3.8 13.5.67z"/>,
    estrella: <path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"/>,
  };

  // Donut SVG
  function DonutChart({ datos, colores, total }) {
    if (!total) return (
      <div style={{ width: 110, height: 110, borderRadius: '50%', background: '#1a1a1a', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <span style={{ fontSize: '11px', color: '#333' }}>Sin datos</span>
      </div>
    );
    let angulo = -90;
    const cx = 55, cy = 55, r = 40, stroke = 16;
    const circum = 2 * Math.PI * r;
    return (
      <svg width="110" height="110" viewBox="0 0 110 110" style={{ flexShrink: 0 }}>
        <circle cx={cx} cy={cy} r={r} fill="none" stroke="#1a1a1a" strokeWidth={stroke} />
        {datos.map(([,n], i) => {
          const pct = n / total;
          const dash = `${pct * circum} ${circum}`;
          const rot = angulo;
          angulo += pct * 360;
          return <circle key={i} cx={cx} cy={cy} r={r} fill="none" stroke={colores[i]} strokeWidth={stroke} strokeDasharray={dash} strokeDashoffset={0} transform={`rotate(${rot} ${cx} ${cy})`} />;
        })}
        <text x={cx} y={cy+1} textAnchor="middle" dominantBaseline="middle" fontSize="14" fontWeight="900" fill="white">{leidosEsteAnio}</text>
        <text x={cx} y={cy+14} textAnchor="middle" dominantBaseline="middle" fontSize="8" fill="#555">libros</text>
      </svg>
    );
  }

  const stats = [
    { icon: STAT_ICONS.libros,   valor: leidosEsteAnio,                           label: 'Libros leídos',    color: '#1DB954' },
    { icon: STAT_ICONS.horas,    valor: `${horasLectura}h`,                        label: 'Horas de lectura', color: '#a78bfa' },
    { icon: STAT_ICONS.racha,    valor: `${racha}d`,                               label: 'Días seguidos',    color: '#f97316' },
    { icon: STAT_ICONS.estrella, valor: mediaVotos != null ? `${mediaVotos}` : '—', label: 'Valoración media', color: '#FFD700' },
  ];

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
      <div style={{ background: '#111', borderRadius: '14px', border: '1px solid #1e1e1e', padding: '20px 18px' }}>
        <p style={{ margin: '0 0 2px', fontSize: '13px', fontWeight: 900, color: 'white' }}>Tu progreso lector</p>
        <p style={{ margin: '0 0 18px', fontSize: '11px', color: '#555' }}>Este año</p>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '18px' }}>
          {stats.map(({ icon, valor, label, color }) => (
            <div key={label} style={{ display: 'flex', alignItems: 'center', gap: '14px' }}>
              <div style={{ width: '38px', height: '38px', borderRadius: '50%', background: `${color}22`, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                <svg width="20" height="20" viewBox="0 0 24 24" fill={color}>{icon}</svg>
              </div>
              <div>
                <p style={{ margin: 0, fontSize: '22px', fontWeight: 900, color, lineHeight: 1 }}>{valor}</p>
                <p style={{ margin: '3px 0 0', fontSize: '12px', color: '#666' }}>{label}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}


// ── Notas rápidas durante lectura ─────────────────────────────────────────────
function NotasLectura({ userId, libroId }) {
  const [nota, setNota] = React.useState('');
  const [guardado, setGuardado] = React.useState(false);
  const [guardando, setGuardando] = React.useState(false);
  React.useEffect(() => {
    if (!userId || !libroId) return;
    getDoc(doc(db, 'notas_lectura', `${userId}_${libroId}`)).then(snap => {
      if (snap.exists()) setNota(snap.data().texto || '');
    }).catch(() => {});
  }, [userId, libroId]);
  const guardar = async () => {
    if (guardando) return;
    setGuardando(true);
    try {
      await setDoc(doc(db, 'notas_lectura', `${userId}_${libroId}`), { userId, libroId, texto: nota, fecha: serverTimestamp() }, { merge: true });
      setGuardado(true); setTimeout(() => setGuardado(false), 2000);
    } catch {}
    setGuardando(false);
  };
  return (
    <div style={{ marginTop: '16px' }}>
      <p style={{ fontSize: '11px', color: '#555', textTransform: 'uppercase', letterSpacing: '1px', margin: '0 0 8px', fontWeight: 'bold' }}>Mis notas</p>
      <textarea value={nota} onChange={e => setNota(e.target.value)}
        placeholder="Apunta ideas, frases, pensamientos..."
        style={{ width: '100%', minHeight: '80px', background: '#0d0d0d', border: '1px solid #1e1e1e', borderRadius: '10px', color: '#ccc', fontSize: '12px', padding: '10px 12px', resize: 'vertical', outline: 'none', fontFamily: 'inherit', lineHeight: 1.5, boxSizing: 'border-box' }}
        onFocus={e => e.target.style.borderColor = '#1DB95466'}
        onBlur={e => { e.target.style.borderColor = '#1e1e1e'; guardar(); }} />
      {guardado && <p style={{ fontSize: '11px', color: '#1DB954', margin: '4px 0 0' }}>✓ Guardado</p>}
    </div>
  );
}

// ── Panel libro Leyendo ───────────────────────────────────────────────────────
function PanelLeyendo({ userId, libro, entrada, onCerrar }) {
  const fechaInicio = entrada?.fecha?.toDate?.() || null;
  const diasLeyendo = fechaInicio ? Math.max(1, Math.round((Date.now() - fechaInicio.getTime()) / 86400000)) : null;
  const [pagActual, setPagActual] = React.useState(entrada?.paginaActual || '');
  const [totalPags, setTotalPags] = React.useState(entrada?.totalPaginas || '');
  const [guardandoPags, setGuardandoPags] = React.useState(false);

  const guardarPaginas = async (pag, total) => {
    if (guardandoPags) return;
    const p = parseInt(pag); const t = parseInt(total);
    if (!p && !t) return;
    setGuardandoPags(true);
    try {
      const updates = {};
      if (p > 0) updates.paginaActual = p;
      if (t > 0) updates.totalPaginas = t;
      await setDoc(doc(db, 'estados_lectura', `${entrada.libroId}_${userId}`), updates, { merge: true });
    } catch {}
    setGuardandoPags(false);
  };

  const pct = pagActual && totalPags ? Math.min(Math.round((parseInt(pagActual) / parseInt(totalPags)) * 100), 100) : null;

  return (
    <div>
      <div style={{ width: '100%', maxHeight: '200px', borderRadius: '10px', overflow: 'hidden', marginBottom: '14px' }}>
        {libro?.portada?.startsWith('https://') ? <img src={libro.portada} alt="" style={{ width: '100%', maxHeight: '200px', objectFit: 'cover', display: 'block' }} onError={e => e.currentTarget.style.display='none'} /> : <div style={{ height: '140px', background: '#1a1a1a', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '36px' }}>📖</div>}
      </div>
      <h2 style={{ margin: '0 0 3px', fontSize: '16px', fontWeight: 900, lineHeight: 1.3 }}>{libro?.titulo}</h2>
      <p style={{ color: '#1DB954', margin: '0 0 14px', fontSize: '12px', fontWeight: 'bold' }}>{libro?.autor}</p>

      {/* Stats de inicio */}
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '8px', marginBottom: '14px' }}>
        {fechaInicio && <div style={{ background: '#111', borderRadius: '10px', padding: '11px', border: '1px solid #1e1e1e' }}><p style={{ margin: '0 0 2px', fontSize: '10px', color: '#444', textTransform: 'uppercase', letterSpacing: '0.8px' }}>Empezado</p><p style={{ margin: 0, fontSize: '13px', fontWeight: 'bold', color: 'white' }}>{fechaInicio.toLocaleDateString('es-ES', { day: 'numeric', month: 'short' })}</p></div>}
        {diasLeyendo && <div style={{ background: '#111', borderRadius: '10px', padding: '11px', border: '1px solid #1e1e1e' }}><p style={{ margin: '0 0 2px', fontSize: '10px', color: '#444', textTransform: 'uppercase', letterSpacing: '0.8px' }}>Días leyendo</p><p style={{ margin: 0, fontSize: '13px', fontWeight: 'bold', color: '#38bdf8' }}>{diasLeyendo}d</p></div>}
      </div>

      {/* Progreso con inputs */}
      <div style={{ background: '#111', borderRadius: '10px', padding: '14px', border: '1px solid #1e1e1e', marginBottom: '14px' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
          <p style={{ margin: 0, fontSize: '11px', color: '#555', textTransform: 'uppercase', letterSpacing: '0.8px', fontWeight: 'bold' }}>Progreso</p>
          {pct !== null && <span style={{ fontSize: '13px', fontWeight: 900, color: '#1DB954' }}>{pct}%</span>}
        </div>
        <div style={{ height: '5px', background: '#1a1a1a', borderRadius: '5px', overflow: 'hidden', marginBottom: '12px' }}>
          <div style={{ height: '100%', width: `${pct || 0}%`, background: 'linear-gradient(90deg, #1DB954, #4ade80)', borderRadius: '5px', boxShadow: '0 0 6px #1DB95466', transition: '0.3s ease' }} />
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <div style={{ flex: 1 }}>
            <p style={{ margin: '0 0 4px', fontSize: '10px', color: '#555' }}>Página actual</p>
            <input type="number" min="1" placeholder="0"
              value={pagActual}
              onChange={e => setPagActual(e.target.value)}
              onBlur={e => guardarPaginas(e.target.value, totalPags)}
              style={{ width: '100%', background: '#1a1a1a', border: '1px solid #2a2a2a', borderRadius: '8px', padding: '8px 10px', color: 'white', fontSize: '14px', fontWeight: 'bold', outline: 'none', boxSizing: 'border-box', textAlign: 'center' }}
              onFocus={e => e.target.style.borderColor = '#1DB95466'}
            />
          </div>
          <span style={{ color: '#333', fontSize: '18px', marginTop: '16px' }}>/</span>
          <div style={{ flex: 1 }}>
            <p style={{ margin: '0 0 4px', fontSize: '10px', color: '#555' }}>Total páginas</p>
            <input type="number" min="1" placeholder="???"
              value={totalPags}
              onChange={e => setTotalPags(e.target.value)}
              onBlur={e => guardarPaginas(pagActual, e.target.value)}
              style={{ width: '100%', background: '#1a1a1a', border: '1px solid #2a2a2a', borderRadius: '8px', padding: '8px 10px', color: '#aaa', fontSize: '14px', outline: 'none', boxSizing: 'border-box', textAlign: 'center' }}
              onFocus={e => e.target.style.borderColor = '#1DB95466'}
            />
          </div>
        </div>
      </div>

      <p style={{ fontSize: '11px', color: '#555', textTransform: 'uppercase', letterSpacing: '1px', margin: '0 0 8px', fontWeight: 'bold' }}>Sesión de lectura</p>
      <TimerLectura userId={userId} libroId={libro?.id} libro={libro} esPremium={true} onUpgrade={() => {}} />
      <NotasLectura userId={userId} libroId={libro?.id} />
      {/* Cambiar estado */}
      <div style={{ marginTop: '20px', paddingTop: '16px', borderTop: '1px solid #1a1a1a' }}>
        <EstadoLectura libroId={libro?.id} userId={userId} libro={libro} onActividad={() => {}} />
      </div>
    </div>
  );
}

// ── Panel libro Leído ─────────────────────────────────────────────────────────
function PanelLeido({ userId, libro, entrada, soloLectura = false }) {
  const [statsTimer, setStatsTimer] = React.useState(null);
  const [vibes, setVibes] = React.useState([]);
  React.useEffect(() => {
    if (!userId || !libro?.id) return;
    getDoc(doc(db, 'stats_timer_libro', `${userId}_${libro.id}`)).then(snap => { if (snap.exists()) setStatsTimer(snap.data()); }).catch(() => {});
    getDoc(doc(db, 'estados_lectura', `${libro.id}_${userId}`)).then(snap => { if (snap.exists()) setVibes(snap.data().vibes || []); }).catch(() => {});
  }, [userId, libro?.id]);
  const fechaFin = entrada?.fecha?.toDate?.() || null;
  const formatSeg = seg => { if (!seg || seg < 60) return `${seg||0}s`; const h = Math.floor(seg/3600), m = Math.floor((seg%3600)/60); return h > 0 ? `${h}h ${m}m` : `${m}m`; };
  const VIBE_COLORS = { adictivo:'#f97316',oscuro:'#8b5cf6',romantico:'#ec4899',epico:'#3b82f6',emotivo:'#06b6d4',divertido:'#eab308',misterioso:'#6366f1',inspirador:'#f59e0b',lento:'#64748b',rapido:'#10b981',reflexivo:'#1DB954',perturbador:'#ef4444' };
  const VIBE_LABELS = { adictivo:'Adictivo',oscuro:'Oscuro',romantico:'Romántico',epico:'Épico',emotivo:'Emotivo',divertido:'Divertido',misterioso:'Misterioso',inspirador:'Inspirador',lento:'Ritmo lento',rapido:'Ritmo rápido',reflexivo:'Reflexivo',perturbador:'Perturbador' };
  return (
    <div>
      <div style={{ width: '100%', maxHeight: '200px', borderRadius: '10px', overflow: 'hidden', marginBottom: '14px', position: 'relative' }}>
        {libro?.portada?.startsWith('https://') ? <img src={libro.portada} alt="" style={{ width: '100%', maxHeight: '200px', objectFit: 'cover', display: 'block' }} onError={e => e.currentTarget.style.display='none'} /> : <div style={{ height: '140px', background: '#1a1a1a', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '36px' }}>📖</div>}
        <div style={{ position: 'absolute', top: '8px', right: '8px', background: '#1DB954', borderRadius: '20px', padding: '3px 9px', display: 'flex', alignItems: 'center', gap: '4px' }}><svg width="10" height="10" viewBox="0 0 24 24" fill="black"><path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/></svg><span style={{ fontSize: '10px', fontWeight: 'bold', color: 'black' }}>Leído</span></div>
      </div>
      <h2 style={{ margin: '0 0 3px', fontSize: '16px', fontWeight: 900, lineHeight: 1.3 }}>{libro?.titulo}</h2>
      <p style={{ color: '#1DB954', margin: '0 0 14px', fontSize: '12px', fontWeight: 'bold' }}>{libro?.autor}</p>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '8px', marginBottom: '14px' }}>
        {fechaFin && <div style={{ background: '#111', borderRadius: '10px', padding: '11px', border: '1px solid #1e1e1e' }}><p style={{ margin: '0 0 2px', fontSize: '10px', color: '#444', textTransform: 'uppercase', letterSpacing: '0.8px' }}>Terminado</p><p style={{ margin: 0, fontSize: '12px', fontWeight: 'bold', color: 'white' }}>{fechaFin.toLocaleDateString('es-ES', { day: 'numeric', month: 'short', year: 'numeric' })}</p></div>}
        {statsTimer?.totalSegundos > 0 && <div style={{ background: '#111', borderRadius: '10px', padding: '11px', border: '1px solid #1e1e1e' }}><p style={{ margin: '0 0 2px', fontSize: '10px', color: '#444', textTransform: 'uppercase', letterSpacing: '0.8px' }}>Tiempo leído</p><p style={{ margin: 0, fontSize: '12px', fontWeight: 'bold', color: '#a78bfa' }}>{formatSeg(statsTimer.totalSegundos)}</p></div>}
      </div>
      {vibes.length > 0 && <div style={{ marginBottom: '14px' }}><p style={{ fontSize: '11px', color: '#555', textTransform: 'uppercase', letterSpacing: '1px', margin: '0 0 8px', fontWeight: 'bold' }}>Vibe</p><div style={{ display: 'flex', flexWrap: 'wrap', gap: '6px' }}>{vibes.map(v => <span key={v} style={{ background: `${VIBE_COLORS[v]||'#555'}18`, color: VIBE_COLORS[v]||'#555', border: `1px solid ${VIBE_COLORS[v]||'#555'}44`, borderRadius: '20px', padding: '4px 10px', fontSize: '11px', fontWeight: 'bold' }}>{VIBE_LABELS[v]||v}</span>)}</div></div>}
      {!soloLectura && <><p style={{ fontSize: '11px', color: '#555', textTransform: 'uppercase', letterSpacing: '1px', margin: '0 0 8px', fontWeight: 'bold' }}>Valoración</p><ValoracionEstrellas libroId={libro?.id} userId={userId} libro={libro} onActividad={() => {}} /></>}
      {!soloLectura && <div style={{ marginTop: '14px' }}><CitasLibro userId={userId} libroId={libro?.id} libro={libro} esPremium={true} onUpgrade={() => {}} /></div>}
      {soloLectura && vibes.length === 0 && <p style={{ fontSize: '12px', color: '#333', marginTop: '8px' }}>Esta persona no ha añadido vibes todavía.</p>}
      {/* Cambiar estado — desmarcar leído */}
      {!soloLectura && (
        <div style={{ marginTop: '20px', paddingTop: '16px', borderTop: '1px solid #1a1a1a' }}>
          <EstadoLectura libroId={libro?.id} userId={userId} libro={libro} onActividad={() => {}} />
        </div>
      )}
    </div>
  );
}

// ── Panel libro Quiero Leer ───────────────────────────────────────────────────
function PanelQuieroLeer({ userId, libro, entrada, soloLectura = false }) {
  return (
    <div>
      <div style={{ width: '100%', maxHeight: '200px', borderRadius: '10px', overflow: 'hidden', marginBottom: '14px' }}>
        {libro?.portada?.startsWith('https://') ? <img src={libro.portada} alt="" style={{ width: '100%', maxHeight: '200px', objectFit: 'cover', display: 'block' }} onError={e => e.currentTarget.style.display='none'} /> : <div style={{ height: '140px', background: '#1a1a1a', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '36px' }}>🔖</div>}
      </div>
      <h2 style={{ margin: '0 0 3px', fontSize: '16px', fontWeight: 900, lineHeight: 1.3 }}>{libro?.titulo}</h2>
      <p style={{ color: '#1DB954', margin: '0 0 14px', fontSize: '12px', fontWeight: 'bold' }}>{libro?.autor}</p>
      {entrada?.fecha && <div style={{ background: '#111', borderRadius: '10px', padding: '11px', border: '1px solid #1e1e1e', marginBottom: '14px' }}><p style={{ margin: '0 0 2px', fontSize: '10px', color: '#444', textTransform: 'uppercase', letterSpacing: '0.8px' }}>Añadido</p><p style={{ margin: 0, fontSize: '13px', fontWeight: 'bold', color: 'white' }}>{entrada.fecha.toDate?.()?.toLocaleDateString('es-ES', { day: 'numeric', month: 'long', year: 'numeric' }) || '—'}</p></div>}
      {!soloLectura && <EstadoLectura libroId={libro?.id} userId={userId} libro={libro} onActividad={() => {}} />}
    </div>
  );
}

// ── Panel de notas de un libro — página de diario ─────────────────────────────
function PanelNotas({ userId, libro, entrada }) {
  const [nota, setNota] = React.useState('');
  const [fecha, setFecha] = React.useState(null);
  const [cargando, setCargando] = React.useState(true);
  const [guardando, setGuardando] = React.useState(false);
  const [guardado, setGuardado] = React.useState(false);

  React.useEffect(() => {
    if (!userId || !libro?.id) return;
    setCargando(true);
    getDoc(doc(db, 'notas_lectura', `${userId}_${libro.id}`)).then(snap => {
      if (snap.exists()) {
        setNota(snap.data().texto || '');
        setFecha(snap.data().fecha?.toDate?.() || null);
      }
      setCargando(false);
    }).catch(() => setCargando(false));
  }, [userId, libro?.id]);

  const guardar = async () => {
    if (guardando || !libro?.id) return;
    setGuardando(true);
    try {
      await setDoc(doc(db, 'notas_lectura', `${userId}_${libro.id}`), { userId, libroId: libro.id, texto: nota, fecha: serverTimestamp() }, { merge: true });
      setFecha(new Date());
      setGuardado(true); setTimeout(() => setGuardado(false), 2000);
    } catch {}
    setGuardando(false);
  };

  return (
    <div>
      {/* Cabecera con portada y degradado */}
      <div style={{ width: '100%', height: '190px', borderRadius: '14px', overflow: 'hidden', marginBottom: '18px', position: 'relative' }}>
        {libro?.portada?.startsWith('https://')
          ? <img src={libro.portada} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }} onError={e => e.currentTarget.style.display = 'none'} />
          : <div style={{ height: '100%', background: 'linear-gradient(135deg, #201a12, #14100a)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}><svg width="40" height="40" viewBox="0 0 24 24" fill="#f97316" opacity="0.5"><path d="M4 4a2 2 0 012-2h9l5 5v13a2 2 0 01-2 2H6a2 2 0 01-2-2V4z" /><path d="M15 2v5h5" fill="#14100a" /></svg></div>}
        <div style={{ position: 'absolute', inset: 0, background: 'linear-gradient(180deg, transparent 35%, rgba(0,0,0,0.88) 100%)' }} />
        <div style={{ position: 'absolute', bottom: '12px', left: '14px', right: '14px' }}>
          <h2 style={{ margin: 0, fontSize: '17px', fontWeight: 900, lineHeight: 1.25, color: 'white', textShadow: '0 2px 10px rgba(0,0,0,0.9)' }}>{libro?.titulo}</h2>
          <p style={{ margin: '3px 0 0', fontSize: '12px', color: '#fdba74', fontWeight: 'bold' }}>{libro?.autor}</p>
        </div>
      </div>

      {/* Tarjeta tipo página de diario */}
      <div style={{ position: 'relative', background: 'linear-gradient(160deg, #201a12 0%, #14100a 100%)', border: '1px solid #f9731633', borderRadius: '16px', padding: '22px 20px 18px', overflow: 'hidden', boxShadow: '0 12px 30px rgba(0,0,0,0.5), 0 0 40px rgba(249,115,22,0.06)' }}>
        {/* Resplandor decorativo */}
        <div style={{ position: 'absolute', top: '-50px', right: '-50px', width: '160px', height: '160px', borderRadius: '50%', background: 'radial-gradient(circle, #f9731633, transparent 70%)', pointerEvents: 'none' }} />

        <div style={{ display: 'flex', alignItems: 'center', gap: '9px', marginBottom: '16px' }}>
          <svg width="19" height="19" viewBox="0 0 24 24" fill="none">
            <defs><linearGradient id="gradPaginaNotas" x1="0" y1="0" x2="1" y2="1"><stop offset="0%" stopColor="#fdba74" /><stop offset="100%" stopColor="#f97316" /></linearGradient></defs>
            <path d="M4 4a2 2 0 012-2h9l5 5v13a2 2 0 01-2 2H6a2 2 0 01-2-2V4z" fill="url(#gradPaginaNotas)" />
            <path d="M15 2v5h5" fill="#fed7aa" />
          </svg>
          <span style={{ fontSize: '11px', color: '#f97316', textTransform: 'uppercase', letterSpacing: '1.6px', fontWeight: 900 }}>Tus notas</span>
          {fecha && <span style={{ marginLeft: 'auto', fontSize: '11px', color: '#666' }}>Editado {fecha.toLocaleDateString('es-ES', { day: 'numeric', month: 'short' })}</span>}
        </div>

        {cargando ? (
          <div style={{ height: '120px', background: '#ffffff08', borderRadius: '10px', animation: 'pulse 1.5s infinite' }} />
        ) : (
          <div style={{ position: 'relative' }}>
            <span style={{ position: 'absolute', top: '-14px', left: '2px', fontSize: '48px', color: '#f97316', opacity: 0.16, fontFamily: 'Georgia, serif', lineHeight: 1, pointerEvents: 'none' }}>&#8220;</span>
            <textarea
              value={nota}
              onChange={e => setNota(e.target.value)}
              placeholder="Escribe aquí tus reflexiones, frases favoritas, ideas..."
              style={{ width: '100%', minHeight: '180px', background: 'transparent', border: 'none', color: '#e8dcc8', fontSize: '14px', lineHeight: 1.8, fontFamily: 'Georgia, serif', resize: 'vertical', outline: 'none', boxSizing: 'border-box', padding: '10px 4px 0 22px' }}
              onFocus={e => e.target.style.background = '#ffffff05'}
              onBlur={e => { e.target.style.background = 'transparent'; guardar(); }}
            />
          </div>
        )}
        {guardado && <p style={{ fontSize: '11px', color: '#f97316', margin: '10px 0 0', fontWeight: 'bold' }}>&#10003; Nota guardada</p>}
      </div>
    </div>
  );
}

function BibliotecaPersonal({ userId, onVerLibro, onVolver, esPremium, onUpgrade, onLibroActivo, onEntradasCargadas, soloLectura = false }) {
  const isMobile = useIsMobile();
  const [entradas, setEntradas] = useState([]);
  const [cargando, setCargando] = useState(true);
  const [tabActiva, setTabActiva] = useState('inicio');

  useEffect(() => {
    if (!userId) return;
    setCargando(true);
    getDocs(query(collection(db, 'estados_lectura'), where('userId', '==', userId), limit(500)))
      .then(snap => {
        const data = snap.docs.map(d => d.data()).filter(d => d.estado && d.libro?.titulo && ESTADOS_LECTURA.some(e => e.valor === d.estado));
        setEntradas(data);
        setCargando(false);
        if (onEntradasCargadas) onEntradasCargadas(data);
      })
      .catch(() => setCargando(false));
  }, [userId]);

  // Notas personales por libro — solo en la biblioteca propia (privadas)
  // Las reglas de Firestore solo permiten leer notas_lectura documento a documento
  // (el id debe empezar por el uid del usuario), así que se piden una a una por libro
  // en vez de con una query sobre la colección completa.
  const [notasMap, setNotasMap] = useState({});
  useEffect(() => {
    if (!userId || soloLectura || entradas.length === 0) return;
    let activo = true;
    (async () => {
      const map = {};
      await Promise.all(entradas.map(async (e) => {
        if (!e.libroId) return;
        try {
          const snap = await getDoc(doc(db, 'notas_lectura', `${userId}_${e.libroId}`));
          if (snap.exists()) {
            const data = snap.data();
            if (data.texto && data.texto.trim()) map[e.libroId] = data;
          }
        } catch {}
      }));
      if (activo) setNotasMap(map);
    })();
    return () => { activo = false; };
  }, [userId, soloLectura, entradas]);

  const quieroLeer = entradas.filter(e => e.estado === 'quiero_leer');
  const leyendo    = entradas.filter(e => e.estado === 'leyendo');
  const leidos     = entradas.filter(e => e.estado === 'leido');

  const abrirLibro = (entrada) => { if (onLibroActivo) onLibroActivo(entrada, soloLectura); };
  const abrirLibroNotas = (entrada) => { if (onLibroActivo) onLibroActivo(entrada, soloLectura, 'notas'); };

  // Rellenar portadas faltantes en background
  const portadasEnCurso = React.useRef(new Set());
  const entradasRef = React.useRef([]);
  entradasRef.current = entradas;

  useEffect(() => {
    if (!userId || soloLectura || cargando) return;

    const sinPortada = entradasRef.current.filter(e =>
      !e.libro?.portada &&
      e.libro?.titulo &&
      e.libroId &&
      !portadasEnCurso.current.has(e.libroId)
    );

    if (sinPortada.length === 0) return;
    sinPortada.forEach(e => portadasEnCurso.current.add(e.libroId));

    const norm = s => (s || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').trim();
    // Caché en localStorage para no releer portadas_cache de Firestore cada sesión
    const lsKey = `leemos_portadas_${userId}`;
    let portadasLocal = {};
    try { portadasLocal = JSON.parse(localStorage.getItem(lsKey) || '{}'); } catch {}
    const guardarLocal = (libroId, portada) => {
      portadasLocal[libroId] = portada;
      try { localStorage.setItem(lsKey, JSON.stringify(portadasLocal)); } catch {}
    };

    const buscarPortadaParaLibro = async (entrada) => {
      const titulo = entrada.libro.titulo;
      const autor = entrada.libro.autor || '';
      const libroId = entrada.libroId;

      // 0. Caché localStorage — sin coste de Firestore
      if (portadasLocal[libroId]) return portadasLocal[libroId];

      try {
        // 1. Buscar en portadas_cache de Firestore
        const cacheSnap = await getDoc(doc(db, 'portadas_cache', libroId));
        if (cacheSnap.exists() && cacheSnap.data().portada) {
          guardarLocal(libroId, cacheSnap.data().portada);
          return cacheSnap.data().portada;
        }

        // 2. Buscar coincidencia en SAGAS_CONOCIDAS por título normalizado
        const tNorm = norm(titulo);
        for (const saga of SAGAS_CONOCIDAS) {
          const libroSaga = saga.libros.find(l => norm(l.titulo) === tNorm ||
            (tNorm.length > 8 && norm(l.titulo).includes(tNorm.slice(0, 12))) ||
            (tNorm.length > 8 && tNorm.includes(norm(l.titulo).slice(0, 12))));
          if (libroSaga) {
            const q = encodeURIComponent(`intitle:${libroSaga.titulo} inauthor:${libroSaga.autor}`);
            const resp = await fetch(`https://www.googleapis.com/books/v1/volumes?q=${q}&maxResults=3&key=${GOOGLE_BOOKS_API_KEY}`);
            if (resp.ok) {
              const data = await resp.json();
              const item = data.items?.find(it => it.volumeInfo?.imageLinks?.thumbnail);
              if (item) {
                const portada = item.volumeInfo.imageLinks.thumbnail
                  .replace('http://', 'https://').replace(/zoom=\d/, 'zoom=1').replace('&edge=curl', '');
                setDoc(doc(db, 'portadas_cache', libroId), { titulo, autor, portada }).catch(() => {});
                guardarLocal(libroId, portada);
                return portada;
              }
            }
          }
        }

        // 3. Búsqueda directa en Google Books con título + autor
        await new Promise(r => setTimeout(r, 200));
        const q = encodeURIComponent(`${titulo} ${autor}`);
        const resp = await fetch(`https://www.googleapis.com/books/v1/volumes?q=${q}&maxResults=5&key=${GOOGLE_BOOKS_API_KEY}`);
        if (!resp.ok) return null;
        const data = await resp.json();
        const item = data.items?.find(it => it.volumeInfo?.imageLinks?.thumbnail);
        if (!item) return null;
        const portada = item.volumeInfo.imageLinks.thumbnail
          .replace('http://', 'https://').replace(/zoom=\d/, 'zoom=1').replace('&edge=curl', '');
        setDoc(doc(db, 'portadas_cache', libroId), { titulo, autor, portada }).catch(() => {});
        guardarLocal(libroId, portada);
        return portada;

      } catch { return null; }
    };

    (async () => {
      for (let i = 0; i < sinPortada.length; i += 3) {
        const lote = sinPortada.slice(i, i + 3);
        await Promise.all(lote.map(async (entrada) => {
          const portada = await buscarPortadaParaLibro(entrada);
          if (!portada) return;
          await setDoc(doc(db, 'estados_lectura', `${entrada.libroId}_${userId}`), {
            libro: { ...entrada.libro, portada }
          }, { merge: true });
        }));
        if (i + 3 < sinPortada.length) await new Promise(r => setTimeout(r, 500));
      }
    })();
  }, [cargando]); // eslint-disable-line

  const irABuscar  = () => onVolver();
  const dnf = entradas.filter(e => e.estado === 'dnf');
  const librosConNotas = entradas
    .filter(e => notasMap[e.libroId]?.texto?.trim())
    .sort((a, b) => (notasMap[b.libroId]?.fecha?.toMillis?.() || 0) - (notasMap[a.libroId]?.fecha?.toMillis?.() || 0));
  const filtroEstado = { quiero_leer: quieroLeer, leyendo, leido: leidos, dnf, notas: librosConNotas }[tabActiva] || [];

  const TABS = [
    { id: 'inicio',      label: 'Inicio' },
    { id: 'quiero_leer', label: 'Quiero leer', count: quieroLeer.length, color: '#1DB954' },
    { id: 'leyendo',     label: 'Leyendo',      count: leyendo.length,   color: '#a78bfa' },
    { id: 'leido',       label: 'Leídos',       count: leidos.length,    color: '#FFD700' },
    { id: 'dnf',         label: 'Lo dejé',      count: dnf.length,       color: '#f44336' },
    ...(!soloLectura ? [{ id: 'notas', label: 'Notas', count: librosConNotas.length, color: '#f97316' }] : []),
  ];

  // SVGs planos para cada sección
  const SVG_QUIERO = <path d="M17 3H7c-1.1 0-1.99.9-1.99 2L5 21l7-3 7 3V5c0-1.1-.9-2-2-2zm0 15l-5-2.18L7 18V5h10v13z"/>;
  const SVG_LEYENDO = <path d="M21 5c-1.11-.35-2.33-.5-3.5-.5-1.95 0-4.05.4-5.5 1.5-1.45-1.1-3.55-1.5-5.5-1.5S2.45 4.9 1 6v14.65c0 .25.25.5.5.5.1 0 .15-.05.25-.05C3.1 20.45 5.05 20 6.5 20c1.95 0 4.05.4 5.5 1.5 1.35-.85 3.8-1.5 5.5-1.5 1.65 0 3.35.3 4.75 1.05.1.05.15.05.25.05.25 0 .5-.25.5-.5V6c-.6-.45-1.25-.75-2-1zm0 13.5c-1.1-.35-2.3-.5-3.5-.5-1.7 0-4.15.65-5.5 1.5V8c1.35-.85 3.8-1.5 5.5-1.5 1.2 0 2.4.15 3.5.5v11.5z"/>;
  const SVG_LEIDO  = <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/>;
  const SVG_DNF    = <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/>;
  const SVG_NOTAS  = <path d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34a.9994.9994 0 00-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"/>;

  const overlayLeido = (entrada) => (
    <div style={{ position: 'absolute', top: '8px', right: '8px', width: '26px', height: '26px', borderRadius: '50%', background: '#1DB954', display: 'flex', alignItems: 'center', justifyContent: 'center', boxShadow: '0 2px 8px rgba(29,185,84,0.5)' }}>
      <svg width="14" height="14" viewBox="0 0 24 24" fill="black"><path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/></svg>
    </div>
  );

  const bloqueQuiero = (
    <BloqueSeccion titulo="Quiero leer" subtitulo="Libros que quieres leer próximamente"
      color="#1DB954" gradientColor="#1DB954" svgIcon={SVG_QUIERO}
      libros={quieroLeer} cargando={cargando}
      onVerLibro={abrirLibro} onAnadir={irABuscar} onVerTodos={() => setTabActiva('quiero_leer')}
      renderOverlay={null} />
  );
  const bloqueLeyendo = (
    <BloqueSeccion titulo="Leyendo" subtitulo="Libros que estás leyendo ahora"
      color="#a78bfa" gradientColor="#a78bfa" svgIcon={SVG_LEYENDO}
      libros={leyendo} cargando={cargando}
      onVerLibro={abrirLibro} onAnadir={irABuscar} onVerTodos={() => setTabActiva('leyendo')}
      renderOverlay={null} />
  );
  const bloqueLeido = (
    <BloqueSeccion titulo="Terminados" subtitulo="Libros que ya has leído"
      color="#FFD700" gradientColor="#FFD700" svgIcon={SVG_LEIDO}
      libros={leidos} cargando={cargando}
      onVerLibro={abrirLibro} onAnadir={irABuscar} onVerTodos={() => setTabActiva('leido')}
      renderOverlay={overlayLeido} />
  );
  const bloqueDnf = dnf.length > 0 ? (
    <BloqueSeccion titulo="Lo dejé" subtitulo="Libros que no terminaste"
      color="#f44336" gradientColor="#f44336" svgIcon={SVG_DNF}
      libros={dnf} cargando={cargando}
      onVerLibro={abrirLibro} onAnadir={irABuscar} onVerTodos={() => setTabActiva('dnf')}
      renderOverlay={null} />
  ) : null;

  const overlayNota = () => (
    <div style={{ position: 'absolute', top: '8px', right: '8px', width: '26px', height: '26px', borderRadius: '50%', background: '#f97316', display: 'flex', alignItems: 'center', justifyContent: 'center', boxShadow: '0 2px 8px rgba(249,115,22,0.5)' }}>
      <svg width="13" height="13" viewBox="0 0 24 24" fill="black">{SVG_NOTAS}</svg>
    </div>
  );
  const bloqueNotas = librosConNotas.length > 0 ? (
    <BloqueSeccion titulo="Notas" subtitulo="Reflexiones y apuntes que has ido dejando en tus libros"
      color="#f97316" gradientColor="#f97316" svgIcon={SVG_NOTAS}
      libros={librosConNotas} cargando={cargando}
      onVerLibro={abrirLibroNotas} onAnadir={irABuscar} onVerTodos={() => setTabActiva('notas')}
      renderOverlay={overlayNota} />
  ) : null;

  return (
    <div style={{ padding: isMobile ? '0 14px 80px' : '0 28px 40px', overflowX: 'hidden' }}>
      {/* Header */}
      <div style={{ display: 'flex', alignItems: 'center', gap: '12px', margin: '24px 0 6px' }}>
        <svg width="24" height="24" viewBox="0 0 24 24" fill="#1DB954" style={{ flexShrink: 0 }}><path d="M21 5c-1.11-.35-2.33-.5-3.5-.5-1.95 0-4.05.4-5.5 1.5-1.45-1.1-3.55-1.5-5.5-1.5S2.45 4.9 1 6v14.65c0 .25.25.5.5.5.1 0 .15-.05.25-.05C3.1 20.45 5.05 20 6.5 20c1.95 0 4.05.4 5.5 1.5 1.35-.85 3.8-1.5 5.5-1.5 1.65 0 3.35.3 4.75 1.05.1.05.15.05.25.05.25 0 .5-.25.5-.5V6c-.6-.45-1.25-.75-2-1zm0 13.5c-1.1-.35-2.3-.5-3.5-.5-1.7 0-4.15.65-5.5 1.5V8c1.35-.85 3.8-1.5 5.5-1.5 1.2 0 2.4.15 3.5.5v11.5z"/></svg>
        <div>
          <h1 style={{ fontSize: '26px', margin: 0, fontWeight: 900, color: 'white', lineHeight: 1 }}>Mi biblioteca</h1>
          <p style={{ margin: '3px 0 0', fontSize: '12px', color: '#555' }}>Todos los libros que formas parte de tu historia.</p>
        </div>
      </div>

      {/* Tabs */}
      <div style={{ display: 'flex', gap: '6px', margin: '18px 0 22px', overflowX: 'auto', scrollbarWidth: 'none' }}>
        {TABS.map(t => {
          const activo = tabActiva === t.id;
          const c = t.color || '#1DB954';
          return (
            <button key={t.id} onClick={() => setTabActiva(t.id)}
              style={{ flexShrink: 0, background: activo ? `${c}18` : 'transparent', color: activo ? c : '#555', border: `1px solid ${activo ? c+'55' : '#222'}`, borderRadius: '20px', padding: '7px 16px', cursor: 'pointer', fontWeight: activo ? 'bold' : 'normal', fontSize: '13px', transition: '0.2s', display: 'flex', alignItems: 'center', gap: '6px' }}>
              <span>{t.label}</span>
              {t.count !== undefined && t.count > 0 && (
                <span style={{ background: activo ? `${c}33` : '#1a1a1a', color: activo ? c : '#555', borderRadius: '10px', padding: '1px 6px', fontSize: '10px', fontWeight: 'bold' }}>{t.count}</span>
              )}
            </button>
          );
        })}
      </div>

      {/* Contenido */}
      {tabActiva === 'inicio' ? (
        <>
          {bloqueQuiero}
          {bloqueLeyendo}
          {bloqueLeido}
          {bloqueDnf}
          {!soloLectura && bloqueNotas}
          {/* En móvil mostramos las stats aquí abajo */}
          {isMobile && (
            <div style={{ marginTop: '8px' }}>
              <PanelProgresoLector userId={userId} entradas={entradas} />
            </div>
          )}
        </>
      ) : (
        <>
          {tabActiva === 'quiero_leer' && <BloqueSeccion titulo="Quiero leer" subtitulo="Libros que quieres leer próximamente"
            color="#1DB954" gradientColor="#1DB954" svgIcon={SVG_QUIERO}
            libros={quieroLeer} cargando={cargando} modoGrid={true}
            onVerLibro={abrirLibro} onAnadir={irABuscar} onVerTodos={() => {}} renderOverlay={null} />}
          {tabActiva === 'leyendo' && <BloqueSeccion titulo="Leyendo" subtitulo="Libros que estás leyendo ahora"
            color="#a78bfa" gradientColor="#a78bfa" svgIcon={SVG_LEYENDO}
            libros={leyendo} cargando={cargando} modoGrid={true}
            onVerLibro={abrirLibro} onAnadir={irABuscar} onVerTodos={() => {}} renderOverlay={null} />}
          {tabActiva === 'leido' && <BloqueSeccion titulo="Terminados" subtitulo="Libros que ya has leído"
            color="#FFD700" gradientColor="#FFD700" svgIcon={SVG_LEIDO}
            libros={leidos} cargando={cargando} modoGrid={true}
            onVerLibro={abrirLibro} onAnadir={irABuscar} onVerTodos={() => {}} renderOverlay={overlayLeido} />}
          {tabActiva === 'dnf' && <BloqueSeccion titulo="Lo dejé" subtitulo="Libros que no terminaste"
            color="#f44336" gradientColor="#f44336" svgIcon={SVG_DNF}
            libros={dnf} cargando={cargando} modoGrid={true}
            onVerLibro={abrirLibro} onAnadir={irABuscar} onVerTodos={() => {}} renderOverlay={null} />}
          {tabActiva === 'notas' && <BloqueSeccion titulo="Notas" subtitulo="Reflexiones y apuntes que has ido dejando en tus libros"
            color="#f97316" gradientColor="#f97316" svgIcon={SVG_NOTAS}
            libros={librosConNotas} cargando={cargando} modoGrid={true}
            onVerLibro={abrirLibroNotas} onAnadir={irABuscar} onVerTodos={() => {}} renderOverlay={overlayNota} />}
        </>
      )}
    </div>
  );
}

// ── Marcos de avatar premium ──────────────────────────────────────────────────
export const MARCOS_AVATAR = [
  {
    id: 'ninguno',
    nombre: 'Sin marco',
    premium: false,
    estilo: {},
    preview: null,
  },
  {
    id: 'verde',
    nombre: 'Esmeralda',
    premium: false,
    estilo: { border: '2px solid #1DB954', boxShadow: '0 0 0 1px #1DB95444' },
    preview: '#1DB954',
  },
  {
    id: 'dorado',
    nombre: 'Dorado',
    premium: true,
    estilo: { border: '2px solid transparent', backgroundImage: 'linear-gradient(#0d0d0d, #0d0d0d), linear-gradient(135deg, #7d5a00, #FFD700, #FFA500, #7d5a00)', backgroundOrigin: 'border-box', backgroundClip: 'padding-box, border-box', boxShadow: '0 0 12px #FFD70066' },
    preview: 'linear-gradient(135deg, #7d5a00, #FFD700, #FFA500)',
  },
  {
    id: 'platino',
    nombre: 'Platino',
    premium: true,
    estilo: { border: '2px solid transparent', backgroundImage: 'linear-gradient(#0d0d0d, #0d0d0d), linear-gradient(135deg, #1a0533, #a78bfa, #38bdf8, #1a0533)', backgroundOrigin: 'border-box', backgroundClip: 'padding-box, border-box', boxShadow: '0 0 16px #a78bfa66' },
    preview: 'linear-gradient(135deg, #1a0533, #a78bfa, #38bdf8)',
  },
  {
    id: 'fuego',
    nombre: 'Fuego',
    premium: true,
    estilo: { border: '2px solid transparent', backgroundImage: 'linear-gradient(#0d0d0d, #0d0d0d), linear-gradient(135deg, #7d1a00, #f44336, #ff9800, #f44336)', backgroundOrigin: 'border-box', backgroundClip: 'padding-box, border-box', boxShadow: '0 0 14px #f4433666' },
    preview: 'linear-gradient(135deg, #7d1a00, #f44336, #ff9800)',
  },
  {
    id: 'oceano',
    nombre: 'Océano',
    premium: true,
    estilo: { border: '2px solid transparent', backgroundImage: 'linear-gradient(#0d0d0d, #0d0d0d), linear-gradient(135deg, #001a33, #0288d1, #00bcd4, #0288d1)', backgroundOrigin: 'border-box', backgroundClip: 'padding-box, border-box', boxShadow: '0 0 14px #0288d166' },
    preview: 'linear-gradient(135deg, #001a33, #0288d1, #00bcd4)',
  },
  {
    id: 'aurora',
    nombre: 'Aurora',
    premium: true,
    estilo: { border: '2px solid transparent', backgroundImage: 'linear-gradient(#0d0d0d, #0d0d0d), linear-gradient(135deg, #1a0533, #e91e63, #9c27b0, #3f51b5)', backgroundOrigin: 'border-box', backgroundClip: 'padding-box, border-box', boxShadow: '0 0 16px #e91e6366' },
    preview: 'linear-gradient(135deg, #1a0533, #e91e63, #9c27b0)',
  },
];

function SelectorMarcos({ marcoActual, esPremium, onSeleccionar }) {
  return (
    <div>
      <p style={{ fontSize: '12px', color: '#555', textTransform: 'uppercase', letterSpacing: '1px', margin: '0 0 14px' }}>
        Marco de avatar {!esPremium && <span style={{ color: '#a78bfa', fontSize: '10px' }}>— Desbloquea más con Premium</span>}
      </p>
      <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
        {MARCOS_AVATAR.map(marco => {
          const bloqueado = marco.premium && !esPremium;
          const activo = marcoActual === marco.id;
          return (
            <div key={marco.id}
              onClick={() => !bloqueado && onSeleccionar(marco.id)}
              title={bloqueado ? `${marco.nombre} — Solo Premium` : marco.nombre}
              style={{ position: 'relative', cursor: bloqueado ? 'not-allowed' : 'pointer', opacity: bloqueado ? 0.5 : 1, transition: '0.2s' }}>
              {/* Preview circular */}
              <div style={{
                width: '44px', height: '44px', borderRadius: '50%',
                background: marco.preview
                  ? typeof marco.preview === 'string' && marco.preview.startsWith('linear')
                    ? marco.preview
                    : marco.preview
                  : '#1a1a1a',
                border: activo ? '3px solid white' : '3px solid transparent',
                boxShadow: activo ? '0 0 0 2px #1DB954' : 'none',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                transition: '0.2s',
                transform: activo ? 'scale(1.1)' : 'scale(1)',
              }}>
                {!marco.preview && <span style={{ fontSize: '18px', color: '#555' }}>○</span>}
              </div>
              {/* Lock icon si premium */}
              {bloqueado && (
                <div style={{ position: 'absolute', top: -2, right: -2, background: '#a78bfa', borderRadius: '50%', width: '14px', height: '14px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '8px' }}>✦</div>
              )}
              {/* Nombre */}
              <p style={{ margin: '4px 0 0', fontSize: '10px', color: activo ? 'white' : '#444', textAlign: 'center', width: '44px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{marco.nombre}</p>
            </div>
          );
        })}
      </div>
    </div>
  );
}

// ── Banner publicitario no invasivo ──────────────────────────────────────────
// Solo visible para usuarios no premium
// Rota entre varios mensajes cada 30 segundos
// ── Modal Solicitud Verificado ────────────────────────────────────────────────
function ModalSolicitudVerificado({ perfil, onCerrar }) {
  const [tipo, setTipo] = React.useState('autor');
  const [nombreReal, setNombreReal] = React.useState('');
  const [instagram, setInstagram] = React.useState('');
  const [enviando, setEnviando] = React.useState(false);
  const [paso, setPaso] = React.useState(1); // 1: datos, 2: instrucciones, 3: enviado

  // Código único basado en el UID del usuario — imposible de falsificar
  const codigoVerificacion = `leemos-${perfil.id?.slice(0, 8)}`;

  const siguientePaso = () => {
    if (!nombreReal.trim() || !instagram.trim()) return;
    setPaso(2);
  };

  const enviar = async () => {
    setEnviando(true);
    try {
      const igHandle = instagram.replace('@', '').trim();
      const asunto = encodeURIComponent(`Solicitud verificado — ${tipo === 'autor' ? 'Autor' : 'Editorial'}: ${nombreReal}`);
      const cuerpo = encodeURIComponent(
        `SOLICITUD DE VERIFICADO EN LEEMOS\n\n` +
        `Tipo: ${tipo === 'autor' ? 'Autor verificado' : 'Editorial verificada'}\n` +
        `Nombre: ${nombreReal}\n` +
        `Usuario en la app: ${perfil.nombre} (ID: ${perfil.id})\n` +
        `Instagram: @${igHandle}\n` +
        `Código de verificación: ${codigoVerificacion}\n\n` +
        `El solicitante confirma haber añadido el código "${codigoVerificacion}" en la bio de su Instagram.\n` +
        `Por favor verifica en: https://instagram.com/${igHandle}`
      );
      window.open(`mailto:leemossupport@gmail.com?subject=${asunto}&body=${cuerpo}`, '_blank');
      setPaso(3);
    } catch { }
    setEnviando(false);
  };

  return (
    <div className="modal-overlay" onClick={onCerrar}>
      <div className="modal-content" style={{ maxWidth: '440px' }} onClick={e => e.stopPropagation()}>
        {paso === 3 && (
          <div style={{ textAlign: 'center', padding: '20px 0' }}>
            <div style={{ fontSize: '48px', marginBottom: '16px' }}>✦</div>
            <h3 style={{ margin: '0 0 10px', fontSize: '20px', fontWeight: 900 }}>¡Solicitud enviada!</h3>
            <p style={{ color: '#555', fontSize: '14px', margin: '0 0 8px', lineHeight: '1.6' }}>
              Revisaremos tu perfil de Instagram en 2-3 días hábiles.
            </p>
            <p style={{ color: '#333', fontSize: '13px', margin: '0 0 24px', lineHeight: '1.6' }}>
              Puedes retirar el código de tu bio una vez recibas la confirmación.
            </p>
            <button onClick={onCerrar} className="btn-verde">Cerrar</button>
          </div>
        )}
        {paso === 2 && (
          <>
            <div style={{ textAlign: 'center', marginBottom: '24px' }}>
              <div style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', width: '56px', height: '56px', borderRadius: '18px', background: 'linear-gradient(135deg, #0ea5e9, #0369a1)', marginBottom: '12px', boxShadow: '0 4px 20px #0ea5e966' }}>
                <span style={{ fontSize: '24px' }}>✦</span>
              </div>
              <h2 style={{ margin: '0 0 6px', fontSize: '20px', fontWeight: 900 }}>Verifica tu identidad</h2>
              <p style={{ color: '#555', fontSize: '13px', margin: 0 }}>Un paso rápido para confirmar que eres tú</p>
            </div>
            <div style={{ background: '#0ea5e911', border: '1px solid #0ea5e933', borderRadius: '12px', padding: '16px', marginBottom: '20px' }}>
              <p style={{ margin: '0 0 12px', fontSize: '13px', color: '#aaa', lineHeight: '1.6' }}>
                Añade este texto a la bio de tu Instagram <strong style={{ color: 'white' }}>@{instagram.replace('@', '')}</strong>:
              </p>
              <div style={{ background: '#0a0a0a', border: '1px solid #1DB95444', borderRadius: '8px', padding: '12px 16px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '8px' }}>
                <code style={{ fontSize: '15px', color: '#1DB954', fontWeight: 'bold', letterSpacing: '0.5px' }}>{codigoVerificacion}</code>
                <button onClick={() => navigator.clipboard?.writeText(codigoVerificacion)}
                  style={{ background: 'none', border: '1px solid #2a2a2a', color: '#555', borderRadius: '8px', padding: '4px 10px', cursor: 'pointer', fontSize: '11px', flexShrink: 0 }}>
                  Copiar
                </button>
              </div>
              <p style={{ margin: '12px 0 0', fontSize: '12px', color: '#444', lineHeight: '1.5' }}>
                Solo necesitas tenerlo mientras revisamos tu solicitud. Después puedes retirarlo.
              </p>
            </div>
            <button onClick={enviar} disabled={enviando} className="btn-verde" style={{ width: '100%', marginBottom: '8px' }}>
              {enviando ? 'Enviando...' : 'Ya lo he añadido — Enviar solicitud'}
            </button>
            <button onClick={() => setPaso(1)} style={{ background: 'none', border: 'none', color: '#444', width: '100%', cursor: 'pointer', fontSize: '13px', padding: '8px' }}>
              Volver
            </button>
          </>
        )}
        {paso === 1 && (
          <>
            <div style={{ textAlign: 'center', marginBottom: '24px' }}>
              <div style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', width: '56px', height: '56px', borderRadius: '18px', background: 'linear-gradient(135deg, #0ea5e9, #0369a1)', marginBottom: '12px', boxShadow: '0 4px 20px #0ea5e966' }}>
                <span style={{ fontSize: '24px' }}>✦</span>
              </div>
              <h2 style={{ margin: '0 0 6px', fontSize: '22px', fontWeight: 900 }}>Solicitar verificado</h2>
              <p style={{ color: '#555', fontSize: '13px', margin: 0 }}>Para autores y editoriales con presencia pública</p>
            </div>
            <div style={{ display: 'flex', gap: '8px', marginBottom: '20px' }}>
              {['autor', 'editorial'].map(t => (
                <button key={t} onClick={() => setTipo(t)}
                  style={{ flex: 1, padding: '10px', borderRadius: '12px', border: `2px solid ${tipo === t ? '#0ea5e9' : '#1e1e1e'}`, background: tipo === t ? '#0ea5e922' : '#141414', color: tipo === t ? '#0ea5e9' : '#555', cursor: 'pointer', fontWeight: tipo === t ? 'bold' : 'normal', fontSize: '13px', transition: '0.2s' }}>
                  {t === 'autor' ? '✦ Autor' : '◆ Editorial'}
                </button>
              ))}
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '12px', marginBottom: '20px' }}>
              <div>
                <label style={{ fontSize: '11px', color: '#555', textTransform: 'uppercase', letterSpacing: '1px', display: 'block', marginBottom: '6px' }}>
                  {tipo === 'autor' ? 'Nombre real del autor' : 'Nombre de la editorial'}
                </label>
                <input className="input-modal" placeholder={tipo === 'autor' ? 'Ej: María García López' : 'Ej: Ediciones Planeta'}
                  value={nombreReal} onChange={e => setNombreReal(e.target.value.slice(0, 80))} maxLength={80} />
              </div>
              <div>
                <label style={{ fontSize: '11px', color: '#555', textTransform: 'uppercase', letterSpacing: '1px', display: 'block', marginBottom: '6px' }}>
                  Instagram oficial
                </label>
                <input className="input-modal" placeholder="@tunombre"
                  value={instagram} onChange={e => setInstagram(e.target.value.slice(0, 60))} maxLength={60} />
                <p style={{ fontSize: '11px', color: '#333', margin: '4px 0 0' }}>
                  Te pediremos añadir un código en tu bio para confirmar que eres tú.
                </p>
              </div>
            </div>
            <button onClick={siguientePaso} disabled={!nombreReal.trim() || !instagram.trim()}
              className="btn-verde" style={{ width: '100%', marginBottom: '8px' }}>
              Continuar
            </button>
            <button onClick={onCerrar} style={{ background: 'none', border: 'none', color: '#444', width: '100%', cursor: 'pointer', fontSize: '13px', padding: '8px' }}>
              Cancelar
            </button>
          </>
        )}
      </div>
    </div>
  );
}
// ── Modal de solicitud de publicación de libro ────────────────────────────────
function ModalPublicarLibro({ userId, perfil, onCerrar }) {
  const [titulo, setTitulo] = React.useState('');
  const [nombreAutor, setNombreAutor] = React.useState(perfil?.nombre || '');
  const [portada, setPortada] = React.useState('');
  const [enlaceCompra, setEnlaceCompra] = React.useState('');
  const [sinopsis, setSinopsis] = React.useState('');
  const [enviando, setEnviando] = React.useState(false);
  const [enviado, setEnviado] = React.useState(false);
  const [errorPortada, setErrorPortada] = React.useState(false);

  const enviarSolicitud = async () => {
    if (!titulo.trim() || !nombreAutor.trim() || !portada.trim()) return;
    setEnviando(true);
    try {
      await addDoc(collection(db, 'solicitudes_libro'), {
        autorUid: userId,
        autorNombreApp: perfil?.nombre || '',
        titulo: titulo.trim(),
        nombreAutor: nombreAutor.trim(),
        portada: portada.trim(),
        enlaceCompra: enlaceCompra.trim() || null,
        descripcion: sinopsis.trim() || '',
        estado: 'pendiente',
        fechaSolicitud: serverTimestamp(),
      });
      // Alerta al admin
      await addDoc(collection(db, 'alertas'), {
        tipo: 'solicitud_libro',
        emisorId: userId,
        emisorNombre: perfil?.nombre || 'Un autor',
        destinatarioId: ADMIN_UID,
        libro: titulo.trim(),
        fecha: serverTimestamp(),
        leida: false,
      });
      setEnviado(true);
    } catch (e) {
      console.error('Error enviando solicitud de libro:', e);
      alert('Error al enviar la solicitud. Inténtalo de nuevo.');
    }
    setEnviando(false);
  };

  return (
    <div className="modal-overlay" onClick={onCerrar}>
      <div className="modal-content" style={{ maxWidth: '480px' }} onClick={e => e.stopPropagation()}>
        {enviado ? (
          <div style={{ textAlign: 'center', padding: '20px 0' }}>
            <div style={{ width: '56px', height: '56px', borderRadius: '18px', background: 'linear-gradient(135deg, #0ea5e9, #0369a1)', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 16px' }}>
              <svg width="24" height="24" viewBox="0 0 24 24" fill="white"><path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z"/></svg>
            </div>
            <h3 style={{ margin: '0 0 10px', fontSize: '20px', fontWeight: 900 }}>¡Solicitud enviada!</h3>
            <p style={{ color: '#555', fontSize: '14px', margin: '0 0 24px', lineHeight: '1.6' }}>
              Revisaremos tu libro en 2-3 días hábiles. Si todo está correcto, aparecerá en tu perfil y en el buscador de Leemos. Te notificaremos cuando esté publicado.
            </p>
            <button onClick={onCerrar} className="btn-verde">Cerrar</button>
          </div>
        ) : (
          <>
            <div style={{ textAlign: 'center', marginBottom: '24px' }}>
              <div style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', width: '56px', height: '56px', borderRadius: '18px', background: 'linear-gradient(135deg, #0ea5e9, #0369a1)', marginBottom: '12px' }}>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="white"><path d="M18 2H6c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM6 4h5v8l-2.5-1.5L6 12V4z"/></svg>
              </div>
              <h2 style={{ margin: '0 0 6px', fontSize: '22px', fontWeight: 900 }}>Publicar mi libro</h2>
              <p style={{ color: '#555', fontSize: '13px', margin: 0 }}>Revisaremos tu solicitud en 2-3 días hábiles</p>
            </div>

            <div style={{ display: 'flex', flexDirection: 'column', gap: '12px', marginBottom: '20px' }}>
              <div>
                <label style={{ fontSize: '11px', color: '#555', textTransform: 'uppercase', letterSpacing: '1px', display: 'block', marginBottom: '6px' }}>Título del libro *</label>
                <input className="input-modal" placeholder="Título exacto del libro" style={{ marginTop: 0 }}
                  value={titulo} onChange={e => setTitulo(e.target.value.slice(0, 120))} maxLength={120} />
              </div>
              <div>
                <label style={{ fontSize: '11px', color: '#555', textTransform: 'uppercase', letterSpacing: '1px', display: 'block', marginBottom: '6px' }}>Nombre del autor (como aparecerá publicado) *</label>
                <input className="input-modal" placeholder="Puede ser tu nombre real o pseudónimo" style={{ marginTop: 0 }}
                  value={nombreAutor} onChange={e => setNombreAutor(e.target.value.slice(0, 80))} maxLength={80} />
              </div>
              <div>
                <label style={{ fontSize: '11px', color: '#555', textTransform: 'uppercase', letterSpacing: '1px', display: 'block', marginBottom: '6px' }}>URL de la portada *</label>
                <input className="input-modal" placeholder="https://... (enlace directo a la imagen)" style={{ marginTop: 0, marginBottom: '8px' }}
                  value={portada} onChange={e => { setPortada(e.target.value); setErrorPortada(false); }} />
                {portada.trim() && (
                  <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                    <img src={portada.trim()} alt="Vista previa"
                      style={{ width: '48px', height: '68px', objectFit: 'cover', borderRadius: '4px', border: '1px solid #1e1e1e', display: errorPortada ? 'none' : 'block' }}
                      onError={() => setErrorPortada(true)} />
                    {errorPortada
                      ? <p style={{ margin: 0, fontSize: '12px', color: '#f44336' }}>La URL no es una imagen válida</p>
                      : <p style={{ margin: 0, fontSize: '12px', color: '#1DB954' }}>✓ Vista previa correcta</p>}
                  </div>
                )}
              </div>
              <div>
                <label style={{ fontSize: '11px', color: '#555', textTransform: 'uppercase', letterSpacing: '1px', display: 'block', marginBottom: '6px' }}>Enlace de compra (opcional)</label>
                <input className="input-modal" placeholder="Amazon, tu web, etc." style={{ marginTop: 0 }}
                  value={enlaceCompra} onChange={e => setEnlaceCompra(e.target.value.slice(0, 300))} maxLength={300} />
              </div>
              <div>
                <label style={{ fontSize: '11px', color: '#555', textTransform: 'uppercase', letterSpacing: '1px', display: 'block', marginBottom: '6px' }}>Sinopsis breve (opcional)</label>
                <textarea className="input-modal" placeholder="Describe tu libro en pocas líneas..." style={{ marginTop: 0, height: '80px', resize: 'none' }}
                  value={sinopsis} onChange={e => setSinopsis(e.target.value.slice(0, 500))} maxLength={500} />
                <p style={{ margin: '4px 0 0', fontSize: '11px', color: '#333', textAlign: 'right' }}>{sinopsis.length}/500</p>
              </div>
            </div>

            <button onClick={enviarSolicitud}
              disabled={enviando || !titulo.trim() || !nombreAutor.trim() || !portada.trim() || errorPortada}
              className="btn-verde" style={{ width: '100%', marginBottom: '8px', background: '#0ea5e9', opacity: (!titulo.trim() || !nombreAutor.trim() || !portada.trim() || errorPortada) ? 0.5 : 1 }}>
              {enviando ? 'Enviando...' : 'Enviar solicitud'}
            </button>
            <button onClick={onCerrar} style={{ background: 'none', border: 'none', color: '#444', width: '100%', cursor: 'pointer', fontSize: '13px', padding: '8px' }}>
              Cancelar
            </button>
          </>
        )}
      </div>
    </div>
  );
}

function BadgeVerificado({ tipo, size = 'normal' }) {
  if (!tipo) return null;

  const configs = {
    admin: {
      label: 'Admin',
      gradient: 'linear-gradient(135deg, #1DB954, #0d9444)',
      glow: '#1DB95466',
      icono: '⚡',
    },
    autor: {
      label: 'Autor verificado',
      gradient: 'linear-gradient(135deg, #0ea5e9, #0369a1)',
      glow: '#0ea5e966',
      icono: '✦',
    },
    editorial: {
      label: 'Editorial verificada',
      gradient: 'linear-gradient(135deg, #f59e0b, #b45309)',
      glow: '#f59e0b66',
      icono: '◆',
    },
  };

  const cfg = configs[tipo];
  if (!cfg) return null;

  const isSmall = size === 'small';

  return (
    <span style={{
      display: 'inline-flex',
      alignItems: 'center',
      gap: isSmall ? '3px' : '5px',
      background: cfg.gradient,
      color: 'white',
      fontSize: isSmall ? '9px' : '11px',
      padding: isSmall ? '1px 6px' : '3px 10px',
      borderRadius: '20px',
      fontWeight: 'bold',
      letterSpacing: '0.3px',
      boxShadow: `0 2px 8px ${cfg.glow}`,
      whiteSpace: 'nowrap',
      userSelect: 'none',
    }}>
      <span style={{ fontSize: isSmall ? '9px' : '11px' }}>{cfg.icono}</span>
      {cfg.label}
    </span>
  );
}

// ── Badge Compatibilidad Lectora ──────────────────────────────────────────────
// ── Estadísticas de un autor — cuántos lectores tienen sus libros en Leemos ──
function EstadisticasAutor({ autorUid }) {
  const [stats, setStats] = React.useState(null);

  React.useEffect(() => {
    if (!autorUid) return;
    let activo = true;
    const cargar = async () => {
      try {
        const librosSnap = await getDocs(query(collection(db, 'portadas_cache'), where('esIndie', '==', true), where('autorUid', '==', autorUid)));
        const libroIds = librosSnap.docs.map(d => d.id);
        if (libroIds.length === 0) { if (activo) setStats(null); return; }

        // Firestore 'in' soporta hasta 30 valores — suficiente para un autor indie
        const idsConsulta = libroIds.slice(0, 30);
        const [estadosSnap, clubsSnap] = await Promise.all([
          getDocs(query(collection(db, 'estados_lectura'), where('libroId', 'in', idsConsulta))),
          getDocs(query(collection(db, 'clubs'), where('libroMes.id', 'in', idsConsulta))).catch(() => ({ docs: [] })),
        ]);
        const lectoresUnicos = new Set(estadosSnap.docs.map(d => d.data().userId).filter(Boolean));
        if (activo) setStats({ lectores: lectoresUnicos.size, clubs: clubsSnap.docs.length, libros: libroIds.length });
      } catch (e) { console.error('Error cargando estadísticas de autor:', e); }
    };
    cargar();
    return () => { activo = false; };
  }, [autorUid]);

  if (!stats || stats.libros === 0) return null;

  if (stats.lectores === 0) {
    return (
      <div style={{ background: '#0a1620', border: '1px solid #0ea5e933', borderRadius: '10px', padding: '14px 16px', marginBottom: '20px' }}>
        <p style={{ margin: 0, fontSize: '13px', color: '#555' }}>Aún no tienes lectores registrados en Leemos. En cuanto alguien marque tu libro como leído, lo verás aquí.</p>
      </div>
    );
  }

  return (
    <div style={{ display: 'flex', gap: '10px', marginBottom: '20px', flexWrap: 'wrap' }}>
      <div style={{ background: '#0a1620', border: '1px solid #0ea5e933', borderRadius: '10px', padding: '10px 16px', flex: 1, minWidth: '120px' }}>
        <p style={{ margin: 0, fontSize: '22px', fontWeight: 900, color: '#0ea5e9' }}>{stats.lectores}</p>
        <p style={{ margin: 0, fontSize: '11px', color: '#555' }}>lector{stats.lectores !== 1 ? 'es' : ''} en Leemos</p>
      </div>
      {stats.clubs > 0 && (
        <div style={{ background: '#0a1620', border: '1px solid #0ea5e933', borderRadius: '10px', padding: '10px 16px', flex: 1, minWidth: '120px' }}>
          <p style={{ margin: 0, fontSize: '22px', fontWeight: 900, color: '#0ea5e9' }}>{stats.clubs}</p>
          <p style={{ margin: 0, fontSize: '11px', color: '#555' }}>club{stats.clubs !== 1 ? 's' : ''} leyendo su obra</p>
        </div>
      )}
    </div>
  );
}

// ── Libros publicados por un autor verificado ─────────────────────────────────
function LibrosDelAutor({ autorUid, onVerLibro }) {
  const [libros, setLibros] = React.useState([]);
  const [cargando, setCargando] = React.useState(true);

  React.useEffect(() => {
    if (!autorUid) { setCargando(false); return; }
    let activo = true;
    const cargar = async () => {
      try {
        const snap = await getDocs(query(collection(db, 'portadas_cache'), where('esIndie', '==', true), where('autorUid', '==', autorUid)));
        if (activo) setLibros(snap.docs.map(d => ({ id: d.id, ...d.data() })));
      } catch (e) { console.error('Error cargando libros del autor:', e); }
      if (activo) setCargando(false);
    };
    cargar();
    return () => { activo = false; };
  }, [autorUid]);

  if (cargando || libros.length === 0) return null;

  return (
    <div style={{ background: '#0a1620', borderRadius: '14px', border: '1px solid #0ea5e933', padding: '18px', marginBottom: '20px' }}>
      <p style={{ margin: '0 0 14px', fontSize: '12px', color: '#0ea5e9', textTransform: 'uppercase', letterSpacing: '1px', fontWeight: 'bold' }}>
        ✦ Libros publicados
      </p>
      <div style={{ display: 'flex', gap: '12px', overflowX: 'auto', paddingBottom: '4px' }}>
        {libros.map(libro => (
          <div key={libro.id} style={{ flexShrink: 0, width: '110px', cursor: 'pointer' }}
            onClick={() => onVerLibro && onVerLibro({ id: libro.id, titulo: libro.titulo, autor: libro.autor, portada: libro.portada, descripcion: libro.descripcion || '' })}>
            <img src={libro.portada} alt={libro.titulo} style={{ width: '100%', aspectRatio: '2/3', objectFit: 'cover', borderRadius: '8px', marginBottom: '6px', boxShadow: '0 4px 14px rgba(0,0,0,0.4)' }} />
            <p style={{ margin: 0, fontSize: '12px', fontWeight: 'bold', color: 'white', overflow: 'hidden', textOverflow: 'ellipsis', display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical', lineHeight: '1.3' }}>{libro.titulo}</p>
            {libro.enlaceCompra && (
              <a href={libro.enlaceCompra} target="_blank" rel="noopener noreferrer" onClick={e => e.stopPropagation()}
                style={{ display: 'inline-block', marginTop: '4px', fontSize: '11px', color: '#1DB954', fontWeight: 'bold', textDecoration: 'none' }}>
                Comprar →
              </a>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}


// ── Clubs creados por un autor verificado, con solicitud de unirse ───────────
function ClubsDelAutor({ autorUid, autorNombre, userId, perfil }) {
  const [clubs, setClubs] = React.useState([]);
  const [misMembresias, setMisMembresias] = React.useState({}); // { clubId: true } — clubs donde ya soy miembro
  const [solicitudesEnviadas, setSolicitudesEnviadas] = React.useState({});
  const [enviando, setEnviando] = React.useState(null);

  React.useEffect(() => {
    if (!autorUid) return;
    let activo = true;
    const cargar = async () => {
      try {
        const snap = await getDocs(query(collection(db, 'clubs_publicos'), where('creadorId', '==', autorUid)));
        if (activo) setClubs(snap.docs.map(d => ({ id: d.id, ...d.data() })));
      } catch (e) { console.error('Error cargando clubs del autor:', e); }
    };
    cargar();
    return () => { activo = false; };
  }, [autorUid]);

  // Comprobar de cuáles ya soy miembro y si ya tengo solicitud pendiente
  React.useEffect(() => {
    if (!userId || clubs.length === 0) return;
    let activo = true;
    const comprobar = async () => {
      const membresias = {};
      for (const c of clubs) {
        try {
          const clubSnap = await getDoc(doc(db, 'clubs', c.clubId));
          if (clubSnap.exists() && clubSnap.data().miembros?.includes(userId)) membresias[c.clubId] = true;
        } catch { /* si no puede leer el club, no es miembro */ }
      }
      try {
        const solSnap = await getDocs(query(collection(db, 'alertas'), where('emisorId', '==', userId), where('tipo', '==', 'solicitud_club')));
        const pendientes = {};
        solSnap.docs.forEach(d => { if (d.data().clubId) pendientes[d.data().clubId] = true; });
        if (activo) setSolicitudesEnviadas(pendientes);
      } catch { /* ignorar */ }
      if (activo) setMisMembresias(membresias);
    };
    comprobar();
    return () => { activo = false; };
  }, [clubs, userId]);

  const solicitarUnirse = async (club) => {
    if (!userId) return;
    setEnviando(club.clubId);
    try {
      await addDoc(collection(db, 'alertas'), {
        tipo: 'solicitud_club',
        emisorId: userId,
        emisorNombre: perfil?.nombre || 'Alguien',
        destinatarioId: club.creadorId,
        club: club.nombre,
        clubId: club.clubId,
        fecha: serverTimestamp(),
        leida: false,
      });
      setSolicitudesEnviadas(prev => ({ ...prev, [club.clubId]: true }));
    } catch (e) { console.error('Error enviando solicitud:', e); }
    setEnviando(null);
  };

  if (clubs.length === 0) return null;

  return (
    <div style={{ background: '#0a1620', borderRadius: '14px', border: '1px solid #0ea5e933', padding: '18px', marginBottom: '20px' }}>
      <p style={{ margin: '0 0 14px', fontSize: '12px', color: '#0ea5e9', textTransform: 'uppercase', letterSpacing: '1px', fontWeight: 'bold' }}>
        ✦ Clubs de {autorNombre || 'este autor'}
      </p>
      <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
        {clubs.map(club => {
          const esMiembro = misMembresias[club.clubId];
          const yaSolicitado = solicitudesEnviadas[club.clubId];
          const esElPropioAutor = userId === autorUid;
          return (
            <div key={club.id} style={{ background: '#0d1a24', borderRadius: '10px', padding: '12px 14px', display: 'flex', alignItems: 'center', gap: '12px' }}>
              <div style={{ flex: 1, minWidth: 0 }}>
                <p style={{ margin: 0, fontSize: '13px', fontWeight: 'bold', color: 'white' }}>{club.nombre}</p>
                <p style={{ margin: '2px 0 0', fontSize: '11px', color: '#555' }}>{club.numMiembros || 1} miembro{(club.numMiembros || 1) !== 1 ? 's' : ''}</p>
              </div>
              {!esElPropioAutor && !esMiembro && (
                <button
                  disabled={yaSolicitado || enviando === club.clubId}
                  onClick={() => solicitarUnirse(club)}
                  style={{
                    background: yaSolicitado ? 'transparent' : '#0ea5e9',
                    color: yaSolicitado ? '#0ea5e9' : 'white',
                    border: yaSolicitado ? '1px solid #0ea5e944' : 'none',
                    borderRadius: '20px', padding: '7px 16px', fontWeight: 'bold', cursor: yaSolicitado ? 'default' : 'pointer', fontSize: '12px', flexShrink: 0, opacity: enviando === club.clubId ? 0.6 : 1,
                  }}>
                  {yaSolicitado ? 'Solicitud enviada' : enviando === club.clubId ? 'Enviando...' : 'Solicitar unirse'}
                </button>
              )}
              {esMiembro && <span style={{ fontSize: '11px', color: '#1DB954', fontWeight: 'bold', flexShrink: 0 }}>✓ Eres miembro</span>}
            </div>
          );
        })}
      </div>
    </div>
  );
}


// ── Compatibilidad lectora entre dos usuarios ─────────────────────────────────
function BadgeCompatibilidad({ userIdPropio, userIdAjeno }) {
  const compatibilidad = useCompatibilidad(userIdPropio, userIdAjeno);
  if (!compatibilidad) return null;

  const { porcentaje, enComun } = compatibilidad;
  const color = porcentaje >= 60 ? '#1DB954' : porcentaje >= 30 ? '#f59e0b' : '#666';

  const iconPath = porcentaje >= 60
    ? "M21 5c-1.11-.35-2.33-.5-3.5-.5-1.95 0-4.05.4-5.5 1.5-1.45-1.1-3.55-1.5-5.5-1.5S2.45 4.9 1 6v14.65c0 .25.25.5.5.5.1 0 .15-.05.25-.05C3.1 20.45 5.05 20 6.5 20c1.95 0 4.05.4 5.5 1.5 1.35-.85 3.8-1.5 5.5-1.5 1.65 0 3.35.3 4.75 1.05.1.05.15.05.25.05.25 0 .5-.25.5-.5V6c-.6-.45-1.25-.75-2-1zm0 13.5c-1.1-.35-2.3-.5-3.5-.5-1.7 0-4.15.65-5.5 1.5V8c1.35-.85 3.8-1.5 5.5-1.5 1.2 0 2.4.15 3.5.5v11.5z"
    : porcentaje >= 30
    ? "M17 3H7c-1.1 0-1.99.9-1.99 2L5 21l7-3 7 3V5c0-1.1-.9-2-2-2zm0 15l-5-2.18L7 18V5h10v13z"
    : "M17 3H7c-1.1 0-1.99.9-1.99 2L5 21l7-3 7 3V5c0-1.1-.9-2-2-2zm0 15l-5-2.18L7 18V5h10v13z";

  return (
    <div style={{ display: 'inline-flex', alignItems: 'center', gap: '6px', background: `${color}15`, border: `1px solid ${color}44`, borderRadius: '20px', padding: '5px 12px', marginTop: '8px' }}>
      <svg width="14" height="14" viewBox="0 0 24 24" fill={color}><path d={iconPath}/></svg>
      <span style={{ fontSize: '13px', color, fontWeight: 'bold' }}>{porcentaje}% compatibilidad</span>
      <span style={{ fontSize: '11px', color: '#555' }}>· {enComun} libro{enComun !== 1 ? 's' : ''} en común</span>
    </div>
  );
}

// ── Hook compatibilidad lectora ───────────────────────────────────────────────
function useCompatibilidad(userIdPropio, userIdAjeno) {
  const [compatibilidad, setCompatibilidad] = React.useState(null);

  React.useEffect(() => {
    if (!userIdPropio || !userIdAjeno || userIdPropio === userIdAjeno) return;
    let activo = true;
    const calcular = async () => {
      try {
        const [propiosSnap, ajenosSnap] = await Promise.all([
          getDocs(query(collection(db, 'estados_lectura'), where('userId', '==', userIdPropio), where('estado', '==', 'leido'), limit(200))),
          getDocs(query(collection(db, 'estados_lectura'), where('userId', '==', userIdAjeno), where('estado', '==', 'leido'), limit(200))),
        ]);
        const propios = new Set(propiosSnap.docs.map(d => d.data().libroId).filter(Boolean));
        const ajenos = new Set(ajenosSnap.docs.map(d => d.data().libroId).filter(Boolean));
        if (propios.size < 3 || ajenos.size < 3) return;
        const enComun = [...propios].filter(id => ajenos.has(id));
        const total = new Set([...propios, ...ajenos]).size;
        const porcentaje = Math.round((enComun.length / total) * 100);
        if (!activo) return;
        setCompatibilidad({ porcentaje, enComun: enComun.length });
      } catch (e) { /* silencioso */ }
    };
    calcular();
    return () => { activo = false; };
  }, [userIdPropio, userIdAjeno]);

  return compatibilidad;
}

// ── AdMob ─────────────────────────────────────────────────────────────────────
async function iniciarAdMobBanner(esPremium) {
  if (!detectarNativa() || esPremium) return;
  if (!AdMob) { console.log('[Leemos][admob] ABORTADO — módulo AdMob aún no cargado'); return; }
  try {
    await AdMob.initialize({ requestTrackingAuthorization: true });
    await AdMob.showBanner({
      adId: ADMOB_BANNER_ID,
      adSize: BannerAdSize?.ADAPTIVE_BANNER || 'ADAPTIVE_BANNER',
      position: BannerAdPosition?.BOTTOM_CENTER || 'BOTTOM_CENTER',
      margin: 0,
    });
    console.log('[Leemos][admob] banner mostrado correctamente');
  } catch (e) { console.error('[Leemos][admob] ERROR:', e); }
}

async function ocultarAdMobBanner() {
  if (!detectarNativa() || !AdMob) return;
  try { await AdMob.hideBanner(); } catch (e) {}
}

// ── Helper portada Google Books ──────────────────────────────────────────────
function getPortadaGoogle(imageLinks, zoom = 1) {
  if (!imageLinks) return null;
  const url = imageLinks.thumbnail || imageLinks.smallThumbnail || imageLinks.medium || imageLinks.large;
  if (!url) return null;
  const urlFixed = url
    .replace('http://', 'https://')
    .replace(/zoom=\d/, `zoom=${zoom}`)
    .replace('&edge=curl', '');
  // Filtrar imágenes de placeholder/not available
  if (urlFixed.includes('notavailable') || urlFixed.includes('no_cover') || urlFixed.includes('placeholder')) return null;
  return urlFixed;
}

// ── Push Notifications ────────────────────────────────────────────────────────
async function initPushNotifications(userId, navegarASala) {
  console.log('[Leemos][push] init — PushNotifications disponible:', !!PushNotifications, '— userId:', userId);
  if (!PushNotifications || !userId) {
    console.log('[Leemos][push] ABORTADO — módulo nativo no disponible o sin userId');
    return;
  }
  try {
    const permiso = await PushNotifications.requestPermissions();
    console.log('[Leemos][push] resultado permiso:', permiso.receive);
    if (permiso.receive !== 'granted') {
      console.log('[Leemos][push] ABORTADO — permiso no concedido por el usuario o el sistema');
      return;
    }

    await PushNotifications.register();
    console.log('[Leemos][push] register() llamado — esperando evento de registro con el token');

    // Limpiar listeners anteriores para evitar duplicados
    await PushNotifications.removeAllListeners().catch(() => {});

    // Guardar token en Firestore cuando se obtiene
    PushNotifications.addListener('registration', async ({ value: token }) => {
      console.log('[Leemos][push] token recibido:', token ? token.slice(0, 12) + '...' : 'VACÍO');
      if (!token) return;
      await setDoc(doc(db, 'fcm_tokens', userId), {
        token, userId, plataforma: window.Capacitor?.getPlatform?.() || 'android', actualizadoEn: serverTimestamp(),
      }).then(() => console.log('[Leemos][push] token guardado en fcm_tokens/' + userId))
        .catch((e) => console.error('[Leemos][push] ERROR guardando token:', e));
    });

    PushNotifications.addListener('registrationError', (err) => {
      console.error('[Leemos][push] ERROR de registro nativo:', err);
    });

    // Notificación recibida con la app en primer plano — no hacer nada
    PushNotifications.addListener('pushNotificationReceived', (n) => {
      console.log('[Leemos][push] notificación recibida en primer plano:', n?.title);
    });

    // Tap en notificación — navegar al sitio correcto
    PushNotifications.addListener('pushNotificationActionPerformed', ({ notification }) => {
      const data = notification.data || {};
      if (data.tipo === 'mensaje_sala' && data.salaId && navegarASala) {
        navegarASala(data.salaId, data.libroTitulo);
      }
    });
  } catch (e) {
    console.error('[Leemos][push] EXCEPCIÓN:', e);
  }
}


let AdMob = null;
let BannerAdSize = null;
let BannerAdPosition = null;
let GoogleAuth = null;
let googleAuthPromise = null;

// Carga de módulos nativos con reintento — mismo problema que tuvimos con las
// notificaciones push: si Capacitor todavía no está listo en el instante exacto
// en que se evalúa esto al cargar el módulo, isNativePlatform() devuelve false
// y AdMob se queda en null para siempre, sin ningún reintento. Eso dejaba el
// banner publicitario con el hueco reservado pero vacío (en negro), porque
// iniciarAdMobBanner() cortaba en el guard "!AdMob" antes de llegar a showBanner().
function cargarModuloAdMob(intentos = 0) {
  import('@capacitor-community/admob').then(mod => {
    AdMob = mod.AdMob;
    BannerAdSize = mod.BannerAdSize;
    BannerAdPosition = mod.BannerAdPosition;
  }).catch((e) => {
    // Algunos dispositivos (tablets más lentas, red inestable al cargar el chunk)
    // pueden fallar la primera vez — reintentamos unas cuantas veces en vez de
    // dejar AdMob en null para siempre y perder el banner toda la sesión.
    console.error('[Leemos][admob] fallo cargando módulo, intento', intentos, e);
    if (intentos < 5) setTimeout(() => cargarModuloAdMob(intentos + 1), 1500);
  });
}

function cargarModulosNativos(intentos = 0) {
  if (typeof window === 'undefined') return;
  const esNativaAhora = window.Capacitor?.isNativePlatform?.() || window.__LEEMOS_ES_NATIVA === true;
  if (!esNativaAhora) {
    // 20 intentos × 500ms = 10s antes de rendirnos, más margen que antes (5s)
    // para tablets/dispositivos donde el puente de Capacitor tarda más en estar listo.
    if (intentos < 20) setTimeout(() => cargarModulosNativos(intentos + 1), 500);
    return;
  }
  cargarModuloAdMob();
  // Inicializar Firebase Analytics para que AdMob reciba datos de usuarios
  import('@capacitor-firebase/analytics').then(mod => {
    const FirebaseAnalytics = mod.FirebaseAnalytics;
    FirebaseAnalytics.setEnabled({ enabled: true }).catch(() => {});
  }).catch(() => {});
  import('@capacitor-community/in-app-review').then(mod => {
    window.__InAppReview = mod.InAppReview;
  }).catch(() => {});
  googleAuthPromise = import('@codetrix-studio/capacitor-google-auth').then(async mod => {
    GoogleAuth = mod.GoogleAuth;
    await GoogleAuth.initialize({
      clientId: '753360054120-5aro3megpfel5j0rf9krtth0tbd1pjnt.apps.googleusercontent.com',
      scopes: ['profile', 'email'],
      grantOfflineAccess: true,
    });
    return mod.GoogleAuth;
  }).catch(() => null);
}
cargarModulosNativos();

// ── AdMob ─────────────────────────────────────────────────────────────────────
const ADMOB_APP_ID = 'ca-app-pub-8535975487836163~9543838783';
const ADMOB_BANNER_ID = 'ca-app-pub-8535975487836163/9313728329';
// IDs de prueba para desarrollo (no generan ingresos reales)
const ADMOB_BANNER_TEST = 'ca-app-pub-3940256099942544/6300978111';

// Detectar si estamos en app nativa (Capacitor)
// esNativa se evalúa con delay para dar tiempo a Capacitor a inicializarse
function detectarNativa() {
  if (typeof window === 'undefined') return false;
  // __LEEMOS_ES_NATIVA se setea en index.html antes de que React cargue
  if (window.__LEEMOS_ES_NATIVA === true) return true;
  try {
    const platform = window.Capacitor?.getPlatform?.();
    if (platform === 'android' || platform === 'ios') return true;
    if (window.Capacitor?.isNativePlatform?.()) return true;
    if (window.cordova !== undefined) return true;
  } catch {}
  return false;
}
const esNativa = detectarNativa();

const ANUNCIOS = [
  { texto: "📚 Descubre los mejores libros del momento en Casa del Libro", url: "https://www.casadellibro.com", cta: "Ver ahora" },
  { texto: "🎧 Audiolibros ilimitados con Storytel — 30 días gratis", url: "https://www.storytel.com/es", cta: "Probar gratis" },
  { texto: "✏️ Crea tu lista de lectura perfecta con Goodreads", url: "https://www.goodreads.com", cta: "Descubrir" },
  { texto: "📖 Libros en español desde 0,99€ en Amazon Kindle", url: "https://www.amazon.es/kindle", cta: "Ver ofertas" },
];

function BannerPublicitario({ esPremium, onUpgrade, mobile = false }) {
  const [indice, setIndice] = React.useState(0);
  const [visible, setVisible] = React.useState(true);

  React.useEffect(() => {
    if (esPremium) return;
    const interval = setInterval(() => {
      setVisible(false);
      setTimeout(() => {
        setIndice(i => (i + 1) % ANUNCIOS.length);
        setVisible(true);
      }, 400);
    }, 30000);
    return () => clearInterval(interval);
  }, [esPremium]);

  if (esPremium) return null;

  const anuncio = ANUNCIOS[indice];

  // Versión móvil — compacta, encima de la nav inferior
  if (mobile) {
    return (
      <div style={{
        position: 'fixed', bottom: '56px', left: 0, right: 0, zIndex: 499,
        background: 'linear-gradient(90deg, #0a0a0a, #0d0d0d)',
        borderTop: '1px solid #1a1a1a',
        padding: '7px 14px',
        display: 'flex', alignItems: 'center', gap: '8px',
        opacity: visible ? 1 : 0, transition: 'opacity 0.4s ease',
      }}>
        <span style={{ fontSize: '8px', color: '#2a2a2a', textTransform: 'uppercase', letterSpacing: '1px', flexShrink: 0, border: '1px solid #1e1e1e', borderRadius: '3px', padding: '1px 4px' }}>
          Pub
        </span>
        <p style={{ margin: 0, fontSize: '12px', color: '#666', flex: 1, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
          {anuncio.texto}
        </p>
        <button onClick={onUpgrade}
          style={{ background: 'none', color: '#a78bfa', border: 'none', fontSize: '11px', fontWeight: 'bold', cursor: 'pointer', flexShrink: 0, padding: '0', whiteSpace: 'nowrap' }}>
          ✦ Sin anuncios
        </button>

      </div>
    );
  }

  return (
    <div style={{
      position: 'fixed', bottom: 0, left: 0, right: 0, zIndex: 500,
      background: 'linear-gradient(90deg, #0d0d0d, #111)',
      borderTop: '1px solid #1e1e1e',
      padding: '10px 20px',
      display: 'flex', alignItems: 'center', gap: '12px',
      opacity: visible ? 1 : 0, transition: 'opacity 0.4s ease',
    }}>
      {/* Etiqueta publicidad */}
      <span style={{ fontSize: '9px', color: '#333', textTransform: 'uppercase', letterSpacing: '1px', flexShrink: 0, border: '1px solid #222', borderRadius: '4px', padding: '2px 5px' }}>
        Publicidad
      </span>

      {/* Texto del anuncio */}
      <p style={{ margin: 0, fontSize: '13px', color: '#888', flex: 1, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
        {anuncio.texto}
      </p>

      {/* CTA */}
      <a href={anuncio.url} target="_blank" rel="noopener noreferrer"
        style={{ background: 'transparent', color: '#1DB954', border: '1px solid #1DB95444', borderRadius: '12px', padding: '5px 12px', fontSize: '12px', fontWeight: 'bold', cursor: 'pointer', textDecoration: 'none', flexShrink: 0, transition: '0.2s', whiteSpace: 'nowrap' }}>
        {anuncio.cta}
      </a>

      {/* Upgrade */}
      <button onClick={onUpgrade}
        style={{ background: 'linear-gradient(135deg, #2d1060, #6a3fa0)', color: 'white', border: 'none', borderRadius: '12px', padding: '5px 12px', fontSize: '11px', fontWeight: 'bold', cursor: 'pointer', flexShrink: 0, whiteSpace: 'nowrap' }}>
        ✦ Sin anuncios
      </button>


    </div>
  );
}

// ── Sección Explorar con salas activas ───────────────────────────────────────
function SeccionExplorar({ isMobile, onCargarLista, onEntrarSala }) {
  const [salasActivas, setSalasActivas] = React.useState([]);
  const [librosInfo, setLibrosInfo] = React.useState({});
  const [cargandoSalas, setCargandoSalas] = React.useState(true);

  React.useEffect(() => {
    let activo = true;
    const cargar = async () => {
      setCargandoSalas(true);
      try {
        const snap = await getDocs(
          query(collection(db, "salas_info"), where("activa", "==", true), where("tipo", "==", "publica"), orderBy("ultimaActividad", "desc"), limit(10))
        );
        if (!activo) return;
        const salas = snap.docs.map(d => ({ id: d.id, ...d.data() }));
        setSalasActivas(salas);
        const info = {};
        for (const sala of salas) {
          if (sala.libroId && sala.titulo) {
            info[sala.libroId] = {
              id: sala.libroId,
              titulo: sala.titulo,
              autor: sala.autor || '',
              portada: sala.portada || '',
              descripcion: '',
            };
          }
        }
        setLibrosInfo(info);
      } catch (e) { console.error(e); }
      setCargandoSalas(false);
    };
    cargar();
    return () => { activo = false; };
  }, []);

  const salasConInfo = salasActivas.filter(s => librosInfo[s.libroId]);

  return (
    <div style={{ padding: isMobile ? '0 16px 40px' : '0 28px 40px', overflowY: 'auto' }}>
      {/* Header */}
      <h1 style={{ fontSize: isMobile ? '28px' : '36px', margin: isMobile ? '20px 0 24px' : '8px 0 28px', fontWeight: 900 }}>Explorar</h1>

      {/* Salas activas ahora */}
      <div style={{ marginBottom: '36px' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '16px' }}>
          <div style={{ width: '8px', height: '8px', borderRadius: '50%', background: '#1DB954', boxShadow: '0 0 8px #1DB954', animation: 'pulse 2s infinite', flexShrink: 0 }} />
          <h2 style={{ fontSize: isMobile ? '18px' : '20px', fontWeight: 900, margin: 0 }}>Salas activas ahora</h2>
        </div>

        {cargandoSalas ? (
          <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
            {[...Array(3)].map((_, i) => (
              <div key={i} style={{ height: '72px', background: '#141414', borderRadius: '12px', animation: 'pulse 1.5s infinite', border: '1px solid #1e1e1e' }} />
            ))}
          </div>
        ) : salasConInfo.length === 0 ? (
          <div style={{ background: '#141414', borderRadius: '12px', padding: '24px', textAlign: 'center', border: '1px solid #1e1e1e' }}>
            <p style={{ color: '#333', fontSize: '14px', margin: 0 }}>No hay salas activas ahora mismo.</p>
            <p style={{ color: '#2a2a2a', fontSize: '13px', margin: '8px 0 0' }}>Sé el primero — entra en un libro y empieza el debate.</p>
          </div>
        ) : (
          <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
            {salasConInfo.map(sala => {
              const libro = librosInfo[sala.libroId];
              const ultimaAct = sala.ultimaActividad?.toDate?.();
              const hace = ultimaAct ? Math.floor((Date.now() - ultimaAct.getTime()) / 60000) : null;
              const tiempoStr = hace !== null ? (hace < 1 ? 'ahora mismo' : hace < 60 ? `hace ${hace}m` : `hace ${Math.floor(hace/60)}h`) : '';
              return (
                <div key={sala.id} onClick={() => onEntrarSala(libro, false, sala.id)}
                  style={{ background: '#141414', borderRadius: '12px', border: '1px solid #1e1e1e', display: 'flex', alignItems: 'center', gap: '0', overflow: 'hidden', cursor: 'pointer', transition: '0.2s' }}
                  onMouseEnter={e => { e.currentTarget.style.borderColor = '#2a2a2a'; e.currentTarget.style.background = '#181818'; }}
                  onMouseLeave={e => { e.currentTarget.style.borderColor = '#1e1e1e'; e.currentTarget.style.background = '#141414'; }}>
                  {/* Portada */}
                  <img src={libro.portada} style={{ width: '54px', height: '72px', objectFit: 'cover', flexShrink: 0, display: 'block' }} alt="" onError={e => e.currentTarget.style.display='none'} />
                  {/* Info */}
                  <div style={{ flex: 1, padding: '10px 14px', minWidth: 0 }}>
                    <p style={{ margin: '0 0 2px', fontWeight: 'bold', fontSize: '14px', color: 'white', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{libro.titulo}</p>
                    <p style={{ margin: '0 0 6px', fontSize: '11px', color: '#555' }}>{libro.autor}</p>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                      <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                        <div style={{ width: '6px', height: '6px', borderRadius: '50%', background: '#1DB954', boxShadow: '0 0 5px #1DB954' }} />
                        <span style={{ fontSize: '11px', color: '#1DB954', fontWeight: 'bold' }}>Activa</span>
                      </div>
                      {sala.numMiembros > 1 && <span style={{ fontSize: '11px', color: '#333' }}>· {sala.numMiembros} leyendo</span>}
                      {tiempoStr && <span style={{ fontSize: '11px', color: '#2a2a2a' }}>· {tiempoStr}</span>}
                    </div>
                  </div>
                  {/* Flecha */}
                  <div style={{ padding: '0 14px', color: '#333', fontSize: '20px', fontWeight: 'bold' }}>›</div>
                </div>
              );
            })}
          </div>
        )}
      </div>

      {/* Divisor */}
      <div style={{ height: '1px', background: '#1a1a1a', marginBottom: '28px' }} />

      {/* Categorías */}
      <div style={{ marginBottom: '16px' }}>
        <h2 style={{ fontSize: isMobile ? '18px' : '20px', fontWeight: 900, margin: '0 0 16px' }}>Géneros</h2>
        <div style={{ display: 'grid', gridTemplateColumns: isMobile ? 'repeat(2, 1fr)' : 'repeat(auto-fill, minmax(180px, 1fr))', gap: '10px' }}>
          {CATEGORIAS_VISUALES.map(cat => (
            <div key={cat.id} onClick={() => onCargarLista(cat.nombre)}
              style={{ borderRadius: '10px', overflow: 'hidden', cursor: 'pointer', position: 'relative', height: isMobile ? '90px' : '100px', transition: '0.2s' }}
              onMouseEnter={e => e.currentTarget.style.transform = 'scale(1.02)'}
              onMouseLeave={e => e.currentTarget.style.transform = 'scale(1)'}>
              <img src={cat.img} style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }} alt="" onError={e => e.currentTarget.style.display='none'} />
              <div style={{ position: 'absolute', inset: 0, background: 'linear-gradient(135deg, rgba(0,0,0,0.75) 0%, rgba(0,0,0,0.2) 100%)', display: 'flex', alignItems: 'flex-end', padding: '10px 12px' }}>
                <b style={{ fontSize: isMobile ? '13px' : '15px', textShadow: '0 1px 4px rgba(0,0,0,0.8)' }}>{cat.nombre}</b>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

// ── Buscador de libro favorito ────────────────────────────────────────────────
function BuscadorLibro({ onSeleccionar, placeholder = "Busca tu libro favorito..." }) {
  const [query, setQuery] = React.useState('');
  const [resultados, setResultados] = React.useState([]);
  const [buscando, setBuscando] = React.useState(false);

  const buscar = async () => {
    if (!query.trim()) return;
    setBuscando(true);
    try {
      const tNorm = normalizarTexto(query);

      // 1. Comprobar saga curada
      const sagaMatch = SAGAS_CONOCIDAS.find(saga =>
        saga.terminos.some(t => tNorm.includes(t) || t.includes(tNorm))
      );
      if (sagaMatch) {
        const libros = await Promise.all(sagaMatch.libros.slice(0, 8).map(async (libro) => {
          try {
            const q = encodeURIComponent(`intitle:${libro.titulo} inauthor:${libro.autor}`);
            const resp = await fetch(`https://www.googleapis.com/books/v1/volumes?q=${q}&maxResults=5&key=${GOOGLE_BOOKS_API_KEY}`);
            const data = await resp.json();
            const itemConPortada = (data.items || []).find(item => item.volumeInfo?.imageLinks?.thumbnail || item.volumeInfo?.imageLinks?.smallThumbnail);
            const portada = getPortadaGoogle(itemConPortada?.volumeInfo?.imageLinks) || '';
            return portada ? { titulo: libro.titulo, autor: libro.autor, portada } : null;
          } catch { return null; }
        }));
        setResultados(libros.filter(Boolean));
        setBuscando(false);
        return;
      }

      // 2. Búsqueda libre con filtros y agrupación
      const esValido = (titulo, autor) => esLibroValido(titulo, autor);

      const normalizarGrupo = (titulo) =>
        normalizarTexto(titulo)
          .replace(/\s*\(.*?\)\s*/g, ' ')
          .replace(/\s*\/.*$/, '')
          .replace(/\s*(:|\.)\s*.+$/, '')
          .replace(/\s+/g, ' ').trim();

      const resp = await fetch(`https://www.googleapis.com/books/v1/volumes?q=${encodeURIComponent(query)}&maxResults=30&key=${GOOGLE_BOOKS_API_KEY}`);
      const data = await resp.json();

      const grupos = new Map();
      for (const item of (data.items || [])) {
        const info = item.volumeInfo;
        if (!info?.title) continue;
        if (!info?.imageLinks?.thumbnail && !info?.imageLinks?.smallThumbnail) continue;
        const titulo = info.title;
        const autor = info.authors?.[0] || 'Anónimo';
        if (!esValido(titulo, autor)) continue;
        const key = normalizarGrupo(titulo) + '_' + normalizarTexto(autor).split(' ')[0];
        if (!grupos.has(key)) {
          const portada = getPortadaGoogle(info.imageLinks) || '';
          if (portada) grupos.set(key, { titulo, autor, portada });
        }
      }
      setResultados([...grupos.values()].slice(0, 8));
    } catch { setResultados([]); }
    setBuscando(false);
  };

  return (
    <div>
      <div style={{ display: 'flex', gap: '8px', marginBottom: '10px' }}>
        <input
          style={{ flex: 1, background: '#1a1a1a', border: '1px solid #2a2a2a', borderRadius: '8px', padding: '9px 14px', color: 'white', outline: 'none', fontSize: '13px' }}
          placeholder={placeholder}
          value={query}
          onChange={e => setQuery(e.target.value)}
          onKeyDown={e => e.key === 'Enter' && buscar()} />
        <button onClick={buscar} disabled={buscando}
          style={{ background: '#1DB954', color: 'black', border: 'none', borderRadius: '8px', padding: '9px 16px', fontWeight: 'bold', cursor: 'pointer', fontSize: '13px', flexShrink: 0 }}>
          {buscando ? '...' : 'Buscar'}
        </button>
      </div>
      {resultados.length > 0 && (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '6px', maxHeight: '320px', overflowY: 'auto' }}>
          {resultados.map((libro, i) => (
            <div key={i} onClick={() => { onSeleccionar(libro); setResultados([]); setQuery(''); }}
              style={{ display: 'flex', gap: '10px', padding: '8px', background: '#1a1a1a', borderRadius: '8px', cursor: 'pointer', alignItems: 'center', border: '1px solid #222', transition: '0.15s' }}
              onMouseEnter={e => e.currentTarget.style.borderColor = '#1DB954'}
              onMouseLeave={e => e.currentTarget.style.borderColor = '#222'}>
              <img src={libro.portada} style={{ width: '32px', height: '46px', objectFit: 'cover', borderRadius: '3px', flexShrink: 0 }} alt="" onError={e => e.currentTarget.style.display='none'} />
              <div>
                <p style={{ margin: '0 0 2px', fontSize: '13px', fontWeight: 'bold', color: 'white' }}>{libro.titulo}</p>
                <p style={{ margin: 0, fontSize: '11px', color: '#555' }}>{libro.autor}</p>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

function BuscadorLibroFavorito({ onSeleccionar }) {
  return (
    <div>
      <p style={{ margin: '0 0 10px', color: '#333', fontSize: '13px' }}>Busca el libro que más te ha marcado</p>
      <BuscadorLibro onSeleccionar={onSeleccionar} placeholder="Busca tu libro favorito..." />
    </div>
  );
}

function BuscadorLibroFrase({ onSeleccionar }) {
  const [abierto, setAbierto] = React.useState(false);
  if (!abierto) return (
    <button onClick={() => setAbierto(true)}
      style={{ background: '#141414', border: '1px solid #2a2a2a', color: '#555', borderRadius: '8px', padding: '8px 14px', cursor: 'pointer', fontSize: '12px', flexShrink: 0 }}>
      + Añadir libro
    </button>
  );
  return (
    <div style={{ flex: 1 }}>
      <BuscadorLibro
        placeholder="¿De qué libro es la frase?"
        onSeleccionar={libro => { onSeleccionar(libro); setAbierto(false); }}
      />
    </div>
  );
}

// ── App principal ─────────────────────────────────────────────────────────────
function App() {
  const [user, setUser] = useState(null);
  const [authCargando, setAuthCargando] = useState(true);
  const [busqueda, setBusqueda] = useState("");
  const [libros, setLibros] = useState([]);
  const [libroSeleccionado, setLibroSeleccionado] = useState(() => { try { const s = lsGet('libro_seleccionado'); const l = s ? JSON.parse(s) : null; return l?.id ? l : null; } catch { return null; } });
  const [entradaActivaBib, setEntradaActivaBib] = useState(null);
  const [soloLecturaBib, setSoloLecturaBib] = useState(false);
  const [vistaNotasBib, setVistaNotasBib] = useState(false);
  const [entradasBib, setEntradasBib] = useState([]); // todas las entradas de biblioteca (para PanelProgresoLector)
  const [conteoSalas, setConteoSalas] = useState(0);
  const [salaAbierta, setSalaAbierta] = useState(null);
  const [cargando, setCargando] = useState(false);
  const [errorApi, setErrorApi] = useState(false);
  const [sinConexion, setSinConexion] = useState(!navigator.onLine);
  const [seccionActiva, setSeccionActiva] = useState('feed');
  const [seccionAnterior, setSeccionAnterior] = useState('feed');
  const [tabSala, setTabSala] = useState('chat');
  const [menuPerfilVisible, setMenuPerfilVisible] = useState(false);
  const [modalInvitarVisible, setModalInvitarVisible] = useState(false);
  const [modalSeguidoresVisible, setModalSeguidoresVisible] = useState(false);
  const [modalCrearPrivadaVisible, setModalCrearPrivadaVisible] = useState(false);
  const [passwordNuevaSala, setPasswordNuevaSala] = useState("");
  const [modalSalirSala, setModalSalirSala] = useState(false);
  const [modalBorrarCuenta, setModalBorrarCuenta] = useState(false);
  const [modalVerificado, setModalVerificado] = useState(false);
  const [modalPublicarLibro, setModalPublicarLibro] = useState(false);
  const [solicitudesLibro, setSolicitudesLibro] = useState([]);
  const [cargandoSolicitudesLibro, setCargandoSolicitudesLibro] = useState(false);
  const [alertasAdmin, setAlertasAdmin] = useState([]);
  const [cargandoAlertasAdmin, setCargandoAlertasAdmin] = useState(false);
  const [modalPasswordAlerta, setModalPasswordAlerta] = useState(null);
  const [passwordAlertaInput, setPasswordAlertaInput] = useState("");
  const [passwordAlertaError, setPasswordAlertaError] = useState(false);
  const [toastMsg, setToastMsg] = useState(null); // { texto, tipo: 'ok'|'error' }
  const [tabSeguidores, setTabSeguidores] = useState('seguidores');
  const [editando, setEditando] = useState(null);
  const [mensaje, setMensaje] = useState("");
  const ultimoEnvioRef = useRef(0);
  const [esSpoiler, setEsSpoiler] = useState(false);
  const [mensajeCitado, setMensajeCitado] = useState(null); // mensaje al que se responde
  const [perfilAjeno, setPerfilAjeno] = useState(null);
  const [alertas, setAlertas] = useState([]);
  const [siguiendoA, setSiguiendoA] = useState([]);
  const [listaSeguidores, setListaSeguidores] = useState([]);
  const [listaSiguiendo, setListaSiguiendo] = useState([]);
  const [actividadReciente, setActividadReciente] = useState([]);
  const [paginaLegal, setPaginaLegal] = useState(null);
  const [mostrarOnboarding, setMostrarOnboarding] = useState(false);
  const [toastInsignia, setToastInsignia] = useState(null); // { insignia, nivel }
  const statsAnteriorRef = React.useRef(null);

  // Actualizar título del navegador con alertas pendientes
  useEffect(() => {
    const n = alertas.length;
    document.title = n > 0 ? `(${n}) Leemos` : 'Leemos';
  }, [alertas]);
  const [modalPremium, setModalPremium] = useState(false);
  // Recheck esNativa — múltiples intentos para cubrir cualquier timing de Capacitor.
  // El chequeo original solo daba 3 intentos en menos de 1 segundo (100/300/800ms),
  // insuficiente en dispositivos donde Capacitor tarda más en estar listo. Si esto
  // fallaba, esNativaConfirmado se quedaba en false para siempre, y la app mostraba
  // el BannerPublicitario de afiliados (pensado solo para web) en vez del banner
  // real de AdMob — apareciendo como un hueco vacío/negro en la app nativa.
  // Ampliado a 10 intentos durante ~5 segundos, igual que el resto de fixes de hoy.
  const [esNativaConfirmado, setEsNativaConfirmado] = useState(esNativa);
  useEffect(() => {
    if (esNativaConfirmado) return;
    const checks = [100, 300, 800, 1300, 1800, 2300, 2800, 3500, 4200, 5000];
    const timers = checks.map(delay =>
      setTimeout(() => {
        const resultado = detectarNativa();
        if (resultado) setEsNativaConfirmado(true);
      }, delay)
    );
    return () => timers.forEach(clearTimeout);
  }, [esNativaConfirmado]);
  const abrirModalPremium = () => { if (detectarNativa()) ocultarAdMobBanner(); setModalPremium(true); };
  const cerrarModalPremium = () => { setModalPremium(false); if (detectarNativa() && !esPremium) setTimeout(() => iniciarAdMobBanner(false), 500); };
  const [modalGoodreads, setModalGoodreads] = useState(false);
  const [menuOpciones, setMenuOpciones] = useState(false);
  const [comprando, setComprando] = useState(false);
  const [marcoSeleccionado, setMarcoSeleccionado] = useState('ninguno');

  const fileInputRef = useRef(null);
  const unsubscribeRef = useRef(null);
  const chatEndRef = useRef(null);

  const [perfil, setPerfil] = useState({
    id: null, nombre: "", nombreNormalizado: "", foto: null,
    fecha: `Miembro desde ${new Date().toLocaleDateString('es-ES', { month: 'long', year: 'numeric' })}`,
    sobreMi: "Cuéntanos algo sobre ti...", seguidores: 0, siguiendo: 0,
    generos: [], fechaNacimiento: null
  });

  const isMobile = useIsMobile();
  const esAdmin = user?.uid === ADMIN_UID;
  const esPremium = perfil.premium === true;

  // Función centralizada para abrir el detalle de un libro
  // Código de invitación del usuario — basado en su UID, único y determinista
  const codigoInvitacionPropio = user ? user.uid.slice(0, 6).toUpperCase() : '';

  const verLibro = (libro) => {
    if (!libro) return;
    const libroNorm = {
      ...libro,
      id: libro.id || libro.libroId || generarIdLibro(libro.titulo || '', libro.autor || ''),
      titulo: libro.titulo || '',
      autor: libro.autor || '',
      portada: libro.portada || '',
      descripcion: libro.descripcion || '',
    };
    setLibroSeleccionado(null);
    setTimeout(() => {
      setLibroSeleccionado(libroNorm);
      const secActual = seccionActivaRef.current;
      if (!['sala', 'perfil-ajeno', 'alertas', 'biblioteca', 'buscar-usuarios', 'admin', 'clubs'].includes(secActual)) {
        setSeccionActiva('libros');
      }
    }, 50);
  };
  const { stats } = useStats(user?.uid);

  useEffect(() => { if (chatEndRef.current) chatEndRef.current.scrollIntoView({ behavior: isMobile ? 'auto' : 'smooth' }); }, [salaAbierta?.mensajes]);

  // Detectar código de invitación en la URL (?ref=XXXXXX)
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const ref = params.get('ref');
    if (ref && ref.length === 6) {
      lsSet('leemos_codigo_invitacion', ref.toUpperCase());
    }
  }, []);

  useEffect(() => {
    // Procesar resultado del redirect de Google Sign In
    getRedirectResult(auth).then(async (result) => {
      if (!result) return;
      const firebaseUser = result.user;
      const userDoc = await getDoc(doc(db, "users", firebaseUser.uid));
      if (!userDoc.exists()) {
        await firebaseUser.getIdToken(true);
        const totalSnap = await getDocs(query(collection(db, "users"), limit(101)));
        const esPionero = totalSnap.size < 100;
        const n = firebaseUser.displayName || "Usuario";
        await setDoc(doc(db, "users", firebaseUser.uid), {
          id: firebaseUser.uid, nombre: n, nombreNormalizado: normalizarTexto(n),
          foto: firebaseUser.photoURL || null,
          fecha: `Miembro desde ${new Date().toLocaleDateString('es-ES', { month: 'long', year: 'numeric' })}`,
          sobreMi: "Cuéntanos algo sobre ti...", seguidores: 0, siguiendo: 0, generos: [],
          fechaNacimiento: null, es_pionero: esPionero ? 1 : 0,
          codigoInvitacion: firebaseUser.uid.slice(0, 6).toUpperCase(),
        }).catch(() => {});
      }
    }).catch(() => {});
  }, []);

  useEffect(() => {
    const unsub = onAuthStateChanged(auth, async (fu) => {
      if (fu) {
        const userDoc = await getDoc(doc(db, "users", fu.uid));
        if (userDoc.exists()) {
          const data = userDoc.data();
          // Verificar si el usuario está bloqueado ANTES de establecer el usuario
          if (data.bloqueado === true) {
            await signOut(auth);
            setUser(null);
            setAuthCargando(false);
            return;
          }
          // NO llamar setUser aquí — esperar a tener todo el estado listo para evitar flash de Home
          const updates = {};
          if (!data.nombreNormalizado) updates.nombreNormalizado = normalizarTexto(data.nombre || "");
          if (fu.displayName && fu.displayName !== data.nombre) { updates.nombre = fu.displayName; updates.nombreNormalizado = normalizarTexto(fu.displayName); }
          if (!data.foto && fu.photoURL) {
            // No bloquear el login — descargar foto en background
            urlToBase64(fu.photoURL, fu.uid).then(b64 => {
              if (b64) updateDoc(doc(db, "users", fu.uid), { foto: b64 }).catch(() => {});
            }).catch(() => {});
          }
          if (Object.keys(updates).length > 0) {
            await updateDoc(doc(db, "users", fu.uid), updates);
            setPerfil({ ...data, ...updates, id: fu.uid });
          } else {
            setPerfil({ ...data, id: fu.uid });
          }
          // Preparar onboarding y marco ANTES de setUser para evitar flash de Home
          if (data.marco) setMarcoSeleccionado(data.marco);
          if (!data.onboardingCompletado) setMostrarOnboarding(true);
          // Añadir codigoInvitacion si no lo tiene
          if (!data.codigoInvitacion) {
            updateDoc(doc(db, 'users', fu.uid), { codigoInvitacion: fu.uid.slice(0, 6).toUpperCase() }).catch(() => {});
          }
          if (detectarNativa()) {
            const esPremiumRC = await comprobarPremiumRevenueCat(fu.uid);
            if (esPremiumRC && !data.premium) {
              await updateDoc(doc(db, 'users', fu.uid), { premium: true });
              setPerfil(prev => ({ ...prev, premium: true }));
            }
          }
          // Establecer usuario al final — todo el estado ya está preparado, sin flash
          setUser(fu);
        } else {
          // Perfil no encontrado — puede estar siendo creado por handleEmail/handleGoogle
          // Simplemente entramos y dejamos que el handler correspondiente gestione el perfil
          const codigoUsado = lsGet('leemos_codigo_invitacion');
          if (codigoUsado) lsRemove('leemos_codigo_invitacion');
          if (fu.photoURL) {
            urlToBase64(fu.photoURL, fu.uid).then(b64 => {
              if (b64) updateDoc(doc(db, "users", fu.uid), { foto: b64 }).catch(() => {});
            }).catch(() => {});
          }
          setMostrarOnboarding(true);
          setUser(fu);
        }
      } else { setUser(null); }
      setAuthCargando(false);
    });
    return () => unsub();
  }, []);

  useEffect(() => {
    if (user) {
      // Solo ejecutar mantenerSalas una vez al día por dispositivo
      const hoy = new Date().toISOString().slice(0, 10);
      const ultimoMantenimiento = lsGet('leemos_ultimo_mantenimiento');
      if (ultimoMantenimiento !== hoy) {
        lsSet('leemos_ultimo_mantenimiento', hoy);
        mantenerSalas();
      }
      // Solo ejecutar animarSalasInactivas una vez al día por dispositivo
      const ultimaAnimacion = lsGet('leemos_ultima_animacion');
      if (ultimaAnimacion !== hoy) {
        lsSet('leemos_ultima_animacion', hoy);
        animarSalasInactivas();
      }
      // Registrar actividad diaria — una entrada por día para calcular racha correctamente
      registrarActividad(user.uid, { id: `login_${hoy}`, titulo: 'Sesión', autor: '', portada: '' });

      // Verificar si este usuario fue invitado y actualizar diasActivo (en background, máx 1 vez/día)
      const ultimoCheckInv = lsGet('leemos_ultimo_check_inv');
      if (ultimoCheckInv !== hoy) {
        lsSet('leemos_ultimo_check_inv', hoy);
        (async () => {
        try {
          const invSnap = await getDocs(query(collection(db, "invitaciones"), where("invitadoId", "==", user.uid), where("activado", "==", false), limit(1)));
          if (!invSnap.empty) {
            const invDoc = invSnap.docs[0];
            const diasActivo = (invDoc.data().diasActivo || 0) + 1;
            if (diasActivo >= 3) {
              await updateDoc(invDoc.ref, { diasActivo, activado: true });
              await setDoc(doc(db, "user_stats", invDoc.data().invitadorId), { invitacionesActivadas: increment(1) }, { merge: true }).catch(() => {});
              await setDoc(doc(db, "alertas", `inv_activada_${invDoc.id}`), {
                destinatarioId: invDoc.data().invitadorId,
                emisorId: user.uid,
                emisorNombre: perfil?.nombre || 'Un lector',
                emisorFoto: perfil?.foto || null,
                tipo: 'invitacion_activada',
                texto: `${perfil?.nombre || 'Tu amigo'} lleva 3 días en Leemos. ¡Has ganado 1 mes de Premium!`,
                fecha: serverTimestamp(),
                leida: false,
              }).catch(() => {});
            } else {
              await updateDoc(invDoc.ref, { diasActivo }).catch(() => {});
            }
          }
        } catch { }
        })();
      }
    }
  }, [user]); // solo al hacer login, no al cambiar esPremium

  // ── Banner AdMob — ÚNICA fuente de verdad ────────────────────────────────────
  // Antes había dos useEffect separados llamando a iniciarAdMobBanner/ocultarAdMobBanner
  // sin coordinarse entre sí (uno por sección/sala, otro por login). Sus cleanups
  // se disparaban de forma cruzada y competían por mostrar/ocultar el banner nativo
  // al mismo tiempo, causando el parpadeo negro/anuncio cada pocos segundos.
  // Ahora todo el control del banner vive aquí, en un único efecto con un único
  // booleano de decisión (debeVerse), evitando llamadas concurrentes.
  useEffect(() => {
    if (!user || !detectarNativa() || esPremium) return;

    const debeVerse = !(seccionActiva === 'sala' && salaAbierta);
    let cancelado = false;

    const intentarMostrar = (intentos = 0) => {
      if (cancelado) return;
      if (!debeVerse) { ocultarAdMobBanner(); return; }
      // Si el módulo AdMob aún no ha terminado de cargar (import asíncrono al
      // iniciar la app), reintentamos un poco antes de rendirnos — sin esto,
      // la primera llamada tras login podía fallar en silencio y el banner se
      // quedaba con el hueco vacío hasta el siguiente cambio de sección.
      if (!AdMob && intentos < 8) { setTimeout(() => intentarMostrar(intentos + 1), 500); return; }
      iniciarAdMobBanner(false);
    };

    const t = setTimeout(() => intentarMostrar(), 400);

    return () => {
      cancelado = true;
      clearTimeout(t);
    };
  }, [seccionActiva, salaAbierta, user, esPremium]);

  // Ocultar el banner al desmontar la app por completo (logout, cierre de sesión)
  useEffect(() => {
    if (!user) return;
    return () => { if (detectarNativa()) ocultarAdMobBanner(); };
  }, [user]);

  // ── Notificaciones push — independiente del banner ───────────────────────────
  useEffect(() => {
    if (!user) return;

    const irASalaDesdeNotif = async (salaId, libroTitulo) => {
      if (!salaId) return;
      const salaSnap = await getDoc(doc(db, 'salas_info', salaId)).catch(() => null);
      if (salaSnap?.exists()) {
        const data = salaSnap.data();
        entrarEnSala({ id: data.libroId, titulo: libroTitulo || data.titulo || '', autor: data.autor || '', portada: data.portada || '', descripcion: '' }, false, salaId);
      }
    };

    // Reintenta detectar el entorno nativo durante unos segundos.
    // Capacitor a veces tarda en inicializarse y la primera comprobación
    // (justo al montar) puede devolver false aunque sí sea la app nativa.
    // Sin este reintento, initPushNotifications nunca llegaba a llamarse
    // y el usuario jamás veía el prompt de permiso de notificaciones.
    let intentos = 0;
    let cancelado = false;
    const MAX_INTENTOS = 10; // ~5s de margen total (10 x 500ms)

    const intentarInicio = () => {
      if (cancelado) return;
      if (detectarNativa()) {
        initPushNotifications(user.uid, irASalaDesdeNotif);
        return;
      }
      intentos++;
      if (intentos < MAX_INTENTOS) {
        setTimeout(intentarInicio, 500);
      }
    };
    intentarInicio();

    return () => { cancelado = true; };
  }, [user]);

  // Detectar cuando el usuario sube de nivel en una insignia
  useEffect(() => {
    if (!stats) return;
    const anterior = statsAnteriorRef.current;
    if (!anterior) { statsAnteriorRef.current = stats; return; }

    // Comparar cada insignia
    for (const ins of INSIGNIAS_DEF) {
      const valorAntes = anterior[ins.campo] || 0;
      const valorAhora = stats[ins.campo] || 0;
      if (valorAhora <= valorAntes) continue;

      const { nivelActual: nivelAntes } = calcularNivel(ins, valorAntes);
      const { nivelActual: nivelAhora } = calcularNivel(ins, valorAhora);

      // Si el nivel ha subido, mostrar toast
      if (nivelAhora && nivelAhora !== nivelAntes) {
        setToastInsignia({ insignia: ins, nivel: nivelAhora });
        break;
      }
    }
    statsAnteriorRef.current = stats;
  }, [stats]);

  useEffect(() => {
    if (!user) return;
    getDocs(query(collection(db, "actividad_reciente"), where("userId", "==", user.uid), orderBy("fecha", "desc"), limit(MAX_ACTIVIDAD)))
      .then(snap => setActividadReciente(snap.docs.map(d => ({ id: d.id, ...d.data() }))))
      .catch(() => {});
  }, [user?.uid]);

  // Cargar relaciones una sola vez al iniciar sesión (getDocs en lugar de onSnapshot)
  const cargarRelaciones = async (uid) => {
    try {
      const [siguiendoSnap, seguidoresSnap] = await Promise.all([
        getDocs(query(collection(db, "relaciones"), where("seguidorId", "==", uid), limit(200))),
        getDocs(query(collection(db, "relaciones"), where("seguidoId", "==", uid), limit(200))),
      ]);
      const idsSiguiendo = siguiendoSnap.docs.map(d => d.data().seguidoId);
      const idsSeguidores = seguidoresSnap.docs.map(d => d.data().seguidorId);
      setSiguiendoA(idsSiguiendo);
      setPerfil(prev => ({ ...prev, siguiendo: idsSiguiendo.length, seguidores: idsSeguidores.length }));
      const [perfilesSiguiendo, perfilesSeguidores] = await Promise.all([
        Promise.all(idsSiguiendo.map(async id => { try { const s = await getDoc(doc(db, "users", id)); return s.exists() ? { id, ...s.data() } : { id, nombre: id, foto: null }; } catch { return { id, nombre: id, foto: null }; } })),
        Promise.all(idsSeguidores.map(async id => { try { const s = await getDoc(doc(db, "users", id)); return s.exists() ? { id, ...s.data() } : { id, nombre: id, foto: null }; } catch { return { id, nombre: id, foto: null }; } })),
      ]);
      setListaSiguiendo(perfilesSiguiendo);
      setListaSeguidores(perfilesSeguidores);
    } catch (e) { console.error('Error cargando relaciones:', e); }
  };

  useEffect(() => {
    if (!user) return;
    cargarRelaciones(user.uid);
  }, [user?.uid]);

  useEffect(() => {
    if (!user) return;
    const unsub = onSnapshot(query(collection(db, "alertas"), where("destinatarioId", "==", user.uid), where("leida", "==", false), orderBy("fecha", "desc"), limit(50)), snap => setAlertas(snap.docs.map(d => ({ id: d.id, ...d.data() }))));
    return () => unsub();
  }, [user]);

  const logout = async () => {
    // Eliminar token FCM al cerrar sesión
    if (user && detectarNativa()) {
      deleteDoc(doc(db, 'fcm_tokens', user.uid)).catch(() => {});
    }
    // Limpiar datos locales al cerrar sesión
    lsRemove('mi_perfil_libros');
    lsRemove('libro_seleccionado');
    Object.keys(localStorage)
      .filter(k => k.startsWith('leemos_busqueda_') || k === 'leemos_ultima_animacion' || k === 'leemos_ultimo_mantenimiento' || k === 'leemos_codigo_invitacion' || k === 'leemos_ultimo_check_inv')
      .forEach(k => lsRemove(k));
    // Limpiar unsubscribe de sala si estaba en una
    if (unsubscribeRef.current) { unsubscribeRef.current(); unsubscribeRef.current = null; }
    // Limpiar timers
    if (perfilUpdateTimerRef.current) { clearTimeout(perfilUpdateTimerRef.current); perfilUpdateTimerRef.current = null; }
    // Resetear estado de la app
    setPerfil({});
    setSalaAbierta(null);
    setLibroSeleccionado(null);
    setAlertas([]);
    setSiguiendoA([]);
    setListaSiguiendo([]);
    setListaSeguidores([]);
    setActividadReciente([]);
    setLibros([]);
    setBusqueda('');
    setSeccionActiva('feed');
    setSeccionAnterior('feed');
    setPerfilAjeno(null);
    setMostrarOnboarding(false);
    setTabSala('chat');
    setEditando(null);
    setMarcoSeleccionado('ninguno');
    setConteoSalas(0);
    await signOut(auth);
  };

  const perfilUpdateTimerRef = useRef(null);
  const perfilAnteriorRef = useRef(null);
  useEffect(() => {
    if (!user) return;
    const { foto, id, premium, bloqueado, ...perfilSeguro } = perfil;
    if (!id || id === null) return;
    try { lsSet('mi_perfil_libros', JSON.stringify(perfilSeguro)); } catch (e) {}
    // Comparar con versión anterior para evitar escrituras innecesarias
    const perfilStr = JSON.stringify(perfilSeguro);
    if (perfilAnteriorRef.current === perfilStr) return;
    perfilAnteriorRef.current = perfilStr;
    // Debounce — esperar 1.5s antes de escribir en Firestore
    if (perfilUpdateTimerRef.current) clearTimeout(perfilUpdateTimerRef.current);
    perfilUpdateTimerRef.current = setTimeout(() => {
      updateDoc(doc(db, "users", user.uid), perfilSeguro).catch(() => {});
    }, 1500);
  }, [perfil, user]);

  useEffect(() => {
    if (libroSeleccionado?.id) lsSet('libro_seleccionado', JSON.stringify(libroSeleccionado));
    else lsRemove('libro_seleccionado');
  }, [libroSeleccionado]);

  useEffect(() => {
    if (!libroSeleccionado?.id) { setConteoSalas(0); return; }
    let activo = true;
    getDocs(query(collection(db, "salas_info"), where("libroId", "==", libroSeleccionado.id), where("tipo", "==", "publica")))
      .then(snap => { if (activo) setConteoSalas(snap.docs.filter(d => d.data().activa !== false).length); })
      .catch(() => {});
    return () => { activo = false; };
  }, [libroSeleccionado]);

  useEffect(() => {
    const on = () => setSinConexion(false), off = () => setSinConexion(true);
    window.addEventListener('online', on); window.addEventListener('offline', off);
    return () => { window.removeEventListener('online', on); window.removeEventListener('offline', off); };
  }, []);

  const handleUpdate = (campo, valor) => {
    if (['premium', 'bloqueado', 'id'].includes(campo)) return; // campos protegidos
    const upd = { [campo]: valor };
    if (campo === 'nombre') upd.nombreNormalizado = normalizarTexto(valor);
    setPerfil(prev => ({ ...prev, ...upd }));
  };

  const toggleSeguirPendienteRef = useRef(false);
  const toggleSeguir = async (u) => {
    if (!user || u.id === user.uid || toggleSeguirPendienteRef.current) return;
    toggleSeguirPendienteRef.current = true;
    const ref = doc(db, "relaciones", `${user.uid}_${u.id}`);
    try {
      if (siguiendoA.includes(u.id)) {
        await deleteDoc(ref);
        await updateDoc(doc(db, "users", user.uid), { siguiendo: increment(-1) });
        await updateDoc(doc(db, "users", u.id), { seguidores: increment(-1) }).catch(() => {});
      } else {
        await setDoc(ref, { seguidorId: user.uid, seguidoId: u.id, fecha: serverTimestamp() });
        await updateDoc(doc(db, "users", user.uid), { siguiendo: increment(1) });
        await updateDoc(doc(db, "users", u.id), { seguidores: increment(1) }).catch(() => {});
        // Crear alerta para el usuario seguido
        await addDoc(collection(db, "alertas"), {
          tipo: 'nuevo_seguidor',
          destinatarioId: u.id,
          emisorId: user.uid,
          emisorNombre: perfil?.nombre || user.displayName || 'Alguien',
          emisorFoto: perfil?.foto || user.photoURL || null,
          leida: false,
          fecha: serverTimestamp(),
        }).catch(() => {});
      }
    } catch (e) { console.error(e); }
    toggleSeguirPendienteRef.current = false;
    // Recargar relaciones para mantener contadores actualizados
    cargarRelaciones(user.uid);
  };

  const borrarCuenta = async () => {
    try {
      const uid = user.uid;

      // Colecciones con campo userId — cada una con su propio catch
      const colsUserId = [
        'estados_lectura', 'valoraciones', 'actividad_reciente',
        'retos', 'sesiones_lectura', 'citas'
      ];
      for (const col of colsUserId) {
        try {
          const snap = await getDocs(query(collection(db, col), where('userId', '==', uid)));
          for (const d of snap.docs) await deleteDoc(d.ref).catch(() => {});
        } catch { }
      }

      // Relaciones
      const segSnap = await getDocs(query(collection(db, 'relaciones'), where('seguidorId', '==', uid))).catch(() => ({ docs: [] }));
      for (const d of segSnap.docs) await deleteDoc(d.ref).catch(() => {});
      const segdoSnap = await getDocs(query(collection(db, 'relaciones'), where('seguidoId', '==', uid))).catch(() => ({ docs: [] }));
      for (const d of segdoSnap.docs) await deleteDoc(d.ref).catch(() => {});

      // Alertas
      const alertasEnvSnap = await getDocs(query(collection(db, 'alertas'), where('emisorId', '==', uid))).catch(() => ({ docs: [] }));
      for (const d of alertasEnvSnap.docs) await deleteDoc(d.ref).catch(() => {});
      const alertasRecSnap = await getDocs(query(collection(db, 'alertas'), where('destinatarioId', '==', uid))).catch(() => ({ docs: [] }));
      for (const d of alertasRecSnap.docs) await deleteDoc(d.ref).catch(() => {});

      // Invitaciones
      try {
        const invEnvSnap = await getDocs(query(collection(db, 'invitaciones'), where('invitadorId', '==', uid)));
        for (const d of invEnvSnap.docs) await deleteDoc(d.ref).catch(() => {});
        const invRecSnap = await getDocs(query(collection(db, 'invitaciones'), where('invitadoId', '==', uid)));
        for (const d of invRecSnap.docs) await deleteDoc(d.ref).catch(() => {});
      } catch { }

      // Buddy reads
      try {
        const buddyASnap = await getDocs(query(collection(db, 'buddy_reads'), where('usuarioA.id', '==', uid)));
        for (const d of buddyASnap.docs) await deleteDoc(d.ref).catch(() => {});
        const buddyBSnap = await getDocs(query(collection(db, 'buddy_reads'), where('usuarioB.id', '==', uid)));
        for (const d of buddyBSnap.docs) await deleteDoc(d.ref).catch(() => {});
      } catch { }

      // Stats timer por libro
      try {
        const timerLibroSnap = await getDocs(query(collection(db, 'stats_timer_libro'), where('userId', '==', uid)));
        for (const d of timerLibroSnap.docs) await deleteDoc(d.ref).catch(() => {});
      } catch { }

      // Miembros de salas
      try {
        const salasSnap = await getDocs(query(collection(db, 'salas_info')));
        for (const salaDoc of salasSnap.docs) {
          await deleteDoc(doc(db, 'salas', salaDoc.id, 'miembros', uid)).catch(() => {});
        }
      } catch { }

      // Documentos únicos
      const docsUnicos = [
        doc(db, 'users', uid),
        doc(db, 'user_stats', uid),
        doc(db, 'stats_timer', uid),
        doc(db, 'tbr_plan', uid),
        doc(db, 'fcm_tokens', uid),
      ];
      for (const ref of docsUnicos) await deleteDoc(ref).catch(() => {});

      // Borrar cuenta de Firebase Auth — siempre al final
      await user.delete();
      logout();
    } catch (e) {
      if (e.code === 'auth/requires-recent-login') {
        showToast('Por seguridad, cierra sesión y vuelve a entrar antes de eliminar tu cuenta.', 'error');
      } else {
        showToast('Error al eliminar la cuenta. Inténtalo de nuevo.', 'error');
      }
    }
  };

  const _portadaCache = React.useRef({});

  const buscarDatosLibro = async (libro) => {
    if (libro.portada && libro.portada.startsWith('https://')) {
      return { id: generarIdLibro(libro.titulo, libro.autor), titulo: libro.titulo, autor: libro.autor, portada: libro.portada, descripcion: '' };
    }
    const cacheKey = (libro.titulo + '_' + libro.autor).toLowerCase();
    if (_portadaCache.current[cacheKey]) return _portadaCache.current[cacheKey];
    try {
      // 1. Firestore cache
      const libroId = generarIdLibro(libro.titulo, libro.autor);
      const snap = await getDoc(doc(db, 'portadas_cache', libroId));
      if (snap.exists()) {
        _portadaCache.current[cacheKey] = snap.data();
        return snap.data();
      }
      // 2. Google Books con delay
      if (_portadaCache.current['__google_rate_limited__']) return null;
      await new Promise(r => setTimeout(r, 300));
      const q = encodeURIComponent(`intitle:${libro.titulo} inauthor:${libro.autor}`);
      const resp = await fetch(`https://www.googleapis.com/books/v1/volumes?q=${q}&maxResults=5&key=${GOOGLE_BOOKS_API_KEY}`);
      if (!resp.ok) {
        if (resp.status === 429) _portadaCache.current['__google_rate_limited__'] = true;
        return null;
      }
      const data = await resp.json();
      const item = (data.items || []).find(i => i.volumeInfo?.imageLinks?.thumbnail);
      if (!item) return null;
      const portada = (item.volumeInfo.imageLinks.thumbnail || '').replace('http://', 'https://');
      const resultado = { id: libroId, titulo: libro.titulo, autor: libro.autor, portada, descripcion: item.volumeInfo?.description?.slice(0, 200) || '' };
      _portadaCache.current[cacheKey] = resultado;
      setDoc(doc(db, 'portadas_cache', libroId), resultado).catch(() => {});
      return resultado;
    } catch { return null; }
  };

  const seccionActivaRef = useRef(seccionActiva);
  useEffect(() => { seccionActivaRef.current = seccionActiva; }, [seccionActiva]);

  const cargarLista = useCallback(async (nombre = "Tendencias", silencioso = false) => {
    setCargando(true); setErrorApi(false);
    if (!silencioso) setSeccionActiva('libros');
    setMenuPerfilVisible(false); setSalaAbierta(null);
    if (nombre !== "Tendencias") setBusqueda(nombre); else setBusqueda("");
    try {
      const lista = LISTAS_LIBROS[nombre] || LISTAS_LIBROS.Tendencias;
      const diaDelAnio = Math.floor(Date.now() / (1000 * 60 * 60 * 24));
      const offset = (diaDelAnio * 3) % lista.length;
      const listaRotada = [...lista.slice(offset), ...lista.slice(0, offset)];

      // Leer Firestore en paralelo primero
      const cacheResults = await Promise.all(
        listaRotada.slice(0, 20).map(async libro => {
          const libroId = generarIdLibro(libro.titulo, libro.autor);
          try {
            const snap = await getDoc(doc(db, 'portadas_cache', libroId));
            if (snap.exists()) return snap.data();
          } catch { }
          return null;
        })
      );

      const resultados = cacheResults.filter(Boolean).slice(0, 10);

      // Si faltan, buscar en Google Books
      if (resultados.length < 5) {
        for (let i = 0; i < listaRotada.length; i++) {
          if (resultados.length >= 10) break;
          if (resultados.find(r => r.titulo === listaRotada[i].titulo)) continue;
          const res = await buscarDatosLibro(listaRotada[i]);
          if (res) resultados.push(res);
          if (i < listaRotada.length - 1) await new Promise(r => setTimeout(r, 150));
        }
      }

      if (!resultados.length) setErrorApi(true);
      setLibros(resultados);
    } catch { setErrorApi(true); } finally { setCargando(false); }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const busquedaTokenRef = useRef(0);

  const buscarManual = async (t) => {
    if (!t.trim()) return cargarLista();
    const token = ++busquedaTokenRef.current;
    const esBusquedaActual = () => token === busquedaTokenRef.current;
    setCargando(true); setErrorApi(false); setSeccionActiva('libros'); setLibroSeleccionado(null);

    const tNorm = normalizarTexto(t);
    const CACHE_VERSION = 'v12'; // incrementado: lote 7 (cozy romance, BookTok España 2024-2026) añadido
    const cacheKey = `leemos_busqueda_${CACHE_VERSION}_${tNorm}`;

    // ── Cache: devolver resultado guardado si existe y tiene < 24h ─────────
    try {
      const cached = lsGet(cacheKey);
      if (cached) {
        const { resultado, timestamp } = JSON.parse(cached);
        if (Date.now() - timestamp < 24 * 60 * 60 * 1000 && resultado?.length > 0) {
          if (esBusquedaActual()) { setLibros(resultado); setCargando(false); }
          return;
        }
      }
    } catch { /* ignorar errores de localStorage */ }

    const guardarCache = (resultado) => {
      try {
        // Limpiar cache antiguo si hay más de 30 entradas
        const keys = Object.keys(localStorage).filter(k => k.startsWith('leemos_busqueda_'));
        if (keys.length >= 30) {
          const masAntiguo = keys.sort((a, b) => {
            try { return JSON.parse(lsGet(a) || 'null').timestamp - JSON.parse(lsGet(b) || 'null').timestamp; }
            catch { return 0; }
          })[0];
          lsRemove(masAntiguo);
        }
        lsSet(cacheKey, JSON.stringify({ resultado, timestamp: Date.now() }));
      } catch { /* ignorar */ }
    };


    // ── 1. Comprobar si coincide con una saga/autor curado ────────────────
    const sagaMatch = SAGAS_CONOCIDAS.find(saga =>
      saga.terminos.some(termino => {
        // Términos cortos (<=3 chars): solo coincidencia exacta o como palabra completa
        // Evita falsos positivos: "it" dentro de "principito", "la" dentro de "ladrona"
        if (termino.length <= 3) {
          return tNorm === termino || tNorm.split(/\s+/).includes(termino);
        }
        return tNorm.includes(termino) || termino.includes(tNorm);
      })
    );

    if (sagaMatch) {
      try {
        // Limitar a 12 libros máximo para no saturar Google Books con sagas grandes
        const librosABuscar = sagaMatch.libros.slice(0, 12);

        // Buscar portadas en lotes de 4 para no saturar la API
        const LOTE = 4;
        const librosConPortada = [];
        for (let i = 0; i < librosABuscar.length; i += LOTE) {
          const lote = librosABuscar.slice(i, i + LOTE);
          const resultadosLote = await Promise.all(
            lote.map(async (libro) => {
              try {
                const resp = await fetch(
                  `https://www.googleapis.com/books/v1/volumes?q=${encodeURIComponent(libro.titulo + ' ' + libro.autor)}&maxResults=5&key=${GOOGLE_BOOKS_API_KEY}`
                );
                if (resp.ok) {
                  const data = await resp.json();
                  const itemConPortada = (data.items || []).find(item =>
                    item.volumeInfo?.imageLinks?.thumbnail || item.volumeInfo?.imageLinks?.smallThumbnail
                  );
                  const portada = getPortadaGoogle(itemConPortada?.volumeInfo?.imageLinks) || '';
                  return { id: generarIdLibro(libro.titulo, libro.autor), titulo: libro.titulo, autor: libro.autor, portada, descripcion: '' };
                }
              } catch { }
              // Sin portada: devolver igualmente para que aparezca en resultados
              return { id: generarIdLibro(libro.titulo, libro.autor), titulo: libro.titulo, autor: libro.autor, portada: '', descripcion: '' };
            })
          );
          librosConPortada.push(...resultadosLote);
          // Pequeña pausa entre lotes para no saturar la API
          if (i + LOTE < librosABuscar.length) await new Promise(r => setTimeout(r, 300));
        }
        const res = librosConPortada.filter(l => l);
        // Si hay libros con portada, mostrarlos
        if (res.length > 0) {
          guardarCache(res);
          if (esBusquedaActual()) { setLibros(res); setCargando(false); }
          return;
        }
        // Si la saga existe pero no se pudieron cargar portadas, mostrar libros sin portada
        // (mejor que mostrar resultados irrelevantes de otro autor)
        const resSinPortada = sagaMatch.libros.map(libro => ({
          id: generarIdLibro(libro.titulo, libro.autor),
          titulo: libro.titulo, autor: libro.autor, portada: '', descripcion: '',
        }));
        if (resSinPortada.length > 0) {
          if (esBusquedaActual()) { setLibros(resSinPortada); setCargando(false); }
          return;
        }
      } catch { /* si falla completamente, seguir con búsqueda normal */ }
    }

    // ── 1.5. Comprobar libros de autores indie (portada custom, sin Google Books) ──
    try {
      const librosAutorSnap = await getDocs(
        query(collection(db, 'portadas_cache'), where('esIndie', '==', true), limit(200))
      );
      const coincidencias = librosAutorSnap.docs
        .map(d => ({ id: d.id, ...d.data() }))
        .filter(l => {
          const tNormLibro = normalizarTexto(l.titulo);
          const aNormLibro = normalizarTexto(l.autor);
          return tNormLibro.includes(tNorm) || tNorm.includes(tNormLibro) || aNormLibro.includes(tNorm);
        });
      if (coincidencias.length > 0) {
        const res = coincidencias.map(l => ({
          id: l.id, titulo: l.titulo, autor: l.autor, portada: l.portada,
          descripcion: l.descripcion || '', esIndie: true, enlaceCompra: l.enlaceCompra || null,
        }));
        guardarCache(res);
        if (esBusquedaActual()) { setLibros(res); setCargando(false); }
        return;
      }
    } catch (e) { console.error('Error buscando libros de autor:', e); /* seguir con Google Books si falla */ }

    // ── 2. Búsqueda exacta por título en Google Books ─────────────────────
    try {
      const esValido = (titulo, autor) => esLibroValido(titulo, autor);

      // Normalizar título para agrupar ediciones del mismo libro
      const normalizarTituloGrupo = (titulo) => {
        return normalizarTexto(titulo)
          .replace(/\s*\(.*?\)\s*/g, ' ')  // quitar todo entre paréntesis
          .replace(/\s*\/.*$/, '')          // quitar todo tras /
          .replace(/\s*(:|\.)\s*.+$/, '')  // quitar subtítulo tras : .
          .replace(/\s+(i|ii|iii|iv|v|1|2|3|4|5)$/, '') // quitar número tomo
          .replace(/\s+/g, ' ')
          .trim();
      };

      const controller = new AbortController();
      const timeout = setTimeout(() => controller.abort(), 10000);

      // Quitar palabras vacías del título para búsqueda más precisa
      const STOP_WORDS = new Set(['el', 'la', 'los', 'las', 'un', 'una', 'de', 'del', 'en', 'y', 'a', 'the', 'a']);
      const tSinStop = normalizarTexto(t).split(/\s+/).filter(w => w.length > 2 && !STOP_WORDS.has(w)).join(' ');
      const queryTitulo = tSinStop || t; // usar original si al quitar stop words queda vacío

      const resp = await fetch(
        `https://www.googleapis.com/books/v1/volumes?q=intitle:${encodeURIComponent(queryTitulo)}&maxResults=40&orderBy=relevance&langRestrict=es&key=${GOOGLE_BOOKS_API_KEY}`,
        { signal: controller.signal }
      ).catch(() => null);
      clearTimeout(timeout);
      const data = resp ? await resp.json().catch(() => ({ items: [] })) : { items: [] };

      // Filtrar por relevancia — el título o autor debe contener términos de la búsqueda
      const tNormTerminos = normalizarTexto(t).split(/\s+/).filter(w => w.length > 2);
      const esRelevante = (titulo, autor) => {
        const tituloNorm = normalizarTexto(titulo);
        const autorNorm = normalizarTexto(autor);
        // Al menos un término de búsqueda debe aparecer en título o autor
        return tNormTerminos.some(term => tituloNorm.includes(term) || autorNorm.includes(term));
      };

      // Agrupar por autor + título normalizado → 1 libro por obra
      const grupos = new Map();
      for (const item of (data.items || [])) {
        const info = item.volumeInfo;
        if (!info?.title) continue;
        if (!info?.imageLinks?.thumbnail && !info?.imageLinks?.smallThumbnail) continue;
        const titulo = info.title;
        const autor = info.authors?.[0] || '';
        if (!autor) continue; // descartar sin autor
        if (!esValido(titulo, autor)) continue;
        if (!esRelevante(titulo, autor)) continue;

        const grupoKey = normalizarTituloGrupo(titulo) + '_' + normalizarTexto(autor).split(' ')[0];
        if (!grupos.has(grupoKey)) {
          grupos.set(grupoKey, {
            id: generarIdLibro(titulo, autor),
            titulo,
            autor,
            portada: getPortadaGoogle(info.imageLinks) || '',
            descripcion: '',
          });
        }
      }

      const res = [...grupos.values()].filter(l => l.portada).slice(0, 20);

      // Si no hay resultados, intentar búsqueda sin intitle: más amplia
      if (res.length === 0 && esBusquedaActual()) {
        const resp2 = await fetch(
          `https://www.googleapis.com/books/v1/volumes?q=${encodeURIComponent(t)}&maxResults=20&orderBy=relevance&key=${GOOGLE_BOOKS_API_KEY}`
        ).catch(() => null);
        if (resp2?.ok) {
          const data2 = await resp2.json().catch(() => ({ items: [] }));
          const grupos2 = new Map();
          for (const item of (data2.items || [])) {
            const info = item.volumeInfo;
            if (!info?.title || !info?.imageLinks?.thumbnail) continue;
            const titulo = info.title;
            const autor = info.authors?.[0] || '';
            if (!autor || !esValido(titulo, autor) || !esRelevante(titulo, autor)) continue;
            const grupoKey = normalizarTituloGrupo(titulo) + '_' + normalizarTexto(autor).split(' ')[0];
            if (!grupos2.has(grupoKey)) {
              grupos2.set(grupoKey, { id: generarIdLibro(titulo, autor), titulo, autor, portada: getPortadaGoogle(info.imageLinks) || '', descripcion: '' });
            }
          }
          const res2 = [...grupos2.values()].filter(l => l.portada).slice(0, 20);
          if (res2.length > 0) guardarCache(res2);
          if (esBusquedaActual()) { if (!res2.length) setErrorApi(true); setLibros(res2); }
          return;
        }
      }

      if (res.length > 0) guardarCache(res);
      if (esBusquedaActual()) { if (!res.length) setErrorApi(true); setLibros(res); }
    } catch (e) {
      console.error('buscarManual error:', e);
      setErrorApi(true);
    } finally {
      setCargando(false);
    }
  };

  useEffect(() => {
    if (user) {
      // Cargar lista en background sin cambiar la sección
      cargarLista("Tendencias", true);
      // Detectar enlace de perfil de autor compartido (?autor=UID)
      const paramsAutor = new URLSearchParams(window.location.search);
      const uidAutor = paramsAutor.get('autor');
      if (uidAutor) {
        try { window.history.replaceState({}, '', window.location.pathname); } catch { }
        const irAlPerfilAutor = async () => {
          try {
            const docSnap = await getDoc(doc(db, 'users', uidAutor));
            if (!docSnap.exists()) return;
            verPerfilAjeno({ id: uidAutor, ...docSnap.data() });
          } catch (e) { console.error('Error abriendo perfil de autor desde enlace:', e); }
        };
        irAlPerfilAutor();
      }
      // Detectar enlace de invitación a club (?club=CODIGO)
      const paramsClub = new URLSearchParams(window.location.search);
      const codigoClub = paramsClub.get('club');
      if (codigoClub) {
        try { window.history.replaceState({}, '', window.location.pathname); } catch { }
        const unirseDesdeEnlace = async () => {
          try {
            const snap = await getDocs(query(collection(db, 'clubs'), where('codigo', '==', codigoClub.toUpperCase())));
            if (snap.empty) { showToast('Ese enlace de club ya no es válido.', 'error'); return; }
            const clubDoc = snap.docs[0];
            const clubData = clubDoc.data();
            if (clubData.miembros?.includes(user.uid)) {
              setSeccionActiva('clubs');
              return;
            }
            const esClubVerificado = clubData.verificado === 'autor' || clubData.verificado === 'editorial';
            const limiteClub = esClubVerificado ? 500 : 50;
            if ((clubData.miembros?.length || 0) >= limiteClub) {
              showToast('Este club ya está completo.', 'error');
              return;
            }
            await updateDoc(clubDoc.ref, {
              miembros: arrayUnion(user.uid),
              miembrosInfo: arrayUnion({ id: user.uid, nombre: perfil?.nombre || 'Usuario', foto: perfil?.foto || null, rol: 'miembro' }),
            });
            showToast(`Te has unido a "${clubData.nombre}"`, 'success');
            setSeccionActiva('clubs');
          } catch (e) { console.error('Error uniéndose por enlace:', e); }
        };
        unirseDesdeEnlace();
      }
      // Detectar enlace compartido de sala
      const params = new URLSearchParams(window.location.search);
      const salaId = params.get('sala');
      const libroTitulo = params.get('libro');
      if (salaId && libroTitulo) {
        // Limpiar URL
        try { window.history.replaceState({}, '', window.location.pathname); } catch { }
        // Buscar info de la sala y entrar
        const entrarDesdeEnlace = async () => {
          try {
            const salaSnap = await getDoc(doc(db, "salas_info", salaId));
            if (salaSnap.exists()) {
              const data = salaSnap.data();
              const libroInfo = {
                id: data.libroId,
                titulo: decodeURIComponent(libroTitulo),
                autor: '',
                portada: '',
                descripcion: '',
              };
              entrarEnSala(libroInfo, false, salaId, null);
            } else {
              showToast('Esta sala ya no está disponible.', 'error');
            }
          } catch (e) { console.error(e); }
        };
        entrarDesdeEnlace();
      }
    }
  }, [user, cargarLista]);

  const obtenerSalaPublica = async (libroId) => {
    // Obtener todas las salas públicas de este libro
    const todasSnap = await getDocs(query(
      collection(db, "salas_info"),
      where("libroId", "==", libroId),
      where("tipo", "==", "publica")
    ));

    // PRIORIDAD 1: comprobar si el usuario ya es miembro de alguna sala de este libro
    for (const salaDoc of todasSnap.docs) {
      const miembroSnap = await getDoc(doc(db, "salas", salaDoc.id, "miembros", user.uid));
      if (miembroSnap.exists()) return salaDoc.id;
    }

    // PRIORIDAD 2: sala activa con hueco
    const conHueco = todasSnap.docs.find(d => d.data().activa && (d.data().numMiembros || 0) < 9);
    if (conHueco) return conHueco.id;

    // PRIORIDAD 3: nueva sala
    return `${libroId}_publica_${todasSnap.size + 1}`;
  };

  const entrarEnSala = async (libro, esPrivada = false, salaIdForzado = null, passwordSala = null, tituloSala = null) => {
    if (!libro && !salaIdForzado) return;
    setTabSala('chat'); setSeccionActiva('sala');
    setEsSpoiler(false); setMensajeCitado(null); setMensaje('');
    try {
      if (unsubscribeRef.current) unsubscribeRef.current();
      const salaId = salaIdForzado || (esPrivada ? `${libro.id}_privada_${user.uid}` : await obtenerSalaPublica(libro.id));

      // Si el libro no tiene id válido, intentar cargarlo desde salas_info
      let libroFinal = libro;
      if (!libroFinal?.id && salaId) {
        try {
          const salaSnap = await getDoc(doc(db, "salas_info", salaId));
          if (salaSnap.exists()) {
            const d = salaSnap.data();
            libroFinal = { id: d.libroId || salaId, titulo: d.titulo || '', autor: d.autor || '', portada: d.portada || '', descripcion: '' };
          }
        } catch {}
      }
      if (!libroFinal?.id) libroFinal = { ...(libroFinal || {}), id: salaId };

      setSalaAbierta({ ...libroFinal, idReal: salaId, tituloSala: tituloSala || libroFinal.titulo, tipo: esPrivada ? 'privada' : salaIdForzado?.startsWith('evento_') ? 'evento' : 'publica', maxParticipantes: 9, password: passwordSala, miembros: [], mensajes: [] });
      const ref = doc(db, "salas_info", salaId);

      // Registrar al usuario como miembro persistente si no lo era ya
      const miembroRef = doc(db, "salas", salaId, "miembros", user.uid);
      const miembroSnap = await getDoc(miembroRef);
      if (!miembroSnap.exists()) {
        await setDoc(miembroRef, {
          id: user.uid,
          nombre: perfil.nombre,
          avatar: perfil.foto || null,
          entradoEn: serverTimestamp(),
        });
      }

      // Actualizar salas_info
      const miembrosSnap = await getDocs(collection(db, "salas", salaId, "miembros"));
      const salaInfoSnap = await getDoc(ref);
      if (!salaInfoSnap.exists()) {
        // Sala nueva — el creador escribe todos los campos
        await setDoc(ref, {
          libroId: libroFinal.id,
          titulo: libroFinal.titulo,
          autor: libroFinal.autor || '',
          portada: libroFinal.portada || '',
          tipo: esPrivada ? 'privada' : 'publica',
          activa: true,
          creadoPor: user.uid,
          password: passwordSala || null,
          numMiembros: miembrosSnap.size,
          ultimaActividad: serverTimestamp(),
        });
      } else {
        // Sala existente — solo actualizar campos que cualquier miembro puede tocar
        await setDoc(ref, {
          numMiembros: miembrosSnap.size,
          ultimaActividad: serverTimestamp(),
          activa: true,
        }, { merge: true });
      }

      // Escuchar mensajes y miembros en tiempo real
      // Premium ve los últimos 500 mensajes, gratuito los últimos 100
      const limiteHistorial = esPremium ? 500 : 100;
      const unsubMensajes = onSnapshot(
        query(collection(db, "salas", salaId, "mensajes"), orderBy("fecha", "desc"), limit(limiteHistorial)),
        snap => {
          const msgs = snap.docs.map(d => ({ id: d.id, ...d.data() })).reverse();
          setSalaAbierta(prev => prev ? { ...prev, mensajes: msgs } : null);
          // Enriquecer nombres de senders vacíos buscando en users/
          const sinNombre = msgs.filter(m => m.sender?.id && !m.esBot && !m.sender?.nombre);
          if (sinNombre.length > 0) {
            const uidsUnicos = [...new Set(sinNombre.map(m => m.sender.id))];
            Promise.all(uidsUnicos.map(uid =>
              getDoc(doc(db, 'users', uid)).then(s => s.exists() ? { id: uid, nombre: s.data().nombre || 'Lector', foto: s.data().foto || null } : null).catch(() => null)
            )).then(usuarios => {
              const mapa = {};
              usuarios.filter(Boolean).forEach(u => { mapa[u.id] = u; });
              setSalaAbierta(prev => {
                if (!prev) return prev;
                return { ...prev, mensajes: prev.mensajes.map(m =>
                  mapa[m.sender?.id] ? { ...m, sender: { ...m.sender, ...mapa[m.sender.id] } } : m
                )};
              });
            }).catch(() => {});
          }
          // Actualizar marca de "visto" mientras la sala está abierta
          if (user?.uid && detectarNativa()) {
            setDoc(doc(db, 'sala_visto', `${user.uid}_${salaId}`), { ts: Date.now() }, { merge: true }).catch(() => {});
          }
        }
      );
      const unsubMiembros = onSnapshot(
        collection(db, "salas", salaId, "miembros"),
        snap => {
          const miembros = snap.docs.map(d => ({ ...d.data(), esYo: d.id === user.uid }));
          setSalaAbierta(prev => prev ? { ...prev, miembros } : null);
          // Enriquecer nombres vacíos sin tocar Firestore ni bloquear el listener
          const sinNombre = miembros.filter(m => !m.nombre);
          if (sinNombre.length > 0) {
            Promise.all(sinNombre.map(m =>
              getDoc(doc(db, 'users', m.id)).then(s => s.exists() ? { id: m.id, nombre: s.data().nombre || 'Usuario', avatar: m.avatar || s.data().foto || null } : null).catch(() => null)
            )).then(enriquecidos => {
              const mapa = {};
              enriquecidos.filter(Boolean).forEach(e => { mapa[e.id] = e; });
              setSalaAbierta(prev => {
                if (!prev) return prev;
                return { ...prev, miembros: prev.miembros.map(m => mapa[m.id] ? { ...m, ...mapa[m.id] } : m) };
              });
            }).catch(() => {});
          }
        }
      );

      unsubscribeRef.current = () => { unsubMensajes(); unsubMiembros(); };
      await registrarActividad(user.uid, libro);
      // Marcar sala como vista para throttle de notificaciones
      if (detectarNativa()) {
        setDoc(doc(db, 'sala_visto', `${user.uid}_${salaId}`), { ts: Date.now() }, { merge: true }).catch(() => {});
      }
    } catch (e) {
      console.error(e);
      setSalaAbierta(null);
      setSeccionActiva('libros');
      showToast('Error al entrar en la sala. Inténtalo de nuevo.', 'error');
    }
  };

  const iniciarCrearSalaPrivada = () => { setPasswordNuevaSala(""); setModalCrearPrivadaVisible(true); };
  const confirmarCrearSalaPrivada = () => { setModalCrearPrivadaVisible(false); entrarEnSala(libroSeleccionado, true, null, passwordNuevaSala.trim() || null); };

  const enviarMensajeSala = async () => {
    if (!mensaje.trim() || mensaje.trim().length > 500 || !salaAbierta) return;
    const ahora = Date.now();
    if (ahora - ultimoEnvioRef.current < 1000) return;
    ultimoEnvioRef.current = ahora;
    const t = mensaje.trim(), s = esSpoiler, cita = mensajeCitado;
    setMensaje(''); setEsSpoiler(false); setMensajeCitado(null);
    const msgData = {
      texto: t, spoiler: s,
      sender: { id: user.uid, nombre: perfil.nombre || 'Usuario', foto: perfil.foto || null, verificado: perfil.verificado || (user.uid === ADMIN_UID ? 'admin' : null) },
      fecha: serverTimestamp(),
    };
    if (cita) msgData.citando = cita;
    try {
      await addDoc(collection(db, 'salas', salaAbierta.idReal, 'mensajes'), msgData);
      await updateDoc(doc(db, 'salas_info', salaAbierta.idReal), { ultimaActividad: serverTimestamp(), activa: true });
      await setDoc(doc(db, 'user_stats', user.uid), { mensajes_enviados: increment(1) }, { merge: true });
      await updateDoc(doc(db, 'users', user.uid), { mensajes_enviados: increment(1) }).catch(() => {});
    } catch (e) {
      console.error(e);
      showToast('Error al enviar el mensaje. Inténtalo de nuevo.', 'error');
      setMensaje(t); // restaurar el mensaje si falla
    }
  };

  const enviarInvitacionAlerta = async (usuarioDestino) => {
    if (!usuarioDestino) return;
    try { await addDoc(collection(db, "alertas"), { destinatarioId: usuarioDestino.id, emisorId: user.uid, emisorNombre: perfil.nombre || 'Usuario', emisorFoto: perfil.foto || null, libro: salaAbierta.titulo, salaData: { id: salaAbierta.idReal, libroId: salaAbierta.id, tipo: salaAbierta.tipo, titulo: salaAbierta.titulo, portada: salaAbierta.portada, autor: salaAbierta.autor, descripcion: salaAbierta.descripcion || "" }, passwordSala: salaAbierta.password || null, fecha: serverTimestamp(), leida: false }); } catch (e) { console.error(e); }
    setModalInvitarVisible(false);
  };

  // Helper toast — reemplaza alert() nativo
  const toastInsigniaTimerRef = useRef(null);
  useEffect(() => {
    if (toastInsignia) {
      if (toastInsigniaTimerRef.current) clearTimeout(toastInsigniaTimerRef.current);
      toastInsigniaTimerRef.current = setTimeout(() => setToastInsignia(null), 5000);
    }
  }, [toastInsignia]);
  const toastTimerRef = useRef(null);
  const showToast = (texto, tipo = 'ok') => {
    if (toastTimerRef.current) clearTimeout(toastTimerRef.current);
    setToastMsg({ texto, tipo });
    toastTimerRef.current = setTimeout(() => setToastMsg(null), 3000);
  };

  const gestionarAlerta = async (alertaId, aceptar) => {
    const alerta = alertas.find(a => a.id === alertaId);

    if (alerta?.tipo === 'solicitud_club') {
      if (aceptar && alerta.clubId) {
        try {
          const clubSnap = await getDoc(doc(db, 'clubs', alerta.clubId));
          if (clubSnap.exists()) {
            const clubData = clubSnap.data();
            if (!clubData.miembros?.includes(alerta.emisorId)) {
              await updateDoc(doc(db, 'clubs', alerta.clubId), {
                miembros: arrayUnion(alerta.emisorId),
                miembrosInfo: arrayUnion({ id: alerta.emisorId, nombre: alerta.emisorNombre || 'Usuario', foto: null, rol: 'miembro' }),
              });
              await setDoc(doc(db, 'clubs_publicos', alerta.clubId), { numMiembros: (clubData.miembros?.length || 1) + 1 }, { merge: true }).catch(() => {});
              showToast(`Has aceptado a ${alerta.emisorNombre} en "${alerta.club}"`, 'ok');
              // Avisar al solicitante de que fue aceptado
              await addDoc(collection(db, 'alertas'), {
                tipo: 'respuesta_solicitud_club', aceptado: true,
                emisorId: user.uid, emisorNombre: perfil?.nombre || 'El autor',
                destinatarioId: alerta.emisorId, club: alerta.club, clubId: alerta.clubId,
                fecha: serverTimestamp(), leida: false,
              });
            }
          }
        } catch (e) { console.error('Error aceptando solicitud de club:', e); }
      } else if (!aceptar && alerta.clubId) {
        // Avisar al solicitante de que fue rechazado, para que sepa que puede reintentar
        try {
          await addDoc(collection(db, 'alertas'), {
            tipo: 'respuesta_solicitud_club', aceptado: false,
            emisorId: user.uid, emisorNombre: perfil?.nombre || 'El autor',
            destinatarioId: alerta.emisorId, club: alerta.club, clubId: alerta.clubId,
            fecha: serverTimestamp(), leida: false,
          });
        } catch (e) { console.error('Error notificando rechazo de solicitud:', e); }
      }
      // Borrar la solicitud (no solo marcarla leída) para permitir un nuevo intento si fue rechazada
      try { await deleteDoc(doc(db, "alertas", alertaId)); } catch (e) { console.error(e); }
      return;
    }

    if (alerta?.tipo === 'respuesta_solicitud_club') {
      try { await updateDoc(doc(db, "alertas", alertaId), { leida: true }); } catch (e) { console.error(e); }
      return;
    }

    if (aceptar && alerta) {
      if (alerta.salaData?.tipo === 'privada' && alerta.passwordSala) {
        // Mostrar modal propio en vez de window.prompt
        setPasswordAlertaInput('');
        setPasswordAlertaError(false);
        setModalPasswordAlerta({ alertaId, alerta });
        return; // el modal se encarga del resto
      }
      if (alerta.salaData) entrarEnSala(
        { id: alerta.salaData.libroId || generarIdLibro(alerta.salaData.titulo, alerta.salaData.autor || ""), titulo: alerta.salaData.titulo, autor: alerta.salaData.autor || "", portada: alerta.salaData.portada || "", descripcion: alerta.salaData.descripcion || "" },
        alerta.salaData.tipo === 'privada',
        alerta.salaData.id,
        alerta.passwordSala || null
      );
    }
    try { await updateDoc(doc(db, "alertas", alertaId), { leida: true }); } catch (e) { console.error(e); }
  };

  const confirmarPasswordAlerta = async () => {
    if (!modalPasswordAlerta) return;
    const { alerta } = modalPasswordAlerta;
    if (passwordAlertaInput !== alerta.passwordSala) {
      setPasswordAlertaError(true);
      return;
    }
    setModalPasswordAlerta(null);
    if (alerta.salaData) entrarEnSala(
      { id: alerta.salaData.libroId || generarIdLibro(alerta.salaData.titulo, alerta.salaData.autor || ""), titulo: alerta.salaData.titulo, autor: alerta.salaData.autor || "", portada: alerta.salaData.portada || "", descripcion: alerta.salaData.descripcion || "" },
      true, alerta.salaData.id, alerta.passwordSala
    );
    try { await updateDoc(doc(db, "alertas", modalPasswordAlerta.alertaId), { leida: true }); } catch (e) { console.error(e); }
  };

  const verPerfilAjeno = async (u) => {
    if (!u || !u.id) return;
    if (u.id === user.uid || u.esYo) { setSeccionActiva('perfil'); setMenuPerfilVisible(false); return; }
    setSeccionAnterior(seccionActiva); // guardar de dónde venimos
    let perfilCompleto = u;
    if (!u.seguidores && !u.sobreMi && !u.generos) {
      try {
        const snap = await getDoc(doc(db, "users", u.id));
        if (snap.exists()) perfilCompleto = { id: snap.id, ...snap.data() };
        else { showToast('Este usuario no está disponible.', 'error'); return; }
      } catch { }
    }
    // El contador "seguidores"/"siguiendo" cacheado en el doc del usuario puede
    // llevar tiempo sin actualizarse correctamente (solo el propio usuario puede
    // escribir su doc), así que se recalcula en vivo contando relaciones reales.
    try {
      const [segSnap, siguSnap] = await Promise.all([
        getDocs(query(collection(db, 'relaciones'), where('seguidoId', '==', u.id))),
        getDocs(query(collection(db, 'relaciones'), where('seguidorId', '==', u.id))),
      ]);
      perfilCompleto = { ...perfilCompleto, seguidores: segSnap.size, siguiendo: siguSnap.size };
    } catch { }
    setPerfilAjeno(perfilCompleto);
    setSeccionActiva('perfil-ajeno');
    setMenuPerfilVisible(false);
  };

  if (authCargando) return (
    <div style={{ height: '100vh', background: '#070e1a', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <div style={{ textAlign: 'center' }}>
        <svg width="120" height="110" viewBox="0 0 220 200" style={{ marginBottom: '4px' }}>
          <defs>
            <radialGradient id="splashGlow" cx="50%" cy="35%" r="60%">
              <stop offset="0%" stopColor="#FFD700" stopOpacity="0.55"><animate attributeName="stop-opacity" values="0.35;0.65;0.35" dur="1.8s" repeatCount="indefinite"/></stop>
              <stop offset="100%" stopColor="#FFD700" stopOpacity="0"/>
            </radialGradient>
          </defs>
          <ellipse cx="110" cy="80" rx="70" ry="65" fill="url(#splashGlow)"/>
          <ellipse cx="110" cy="158" rx="58" ry="10" fill="#0a1422" opacity="0.8"/>
          <path d="M52,150 L52,90 L108,80 L108,140 Z" fill="#e8dcc0"/>
          <path d="M168,150 L168,90 L112,80 L112,140 Z" fill="#d4c8aa"/>
          <line x1="60" y1="98" x2="98" y2="92" stroke="#9a8a68" strokeWidth="1"/>
          <line x1="60" y1="108" x2="98" y2="102" stroke="#9a8a68" strokeWidth="1"/>
          <line x1="60" y1="118" x2="98" y2="112" stroke="#9a8a68" strokeWidth="1"/>
          <line x1="122" y1="92" x2="160" y2="98" stroke="#9a8a68" strokeWidth="1"/>
          <line x1="122" y1="102" x2="160" y2="108" stroke="#9a8a68" strokeWidth="1"/>
          <line x1="122" y1="112" x2="160" y2="118" stroke="#9a8a68" strokeWidth="1"/>
          <g transform="translate(170,128)">
            <rect x="-7" y="0" width="14" height="22" rx="2" fill="#2a1f10"/>
            <ellipse cx="0" cy="0" rx="7" ry="3" fill="#3a2a14"/>
            <path d="M0,-2 Q-3,-12 0,-18 Q3,-12 0,-2 Z" fill="#FFA500">
              <animate attributeName="d" values="M0,-2 Q-3,-12 0,-18 Q3,-12 0,-2 Z;M0,-2 Q-2,-13 0,-20 Q2,-13 0,-2 Z;M0,-2 Q-3,-12 0,-18 Q3,-12 0,-2 Z" dur="1.4s" repeatCount="indefinite"/>
            </path>
            <path d="M0,-3 Q-1.5,-8 0,-12 Q1.5,-8 0,-3 Z" fill="#FFD700">
              <animate attributeName="d" values="M0,-3 Q-1.5,-8 0,-12 Q1.5,-8 0,-3 Z;M0,-3 Q-1,-9 0,-14 Q1,-9 0,-3 Z;M0,-3 Q-1.5,-8 0,-12 Q1.5,-8 0,-3 Z" dur="1.4s" repeatCount="indefinite"/>
            </path>
          </g>
        </svg>
        <p style={{ fontSize: '26px', fontWeight: 900, color: 'white', margin: '0 0 4px', letterSpacing: '-0.5px' }}>Leemos</p>
        <p style={{ fontSize: '12px', color: '#445', margin: 0 }}>Preparando tu biblioteca...</p>
      </div>
    </div>
  );
  if (mostrarOnboarding && user) {
    // Ocultar el banner AdMob durante el onboarding para evitar solapamiento
    if (detectarNativa()) ocultarAdMobBanner();
    return (
      <Onboarding
        userId={user.uid}
        onCompletado={(generos) => {
          setPerfil(prev => ({ ...prev, generos, onboardingCompletado: true }));
          setMostrarOnboarding(false);
          if (detectarNativa() && !esPremium) iniciarAdMobBanner(false);
        }}
      />
    );
  }

  if (paginaLegal) return <div style={{ height: '100vh', backgroundColor: '#000', color: 'white', fontFamily: 'sans-serif', overflowY: 'auto' }}><PaginaLegal seccionInicial={paginaLegal} onCerrar={() => setPaginaLegal(null)} /></div>;
  if (!user) return <PantallaAuth onVerLegal={setPaginaLegal} />;

  const SidebarItem = ({ icon, label, onClick, active, accent, badge }) => (
    <div onClick={onClick} className="sidebar-item" style={{ padding: '10px 12px', borderRadius: '8px', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '12px', color: active ? 'white' : accent || '#555', background: active ? '#1a1a1a' : 'transparent', fontWeight: active ? 'bold' : 'normal', fontSize: '14px', transition: '0.15s', position: 'relative' }}>
      <span style={{ color: active ? '#1DB954' : accent || '#555', flexShrink: 0 }}>{icon}</span>
      <span style={{ flex: 1 }}>{label}</span>
      {badge > 0 && <span style={{ background: '#f44336', borderRadius: '10px', fontSize: '10px', fontWeight: 'bold', padding: '1px 6px', color: 'white', minWidth: '18px', textAlign: 'center' }}>{badge}</span>}
    </div>
  );

  const MenuItem = ({ icon, label, onClick, danger, badge }) => (
    <div onClick={() => { onClick(); setMenuPerfilVisible(false); }}
      style={{ padding: '11px 16px', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '12px', color: danger ? '#f44336' : '#aaa', fontSize: '14px', borderRadius: '6px', transition: '0.15s' }}
      onMouseEnter={e => e.currentTarget.style.background = '#222'}
      onMouseLeave={e => e.currentTarget.style.background = 'transparent'}>
      <span style={{ color: danger ? '#f44336' : '#555', flexShrink: 0 }}>{icon}</span>
      <span style={{ flex: 1 }}>{label}</span>
      {badge > 0 && <span style={{ background: '#f44336', borderRadius: '10px', fontSize: '10px', fontWeight: 'bold', padding: '1px 6px', color: 'white' }}>{badge}</span>}
    </div>
  );

  return (
    <div className="layout-root" style={{ paddingTop: isMobile ? '0' : '8px', paddingLeft: isMobile ? '0' : '8px', paddingRight: isMobile ? '0' : '8px', paddingBottom: isMobile ? '56px' : !esPremium ? '50px' : '8px' }}>
      <style>{GLOBAL_STYLES}</style>
      <style>{`@keyframes slideInToast { from { opacity: 0; transform: translateX(-50%) translateY(10px); } to { opacity: 1; transform: translateX(-50%) translateY(0); } } @keyframes spin { to { transform: rotate(360deg); } }`}</style>

      <input type="file" ref={fileInputRef} style={{ display: 'none' }} accept="image/jpeg,image/png,image/webp,image/gif" onChange={e => {
        const file = e.target.files[0];
        if (!file) return;
        // Validar tipo
        if (!['image/jpeg', 'image/png', 'image/webp', 'image/gif'].includes(file.type)) {
          showToast('Formato no válido. Usa JPG, PNG o WebP', 'error');
          return;
        }
        // Validar tamaño máximo 5MB
        if (file.size > 5 * 1024 * 1024) {
          showToast('La imagen no puede superar 5MB', 'error');
          return;
        }
        const img = new window.Image();
        const url = URL.createObjectURL(file);
        img.onload = () => {
          const canvas = document.createElement('canvas');
          const MAX = 300;
          const ratio = Math.min(MAX / img.width, MAX / img.height, 1);
          canvas.width = img.width * ratio; canvas.height = img.height * ratio;
          canvas.getContext('2d').drawImage(img, 0, 0, canvas.width, canvas.height);
          URL.revokeObjectURL(url);
          canvas.toBlob(async (blob) => {
            try {
              const storageRef = ref(storage, `avatars/${user.uid}/perfil.jpg`);
              await uploadBytes(storageRef, blob, { contentType: 'image/jpeg' });
              const downloadURL = await getDownloadURL(storageRef);
              handleUpdate('foto', downloadURL);
              await updateDoc(doc(db, 'users', user.uid), { foto: downloadURL }).catch(() => {});
            } catch {
              const base64 = canvas.toDataURL('image/jpeg', 0.75);
              handleUpdate('foto', base64);
              await updateDoc(doc(db, 'users', user.uid), { foto: base64 }).catch(() => {});
            }
          }, 'image/jpeg', 0.82);
        };
        img.src = url;
      }} />

      {sinConexion && <div style={{ position: 'fixed', top: 0, left: 0, right: 0, zIndex: 9999, background: '#c62828', color: 'white', textAlign: 'center', padding: '10px', fontSize: '13px', fontWeight: 'bold' }}>Sin conexión — los cambios no se guardarán</div>}
      {errorApi && !sinConexion && <div style={{ position: 'fixed', top: 0, left: 0, right: 0, zIndex: 9999, background: '#e65100', color: 'white', textAlign: 'center', padding: '10px', fontSize: '13px', fontWeight: 'bold', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '12px' }}>No se pudieron cargar los libros <button onClick={() => cargarLista()} style={{ background: 'rgba(255,255,255,0.2)', color: 'white', border: 'none', borderRadius: '12px', padding: '4px 12px', cursor: 'pointer', fontSize: '12px' }}>Reintentar</button></div>}

      {/* MODALES */}
      {modalCrearPrivadaVisible && (
        <div className="modal-overlay" onClick={() => setModalCrearPrivadaVisible(false)}>
          <div className="modal-content" onClick={e => e.stopPropagation()}>
            <h3 style={{ margin: '0 0 6px', fontSize: '20px', fontWeight: 900 }}>Sala Privada</h3>
            <p style={{ color: '#555', fontSize: '13px', margin: '0 0 20px' }}>Contraseña opcional para protegerla.</p>
            <label style={{ fontSize: '12px', color: '#444', textTransform: 'uppercase', letterSpacing: '0.5px' }}>Contraseña</label>
            <input className="input-modal" type="password" placeholder="Ej: lectura2026" autoComplete="off" value={passwordNuevaSala} onChange={e => setPasswordNuevaSala(e.target.value.slice(0, 30))} maxLength={30} onKeyDown={e => e.key === 'Enter' && confirmarCrearSalaPrivada()} />
            <button className="btn-verde" style={{ marginTop: '20px' }} onClick={confirmarCrearSalaPrivada}>Crear sala</button>
            <button onClick={() => setModalCrearPrivadaVisible(false)} style={{ background: 'none', border: 'none', color: '#444', width: '100%', marginTop: '10px', cursor: 'pointer', fontSize: '13px', padding: '8px' }}>Cancelar</button>
          </div>
        </div>
      )}

      {modalSeguidoresVisible && (
        <div className="modal-overlay" onClick={() => setModalSeguidoresVisible(false)}>
          <div className="modal-content" onClick={e => e.stopPropagation()}>
            <div style={{ display: 'flex', borderBottom: '1px solid #1e1e1e', marginBottom: '20px' }}>
              {[{ id: 'seguidores', label: 'Seguidores', count: listaSeguidores.length }, { id: 'siguiendo', label: 'Siguiendo', count: listaSiguiendo.length }].map(t => (
                <div key={t.id} onClick={() => setTabSeguidores(t.id)}
                  style={{ flex: 1, padding: '14px', textAlign: 'center', cursor: 'pointer', color: tabSeguidores === t.id ? 'white' : '#444', fontWeight: tabSeguidores === t.id ? 'bold' : 'normal', borderBottom: tabSeguidores === t.id ? '2px solid #1DB954' : '2px solid transparent', fontSize: '14px', transition: '0.2s' }}>
                  {t.label} <span style={{ color: tabSeguidores === t.id ? '#1DB954' : '#333', fontSize: '13px' }}>({t.count})</span>
                </div>
              ))}
            </div>
            <div style={{ maxHeight: '320px', overflowY: 'auto', display: 'flex', flexDirection: 'column', gap: '8px' }}>
              {(tabSeguidores === 'seguidores' ? listaSeguidores : listaSiguiendo).length > 0
                ? (tabSeguidores === 'seguidores' ? listaSeguidores : listaSiguiendo).map(u => (
                  <div key={u.id} style={{ display: 'flex', alignItems: 'center', gap: '12px', padding: '10px', background: '#141414', borderRadius: '10px', border: '1px solid #1e1e1e' }}>
                    <Avatar src={u.foto} nombre={u.nombre} size={38} onClick={() => { verPerfilAjeno(u); setModalSeguidoresVisible(false); }} />
                    <b style={{ flex: 1, fontSize: '14px', cursor: 'pointer' }} onClick={() => { verPerfilAjeno(u); setModalSeguidoresVisible(false); }}>{u.nombre}</b>
                    {tabSeguidores === 'siguiendo' && (
                      <button onClick={() => toggleSeguir(u)} style={{ background: 'transparent', border: '1px solid #2a2a2a', color: '#555', padding: '5px 12px', borderRadius: '15px', cursor: 'pointer', fontSize: '12px' }}>Dejar de seguir</button>
                    )}
                  </div>
                ))
                : <p style={{ textAlign: 'center', color: '#333', marginTop: '40px', fontSize: '14px' }}>{tabSeguidores === 'seguidores' ? 'Nadie te sigue todavía.' : 'No sigues a nadie todavía.'}</p>}
            </div>
          </div>
        </div>
      )}

      {modalInvitarVisible && (
        <div className="modal-overlay" onClick={() => setModalInvitarVisible(false)}>
          <div className="modal-content" onClick={e => e.stopPropagation()}>
            <h3 style={{ margin: '0 0 6px', fontSize: '20px', fontWeight: 900 }}>Invitar</h3>
            <p style={{ color: '#555', fontSize: '13px', margin: '0 0 20px' }}>Personas que sigues</p>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', maxHeight: '300px', overflowY: 'auto' }}>
              {listaSiguiendo.length > 0 ? listaSiguiendo.map(u => {
                const yaEnSala = salaAbierta?.miembros.some(m => m.id === u.id);
                return (
                  <div key={u.id} style={{ display: 'flex', alignItems: 'center', gap: '12px', padding: '10px', background: '#141414', borderRadius: '10px', border: '1px solid #1e1e1e', opacity: yaEnSala ? 0.4 : 1 }}>
                    <Avatar src={u.foto} nombre={u.nombre} size={36} />
                    <b style={{ flex: 1, fontSize: '14px' }}>{u.nombre}</b>
                    <button onClick={() => enviarInvitacionAlerta(u)} disabled={yaEnSala} className="btn-verde" style={{ width: 'auto', margin: 0, padding: '7px 14px', fontSize: '12px' }}>{yaEnSala ? 'En la sala' : 'Invitar'}</button>
                  </div>
                );
              }) : <p style={{ textAlign: 'center', color: '#333', marginTop: '20px', fontSize: '14px' }}>Sigue a alguien para invitarlo.</p>}
            </div>
          </div>
        </div>
      )}

      {/* Modal confirmar borrar cuenta */}
      {/* Modal Solicitud Verificado */}
      {modalVerificado && (
        <ModalSolicitudVerificado
          perfil={perfil}
          onCerrar={() => setModalVerificado(false)}
        />
      )}

      {modalPublicarLibro && (
        <ModalPublicarLibro
          userId={user?.uid}
          perfil={perfil}
          onCerrar={() => setModalPublicarLibro(false)}
        />
      )}

      {modalBorrarCuenta && (
        <div className="modal-overlay" onClick={() => setModalBorrarCuenta(false)}>
          <div className="modal-content" style={{ maxWidth: '360px' }} onClick={e => e.stopPropagation()}>
            <h3 style={{ margin: '0 0 12px', fontSize: '18px', fontWeight: 900, color: '#f44336' }}>⚠️ Eliminar cuenta</h3>
            <p style={{ color: '#aaa', fontSize: '14px', margin: '0 0 8px', lineHeight: '1.6' }}>
              Esta acción es <b>irreversible</b>. Se eliminarán permanentemente:
            </p>
            <ul style={{ color: '#555', fontSize: '13px', margin: '0 0 20px', paddingLeft: '20px', lineHeight: '1.8' }}>
              <li>Tu perfil y datos de usuario</li>
              <li>Tu biblioteca y estados de lectura</li>
              <li>Tus valoraciones</li>
              <li>Tus relaciones de seguimiento</li>
            </ul>
            <div style={{ display: 'flex', gap: '10px' }}>
              <button onClick={() => setModalBorrarCuenta(false)} className="btn-outline" style={{ flex: 1, marginTop: 0 }}>Cancelar</button>
              <button onClick={() => { setModalBorrarCuenta(false); borrarCuenta(); }}
                style={{ flex: 1, background: '#f44336', color: 'white', border: 'none', borderRadius: '25px', padding: '12px', fontWeight: 'bold', cursor: 'pointer', fontSize: '14px' }}>
                Eliminar todo
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Modal confirmación salir de sala */}
      {modalSalirSala && (
        <div className="modal-overlay" onClick={() => setModalSalirSala(false)}>
          <div className="modal-content" style={{ maxWidth: '340px' }} onClick={e => e.stopPropagation()}>
            <h3 style={{ margin: '0 0 12px', fontSize: '18px', fontWeight: 900 }}>¿Salir de la sala?</h3>
            <p style={{ color: '#555', fontSize: '14px', margin: '0 0 24px', lineHeight: '1.6' }}>
              Si sales, dejarás de ser miembro de esta sala y se restará una plaza. Esta acción no se puede deshacer.
            </p>
            <div style={{ display: 'flex', gap: '10px' }}>
              <button onClick={() => setModalSalirSala(false)} className="btn-outline" style={{ flex: 1, marginTop: 0 }}>No</button>
              <button onClick={async () => {
                setModalSalirSala(false);
                const salaId = salaAbierta.idReal;
                try {
                  // Borrar al usuario de miembros
                  await deleteDoc(doc(db, "salas", salaId, "miembros", user.uid));
                  // Recalcular numMiembros
                  const miembrosSnap = await getDocs(collection(db, "salas", salaId, "miembros"));
                  await setDoc(doc(db, "salas_info", salaId), { numMiembros: miembrosSnap.size }, { merge: true });
                } catch (e) { console.error(e); }
                if (unsubscribeRef.current) { unsubscribeRef.current(); unsubscribeRef.current = null; }
                setSalaAbierta(null);
                setSeccionActiva('libros');
              }} style={{ flex: 1, background: '#f44336', color: 'white', border: 'none', borderRadius: '25px', padding: '12px', fontWeight: 'bold', cursor: 'pointer', fontSize: '14px' }}>
                Sí, salir
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Toast genérico — reemplaza alert() nativo */}
      {toastMsg && (
        <div style={{ position: 'fixed', bottom: isMobile ? '70px' : '24px', left: '50%', transform: 'translateX(-50%)', zIndex: 9999, background: toastMsg.tipo === 'error' ? '#c0392b' : '#1DB954', color: toastMsg.tipo === 'error' ? 'white' : 'black', borderRadius: '25px', padding: '12px 24px', fontWeight: 'bold', fontSize: '14px', boxShadow: '0 4px 20px rgba(0,0,0,0.4)', whiteSpace: 'nowrap', animation: 'slideInToast 0.3s ease' }}>
          {toastMsg.texto}
        </div>
      )}

      {/* Modal contraseña sala privada desde invitación */}
      {modalPasswordAlerta && (
        <div className="modal-overlay" onClick={() => setModalPasswordAlerta(null)}>
          <div className="modal-content" style={{ maxWidth: '360px' }} onClick={e => e.stopPropagation()}>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '16px' }}>
              <h3 style={{ margin: 0, fontSize: '18px', fontWeight: 900 }}>🔒 Sala privada</h3>
              <button onClick={() => setModalPasswordAlerta(null)} style={{ background: 'none', border: 'none', color: '#555', cursor: 'pointer', fontSize: '20px' }}>✕</button>
            </div>
            <p style={{ color: '#555', fontSize: '13px', margin: '0 0 16px' }}>
              Introduce la contraseña para entrar en la sala de <b style={{ color: 'white' }}>{modalPasswordAlerta.alerta.libro}</b>
            </p>
            <input
              className="input-modal"
              type="password"
              placeholder="Contraseña de la sala"
              value={passwordAlertaInput}
              onChange={e => { setPasswordAlertaInput(e.target.value); setPasswordAlertaError(false); }}
              onKeyDown={e => e.key === 'Enter' && confirmarPasswordAlerta()}
              autoFocus
            />
            {passwordAlertaError && (
              <p style={{ color: '#f44336', fontSize: '12px', margin: '8px 0 0' }}>Contraseña incorrecta</p>
            )}
            <button onClick={confirmarPasswordAlerta} className="btn-verde">
              Entrar
            </button>
          </div>
        </div>
      )}

      {/* Toast de insignia desbloqueada */}
      {toastInsignia && (() => {
        const nivel = NIVELES[toastInsignia.nivel];
        return (
          <div style={{ position: 'fixed', bottom: isMobile ? '70px' : '70px', left: isMobile ? '12px' : '24px', right: isMobile ? '12px' : 'auto', zIndex: 9998, background: nivel.gradient, borderRadius: '16px', padding: '16px 20px', display: 'flex', alignItems: 'center', gap: '14px', boxShadow: `0 8px 32px ${nivel.glow}66, 0 0 0 1px ${nivel.glow}44`, transition: 'bottom 0.4s cubic-bezier(0.34, 1.56, 0.64, 1)', maxWidth: '320px', animation: 'slideInToast 0.4s cubic-bezier(0.34, 1.56, 0.64, 1)' }}>
            {/* Icono */}
            <div style={{ width: '48px', height: '48px', borderRadius: '50%', background: 'rgba(0,0,0,0.25)', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
              <div style={{ width: '28px', height: '28px' }}>{toastInsignia.insignia.icono('white')}</div>
            </div>
            {/* Texto */}
            <div style={{ flex: 1 }}>
              <p style={{ margin: '0 0 2px', fontSize: '11px', fontWeight: 900, color: nivel.text, textTransform: 'uppercase', letterSpacing: '1px', opacity: 0.7 }}>¡Insignia desbloqueada!</p>
              <p style={{ margin: '0 0 2px', fontSize: '15px', fontWeight: 900, color: nivel.text }}>{toastInsignia.insignia.nombre[toastInsignia.nivel]}</p>
              <p style={{ margin: 0, fontSize: '12px', color: nivel.text, opacity: 0.7 }}>✦ {nivel.label} · {toastInsignia.insignia.categoria}</p>
            </div>
            {/* Cerrar */}
            <button onClick={() => setToastInsignia(null)} style={{ background: 'rgba(0,0,0,0.2)', border: 'none', borderRadius: '50%', width: '24px', height: '24px', cursor: 'pointer', color: nivel.text, fontSize: '12px', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>✕</button>
          </div>
        );
      })()}

      {/* Modal Goodreads */}
      {modalGoodreads && (
        <ImportarGoodreads
          userId={user.uid}
          onCompletado={() => { setModalGoodreads(false); setSeccionActiva('biblioteca'); }}
          onCerrar={() => { setModalGoodreads(false); setSeccionActiva('biblioteca'); }}
        />
      )}

      {/* Modal Premium */}
      {modalPremium && (
        <div className="modal-overlay" onClick={() => !comprando && cerrarModalPremium()}>
          <div className="modal-content" style={{ maxWidth: '420px', background: 'linear-gradient(135deg, #0d0020, #111)' }} onClick={e => e.stopPropagation()}>
            <div style={{ textAlign: 'center', marginBottom: '24px' }}>
              <p style={{ fontSize: '32px', margin: '0 0 8px' }}>✦</p>
              <h2 style={{ fontSize: '24px', fontWeight: 900, margin: '0 0 8px', background: 'linear-gradient(90deg, #a78bfa, #38bdf8)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}>Leemos Premium</h2>
              <p style={{ color: '#555', fontSize: '14px', margin: 0 }}>Una experiencia sin interrupciones</p>
            </div>
            {/* Beneficios */}
            <div style={{ background: '#0a0a0a', borderRadius: '12px', padding: '16px', marginBottom: '20px', border: '1px solid #1a1a1a' }}>
              {['Sin anuncios'].map((b, i) => (
                <div key={i} style={{ display: 'flex', alignItems: 'center', gap: '10px', padding: '8px 0' }}>
                  <span style={{ color: '#1DB954', fontSize: '16px' }}>✓</span>
                  <span style={{ fontSize: '14px', color: '#ccc' }}>{b}</span>
                </div>
              ))}
            </div>
            {/* Opciones de precio */}
            <div style={{ display: 'flex', flexDirection: 'column', gap: '10px', marginBottom: '16px' }}>
              <button onClick={async () => {
                setComprando(true);
                try {
                  const resultado = await comprarPremiumMensual();
                  if (resultado.exito) {
                    await updateDoc(doc(db, 'users', user.uid), { premium: true });
                    setPerfil(prev => ({ ...prev, premium: true }));
                    setModalPremium(false);
                  }
                } catch (e) { console.error(e); }
                setComprando(false);
              }} disabled={comprando}
                style={{ background: 'linear-gradient(135deg, #6a3fa0, #a78bfa)', color: 'white', border: 'none', borderRadius: '12px', padding: '14px', fontWeight: 900, cursor: comprando ? 'default' : 'pointer', fontSize: '15px', transition: '0.2s', opacity: comprando ? 0.7 : 1 }}>
                {comprando ? 'Procesando...' : '1,99€ / mes'}
              </button>
              <button onClick={async () => {
                setComprando(true);
                try {
                  const resultado = await comprarPremiumAnual();
                  if (resultado.exito) {
                    await updateDoc(doc(db, 'users', user.uid), { premium: true });
                    setPerfil(prev => ({ ...prev, premium: true }));
                    setModalPremium(false);
                  }
                } catch (e) { console.error(e); }
                setComprando(false);
              }} disabled={comprando}
                style={{ background: 'transparent', color: '#a78bfa', border: '2px solid #a78bfa44', borderRadius: '12px', padding: '14px', fontWeight: 900, cursor: comprando ? 'default' : 'pointer', fontSize: '15px', transition: '0.2s', position: 'relative' }}>
                11,99€ / año
                <span style={{ position: 'absolute', top: '-10px', right: '12px', background: '#1DB954', color: 'black', fontSize: '10px', fontWeight: 900, padding: '2px 8px', borderRadius: '10px' }}>-50%</span>
              </button>
            </div>
            {/* Restaurar compras */}
            <button onClick={async () => {
              setComprando(true);
              try {
                const esPremiumRC = await restaurarCompras();
                if (esPremiumRC) {
                  await updateDoc(doc(db, 'users', user.uid), { premium: true });
                  setPerfil(prev => ({ ...prev, premium: true }));
                  setModalPremium(false);
                }
              } catch (e) { console.error(e); }
              setComprando(false);
            }} style={{ background: 'none', border: 'none', color: '#444', fontSize: '13px', cursor: 'pointer', width: '100%', padding: '8px', marginBottom: '4px' }}>
              Restaurar compras
            </button>
            <button onClick={() => cerrarModalPremium()} style={{ background: 'none', border: 'none', color: '#333', fontSize: '13px', cursor: 'pointer', width: '100%', padding: '4px' }}>
              Ahora no
            </button>
          </div>
        </div>
      )}

      {/* Banner publicitario — desktop via layout-banner, móvil web directo */}
      {!esNativaConfirmado && <div className="layout-banner"><BannerPublicitario
        esPremium={esPremium}
        onUpgrade={abrirModalPremium}
      /></div>}
      {isMobile && !esNativaConfirmado && typeof window !== "undefined" && !window.location.href.includes("capacitor://") && <BannerPublicitario
        esPremium={esPremium}
        onUpgrade={abrirModalPremium}
        mobile={true}
      />}

      {/* SIDEBAR */}
      <div className="layout-sidebar">
        <div className="box" style={{ padding: '12px' }}>
          <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
            <button onClick={() => setSeccionActiva('feed')} style={{ width: '40px', height: '40px', background: seccionActiva === 'feed' ? '#1DB954' : '#1a1a1a', border: 'none', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', color: seccionActiva === 'feed' ? 'black' : '#888', flexShrink: 0, transition: '0.2s' }} onMouseEnter={e => { if (seccionActiva !== 'feed') { e.currentTarget.style.background = '#242424'; e.currentTarget.style.color = 'white'; } }} onMouseLeave={e => { if (seccionActiva !== 'feed') { e.currentTarget.style.background = '#1a1a1a'; e.currentTarget.style.color = '#888'; } }}>
              <Icon.Home />
            </button>
            <div style={{ flex: 1, position: 'relative' }}>
              <div style={{ position: 'absolute', left: '12px', top: '50%', transform: 'translateY(-50%)', color: '#444', pointerEvents: 'none' }}><Icon.Search /></div>
              <input type="search" style={{ width: '100%', background: '#1a1a1a', border: '1px solid #1e1e1e', borderRadius: '20px', padding: '9px 14px 9px 38px', color: 'white', outline: 'none', fontSize: '13px', boxSizing: 'border-box', transition: '0.2s' }}
                placeholder="Buscar libros..." value={busqueda} onChange={e => setBusqueda(e.target.value.slice(0, 100))} onKeyDown={e => e.key === 'Enter' && buscarManual(busqueda)}
                onFocus={e => e.target.style.borderColor = '#333'} onBlur={e => e.target.style.borderColor = '#1e1e1e'} />
            </div>
          </div>
        </div>

        <div className="box" style={{ flex: 1, padding: '12px', overflowY: 'auto', display: 'flex', flexDirection: 'column', gap: '2px' }}>
          <SidebarItem icon={<Icon.Library />} label="Libros" onClick={() => { setSeccionActiva('libros'); setLibroSeleccionado(null); cargarLista(); }} active={seccionActiva === 'libros'} />
          <SidebarItem icon={<Icon.Grid />} label="Explorar" onClick={() => setSeccionActiva('explorar')} active={seccionActiva === 'explorar'} />
          <SidebarItem icon={<Icon.People />} label="Clubs" onClick={() => setSeccionActiva('clubs')} active={seccionActiva === 'clubs'} />
          <SidebarItem icon={<Icon.People />} label="Buscar personas" onClick={() => setSeccionActiva('buscar-usuarios')} active={seccionActiva === 'buscar-usuarios'} />
          {esAdmin && <SidebarItem icon={<Icon.Settings />} label="Panel Admin" onClick={() => setSeccionActiva('admin')} active={seccionActiva === 'admin'} accent="#1DB954" />}

          <div style={{ height: '1px', background: '#1a1a1a', margin: '10px 0' }} />
          <p style={{ fontSize: '11px', color: '#333', textTransform: 'uppercase', letterSpacing: '1px', margin: '0 0 8px 12px' }}>Biblioteca</p>

          {cargando ? [...Array(6)].map((_, i) => (
            <div key={i} style={{ display: 'flex', gap: '10px', padding: '6px 8px', alignItems: 'center' }}>
              <div style={{ width: '36px', height: '36px', borderRadius: '4px', background: '#1a1a1a', animation: 'pulse 1.5s infinite', flexShrink: 0 }} />
              <div style={{ flex: 1, height: '12px', background: '#1a1a1a', borderRadius: '6px', animation: 'pulse 1.5s infinite' }} />
            </div>
          )) : libros.map((l) => (
            <div key={l.id} onClick={() => verLibro(l)}
              style={{ display: 'flex', gap: '10px', padding: '6px 8px', cursor: 'pointer', borderRadius: '8px', alignItems: 'center', transition: '0.15s', background: libroSeleccionado?.id === l.id ? '#1a1a1a' : 'transparent' }}
              onMouseEnter={e => e.currentTarget.style.background = '#141414'} onMouseLeave={e => e.currentTarget.style.background = libroSeleccionado?.id === l.id ? '#1a1a1a' : 'transparent'}>
              <img src={l.portada} style={{ width: '36px', height: '36px', borderRadius: '4px', objectFit: 'cover', flexShrink: 0 }} alt="" onError={e => e.currentTarget.style.display = 'none'} />
              <div style={{ minWidth: 0 }}>
                <p style={{ margin: 0, fontSize: '13px', fontWeight: libroSeleccionado?.id === l.id ? 'bold' : 'normal', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', color: libroSeleccionado?.id === l.id ? 'white' : '#aaa' }}>{l.titulo}</p>
                <p style={{ margin: 0, fontSize: '11px', color: '#444', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{l.autor}</p>
              </div>
            </div>
          ))}
        </div>
      </div>{/* fin sidebar */}

      {/* PANEL PRINCIPAL */}
      <div className="box layout-main" style={{ background: '#070e1a', overflowY: 'auto', display: 'flex', flexDirection: 'column' }}>

        {seccionActiva !== 'sala' && (
          <div style={{ height: isMobile ? 'auto' : '60px', display: 'flex', flexDirection: isMobile ? 'column' : 'row', alignItems: isMobile ? 'stretch' : 'center', justifyContent: 'flex-end', padding: isMobile ? '10px 14px 8px' : '0 24px', gap: isMobile ? '8px' : 0, position: 'relative', flexShrink: 0, borderBottom: isMobile ? '1px solid #1a1a1a' : 'none' }}>
            {isMobile && (
              <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                <div style={{ flex: 1, position: 'relative' }}>
                  <div style={{ position: 'absolute', left: '12px', top: '50%', transform: 'translateY(-50%)', color: '#444', pointerEvents: 'none' }}>
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><path d="M15.5 14h-.79l-.28-.27A6.471 6.471 0 0 0 16 9.5 6.5 6.5 0 1 0 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"/></svg>
                  </div>
                  <input style={{ width: '100%', background: '#1a1a1a', border: '1px solid #1e1e1e', borderRadius: '20px', padding: '9px 14px 9px 36px', color: 'white', outline: 'none', fontSize: '14px', boxSizing: 'border-box' }}
                    placeholder="Buscar libros..." value={busqueda}
                    onChange={e => setBusqueda(e.target.value.slice(0, 100))}
                    onKeyDown={e => e.key === 'Enter' && buscarManual(busqueda)} />
                </div>
                {/* Campana alertas */}
                <button onClick={() => setSeccionActiva('alertas')}
                  style={{ position: 'relative', background: 'none', border: 'none', color: alertas.length > 0 ? '#1DB954' : '#555', cursor: 'pointer', padding: '8px', flexShrink: 0, display: 'flex', alignItems: 'center' }}>
                  <svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor"><path d="M12 22c1.1 0 2-.9 2-2h-4c0 1.1.9 2 2 2zm6-6v-5c0-3.07-1.64-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.63 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2z"/></svg>
                  {alertas.length > 0 && <span style={{ position: 'absolute', top: '4px', right: '4px', background: '#f44336', borderRadius: '10px', fontSize: '9px', fontWeight: 'bold', padding: '1px 4px', color: 'white', minWidth: '14px', textAlign: 'center' }}>{alertas.length}</span>}
                </button>
                {(() => {
                  const marcoActivo = MARCOS_AVATAR.find(mx => mx.id === marcoSeleccionado);
                  const tieneMarco = marcoActivo && marcoActivo.id !== 'ninguno';
                  return (
                    <div onClick={() => setMenuPerfilVisible(!menuPerfilVisible)}
                      style={{ width: '40px', height: '40px', borderRadius: '50%', flexShrink: 0, cursor: 'pointer', boxSizing: 'border-box', ...(tieneMarco ? { ...marcoActivo.estilo, padding: '2px' } : {}) }}>
                      <div style={{ width: '100%', height: '100%', borderRadius: '50%', overflow: 'hidden', background: '#2d1a23', display: 'flex', alignItems: 'center', justifyContent: 'center', border: '2px solid #2a2a2a' }}>
                        <Avatar src={perfil.foto} nombre={perfil.nombre} size={36} />
                      </div>
                    </div>
                  );
                })()}
              </div>
            )}
            {!isMobile && (() => {
              const marcoActivo = MARCOS_AVATAR.find(mx => mx.id === marcoSeleccionado);
              const tieneMarco = marcoActivo && marcoActivo.id !== 'ninguno';
              return (
                <button onClick={() => setMenuPerfilVisible(!menuPerfilVisible)}
                  style={{ width: '40px', height: '40px', borderRadius: '50%', cursor: 'pointer', padding: '0', border: 'none', background: 'none', flexShrink: 0, boxSizing: 'border-box', transition: '0.2s', ...(tieneMarco ? marcoActivo.estilo : { outline: menuPerfilVisible ? '2px solid #1DB954' : '2px solid #2a2a2a', outlineOffset: '2px' }) }}>
                  <div style={{ width: '100%', height: '100%', borderRadius: '50%', overflow: 'hidden', background: '#2d1a23', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <Avatar src={perfil.foto} nombre={perfil.nombre} size={40} />
                  </div>
                </button>
              );
            })()}

            {menuPerfilVisible && (
              <>
                <div style={{ position: 'fixed', inset: 0, zIndex: 999 }} onClick={() => setMenuPerfilVisible(false)} />
                <div style={{ position: 'absolute', top: '52px', right: '16px', background: '#111', borderRadius: '12px', padding: '8px', zIndex: 1000, border: '1px solid #1e1e1e', minWidth: '220px', boxShadow: '0 16px 40px rgba(0,0,0,0.8)' }}>
                <div style={{ padding: '10px 16px 14px', borderBottom: '1px solid #1e1e1e', marginBottom: '6px' }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                    <Avatar src={perfil.foto} nombre={perfil.nombre} size={32} />
                    <div>
                      <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                        <p style={{ margin: 0, fontSize: '13px', fontWeight: 'bold', color: 'white' }}>{perfil.nombre}</p>
                        {esPremium && <span style={{ background: 'linear-gradient(135deg, #6a3fa0, #a78bfa)', color: 'white', fontSize: '9px', padding: '1px 5px', borderRadius: '6px', fontWeight: 'bold' }}>✦</span>}
                      </div>
                      <p style={{ margin: 0, fontSize: '11px', color: '#444' }}>{esPremium ? '✦ Premium' : listaSeguidores.length + ' seguidores'}</p>
                    </div>
                  </div>
                </div>
                <MenuItem icon={<Icon.Person />} label="Mi Perfil" onClick={() => setSeccionActiva('perfil')} />
                <MenuItem icon={<Icon.People />} label="Seguidores" onClick={() => setModalSeguidoresVisible(true)} />
                <MenuItem icon={<Icon.Search />} label="Buscar personas" onClick={() => setSeccionActiva('buscar-usuarios')} />
                <MenuItem icon={<Icon.Bell count={alertas.length} />} label="Alertas" onClick={() => setSeccionActiva('alertas')} badge={alertas.length} />
                <MenuItem icon={<Icon.Search />} label="Libros" onClick={() => { setSeccionActiva('libros'); setLibroSeleccionado(null); cargarLista(); }} />
                <MenuItem icon={<Icon.Library />} label="Mi Biblioteca" onClick={() => setSeccionActiva('biblioteca')} />
                <MenuItem icon={<Icon.Calendar />} label="Calendario de lectura" onClick={() => setSeccionActiva('calendario')} />
                <MenuItem icon={<Icon.Doc />} label="Importar de Goodreads" onClick={() => setModalGoodreads(true)} />
                <MenuItem icon={<span style={{ fontSize: '14px' }}>✦</span>} label={esPremium ? 'Leemos Premium' : 'Hazte Premium'} onClick={() => setSeccionActiva('premium')} />
                <MenuItem icon={<Icon.People />} label="Clubs" onClick={() => setSeccionActiva('clubs')} />
                {esAdmin && <MenuItem icon={<Icon.Settings />} label="Panel Admin" onClick={() => setSeccionActiva('admin')} />}
                <div style={{ height: '1px', background: '#1e1e1e', margin: '6px 8px' }} />
                <MenuItem icon={<Icon.Logout />} label="Cerrar sesión" onClick={logout} danger />
                {!perfil.verificado && <MenuItem icon={<span style={{ fontSize: '14px' }}>✦</span>} label="Solicitar verificado" onClick={() => { setMenuPerfilVisible(false); setModalVerificado(true); }} />}
                <MenuItem icon={<Icon.Close />} label="Eliminar cuenta" onClick={() => setModalBorrarCuenta(true)} danger />
              </div>
              </>
            )}
          </div>
        )}

        <div style={{ flex: 1, overflowY: 'auto' }}>

          {seccionActiva === 'feed' && (
            <SeccionFeed
              userId={user.uid}
              perfil={perfil}
              siguiendoA={siguiendoA}
              onVerLibro={libro => verLibro(libro)}
              onVerPerfil={u => { if (u) verPerfilAjeno(u); else setSeccionActiva('buscar-usuarios'); }}
              onEntrarSala={entrarEnSala}
              onIrEventos={() => {}}
              onExplorar={() => setSeccionActiva('explorar')}
              onToggleSeguir={toggleSeguir}
              entradasCache={entradasBib}
              onIrBibliotecaLeyendo={entrada => {
                setSeccionActiva('biblioteca');
                setTimeout(() => {
                  setEntradaActivaBib(entrada);
                  setSoloLecturaBib(false);
                }, 100);
              }}
              onIrPerfil={() => setSeccionActiva('perfil')}
              onIrClubs={() => setSeccionActiva('clubs')}
              esPremium={true /* función liberada temporalmente */}
              onUpgrade={abrirModalPremium}
            />
          )}

          {seccionActiva === 'admin' && esAdmin && <PanelAdmin onCerrar={() => setSeccionActiva('feed')} userId={user.uid} onVerPerfil={verPerfilAjeno} />}

          {seccionActiva === 'calendario' && (
            <CalendarioLectura userId={user.uid} onVerLibro={entrada => {
              setSeccionActiva('biblioteca');
              setTimeout(() => {
                setEntradaActivaBib(entrada);
                setSoloLecturaBib(false);
                setVistaNotasBib(false);
              }, 100);
            }} />
          )}

          {seccionActiva === 'premium' && (
            <div style={{ padding: isMobile ? '0 16px 40px' : '0 32px 40px', maxWidth: '520px' }}>
              <h1 style={{ fontSize: isMobile ? '28px' : '36px', margin: '32px 0 8px', fontWeight: 900 }}>Leemos Premium</h1>
              <p style={{ color: '#555', fontSize: '14px', margin: '0 0 28px' }}>
                {esPremium ? 'Ya tienes Premium activo. ¡Gracias por apoyar Leemos!' : 'Apoya Leemos y disfruta de la app sin anuncios.'}
              </p>

              <div style={{ background: 'linear-gradient(135deg, #1a0533 0%, #2d1060 50%, #1a0533 100%)', borderRadius: '16px', padding: '20px 24px', marginBottom: '24px', border: '1px solid #a78bfa33', display: 'flex', alignItems: 'center', gap: '20px', flexWrap: 'wrap' }}>
                <div style={{ fontSize: '32px', flexShrink: 0 }}>✦</div>
                <div style={{ flex: 1, minWidth: '180px' }}>
                  <p style={{ margin: '0 0 4px', fontWeight: 'bold', fontSize: '15px', background: 'linear-gradient(90deg, #a78bfa, #38bdf8)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}>Leemos Premium</p>
                  <p style={{ margin: 0, fontSize: '13px', color: '#7c5fad' }}>Sin anuncios</p>
                </div>
                {!esPremium && (
                  <div style={{ textAlign: 'center', flexShrink: 0 }}>
                    <p style={{ margin: '0 0 6px', fontSize: '18px', fontWeight: 900, color: 'white' }}>1,99€</p>
                    <p style={{ margin: '0 0 8px', fontSize: '11px', color: '#7c5fad' }}>al mes</p>
                    <button style={{ background: 'linear-gradient(135deg, #6a3fa0, #a78bfa)', color: 'white', border: 'none', borderRadius: '20px', padding: '8px 16px', fontWeight: 'bold', cursor: 'pointer', fontSize: '13px' }}
                      onClick={abrirModalPremium}>
                      Actualizar
                    </button>
                  </div>
                )}
                {esPremium && <span style={{ background: 'linear-gradient(135deg, #6a3fa0, #a78bfa)', color: 'white', fontSize: '11px', padding: '4px 12px', borderRadius: '10px', fontWeight: 'bold', flexShrink: 0 }}>✦ Activo</span>}
              </div>
            </div>
          )}

          {seccionActiva === 'ayuda' && (
            <div style={{ padding: isMobile ? '0 16px 40px' : '0 32px 40px' }}>
              <h1 style={{ fontSize: isMobile ? '28px' : '36px', margin: '32px 0 8px', fontWeight: 900 }}>Ayuda y soporte</h1>
              <p style={{ color: '#555', fontSize: '14px', margin: '0 0 32px' }}>¿Tienes algún problema o sugerencia?</p>

              {/* Contacto */}
              <div style={{ background: '#141414', borderRadius: '12px', padding: '20px', border: '1px solid #1e1e1e', marginBottom: '16px' }}>
                <p style={{ margin: '0 0 6px', fontWeight: 'bold', fontSize: '15px', color: 'white' }}>Contactar con soporte</p>
                <p style={{ margin: '0 0 6px', fontSize: '13px', color: '#555', lineHeight: '1.6' }}>
                  Si tienes un problema técnico, has encontrado un bug o tienes alguna sugerencia, escríbenos y te responderemos lo antes posible.
                </p>
                <p style={{ margin: '0 0 14px', fontSize: '13px', color: '#1DB954' }}>leemossupport@gmail.com</p>
                <a href="mailto:leemossupport@gmail.com?subject=Soporte%20Leemos" style={{ display: 'inline-block', background: '#1DB954', color: 'black', fontWeight: 'bold', padding: '10px 20px', borderRadius: '20px', fontSize: '14px', textDecoration: 'none' }}>
                  Enviar email
                </a>
              </div>

              {/* FAQ */}
              <div style={{ display: 'flex', flexDirection: 'column', gap: '10px', marginBottom: '24px' }}>
                {[
                  { p: '¿Cómo cancelo mi suscripción Premium?', r: 'Puedes cancelar tu suscripción en cualquier momento desde Google Play → Cuenta → Suscripciones → Leemos. Al cancelar seguirás teniendo acceso Premium hasta el final del período pagado.' },
                  { p: '¿Cómo importo mis libros de Goodreads?', r: 'Ve a tu perfil → "Importar de Goodreads". Necesitas exportar primero tu biblioteca desde Goodreads (Mi cuenta → Importar y exportar → Exportar biblioteca).' },
                  { p: '¿Cómo creo un club privado?', r: 'Los clubs privados son una función Premium. Con Premium activo ve a "Clubs → Crear club". Comparte el código con tus amigos para que se unan gratis.' },
                  { p: '¿Qué pasa si pierdo mi racha de lectura?', r: 'La racha se cuenta por días consecutivos con actividad en la app. Si un día no entras la racha vuelve a cero, pero tus libros y datos se mantienen siempre.' },
                ].map((faq, i) => (
                  <div key={i} style={{ background: '#141414', borderRadius: '12px', padding: '16px 18px', border: '1px solid #1e1e1e' }}>
                    <p style={{ margin: '0 0 6px', fontWeight: 'bold', fontSize: '14px', color: 'white' }}>{faq.p}</p>
                    <p style={{ margin: 0, fontSize: '13px', color: '#555', lineHeight: '1.6' }}>{faq.r}</p>
                  </div>
                ))}
              </div>

              {/* Legal */}
              <div style={{ display: 'flex', gap: '12px', flexWrap: 'wrap' }}>
                <a href="https://lectuclubapp.web.app/legal/privacy.html" target="_blank" rel="noreferrer" style={{ color: '#1DB954', fontSize: '13px' }}>Política de privacidad</a>
                <span style={{ color: '#2a2a2a' }}>·</span>
                <a href="https://lectuclubapp.web.app/legal/terms.html" target="_blank" rel="noreferrer" style={{ color: '#1DB954', fontSize: '13px' }}>Términos y condiciones</a>
              </div>
            </div>
          )}

          {seccionActiva === 'clubs' && (
            <SeccionClubs
              userId={user.uid}
              perfil={perfil}
              esPremium={esPremium}
              esVerificado={!!(perfil.verificado === 'autor' || perfil.verificado === 'editorial')}
              onUpgrade={abrirModalPremium}
            />
          )}

          {seccionActiva === 'buscar-usuarios' && (
            <BusquedaUsuarios userId={user.uid} siguiendoA={siguiendoA} onToggleSeguir={toggleSeguir} onVerPerfil={u => verPerfilAjeno(u)} onCerrar={() => setSeccionActiva('feed')} />
          )}

          {seccionActiva === 'alertas' && (
            <div style={{ padding: '0 32px' }}>
              <h1 style={{ fontSize: '36px', margin: '40px 0 24px', fontWeight: 900 }}>Alertas</h1>
              {alertas.length > 0 ? alertas.map(a => {
                const alertaConfig = {
                  nuevo_seguidor:        { color: '#1DB954', path: 'M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z' },
                  solicitud_club:        { color: '#38bdf8', path: 'M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z' },
                  respuesta_solicitud_club: { color: a.aceptado ? '#1DB954' : '#f44336', path: a.aceptado ? 'M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z' : 'M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z' },
                  solicitud_libro:       { color: '#a78bfa', path: 'M21 5c-1.11-.35-2.33-.5-3.5-.5-1.95 0-4.05.4-5.5 1.5-1.45-1.1-3.55-1.5-5.5-1.5S2.45 4.9 1 6v14.65c0 .25.25.5.5.5.1 0 .15-.05.25-.05C3.1 20.45 5.05 20 6.5 20c1.95 0 4.05.4 5.5 1.5 1.35-.85 3.8-1.5 5.5-1.5 1.65 0 3.35.3 4.75 1.05.1.05.15.05.25.05.25 0 .5-.25.5-.5V6c-.6-.45-1.25-.75-2-1zm0 13.5c-1.1-.35-2.3-.5-3.5-.5-1.7 0-4.15.65-5.5 1.5V8c1.35-.85 3.8-1.5 5.5-1.5 1.2 0 2.4.15 3.5.5v11.5z' },
                  libro_aprobado:        { color: '#1DB954', path: 'M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z' },
                  libro_rechazado:       { color: '#f44336', path: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z' },
                  evento_apuntado:       { color: '#f59e0b', path: 'M17 12h-5v5h5v-5zM16 1v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2h-1V1h-2zm3 18H5V8h14v11z' },
                }[a.tipo] || { color: '#1DB954', path: 'M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2z' };
                return (
                <div key={a.id} style={{ background: '#141414', padding: '16px 20px', borderRadius: '12px', display: 'flex', alignItems: 'center', gap: '14px', marginBottom: '10px', border: `1px solid ${a.leida ? '#1a1a1a' : alertaConfig.color + '33'}`, opacity: a.leida ? 0.6 : 1, transition: '0.2s' }}>
                  {/* Avatar del emisor */}
                  <div style={{ position: 'relative', flexShrink: 0 }}>
                    <Avatar src={a.emisorFoto} nombre={a.emisorNombre} size={40} onClick={() => a.emisorId && verPerfilAjeno({ id: a.emisorId, nombre: a.emisorNombre, foto: a.emisorFoto })} />
                    {/* Badge de tipo en esquina */}
                    <div style={{ position: 'absolute', bottom: -2, right: -2, width: 18, height: 18, borderRadius: '50%', background: alertaConfig.color, display: 'flex', alignItems: 'center', justifyContent: 'center', border: '2px solid #141414' }}>
                      <svg width="10" height="10" viewBox="0 0 24 24" fill="white"><path d={alertaConfig.path}/></svg>
                    </div>
                  </div>
                  <div style={{ flex: 1 }}>
                    <p style={{ margin: 0, fontSize: '14px' }}>
                      {a.tipo === 'evento_apuntado'
                        ? <span><b>{a.emisorNombre || 'Alguien'}</b> se apuntó a tu evento <b>{a.eventoTitulo}</b></span>
                        : a.tipo === 'nuevo_seguidor'
                        ? <span><b>{a.emisorNombre || 'Alguien'}</b> ha empezado a seguirte</span>
                        : a.tipo === 'solicitud_club'
                        ? <span><b>{a.emisorNombre || 'Alguien'}</b> quiere unirse a tu club <b>{a.club}</b></span>
                        : a.tipo === 'respuesta_solicitud_club'
                        ? (a.aceptado
                          ? <span>Has sido aceptado en <b>{a.club}</b></span>
                          : <span>Tu solicitud para unirte a <b>{a.club}</b> no fue aceptada. Puedes volver a intentarlo.</span>)
                        : a.tipo === 'solicitud_libro'
                        ? <span><b>{a.emisorNombre}</b> solicita publicar su libro <b>{a.libro}</b></span>
                        : a.tipo === 'libro_aprobado'
                        ? <span>Tu libro <b>{a.libro}</b> ha sido aprobado y ya está publicado en Leemos</span>
                        : a.tipo === 'libro_rechazado'
                        ? <span>Tu solicitud para publicar <b>{a.libro}</b> no fue aprobada{a.motivo ? `: ${a.motivo}` : '. Puedes volver a intentarlo.'}</span>
                        : <span>Invitación de <b>{a.emisorNombre}</b> para <b>{a.libro}</b>{a.passwordSala ? ' 🔒' : ''}</span>}
                    </p>
                    {a.salaData && <p style={{ margin: '4px 0 0', fontSize: '12px', color: '#444' }}>{a.salaData.tipo === 'privada' ? 'Sala privada' : 'Sala pública'}</p>}
                  </div>
                  {a.salaData && <>
                    <button onClick={() => gestionarAlerta(a.id, true)} className="btn-verde" style={{ width: 'auto', margin: 0, padding: '8px 16px', fontSize: '13px' }}>Aceptar</button>
                    <button onClick={() => gestionarAlerta(a.id, false)} style={{ background: 'none', color: '#444', border: 'none', cursor: 'pointer', fontSize: '13px', padding: '8px' }}>Ignorar</button>
                  </>}
                  {a.tipo === 'solicitud_club' && <>
                    <button onClick={() => gestionarAlerta(a.id, true)} className="btn-verde" style={{ width: 'auto', margin: 0, padding: '8px 16px', fontSize: '13px', background: '#0ea5e9' }}>Aceptar</button>
                    <button onClick={() => gestionarAlerta(a.id, false)} style={{ background: 'none', color: '#444', border: 'none', cursor: 'pointer', fontSize: '13px', padding: '8px' }}>Ignorar</button>
                  </>}
                  {a.tipo === 'respuesta_solicitud_club' && (
                    <button onClick={() => gestionarAlerta(a.id, true)} style={{ background: 'none', color: '#444', border: 'none', cursor: 'pointer', fontSize: '13px', padding: '8px' }}>Leer</button>
                  )}
                  {(a.tipo === 'libro_aprobado' || a.tipo === 'libro_rechazado') && (
                    <button onClick={() => updateDoc(doc(db, "alertas", a.id), { leida: true })} style={{ background: 'none', color: '#444', border: 'none', cursor: 'pointer', fontSize: '13px', padding: '8px' }}>Leer</button>
                  )}
                  {!a.salaData && a.tipo !== 'solicitud_club' && a.tipo !== 'respuesta_solicitud_club' && a.tipo !== 'libro_aprobado' && a.tipo !== 'libro_rechazado' && <button onClick={() => updateDoc(doc(db, "alertas", a.id), { leida: true })} style={{ background: 'none', color: '#444', border: 'none', cursor: 'pointer', fontSize: '13px', padding: '8px' }}>Leer</button>}
                </div>
              ); }) : <p style={{ color: '#333', textAlign: 'center', marginTop: '100px', fontSize: '14px' }}>No tienes alertas nuevas.</p>}
              <button className="btn-outline" style={{ width: '150px', marginTop: '20px' }} onClick={() => setSeccionActiva('feed')}>Volver</button>
            </div>
          )}

          {seccionActiva === 'biblioteca' && (
            <BibliotecaPersonal userId={user.uid} onVerLibro={libro => verLibro(libro)} onVolver={() => setSeccionActiva('libros')} esPremium={true} onUpgrade={abrirModalPremium}
                onLibroActivo={(entrada, esAjena, modo) => { setEntradaActivaBib(entrada); setSoloLecturaBib(!!esAjena); setVistaNotasBib(modo === 'notas'); }}
                onEntradasCargadas={data => setEntradasBib(data)}
              />
          )}

          {seccionActiva === 'libros' && (
            <div style={{ padding: isMobile ? '0 16px' : '0 28px' }}>
              <h2 style={{ fontSize: '28px', marginBottom: '20px', marginTop: '8px', fontWeight: 900 }}>{cargando ? "Cargando..." : (busqueda || "Tendencias")}</h2>
              <div style={{ display: 'grid', gridTemplateColumns: isMobile ? 'repeat(auto-fill, minmax(110px, 1fr))' : 'repeat(auto-fill, minmax(150px, 1fr))', gap: isMobile ? '10px' : '16px' }}>
                {cargando ? [...Array(10)].map((_, i) => (
                  <div key={i} style={{ borderRadius: '8px', background: '#141414', padding: '12px' }}>
                    <div style={{ width: '100%', aspectRatio: '2/3', background: '#1a1a1a', borderRadius: '6px', animation: 'pulse 1.5s infinite' }} />
                  </div>
                )) : libros.length === 0 ? (
                  <div style={{ gridColumn: '1 / -1', textAlign: 'center', padding: '60px 0', color: '#333' }}>
                    <p style={{ fontSize: '32px', marginBottom: '12px' }}>📚</p>
                    <p style={{ fontSize: '14px' }}>No se encontraron libros</p>
                    <button onClick={() => cargarLista()} style={{ background: 'none', border: '1px solid #2a2a2a', color: '#555', borderRadius: '20px', padding: '8px 20px', cursor: 'pointer', fontSize: '13px', marginTop: '12px' }}>Ver tendencias</button>
                  </div>
                ) : libros.map((l) => (
                  <div key={l.id} className="book-card" onClick={() => verLibro(l)}>
                    <img src={l.portada} alt="" onError={e => { e.currentTarget.style.background = '#1a1a1a'; e.currentTarget.src = ''; }} />
                    <p style={{ margin: '10px 0 3px', fontWeight: 'bold', fontSize: '13px', color: 'white' }}>{l.titulo}</p>
                    <p style={{ fontSize: '12px', color: '#555', margin: 0 }}>{l.autor}</p>
                  </div>
                ))}
              </div>
            </div>
          )}

          {seccionActiva === 'explorar' && (
            <SeccionExplorar
              isMobile={isMobile}
              onCargarLista={cargarLista}
              onEntrarSala={entrarEnSala}
            />
          )}

          {seccionActiva === 'sala' && salaAbierta && (
            <div style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
              <div className="sala-header" style={{ padding: isMobile ? '16px' : undefined }}>
                <img src={salaAbierta.portada} className="sala-portada" onError={e => e.currentTarget.style.display='none'} style={{ width: isMobile ? '70px' : undefined, height: isMobile ? '95px' : undefined }} alt="" />
                <div style={{ flex: 1 }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '10px', flexWrap: 'wrap' }}>
                    <h1 style={{ margin: '0', fontSize: '24px', fontWeight: 900 }}>{salaAbierta.tituloSala || salaAbierta.titulo}</h1>
                    <span style={{ background: salaAbierta.tipo === 'privada' ? '#f4433622' : salaAbierta.tipo === 'evento' ? '#9c27b022' : '#1DB95422', color: salaAbierta.tipo === 'privada' ? '#f44336' : salaAbierta.tipo === 'evento' ? '#9c27b0' : '#1DB954', padding: '3px 10px', borderRadius: '20px', fontSize: '11px', fontWeight: 'bold', border: `1px solid ${salaAbierta.tipo === 'privada' ? '#f4433644' : salaAbierta.tipo === 'evento' ? '#9c27b044' : '#1DB95444'}` }}>
                      {salaAbierta.tipo === 'privada' ? 'PRIVADA' : salaAbierta.tipo === 'evento' ? '📅 EVENTO' : 'PÚBLICA'}
                    </span>
                  </div>
                  <p style={{ margin: '4px 0 0', color: '#555', fontSize: '13px' }}>{salaAbierta.autor}</p>
                  <div style={{ display: 'flex', gap: '8px', marginTop: '14px' }}>
                    {salaAbierta.tipo !== 'evento' && <button onClick={() => setModalInvitarVisible(true)} className="btn-verde" style={{ width: 'auto', margin: 0, padding: '9px 20px', fontSize: '13px' }}>Invitar</button>}
                    <button onClick={async () => {
                      const baseUrl = esNativa ? 'https://lectuclubapp.web.app' : window.location.origin;
                      const url = `${baseUrl}?sala=${salaAbierta.idReal}&libro=${encodeURIComponent(salaAbierta.titulo)}`;
                      if (navigator.share) {
                        try {
                          await navigator.share({ title: `Debate: ${salaAbierta.titulo}`, text: `¡Únete al debate de "${salaAbierta.titulo}" en Leemos!`, url });
                        } catch { /* usuario canceló */ }
                      } else {
                        try {
                          await navigator.clipboard.writeText(url);
                          showToast('Enlace copiado al portapapeles');
                        } catch {
                          // Fallback para navegadores sin permiso de clipboard
                          const ta = document.createElement('textarea');
                          ta.value = url; ta.style.position = 'fixed'; ta.style.opacity = '0';
                          document.body.appendChild(ta); ta.focus(); ta.select();
                          document.execCommand('copy');
                          document.body.removeChild(ta);
                          showToast('Enlace copiado al portapapeles');
                        }
                      }
                    }} className="btn-outline" style={{ padding: '9px 16px', display: 'flex', alignItems: 'center', gap: '6px', marginTop: 0 }}>
                      <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><path d="M18 16.08c-.76 0-1.44.3-1.96.77L8.91 12.7c.05-.23.09-.46.09-.7s-.04-.47-.09-.7l7.05-4.11c.54.5 1.25.81 2.04.81 1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3c0 .24.04.47.09.7L8.04 9.81C7.5 9.31 6.79 9 6 9c-1.66 0-3 1.34-3 3s1.34 3 3 3c.79 0 1.5-.31 2.04-.81l7.12 4.16c-.05.21-.08.43-.08.65 0 1.61 1.31 2.92 2.92 2.92s2.92-1.31 2.92-2.92-1.31-2.92-2.92-2.92z"/></svg>
                      Compartir
                    </button>
                    <button className="btn-outline" style={{ padding: '9px 20px' }} onClick={() => setModalSalirSala(true)}>Salir de sala</button>
                  </div>
                </div>
              </div>
              <div className="sala-nav">
                <div className={`sala-nav-item ${tabSala === 'chat' ? 'active' : ''}`} onClick={() => setTabSala('chat')}>Chat</div>
                <div className={`sala-nav-item ${tabSala === 'miembros' ? 'active' : ''}`} onClick={() => setTabSala('miembros')}>Miembros {salaAbierta.miembros.length > 0 && `(${salaAbierta.miembros.length})`}</div>
              </div>
              {tabSala === 'chat' ? (
                <>
                  <div className="chat-area">
                    {salaAbierta.mensajes.length === 0 && <p style={{ textAlign: 'center', color: '#2a2a2a', marginTop: '60px', fontSize: '14px' }}>Sé el primero en escribir sobre este libro.</p>}
                    {/* Aviso historial limitado para gratuitos */}
                    {!esPremium && salaAbierta.mensajes.length >= 100 && (
                      <div style={{ textAlign: 'center', padding: '12px 16px', marginBottom: '8px' }}>
                        <p style={{ margin: '0 0 8px', fontSize: '12px', color: '#444' }}>Estás viendo los últimos 100 mensajes</p>
                        <button onClick={abrirModalPremium}
                          style={{ background: 'transparent', border: '1px solid #a78bfa44', color: '#a78bfa', borderRadius: '20px', padding: '5px 14px', cursor: 'pointer', fontSize: '11px', fontWeight: 'bold' }}>
                          ✦ Ver historial completo con Premium
                        </button>
                      </div>
                    )}
                    {salaAbierta.mensajes.map((m) => {
                      const esBot = m.esBot || m.sender?.id === 'club_oficial';
                      const esMio = m.sender?.id === user.uid;

                      // Mensaje del Leemos
                      if (esBot) {
                        return (
                          <div key={m.id} style={{ display: 'flex', justifyContent: 'center', margin: '8px 0' }}>
                            <div style={{ background: '#0a0a0a', border: '1px solid #1DB95422', borderRadius: '12px', padding: '12px 18px', maxWidth: '85%', textAlign: 'center' }}>
                              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '6px', marginBottom: '6px' }}>
                                <svg width="12" height="12" viewBox="0 0 24 24" fill="#1DB954"><path d="M21 5c-1.11-.35-2.33-.5-3.5-.5-1.95 0-4.05.4-5.5 1.5-1.45-1.1-3.55-1.5-5.5-1.5S2.45 4.9 1 6v14.65c0 .25.25.5.5.5.1 0 .15-.05.25-.05C3.1 20.45 5.05 20 6.5 20c1.95 0 4.05.4 5.5 1.5 1.35-.85 3.8-1.5 5.5-1.5 1.65 0 3.35.3 4.75 1.05.1.05.15.05.25.05.25 0 .5-.25.5-.5V6c-.6-.45-1.25-.75-2-1zm0 13.5c-1.1-.35-2.3-.5-3.5-.5-1.7 0-4.15.65-5.5 1.5V8c1.35-.85 3.8-1.5 5.5-1.5 1.2 0 2.4.15 3.5.5v11.5z"/></svg>
                                <span style={{ fontSize: '11px', fontWeight: 900, color: '#1DB954', textTransform: 'uppercase', letterSpacing: '1px' }}>Leemos</span>
                              </div>
                              <p style={{ margin: 0, fontSize: '13px', color: '#666', lineHeight: '1.5' }}>{m.texto}</p>
                            </div>
                          </div>
                        );
                      }

                      return (
                        <div key={m.id} className={`msg-row ${esMio ? 'mine' : ''}`}
                          onMouseEnter={e => { const btn = e.currentTarget.querySelector('.reply-btn'); if (btn) btn.style.opacity = '1'; }}
                          onMouseLeave={e => { const btn = e.currentTarget.querySelector('.reply-btn'); if (btn) btn.style.opacity = '0'; }}>
                          <Avatar src={m.sender?.foto} nombre={m.sender?.nombre} size={32} onClick={() => m.sender && verPerfilAjeno(m.sender)} />
                          <div style={{ display: 'flex', flexDirection: 'column', gap: '4px', maxWidth: '100%' }}>
                            {/* Cita del mensaje original si es una respuesta */}
                            {m.citando && (
                              <div style={{ background: '#1a1a1a', borderLeft: '3px solid #1DB954', borderRadius: '0 8px 8px 0', padding: '6px 10px', marginBottom: '2px', opacity: 0.8, cursor: 'pointer' }}
                                onClick={() => {
                                  const el = document.getElementById(`msg-${m.citando.id}`);
                                  if (el) el.scrollIntoView({ behavior: 'smooth', block: 'center' });
                                }}>
                                <p style={{ margin: '0 0 2px', fontSize: '11px', fontWeight: 'bold', color: '#1DB954' }}>{m.citando.nombre || 'Usuario'}</p>
                                <p style={{ margin: 0, fontSize: '12px', color: '#666', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', maxWidth: '280px' }}>
                                  {m.citando.texto}
                                </p>
                              </div>
                            )}
                            <div id={`msg-${m.id}`} className="msg-bubble">
                              <div style={{ fontSize: '11px', fontWeight: 'bold', marginBottom: '4px', color: '#1DB954', display: 'flex', alignItems: 'center', gap: '4px' }}>
                                {m.sender?.nombre || 'Lector'}
                                {m.sender?.verificado && <BadgeVerificado tipo={m.sender.verificado} size="small" />}
                              </div>
                              {m.spoiler ? <SpoilerBlur texto={m.texto} /> : m.texto}
                            </div>
                          </div>
                          {/* Botón responder — visible en hover */}
                          <button className="reply-btn" onClick={() => setMensajeCitado({ id: m.id || m.fecha?.seconds?.toString() || Date.now().toString(), texto: m.texto, nombre: m.sender?.nombre })}
                            style={{ background: 'none', border: 'none', color: '#444', cursor: 'pointer', fontSize: '16px', padding: '4px 6px', opacity: 0, transition: 'opacity 0.15s', alignSelf: 'center', flexShrink: 0, order: esMio ? -1 : 1, transform: esMio ? 'scaleX(-1)' : 'none' }}
                            title="Responder">
                            ↩
                          </button>
                        </div>
                      );
                    })}
                    <div ref={chatEndRef} />
                  </div>
                  <div style={{ padding: '12px 20px', background: '#0a0a0a', borderTop: '1px solid #1a1a1a' }}>
                    {/* Preview del mensaje citado */}
                    {mensajeCitado && (
                      <div style={{ display: 'flex', alignItems: 'center', gap: '8px', padding: '8px 12px', background: '#141414', borderRadius: '8px', marginBottom: '8px', borderLeft: '3px solid #1DB954' }}>
                        <div style={{ flex: 1, minWidth: 0 }}>
                          <p style={{ margin: '0 0 2px', fontSize: '11px', fontWeight: 'bold', color: '#1DB954' }}>Respondiendo a {mensajeCitado.nombre}</p>
                          <p style={{ margin: 0, fontSize: '12px', color: '#555', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{mensajeCitado.texto}</p>
                        </div>
                        <button onClick={() => setMensajeCitado(null)} style={{ background: 'none', border: 'none', color: '#444', cursor: 'pointer', fontSize: '18px', flexShrink: 0, lineHeight: 1 }}>✕</button>
                      </div>
                    )}
                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '8px' }}>
                      <label style={{ display: 'flex', alignItems: 'center', gap: '6px', cursor: 'pointer', fontSize: '12px', color: esSpoiler ? '#f44336' : '#444' }}>
                        <input type="checkbox" checked={esSpoiler} onChange={e => setEsSpoiler(e.target.checked)} style={{ accentColor: '#f44336' }} />
                        Spoiler
                      </label>
                    </div>
                    <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                    <input enterKeyHint="send" placeholder={mensajeCitado ? `Respondiendo a ${mensajeCitado.nombre || 'Usuario'}...` : "Escribe un mensaje..."} value={mensaje} onChange={e => setMensaje(e.target.value.slice(0, 500))}
                      onKeyDown={async e => {
                        if (e.key === 'Escape') { setMensajeCitado(null); return; }
                        if (e.key === 'Enter' && mensaje.trim() && mensaje.trim().length <= 500) await enviarMensajeSala();
                      }}
                      style={{ flex: 1, background: '#141414', border: '1px solid #1e1e1e', borderRadius: '20px', padding: '10px 18px', color: 'white', outline: 'none', fontSize: '14px', boxSizing: 'border-box' }} />
                    <button onClick={enviarMensajeSala} disabled={!mensaje.trim()} style={{ background: mensaje.trim() ? '#1DB954' : '#1a1a1a', border: 'none', borderRadius: '50%', width: '40px', height: '40px', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: mensaje.trim() ? 'pointer' : 'default', flexShrink: 0, fontSize: '18px', transition: '0.2s' }}>➤</button>
                    </div>
                  </div>
                </>
              ) : (
                <div style={{ padding: '20px 28px', display: 'flex', flexDirection: 'column', gap: '10px' }}>
                  {salaAbierta.miembros.map((mb) => (
                    <div key={mb.id} style={{ display: 'flex', alignItems: 'center', gap: '12px', padding: '10px', background: '#141414', borderRadius: '10px', cursor: 'pointer', border: '1px solid #1e1e1e' }} onClick={() => verPerfilAjeno(mb)}>
                      <Avatar src={mb.avatar || mb.foto} nombre={mb.nombre} size={38} />
                      <b style={{ fontSize: '14px' }}>{mb.nombre} {mb.id === user.uid ? <span style={{ color: '#1DB954', fontWeight: 'normal', fontSize: '12px' }}>(Tú)</span> : ''}</b>
                    </div>
                  ))}
                </div>
              )}
            </div>
          )}

          {seccionActiva === 'perfil-ajeno' && perfilAjeno && (() => {
            const esAutorAjeno = perfilAjeno.verificado === 'autor' || perfilAjeno.verificado === 'editorial';
            return (
            <div style={{ padding: '0 32px' }}>
              <div style={{
                display: 'flex', alignItems: 'center', gap: '28px', margin: '0 -32px 24px', padding: '40px 32px',
                ...(esAutorAjeno ? { background: 'linear-gradient(135deg, #061824, #0d2433)', borderBottom: '1px solid #0ea5e933' } : {}),
              }}>
                {(() => {
                    const marcoAjeno = MARCOS_AVATAR.find(mx => mx.id === perfilAjeno.marco);
                    const tieneMarcoAjeno = marcoAjeno && marcoAjeno.id !== 'ninguno';
                    return (
                      <div style={{ width: '120px', height: '120px', borderRadius: '50%', flexShrink: 0, boxSizing: 'border-box', ...(tieneMarcoAjeno ? { ...marcoAjeno.estilo, padding: '3px' } : { border: `3px solid ${esAutorAjeno ? '#0ea5e944' : '#1a1a1a'}` }) }}>
                        <div style={{ width: '100%', height: '100%', borderRadius: '50%', overflow: 'hidden' }}>
                          <Avatar src={perfilAjeno.foto || perfilAjeno.avatar} nombre={perfilAjeno.nombre} size={114} />
                        </div>
                      </div>
                    );
                  })()}
                <div style={{ flex: 1 }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '10px', flexWrap: 'wrap', marginBottom: '4px' }}>
                    <h1 style={{ fontSize: '42px', margin: 0, fontWeight: 900 }}>{perfilAjeno.nombre}</h1>
                    <BadgeVerificado tipo={perfilAjeno.id === ADMIN_UID ? 'admin' : perfilAjeno.verificado} />
                    <BadgeCompatibilidad userIdPropio={user?.uid} userIdAjeno={perfilAjeno.id} />
                    {perfilAjeno.premium && <span style={{ background: 'linear-gradient(135deg, #6a3fa0, #a78bfa)', color: 'white', fontSize: '11px', padding: '3px 10px', borderRadius: '10px', fontWeight: 'bold' }}>✦ PREMIUM</span>}
                  </div>
                  <p style={{ color: '#444', margin: '0 0 8px', fontSize: '13px' }}>{perfilAjeno.seguidores || 0} seguidores</p>
                  {perfilAjeno.fecha && <p style={{ color: '#333', margin: '0 0 16px', fontSize: '12px' }}>{perfilAjeno.fecha}</p>}
                  <div style={{ display: 'flex', gap: '8px' }}>
                    <button className="btn-verde" style={{ width: esAutorAjeno ? '220px' : '140px', margin: 0, ...(esAutorAjeno ? { background: '#0ea5e9' } : {}) }} onClick={() => toggleSeguir(perfilAjeno)}>
                      {siguiendoA.includes(perfilAjeno.id) ? 'Siguiendo' : esAutorAjeno ? 'Seguir a este autor' : 'Seguir'}
                    </button>
                    {esAutorAjeno && (
                      <button
                        onClick={async () => {
                          const url = `${window.location.origin}/?autor=${perfilAjeno.id}`;
                          const texto = `Descubre a ${perfilAjeno.nombre} en Leemos`;
                          if (navigator.share) {
                            try { await navigator.share({ title: perfilAjeno.nombre, text: texto, url }); } catch {}
                          } else {
                            await navigator.clipboard.writeText(`${texto}\n${url}`);
                            showToast('Enlace copiado', 'ok');
                          }
                        }}
                        className="btn-outline" style={{ margin: 0, padding: '0 16px', borderColor: '#0ea5e944', color: '#0ea5e9' }}>
                        Compartir
                      </button>
                    )}
                  </div>
                </div>
              </div>

              {/* Libros del autor — destacados arriba del todo, antes que cualquier otra cosa */}
              {esAutorAjeno && (
                <>
                  <EstadisticasAutor autorUid={perfilAjeno.id} />
                  <LibrosDelAutor autorUid={perfilAjeno.id} onVerLibro={libro => verLibro(libro)} />
                  <ClubsDelAutor autorUid={perfilAjeno.id} autorNombre={perfilAjeno.nombre} userId={user?.uid} perfil={perfil} />
                </>
              )}

              {!esAutorAjeno && (
                <div style={{ marginBottom: '16px' }}>
                  <RetoLector userId={perfilAjeno.id} compact soloVer />
                </div>
              )}
              {/* sobreMi */}
              {perfilAjeno.sobreMi && perfilAjeno.sobreMi !== 'Cuéntanos algo sobre ti...' && (
                <div style={{ marginBottom: '16px' }}>
                  {esAutorAjeno && <p style={{ fontSize: '11px', color: '#0ea5e9', textTransform: 'uppercase', letterSpacing: '1px', margin: '0 0 6px', fontWeight: 'bold' }}>Sobre el autor</p>}
                  <p style={{ color: '#666', fontSize: '14px', lineHeight: '1.6', margin: 0 }}>{perfilAjeno.sobreMi}</p>
                </div>
              )}
              {/* Géneros */}
              {perfilAjeno.generos?.length > 0 && (
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: '6px', marginBottom: '20px' }}>
                  {perfilAjeno.generos.map(g => (
                    <span key={g} style={{ background: '#141414', border: '1px solid #1e1e1e', borderRadius: '20px', padding: '4px 12px', fontSize: '12px', color: '#888' }}>{g}</span>
                  ))}
                </div>
              )}
              {/* Libro y frase favorita del perfil ajeno */}
              {(perfilAjeno.libroFavorito || perfilAjeno.fraseFavorita?.texto) && (
                <div style={{ background: '#141414', borderRadius: '14px', border: '1px solid #1e1e1e', overflow: 'hidden', marginBottom: '16px' }}>
                  {perfilAjeno.libroFavorito && (
                    <div style={{ padding: '14px 16px', borderBottom: perfilAjeno.fraseFavorita?.texto ? '1px solid #1a1a1a' : 'none' }}>
                      <p style={{ fontSize: '11px', color: '#444', textTransform: 'uppercase', letterSpacing: '0.5px', margin: '0 0 10px', fontWeight: 'bold' }}>Libro favorito</p>
                      <div style={{ display: 'flex', gap: '12px', alignItems: 'center' }}>
                        <img src={perfilAjeno.libroFavorito.portada} style={{ width: '48px', height: '68px', objectFit: 'cover', borderRadius: '4px', boxShadow: '0 4px 12px rgba(0,0,0,0.4)' }} alt="" onError={e => e.currentTarget.style.display='none'} />
                        <div>
                          <p style={{ margin: '0 0 2px', fontWeight: 900, fontSize: '14px', color: 'white' }}>{perfilAjeno.libroFavorito.titulo}</p>
                          <p style={{ margin: 0, fontSize: '12px', color: '#555' }}>{perfilAjeno.libroFavorito.autor}</p>
                        </div>
                      </div>
                    </div>
                  )}
                  {perfilAjeno.fraseFavorita?.texto && (
                    <div style={{ padding: '14px 16px' }}>
                      <p style={{ fontSize: '11px', color: '#444', textTransform: 'uppercase', letterSpacing: '0.5px', margin: '0 0 10px', fontWeight: 'bold' }}>Frase favorita</p>
                      <div style={{ display: 'flex', gap: '12px', alignItems: 'flex-start' }}>
                        {perfilAjeno.fraseFavorita.portada && (
                          <img src={perfilAjeno.fraseFavorita.portada} style={{ width: '36px', height: '52px', objectFit: 'cover', borderRadius: '3px', flexShrink: 0, opacity: 0.8 }} alt="" onError={e => e.currentTarget.style.display='none'} />
                        )}
                        <div>
                          <p style={{ margin: '0 0 4px', color: '#aaa', fontSize: '13px', fontStyle: 'italic', lineHeight: '1.6' }}>"{perfilAjeno.fraseFavorita.texto}"</p>
                          {perfilAjeno.fraseFavorita.libro && <p style={{ margin: 0, fontSize: '11px', color: '#444' }}>— {perfilAjeno.fraseFavorita.libro}</p>}
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              )}
              {!(esAutorAjeno || perfilAjeno.verificado === 'autor' || perfilAjeno.verificado === 'editorial') && <InsigniasPerfil userId={perfilAjeno.id} />}
              {!(esAutorAjeno || perfilAjeno.verificado === 'autor' || perfilAjeno.verificado === 'editorial') && (
                <div style={{ marginTop: '24px' }}>
                  <BibliotecaPersonal
                    userId={perfilAjeno.id}
                    onVerLibro={libro => verLibro(libro)}
                    onVolver={() => { setSeccionActiva(seccionAnterior || 'buscar-usuarios'); setPerfilAjeno(null); }}
                    soloLectura={true}
                  />
                </div>
              )}
            </div>
            );
          })()}

          {seccionActiva === 'perfil' && (() => {
            const esAutorPropio = perfil.verificado === 'autor' || perfil.verificado === 'editorial';
            return (
            <div style={{ padding: isMobile ? '0 16px 20px' : '0 32px 40px' }}>
              <div style={{
                position: 'relative', display: 'flex', alignItems: isMobile ? 'flex-start' : 'center', flexDirection: isMobile ? 'column' : 'row', gap: isMobile ? '16px' : '32px', margin: isMobile ? '16px -16px' : '36px -32px', padding: isMobile ? '16px 16px 32px' : '36px 32px 32px', borderBottom: '1px solid #1a1a1a',
                ...(esAutorPropio ? { background: 'linear-gradient(135deg, #061824, #0d2433)', borderBottomColor: '#0ea5e933' } : {}),
              }}>
                {/* Botón 3 puntos — esquina superior derecha */}
                <div style={{ position: 'absolute', top: 0, right: 0 }}>
                  <button onClick={() => setMenuOpciones(!menuOpciones)}
                    style={{ background: 'none', border: '1px solid #2a2a2a', color: '#555', borderRadius: '8px', padding: '6px 10px', cursor: 'pointer', fontSize: '16px', letterSpacing: '2px', transition: '0.2s' }}
                    onMouseEnter={e => { e.currentTarget.style.borderColor = '#444'; e.currentTarget.style.color = '#aaa'; }}
                    onMouseLeave={e => { e.currentTarget.style.borderColor = '#2a2a2a'; e.currentTarget.style.color = '#555'; }}>
                    •••
                  </button>
                  {menuOpciones && (
                    <>
                      <div style={{ position: 'fixed', inset: 0, zIndex: 99 }} onClick={() => setMenuOpciones(false)} />
                      <div style={{ position: 'absolute', right: 0, top: '40px', background: '#141414', border: '1px solid #1e1e1e', borderRadius: '12px', padding: '8px', minWidth: '200px', zIndex: 100, boxShadow: '0 8px 24px rgba(0,0,0,0.5)' }}
                        onClick={() => setMenuOpciones(false)}>
                      <button onClick={() => setSeccionActiva('ayuda')}
                        style={{ width: '100%', background: 'none', border: 'none', color: '#aaa', padding: '10px 14px', textAlign: 'left', cursor: 'pointer', fontSize: '14px', borderRadius: '8px', display: 'flex', alignItems: 'center', gap: '10px' }}
                        onMouseEnter={e => e.currentTarget.style.background = '#1a1a1a'}
                        onMouseLeave={e => e.currentTarget.style.background = 'none'}>
                        <Icon.Info /> Ayuda y soporte
                      </button>
                      {esPremium && (
                        <button onClick={cancelarSuscripcion}
                          style={{ width: '100%', background: 'none', border: 'none', color: '#aaa', padding: '10px 14px', textAlign: 'left', cursor: 'pointer', fontSize: '14px', borderRadius: '8px', display: 'flex', alignItems: 'center', gap: '10px' }}
                          onMouseEnter={e => e.currentTarget.style.background = '#1a1a1a'}
                          onMouseLeave={e => e.currentTarget.style.background = 'none'}>
                          <Icon.Settings /> Gestionar suscripción
                        </button>
                      )}
                    </div>
                  </>
                  )}
                </div>
                <div
                  onClick={() => fileInputRef.current.click()}
                  style={{ width: '140px', height: '140px', borderRadius: '50%', cursor: 'pointer', position: 'relative', transition: '0.2s', flexShrink: 0, boxSizing: 'border-box', ...(() => { const m = MARCOS_AVATAR.find(mx => mx.id === marcoSeleccionado); return m && m.id !== 'ninguno' ? { ...m.estilo, padding: '3px' } : {}; })() }}>
                  <div style={{ width: '100%', height: '100%', borderRadius: '50%', overflow: 'hidden', background: '#2d1a23', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <Avatar src={perfil.foto} nombre={perfil.nombre} size={134} />
                  </div>
                </div>
                <div style={{ flex: 1 }}>
                  {editando === 'n'
                    ? <input autoFocus onBlur={() => setEditando(null)} style={{ background: '#1a1a1a', border: '1px solid #1DB954', color: 'white', fontSize: '40px', width: '100%', borderRadius: '8px', padding: '4px 12px', fontWeight: 900, outline: 'none' }} value={perfil.nombre} onChange={e => handleUpdate('nombre', e.target.value.slice(0, 40))} maxLength={40} />
                    : <div style={{ display: 'flex', alignItems: 'center', gap: '12px', flexWrap: 'wrap' }}><h1 style={{ fontSize: '52px', margin: '0', fontWeight: 900, cursor: 'pointer' }} onClick={() => setEditando('n')}>{perfil.nombre}</h1>{esPremium && <span style={{ background: 'linear-gradient(135deg, #6a3fa0, #a78bfa)', color: 'white', fontSize: '12px', padding: '4px 12px', borderRadius: '12px', fontWeight: 'bold', letterSpacing: '0.5px' }}>✦ PREMIUM</span>}<BadgeVerificado tipo={perfil.id === ADMIN_UID ? 'admin' : perfil.verificado} /></div>}
                  <div style={{ display: 'flex', gap: '24px', marginTop: '12px' }}>
                    <div style={{ cursor: 'pointer' }} onClick={() => { setTabSeguidores('seguidores'); setModalSeguidoresVisible(true); }}>
                      <span style={{ fontWeight: 'bold', fontSize: '16px' }}>{listaSeguidores.length}</span> <span style={{ color: '#555', fontSize: '13px' }}>seguidores</span>
                    </div>
                    <div style={{ cursor: 'pointer' }} onClick={() => { setTabSeguidores('siguiendo'); setModalSeguidoresVisible(true); }}>
                      <span style={{ fontWeight: 'bold', fontSize: '16px' }}>{listaSiguiendo.length}</span> <span style={{ color: '#555', fontSize: '13px' }}>siguiendo</span>
                    </div>
                  </div>
                  {perfil.fechaNacimiento && <p style={{ color: '#333', fontSize: '12px', marginTop: '8px' }}>🎂 {perfil.fechaNacimiento}</p>}
                </div>
              </div>

              {/* Libros del autor — destacados arriba del todo, solo si está verificado */}
              {esAutorPropio && (
                <>
                  <div style={{ display: 'flex', gap: '8px', marginBottom: '20px', flexWrap: 'wrap' }}>
                    <button
                      onClick={async () => {
                        const url = `${window.location.origin}/?autor=${user.uid}`;
                        const texto = `Descubre mi perfil de autor en Leemos`;
                        if (navigator.share) {
                          try { await navigator.share({ title: perfil.nombre, text: texto, url }); } catch {}
                        } else {
                          await navigator.clipboard.writeText(`${texto}\n${url}`);
                          showToast('Enlace copiado', 'ok');
                        }
                      }}
                      style={{ background: 'transparent', border: '1px solid #0ea5e944', color: '#0ea5e9', borderRadius: '20px', padding: '8px 18px', fontWeight: 'bold', cursor: 'pointer', fontSize: '13px', display: 'inline-flex', alignItems: 'center', gap: '6px' }}>
                      <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor"><path d="M18 16.08c-.76 0-1.44.3-1.96.77L8.91 12.7c.05-.23.09-.46.09-.7s-.04-.47-.09-.7l7.05-4.11c.54.5 1.25.81 2.04.81 1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3c0 .24.04.47.09.7L8.04 9.81C7.5 9.31 6.79 9 6 9c-1.66 0-3 1.34-3 3s1.34 3 3 3c.79 0 1.5-.31 2.04-.81l7.12 4.16c-.05.21-.08.43-.08.65 0 1.61 1.31 2.92 2.92 2.92 1.61 0 2.92-1.31 2.92-2.92s-1.31-2.92-2.92-2.92z"/></svg>
                      Compartir mi perfil
                    </button>
                    <button
                      onClick={() => setModalPublicarLibro(true)}
                      style={{ background: '#0ea5e9', border: 'none', color: 'white', borderRadius: '20px', padding: '8px 18px', fontWeight: 'bold', cursor: 'pointer', fontSize: '13px', display: 'inline-flex', alignItems: 'center', gap: '6px' }}>
                      Publicar mi libro
                    </button>
                  </div>
                  <EstadisticasAutor autorUid={user.uid} />
                  <LibrosDelAutor autorUid={user.uid} onVerLibro={libro => verLibro(libro)} />
                  <ClubsDelAutor autorUid={user.uid} autorNombre={perfil.nombre} userId={user.uid} perfil={perfil} />
                </>
              )}

              {/* Código de invitación — no aplica a autores, su rol no es captar referidos premium */}
              {!esAutorPropio && (
                <div style={{ background: '#111', border: '1px solid #1e1e1e', borderRadius: '16px', padding: '18px 20px', marginBottom: '28px' }}>
                  {/* Header */}
                  <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '16px' }}>
                    <div>
                      <p style={{ margin: '0 0 2px', fontSize: '13px', fontWeight: 900, color: 'white' }}>Invita amigos</p>
                      <p style={{ margin: 0, fontSize: '11px', color: '#444' }}>Deben usar la app 3 días para activarse</p>
                    </div>
                    <button
                      onClick={() => {
                        const enlace = `https://lectuclubapp.web.app?ref=${codigoInvitacionPropio}`;
                        navigator.clipboard?.writeText(enlace);
                        showToast('¡Enlace copiado!', 'ok');
                      }}
                      className="btn-outline"
                      style={{ padding: '6px 14px', fontSize: '12px', borderRadius: '20px', flexShrink: 0 }}>
                      Copiar enlace
                    </button>
                  </div>

                  {/* Niveles con estados */}
                  {(() => {
                    const activadas = stats?.invitacionesActivadas || 0;
                    const niveles = [
                      { n: 1, label: '1 mes premium' },
                      { n: 3, label: '3 meses premium' },
                      { n: 5, label: '1 año premium' },
                    ];
                    return (
                      <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                        {niveles.map(({ n, label }) => {
                          const completado = activadas >= n;
                          const enProgreso = !completado && (stats?.invitaciones || 0) >= n;
                          return (
                            <div key={n} style={{ display: 'flex', alignItems: 'center', gap: '12px', padding: '10px 12px', background: completado ? '#1DB95410' : enProgreso ? '#f59e0b10' : '#0a0a0a', border: `1px solid ${completado ? '#1DB95430' : enProgreso ? '#f59e0b30' : '#1a1a1a'}`, borderRadius: '10px', transition: '0.2s' }}>
                              {/* Indicador */}
                              <div style={{ width: '20px', height: '20px', borderRadius: '50%', background: completado ? '#1DB954' : enProgreso ? '#f59e0b' : '#1e1e1e', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, fontSize: '11px', fontWeight: 900, color: completado || enProgreso ? 'black' : '#333' }}>
                                {completado ? '✓' : n}
                              </div>
                              {/* Texto */}
                              <div style={{ flex: 1 }}>
                                <p style={{ margin: 0, fontSize: '12px', fontWeight: 'bold', color: completado ? 'white' : enProgreso ? '#f59e0b' : '#333' }}>{label}</p>
                              </div>
                              {/* Estado */}
                              <span style={{ fontSize: '10px', color: completado ? '#1DB954' : enProgreso ? '#f59e0b' : '#2a2a2a', fontWeight: 'bold', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                                {completado ? 'Desbloqueado' : enProgreso ? 'Pendiente' : `${n} amigos`}
                              </span>
                            </div>
                          );
                        })}
                      </div>
                    );
                  })()}

                  {/* Resumen */}
                  {(stats?.invitaciones || 0) > 0 && (
                    <div style={{ marginTop: '12px', paddingTop: '12px', borderTop: '1px solid #1a1a1a', display: 'flex', justifyContent: 'space-between' }}>
                      <p style={{ margin: 0, fontSize: '11px', color: '#555' }}>
                        {stats?.invitacionesActivadas || 0} activada{(stats?.invitacionesActivadas || 0) !== 1 ? 's' : ''}
                      </p>
                      {((stats?.invitaciones || 0) - (stats?.invitacionesActivadas || 0)) > 0 && (
                        <p style={{ margin: 0, fontSize: '11px', color: '#f59e0b' }}>
                          {(stats?.invitaciones || 0) - (stats?.invitacionesActivadas || 0)} pendiente{((stats?.invitaciones || 0) - (stats?.invitacionesActivadas || 0)) !== 1 ? 's' : ''} (esperando 3 días)
                        </p>
                      )}
                    </div>
                  )}
                </div>
              )}

              <div style={{ display: 'grid', gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr', gap: isMobile ? '20px' : '32px', marginBottom: '32px' }}>
                <div>
                  <h3 style={{ fontSize: '12px', color: esAutorPropio ? '#0ea5e9' : '#555', textTransform: 'uppercase', letterSpacing: '1px', margin: '0 0 12px' }}>{esAutorPropio ? 'Biografía de autor' : 'Sobre mí'}</h3>
                  {editando === 'sm'
                    ? <textarea autoFocus onBlur={() => setEditando(null)} placeholder={esAutorPropio ? 'Qué escribes, tu trayectoria, dónde encontrarte...' : ''} style={{ background: '#1a1a1a', border: `1px solid ${esAutorPropio ? '#0ea5e9' : '#1DB954'}`, color: 'white', width: '100%', height: '90px', borderRadius: '8px', padding: '10px', outline: 'none', resize: 'none', fontSize: '14px' }} value={perfil.sobreMi} onChange={e => handleUpdate('sobreMi', e.target.value.slice(0, 300))} maxLength={300} />
                    : <p style={{ color: '#666', cursor: 'pointer', lineHeight: '1.6', fontSize: '14px' }} onClick={() => setEditando('sm')}>{perfil.sobreMi}</p>}
                </div>
                <div>
                  <h3 style={{ fontSize: '12px', color: '#555', textTransform: 'uppercase', letterSpacing: '1px', margin: '0 0 12px' }}>Géneros favoritos</h3>
                  <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
                    {GENEROS_LIBROS.map(g => {
                      const generos = perfil.generos || [];
                      return (
                      <div key={g} onClick={() => {
                        const activo = generos.includes(g);
                        const n = activo
                          ? generos.filter(i => i !== g)
                          : generos.length >= 10 ? generos : [...generos, g];
                        handleUpdate('generos', n);
                      }} className="tag"
                        style={{ background: generos.includes(g) ? '#1DB95422' : '#141414', border: `1px solid ${generos.includes(g) ? '#1DB954' : '#1e1e1e'}`, color: generos.includes(g) ? '#1DB954' : '#555' }}>
                        {g}
                      </div>
                      );
                    })}
                  </div>
                </div>
              </div>

              {/* Libro y frase favorita — colapsado para autores */}
              {esAutorPropio ? (
                <details style={{ marginBottom: '32px' }}>
                  <summary style={{ cursor: 'pointer', fontSize: '12px', color: '#555', textTransform: 'uppercase', letterSpacing: '1px' }}>Libro y frase favorita (opcional)</summary>
                  <div style={{ marginTop: '16px' }}>
                    <div style={{ background: '#141414', borderRadius: '14px', border: '1px solid #1e1e1e', overflow: 'hidden' }}>
                      {/* Libro favorito */}
                      <div style={{ padding: '16px', borderBottom: '1px solid #1a1a1a' }}>
                    <p style={{ fontSize: '11px', color: '#444', textTransform: 'uppercase', letterSpacing: '0.5px', margin: '0 0 12px', fontWeight: 'bold' }}>Libro favorito</p>
                    {perfil.libroFavorito ? (
                      <div style={{ display: 'flex', gap: '14px', alignItems: 'flex-start' }}>
                        <img src={perfil.libroFavorito.portada} style={{ width: '60px', height: '85px', objectFit: 'cover', borderRadius: '4px', flexShrink: 0, boxShadow: '0 4px 12px rgba(0,0,0,0.4)' }} alt="" onError={e => e.currentTarget.style.display='none'} />
                        <div style={{ flex: 1 }}>
                          <p style={{ margin: '0 0 4px', fontWeight: 900, fontSize: '14px', color: 'white' }}>{perfil.libroFavorito.titulo}</p>
                          <p style={{ margin: '0 0 12px', fontSize: '12px', color: '#555' }}>{perfil.libroFavorito.autor}</p>
                          <button onClick={() => handleUpdate('libroFavorito', null)}
                            style={{ background: 'none', border: '1px solid #2a2a2a', color: '#555', borderRadius: '8px', padding: '5px 12px', cursor: 'pointer', fontSize: '12px' }}>
                            Cambiar
                          </button>
                        </div>
                      </div>
                    ) : (
                      <BuscadorLibroFavorito onSeleccionar={libro => handleUpdate('libroFavorito', libro)} />
                    )}
                  </div>
                  {/* Frase favorita */}
                  <div style={{ padding: '16px' }}>
                    <p style={{ fontSize: '11px', color: '#444', textTransform: 'uppercase', letterSpacing: '0.5px', margin: '0 0 12px', fontWeight: 'bold' }}>
                      Frase favorita
                      {perfil.fraseFavorita?.libro && (
                        <span style={{ color: '#333', marginLeft: '8px', textTransform: 'none', letterSpacing: 0 }}>— {perfil.fraseFavorita.libro}</span>
                      )}
                    </p>
                    {editando === 'frase' ? (
                      <div>
                        {/* Portada del libro seleccionado para la frase */}
                        {perfil.fraseFavorita?.portada && (
                          <div style={{ display: 'flex', gap: '12px', alignItems: 'center', marginBottom: '10px', padding: '10px', background: '#1a1a1a', borderRadius: '8px', border: '1px solid #2a2a2a' }}>
                            <img src={perfil.fraseFavorita.portada} style={{ width: '36px', height: '52px', objectFit: 'cover', borderRadius: '4px', flexShrink: 0 }} alt="" onError={e => e.currentTarget.style.display='none'} />
                            <div style={{ flex: 1, minWidth: 0 }}>
                              <p style={{ margin: '0 0 2px', fontSize: '13px', fontWeight: 'bold', color: 'white', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{perfil.fraseFavorita.libro}</p>
                              <button onClick={() => handleUpdate('fraseFavorita', { ...(perfil.fraseFavorita || {}), libro: null, portada: null })}
                                style={{ background: 'none', border: 'none', color: '#555', cursor: 'pointer', fontSize: '11px', padding: 0 }}>
                                Cambiar libro
                              </button>
                            </div>
                          </div>
                        )}
                        <textarea autoFocus
                          style={{ background: '#1a1a1a', border: '1px solid #1DB954', color: 'white', width: '100%', height: '80px', borderRadius: '8px', padding: '10px', outline: 'none', resize: 'none', fontSize: '14px', boxSizing: 'border-box', marginBottom: '8px' }}
                          value={perfil.fraseFavorita?.texto || ''}
                          onChange={e => handleUpdate('fraseFavorita', { ...(perfil.fraseFavorita || {}), texto: e.target.value.slice(0, 300) })}
                          placeholder="Escribe tu frase literaria favorita..."
                          maxLength={280} />
                        <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                          {!perfil.fraseFavorita?.portada && (
                            <BuscadorLibroFrase onSeleccionar={libro => handleUpdate('fraseFavorita', { ...(perfil.fraseFavorita || {}), libro: libro.titulo, portada: libro.portada })} />
                          )}
                          <button onClick={() => setEditando(null)}
                            style={{ background: '#1DB954', color: 'black', border: 'none', borderRadius: '8px', padding: '8px 16px', fontWeight: 'bold', cursor: 'pointer', fontSize: '13px' }}>
                            Guardar
                          </button>
                        </div>
                      </div>
                    ) : (
                      <div onClick={() => setEditando('frase')} style={{ cursor: 'pointer' }}>
                        {perfil.fraseFavorita?.texto ? (
                          <div style={{ display: 'flex', gap: '12px', alignItems: 'flex-start' }}>
                            {perfil.fraseFavorita?.portada && (
                              <img src={perfil.fraseFavorita.portada} style={{ width: '40px', height: '56px', objectFit: 'cover', borderRadius: '3px', flexShrink: 0, opacity: 0.8 }} alt="" onError={e => e.currentTarget.style.display='none'} />
                            )}
                            <div>
                              <p style={{ margin: '0 0 6px', color: '#aaa', fontSize: '14px', fontStyle: 'italic', lineHeight: '1.6' }}>"{perfil.fraseFavorita.texto}"</p>
                              {perfil.fraseFavorita.libro && <p style={{ margin: 0, fontSize: '12px', color: '#444' }}>— {perfil.fraseFavorita.libro}</p>}
                            </div>
                          </div>
                        ) : (
                          <p style={{ color: '#333', fontSize: '13px' }}>Pulsa para añadir tu frase literaria favorita...</p>
                        )}
                      </div>
                    )}
                  </div>
                </div>
                  </div>
                </details>
              ) : (
                <div style={{ marginBottom: '32px' }}>
                  <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '16px' }}>
                    <h3 style={{ fontSize: '12px', color: '#555', textTransform: 'uppercase', letterSpacing: '1px', margin: 0 }}>Libro y frase favorita</h3>
                  </div>
                  <div style={{ background: '#141414', borderRadius: '14px', border: '1px solid #1e1e1e', overflow: 'hidden' }}>
                    {/* Libro favorito */}
                    <div style={{ padding: '16px', borderBottom: '1px solid #1a1a1a' }}>
                      <p style={{ fontSize: '11px', color: '#444', textTransform: 'uppercase', letterSpacing: '0.5px', margin: '0 0 12px', fontWeight: 'bold' }}>Libro favorito</p>
                      {perfil.libroFavorito ? (
                        <div style={{ display: 'flex', gap: '14px', alignItems: 'flex-start' }}>
                          <img src={perfil.libroFavorito.portada} style={{ width: '60px', height: '85px', objectFit: 'cover', borderRadius: '4px', flexShrink: 0, boxShadow: '0 4px 12px rgba(0,0,0,0.4)' }} alt="" onError={e => e.currentTarget.style.display='none'} />
                          <div style={{ flex: 1 }}>
                            <p style={{ margin: '0 0 4px', fontWeight: 900, fontSize: '14px', color: 'white' }}>{perfil.libroFavorito.titulo}</p>
                            <p style={{ margin: '0 0 12px', fontSize: '12px', color: '#555' }}>{perfil.libroFavorito.autor}</p>
                            <button onClick={() => handleUpdate('libroFavorito', null)}
                              style={{ background: 'none', border: '1px solid #2a2a2a', color: '#555', borderRadius: '8px', padding: '5px 12px', cursor: 'pointer', fontSize: '12px' }}>
                              Cambiar
                            </button>
                          </div>
                        </div>
                      ) : (
                        <BuscadorLibroFavorito onSeleccionar={libro => handleUpdate('libroFavorito', libro)} />
                      )}
                    </div>
                    {/* Frase favorita */}
                    <div style={{ padding: '16px' }}>
                      <p style={{ fontSize: '11px', color: '#444', textTransform: 'uppercase', letterSpacing: '0.5px', margin: '0 0 12px', fontWeight: 'bold' }}>
                        Frase favorita
                        {perfil.fraseFavorita?.libro && (
                          <span style={{ color: '#333', marginLeft: '8px', textTransform: 'none', letterSpacing: 0 }}>— {perfil.fraseFavorita.libro}</span>
                        )}
                      </p>
                      {editando === 'frase' ? (
                        <div>
                          {perfil.fraseFavorita?.portada && (
                            <div style={{ display: 'flex', gap: '12px', alignItems: 'center', marginBottom: '10px', padding: '10px', background: '#1a1a1a', borderRadius: '8px', border: '1px solid #2a2a2a' }}>
                              <img src={perfil.fraseFavorita.portada} style={{ width: '36px', height: '52px', objectFit: 'cover', borderRadius: '4px', flexShrink: 0 }} alt="" onError={e => e.currentTarget.style.display='none'} />
                              <div style={{ flex: 1, minWidth: 0 }}>
                                <p style={{ margin: '0 0 2px', fontSize: '13px', fontWeight: 'bold', color: 'white', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{perfil.fraseFavorita.libro}</p>
                                <button onClick={() => handleUpdate('fraseFavorita', { ...(perfil.fraseFavorita || {}), libro: null, portada: null })}
                                  style={{ background: 'none', border: 'none', color: '#555', cursor: 'pointer', fontSize: '11px', padding: 0 }}>
                                  Cambiar libro
                                </button>
                              </div>
                            </div>
                          )}
                          <textarea autoFocus
                            style={{ background: '#1a1a1a', border: '1px solid #1DB954', color: 'white', width: '100%', height: '80px', borderRadius: '8px', padding: '10px', outline: 'none', resize: 'none', fontSize: '14px', boxSizing: 'border-box', marginBottom: '8px' }}
                            value={perfil.fraseFavorita?.texto || ''}
                            onChange={e => handleUpdate('fraseFavorita', { ...(perfil.fraseFavorita || {}), texto: e.target.value.slice(0, 300) })}
                            placeholder="Escribe tu frase literaria favorita..."
                            maxLength={280} />
                          <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                            {!perfil.fraseFavorita?.portada && (
                              <BuscadorLibroFrase onSeleccionar={libro => handleUpdate('fraseFavorita', { ...(perfil.fraseFavorita || {}), libro: libro.titulo, portada: libro.portada })} />
                            )}
                            <button onClick={() => setEditando(null)}
                              style={{ background: '#1DB954', color: 'black', border: 'none', borderRadius: '8px', padding: '8px 16px', fontWeight: 'bold', cursor: 'pointer', fontSize: '13px' }}>
                              Guardar
                            </button>
                          </div>
                        </div>
                      ) : (
                        <div onClick={() => setEditando('frase')} style={{ cursor: 'pointer' }}>
                          {perfil.fraseFavorita?.texto ? (
                            <div style={{ display: 'flex', gap: '12px', alignItems: 'flex-start' }}>
                              {perfil.fraseFavorita?.portada && (
                                <img src={perfil.fraseFavorita.portada} style={{ width: '40px', height: '56px', objectFit: 'cover', borderRadius: '3px', flexShrink: 0, opacity: 0.8 }} alt="" onError={e => e.currentTarget.style.display='none'} />
                              )}
                              <div>
                                <p style={{ margin: '0 0 6px', color: '#aaa', fontSize: '14px', fontStyle: 'italic', lineHeight: '1.6' }}>"{perfil.fraseFavorita.texto}"</p>
                                {perfil.fraseFavorita.libro && <p style={{ margin: 0, fontSize: '12px', color: '#444' }}>— {perfil.fraseFavorita.libro}</p>}
                              </div>
                            </div>
                          ) : (
                            <p style={{ color: '#333', fontSize: '13px' }}>Pulsa para añadir tu frase literaria favorita...</p>
                          )}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              )}

              {/* Selector de marcos — colapsado para autores, ya que no es lo prioritario en su perfil */}
              {esAutorPropio ? (
                <details style={{ marginBottom: '32px' }}>
                  <summary style={{ cursor: 'pointer', fontSize: '12px', color: '#555', textTransform: 'uppercase', letterSpacing: '1px', marginBottom: '12px' }}>Marco de avatar (opcional)</summary>
                  <div style={{ marginTop: '12px' }}>
                    <SelectorMarcos
                      marcoActual={marcoSeleccionado}
                      esPremium={true /* función liberada temporalmente */}
                      onSeleccionar={async (id) => {
                        setMarcoSeleccionado(id);
                        try { await updateDoc(doc(db, 'users', user.uid), { marco: id }); } catch (e) { console.error(e); }
                      }}
                    />
                  </div>
                </details>
              ) : (
                <div style={{ marginBottom: '32px' }}>
                  <SelectorMarcos
                    marcoActual={marcoSeleccionado}
                    esPremium={true /* función liberada temporalmente */}
                    onSeleccionar={async (id) => {
                      setMarcoSeleccionado(id);
                      try { await updateDoc(doc(db, 'users', user.uid), { marco: id }); } catch (e) { console.error(e); }
                    }}
                  />
                </div>
              )}

              {!esAutorPropio && actividadReciente.length > 0 && (
                <div style={{ marginBottom: '32px' }}>
                  <h3 style={{ fontSize: '12px', color: '#555', textTransform: 'uppercase', letterSpacing: '1px', margin: '0 0 14px' }}>Actividad reciente</h3>
                  <div style={{ display: 'flex', gap: '12px', overflowX: 'auto', paddingBottom: '8px' }}>
                    {actividadReciente.filter(a => 
                      !a.libroId?.startsWith('login_') && 
                      a.libroId !== 'login_diario' &&
                      a.titulo && 
                      a.titulo !== 'Sesión' &&
                      a.titulo !== 'Actividad diaria' &&
                      a.autor
                    ).map((a) => (
                      <div key={a.id || a.libroId} onClick={() => verLibro({ id: a.libroId, titulo: a.titulo, autor: a.autor, portada: a.portada, descripcion: '' })}
                        style={{ flexShrink: 0, width: '90px', cursor: 'pointer', textAlign: 'center' }}>
                        {a.portada ? <img src={a.portada} alt="" onError={e => e.currentTarget.style.display='none'} style={{ width: '90px', height: '130px', objectFit: 'cover', borderRadius: '6px' }} /> : <div style={{ width: '90px', height: '130px', borderRadius: '6px', background: '#1a1a1a', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '24px' }}>📖</div>}
                        <p style={{ fontSize: '11px', margin: '6px 0 0', color: '#555', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{a.titulo}</p>
                      </div>
                    ))}
                  </div>
                </div>
              )}

              {/* Estadísticas avanzadas — solo para lectores. Los autores ya tienen
                  sus estadísticas (lectores, clubs) destacadas arriba del todo */}
              {!esAutorPropio && (
                <div style={{ marginBottom: '32px' }}>
                  <h3 style={{ fontSize: '12px', color: '#555', textTransform: 'uppercase', letterSpacing: '1px', margin: '0 0 16px' }}>Mis estadísticas</h3>
                  <EstadisticasAvanzadas userId={user.uid} esPremium={true /* función liberada temporalmente */} onUpgrade={abrirModalPremium} />
                </div>
              )}

              {/* Insignias — son de lector (libros leídos, mensajes, etc.), no aplican al rol de autor */}
              {!esAutorPropio && (
                <div style={{ marginBottom: '32px' }}>
                  <h3 style={{ fontSize: '12px', color: '#555', textTransform: 'uppercase', letterSpacing: '1px', margin: '0 0 16px' }}>Insignias</h3>
                  <SeccionInsignias userId={user.uid} stats={stats} />
                </div>
              )}

              <button className="btn-verde" style={{ width: '200px', margin: 0 }} onClick={() => setSeccionActiva('biblioteca')}>Ver mi Biblioteca</button>
              <button className="btn-outline" style={{ width: '200px', marginTop: '10px' }} onClick={() => setModalGoodreads(true)}>
                Importar de Goodreads
              </button>
              <button className="btn-outline" style={{ width: '150px', marginLeft: '10px', marginTop: '15px' }} onClick={() => setSeccionActiva('libros')}>Cerrar</button>
            </div>
            );
          })()}
        </div>
      </div>

      {/* PANEL DETALLE LIBRO — BIBLIOTECA desktop */}
      {seccionActiva === 'biblioteca' && !isMobile && (
        <div className="box layout-detail" style={{ background: '#0a0a0a', padding: '20px', borderLeft: '1px solid #1a1a1a', overflowY: 'auto' }}>
          {entradaActivaBib ? (
            <>
              <button onClick={() => { setEntradaActivaBib(null); setVistaNotasBib(false); }} style={{ background: 'none', border: 'none', color: '#444', fontSize: '20px', cursor: 'pointer', float: 'right', padding: '0 4px', lineHeight: 1 }}>✕</button>
              <div style={{ clear: 'both', paddingTop: '4px' }}>
                {vistaNotasBib
                  ? <PanelNotas userId={user.uid} libro={entradaActivaBib.libro} entrada={entradaActivaBib} />
                  : entradaActivaBib.estado === 'leyendo'
                  ? <PanelLeyendo userId={user.uid} libro={entradaActivaBib.libro} entrada={entradaActivaBib} onCerrar={() => setEntradaActivaBib(null)} />
                  : entradaActivaBib.estado === 'leido'
                  ? <PanelLeido userId={user.uid} libro={entradaActivaBib.libro} entrada={entradaActivaBib} soloLectura={soloLecturaBib} />
                  : <PanelQuieroLeer userId={user.uid} libro={entradaActivaBib.libro} entrada={entradaActivaBib} soloLectura={soloLecturaBib} />
                }
              </div>
            </>
          ) : (
            <PanelProgresoLector userId={user.uid} entradas={entradasBib} />
          )}
        </div>
      )}

      {/* PANEL DETALLE LIBRO — BIBLIOTECA móvil (overlay) */}
      {seccionActiva === 'biblioteca' && isMobile && entradaActivaBib && (
        <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: '56px', background: '#0a0a0a', zIndex: 900, overflowY: 'auto', padding: '20px' }}>
          <button onClick={() => { setEntradaActivaBib(null); setVistaNotasBib(false); }} style={{ background: 'none', border: 'none', color: '#444', fontSize: '24px', cursor: 'pointer', float: 'right', padding: '0 4px', lineHeight: 1 }}>✕</button>
          <div style={{ clear: 'both', paddingTop: '4px' }}>
            {vistaNotasBib
              ? <PanelNotas userId={user.uid} libro={entradaActivaBib.libro} entrada={entradaActivaBib} />
              : entradaActivaBib.estado === 'leyendo'
              ? <PanelLeyendo userId={user.uid} libro={entradaActivaBib.libro} entrada={entradaActivaBib} onCerrar={() => setEntradaActivaBib(null)} />
              : entradaActivaBib.estado === 'leido'
              ? <PanelLeido userId={user.uid} libro={entradaActivaBib.libro} entrada={entradaActivaBib} soloLectura={soloLecturaBib} />
              : <PanelQuieroLeer userId={user.uid} libro={entradaActivaBib.libro} entrada={entradaActivaBib} soloLectura={soloLecturaBib} />
            }
          </div>
        </div>
      )}

      {/* PANEL DETALLE LIBRO */}
      {libroSeleccionado && !['sala','perfil-ajeno','alertas','buscar-usuarios','admin','clubs','biblioteca'].includes(seccionActiva) && (
        <div className={`box layout-detail${isMobile ? ' active' : ''}`} style={{ padding: 0, borderLeft: isMobile ? 'none' : '1px solid #1a1a1a', overflowY: 'auto', overflowX: 'hidden', backgroundColor: '#0a0a0a' }}>
          {libroSeleccionado.portada && (
            <div style={{ position: 'relative', height: '180px', overflow: 'hidden', marginBottom: '-60px' }}>
              <img src={libroSeleccionado.portada} alt="" style={{
                position: 'absolute', top: '-40px', left: '-20px', width: 'calc(100% + 40px)', height: 'calc(100% + 80px)',
                objectFit: 'cover', filter: 'blur(28px) brightness(0.4) saturate(1.5)',
              }} onError={e => e.currentTarget.parentElement.style.display = 'none'} />
              <div style={{ position: 'absolute', inset: 0, background: 'linear-gradient(180deg, rgba(10,10,10,0.1) 0%, #0a0a0a 100%)' }} />
            </div>
          )}
          <div style={{ padding: '20px', position: 'relative' }}>
          <button onClick={() => { setLibroSeleccionado(null); }} style={{ background: 'rgba(0,0,0,0.4)', border: 'none', color: 'white', fontSize: '18px', cursor: 'pointer', float: 'right', padding: '4px 10px', lineHeight: 1, borderRadius: '50%', backdropFilter: 'blur(4px)' }}>✕</button>
          <img src={libroSeleccionado.portada} style={{ width: '100%', borderRadius: '8px', display: 'block', marginTop: '36px', boxShadow: '0 16px 40px rgba(0,0,0,0.6)' }} alt="" onError={e => e.currentTarget.style.display='none'} />
          <h2 style={{ marginTop: '16px', marginBottom: '4px', fontSize: '18px', fontWeight: 900 }}>{libroSeleccionado.titulo}</h2>
          <p style={{ color: '#1DB954', margin: '0 0 4px', fontSize: '13px', fontWeight: 'bold' }}>{libroSeleccionado.autor}</p>
          <EstadoLectura libroId={libroSeleccionado.id} userId={user.uid} libro={libroSeleccionado} onActividad={() => registrarActividad(user.uid, libroSeleccionado)} />
          <ProgresoLectura libroId={libroSeleccionado.id} userId={user.uid} libro={libroSeleccionado} />
          <MoodTags userId={user.uid} libroId={libroSeleccionado.id} />
          <TimerLectura
            userId={user.uid}
            libroId={libroSeleccionado.id}
            libro={libroSeleccionado}
            esPremium={true /* función liberada temporalmente */}
            onUpgrade={abrirModalPremium}
          />
          <ValoracionEstrellas libroId={libroSeleccionado.id} userId={user.uid} libro={libroSeleccionado} onActividad={() => registrarActividad(user.uid, libroSeleccionado)} />
          <CitasLibro
            userId={user.uid}
            libroId={libroSeleccionado.id}
            libro={libroSeleccionado}
            esPremium={true /* función liberada temporalmente */}
            onUpgrade={abrirModalPremium}
          />
          <BuddyReads
            userId={user.uid}
            perfil={perfil}
            libroId={libroSeleccionado.id}
            libro={libroSeleccionado}
            esPremium={true /* función liberada temporalmente */}
            onUpgrade={abrirModalPremium}
            onEntrarSala={entrarEnSala}
            listaSiguiendo={listaSiguiendo}
          />
          <div style={{ background: '#141414', padding: '10px 14px', borderRadius: '8px', margin: '12px 0', border: '1px solid #1e1e1e', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <span style={{ color: '#555', fontSize: '12px' }}>Salas activas</span>
            <span style={{ fontSize: '18px', fontWeight: 900, color: '#1DB954' }}>{conteoSalas}</span>
          </div>

          <button className="btn-verde" style={{ margin: '0 0 8px' }} onClick={async () => {
            // Si el usuario ya es miembro de alguna sala de este libro, entrar en ella directamente
            const salasSnap = await getDocs(query(
              collection(db, "salas_info"),
              where("libroId", "==", libroSeleccionado.id),
              where("tipo", "==", "publica")
            )).catch(() => null);
            if (salasSnap) {
              // Filtrar activas en cliente para evitar índice compuesto
              const salasActivas = salasSnap.docs.filter(d => d.data().activa !== false);
              for (const salaDoc of salasActivas) {
                const miembroSnap = await getDoc(doc(db, "salas", salaDoc.id, "miembros", user.uid)).catch(() => null);
                if (miembroSnap?.exists()) {
                  entrarEnSala(libroSeleccionado, false, salaDoc.id);
                  return;
                }
              }
            }
            // No es miembro de ninguna sala → entrar en sala con hueco (o nueva)
            entrarEnSala(libroSeleccionado, false);
          }}>Entrar en sala pública</button>
          <button className="btn-outline" style={{ width: '100%', marginTop: 0 }} onClick={iniciarCrearSalaPrivada}>Crear sala privada</button>

          {/* Afiliación Casa del Libro — desactivado hasta tener afiliación activa */}
          {false && <a href={`https://www.casadellibro.com/libros/buscar?q=${encodeURIComponent((libroSeleccionado.titulo || '') + ' ' + (libroSeleccionado.autor || ''))}`}
            target="_blank" rel="noopener noreferrer"
            style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '8px', marginTop: '16px', padding: '11px 16px', background: 'transparent', border: '1px solid #2a2a2a', borderRadius: '20px', textDecoration: 'none', color: '#555', fontSize: '13px', fontWeight: 'bold', transition: 'all 0.2s', cursor: 'pointer', letterSpacing: '0.2px' }}
            onMouseEnter={e => { e.currentTarget.style.borderColor = '#1DB954'; e.currentTarget.style.color = 'white'; }}
            onMouseLeave={e => { e.currentTarget.style.borderColor = '#2a2a2a'; e.currentTarget.style.color = '#555'; }}>
            <span>Comprar en Casa del Libro</span>
            <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor" style={{ flexShrink: 0, opacity: 0.6 }}><path d="M19 19H5V5h7V3H5a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2v-7h-2v7zM14 3v2h3.59l-9.83 9.83 1.41 1.41L19 6.41V10h2V3h-7z"/></svg>
          </a>}
          </div>
        </div>
      )}
      {/* Navegación inferior — solo móvil */}
      <nav className="layout-nav-bottom nav-bottom" style={{ paddingBottom: 'env(safe-area-inset-bottom, 0px)' }}>
          <button className={`nav-bottom-item ${seccionActiva === 'feed' ? 'active' : ''}`} onClick={() => { setSeccionActiva('feed'); setLibroSeleccionado(null); }}>
            <svg viewBox="0 0 24 24" fill="currentColor"><path d="M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z"/></svg>
            <span>Inicio</span>
          </button>
          <button className={`nav-bottom-item ${seccionActiva === 'explorar' || seccionActiva === 'libros' ? 'active' : ''}`} onClick={() => setSeccionActiva('explorar')}>
            <svg viewBox="0 0 24 24" fill="currentColor"><path d="M15.5 14h-.79l-.28-.27A6.471 6.471 0 0 0 16 9.5 6.5 6.5 0 1 0 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"/></svg>
            <span>Explorar</span>
          </button>
          <button className={`nav-bottom-item ${seccionActiva === 'clubs' ? 'active' : ''}`} onClick={() => setSeccionActiva('clubs')}>
            <svg viewBox="0 0 24 24" fill="currentColor"><path d="M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z"/></svg>
            <span>Clubs</span>
          </button>
          <button className={`nav-bottom-item ${seccionActiva === 'biblioteca' ? 'active' : ''}`} onClick={() => setSeccionActiva('biblioteca')}>
            <svg viewBox="0 0 24 24" fill="currentColor"><path d="M21 5c-1.11-.35-2.33-.5-3.5-.5-1.95 0-4.05.4-5.5 1.5-1.45-1.1-3.55-1.5-5.5-1.5S2.45 4.9 1 6v14.65c0 .25.25.5.5.5.1 0 .15-.05.25-.05C3.1 20.45 5.05 20 6.5 20c1.95 0 4.05.4 5.5 1.5 1.35-.85 3.8-1.5 5.5-1.5 1.65 0 3.35.3 4.75 1.05.1.05.15.05.25.05.25 0 .5-.25.5-.5V6c-.6-.45-1.25-.75-2-1zm0 13.5c-1.1-.35-2.3-.5-3.5-.5-1.7 0-4.15.65-5.5 1.5V8c1.35-.85 3.8-1.5 5.5-1.5 1.2 0 2.4.15 3.5.5v11.5z"/></svg>
            <span>Biblioteca</span>
          </button>
          <button className={`nav-bottom-item ${seccionActiva === 'perfil' ? 'active' : ''}`} onClick={() => setSeccionActiva('perfil')}>
            <svg viewBox="0 0 24 24" fill="currentColor"><path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"/></svg>
            <span>Perfil</span>
          </button>
      </nav>

    </div>
  );
}

export default App;
